(function(){
  "use strict";
  /* ===== MODE ADMIN (pont admin.mytomette.fr) : actif uniquement en iframe/fenêtre ouverte par l'admin avec ?admin=1 ===== */
  var MT_ADMIN=false;
  try{ MT_ADMIN = /[?&#]admin=1(&|$)/.test((location.search||'')+(location.hash||'')) && (window.opener!=null || window.self!==window.top); }catch(e){ MT_ADMIN=true; }
  var ICONS = {
    leaf:'<path d="M11 21c-4 0-8-3-8-9 0-1 0-2 .3-3 3 .5 9 2 9.7 9z"/><path d="M11 21C11 12 14 5 21 3c0 9-4 16-10 18z"/>',
    heart:'<path d="M12 20s-7-4.6-9.2-9.2C1.3 7.8 3 5 6 5c1.8 0 3.2.9 4 2.1C10.8 5.9 12.2 5 14 5c3 0 4.7 2.8 3.2 5.8C19 15.4 12 20 12 20z"/>',
    house:'<path d="M4 11l8-6 8 6"/><path d="M6 10v9h12v-9"/><path d="M10 19v-5h4v5"/>',
    ring:'<circle cx="12" cy="14" r="6"/><path d="M9 7l1.5-3h3L15 7"/>',
    star:'<path d="M12 3l2.6 5.6L20 9.3l-4 4 1 6-5-2.8L7 19l1-6-4-4 5.4-.7z"/>',
    wine:'<path d="M8 3h8l-1 6a3 3 0 0 1-6 0z"/><path d="M12 12v6"/><path d="M9 21h6"/>',
    key:'<circle cx="8" cy="8" r="4"/><path d="M11 11l8 8"/><path d="M16 16l2-2"/><path d="M18 18l2-2"/>',
    olive:'<path d="M5 19C5 12 9 6 19 5c0 8-5 13-12 14z"/><circle cx="9" cy="13" r="1.4"/><circle cx="13" cy="9" r="1.4"/>'
  };
  /* Index léger : chaque aperçu WebP et chaque SVG de gravure sont ensuite chargés
     séparément. Le gros logos.json historique reste uniquement un secours admin. */
  var URL_LOGOS = 'https://admin.mytomette.fr/save.php?public=logo-manifest';
  var URL_LOGOS_FALLBACK = 'https://admin.mytomette.fr/json/logos.json';
  var URL_TEMPLATE_LOGOS = (window.MT_CONFIG_ASSETS&&window.MT_CONFIG_ASSETS.templateLogos)||[];
  var URL_TEMPLATE_LOGO_KEYS = (window.MT_CONFIG_ASSETS&&window.MT_CONFIG_ASSETS.templateLogoKeys)||[];
  var LOGOCAT = {};   // key -> {svg,name,category,minSize,maxSize}
  var LOGOCATS = [];  // [{id,name,emoji}]
  var TPL_ASSETS={}, TPL_SVG_CACHE={}, TPL_SVG_STATE={}, TPL_SVG_WAITERS={};
  var TPL_SVG_QUEUE=[], TPL_SVG_INFLIGHT=0, TPL_SVG_MAX=4, TPL_SVG_LOADED=0, TPL_SVG_REDRAW=null;
  var TEMPLATE_LOGOS_READY=false, TEMPLATE_LOGOS_ALL_READY=false, TEMPLATE_LOGOS_REQUEST_ID=0, TEMPLATE_LOGO_PROMISES={}, PENDING_TEMPLATES=null, REMOTE_TEMPLATES_STARTED=false, INITIAL_RECIPE=null, INITIAL_RECIPE_ACTIVE=false, FULL_LOGOS_STARTED=false, FULL_LOGOS_READY=false, FULL_LOGOS_WAITERS=[];
  function logoSvg(item){
    if(item.svg){ var a=sanitizeSvg(item.svg); return a||item.svg; }            // SVG importé
    if(item.svgRef&&TPL_SVG_CACHE[item.svgRef]){ var s2=TPL_SVG_CACHE[item.svgRef]; var c=sanitizeSvg(s2); return c||s2; } // SVG propre au modèle
    if(LOGOCAT[item.icon]){ var b=sanitizeSvg(LOGOCAT[item.icon].svg); return b||LOGOCAT[item.icon].svg; } // catalogue
    return null;                                         // motif intégré -> ICONS
  }
  function svgRatioWH(svg,size){
    var vbW=0,vbH=0,m=String(svg).match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);
    if(m){var a=m[1].trim().split(/\s+/);if(a.length===4){vbW=parseFloat(a[2])||0;vbH=parseFloat(a[3])||0;}}
    if(!(vbW>0)||!(vbH>0))return{w:size,h:size};
    var mx=Math.max(vbW,vbH);
    return{w:Math.round(size*(vbW/mx)*1000)/1000,h:Math.round(size*(vbH/mx)*1000)/1000};
  }
  function svgSized(svg,size,flip){
    return String(svg).replace(/<svg\b/i,'<svg style="width:'+svgRatioWH(svg,size).w+'cqw;height:'+svgRatioWH(svg,size).h+'cqw'+(flip?';transform:scaleX(-1)':'')+'"');
  }
  function sanitizeSvg(raw){
    var s=String(raw);
    s=s.replace(/<\?xml[\s\S]*?\?>/gi,'').replace(/<!DOCTYPE[\s\S]*?>/gi,'');
    s=s.replace(/<script[\s\S]*?<\/script>/gi,'').replace(/<style[\s\S]*?<\/style>/gi,'');
    s=s.replace(/<foreignObject[\s\S]*?<\/foreignObject>/gi,'');
    s=s.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*')/gi,'');
    s=s.replace(/\sclass\s*=\s*("[^"]*"|'[^']*')/gi,'');  // classes inutiles sans <style> -> évite toute fuite de style globale
    var m=s.match(/<svg[\s\S]*<\/svg>/i);
    if(!m) return null;
    s=m[0];
    s=s.replace(/(fill|stroke)\s*=\s*("[^"]*"|'[^']*')/gi,function(full,prop,val){
      var v=val.slice(1,-1).trim().toLowerCase();
      if(v==='none'||v==='currentcolor') return prop+'="'+v+'"';
      return prop+'="currentColor"';
    });
    s=s.replace(/(fill|stroke)\s*=\s*([^\s"'>\/]+)/gi,function(full,prop,val){
      var v=val.trim().toLowerCase();
      if(v==='none'||v==='currentcolor') return prop+'="'+v+'"';
      return prop+'="currentColor"';
    });
    s=s.replace(/(fill|stroke)\s*:\s*([^;"')]+)/gi,function(full,prop,val){
      var v=val.trim().toLowerCase();
      if(v==='none'||v==='currentcolor'||v==='inherit'||v==='transparent'||/^url\(/.test(v)) return full;
      return prop+':currentColor';
    });
    if(!/<svg\b[^>]*\bfill\s*=/i.test(s)) s=s.replace(/<svg\b/i,'<svg fill="currentColor"');
    return s;
  }
  function logoAssetUrl(path){
    path=String(path||'').trim();
    if(!path)return '';
    if(/^https?:\/\//i.test(path))return path;
    try{
      var root=(new URL(URL_LOGOS,location.href)).origin+'/';
      return new URL(path.replace(/^\/+/,''),root).href;
    }catch(e){return path;}
  }
  function logoPublicFileUrl(path){
    path=String(path||'').trim();
    if(!path)return '';
    if(/^https?:\/\//i.test(path))return path;
    try{
      var endpoint=new URL(URL_LOGOS,location.href);
      endpoint.search='?public=logo-asset&path='+encodeURIComponent(path.replace(/^\/+/,''));
      return endpoint.href;
    }catch(e){return logoAssetUrl(path);}
  }
  /* SVG propre à un modèle, extrait par save.php dans template-assets/svg/.
     Même principe que les logos du catalogue : rien n'est chargé tant qu'un
     modèle qui en a besoin n'est pas réellement affiché. */
  function templateAssetUrl(path){
    path=String(path||'').trim();
    if(!path)return '';
    if(/^https?:\/\//i.test(path))return path;
    try{
      var endpoint=new URL(URL_LOGOS,location.href);
      endpoint.search='?public=template-asset&path='+encodeURIComponent(path.replace(/^\/+/,''));
      return endpoint.href;
    }catch(e){return '';}
  }
  /* Logos propres à un modèle (imports, créations IA) : absents du catalogue,
     ils vivent dans template-assets/. Rien n'est téléchargé tant qu'une carte qui
     en a besoin n'approche pas de l'écran. Générique : tout modèle créé dans
     l'admin reçoit son svgRef automatiquement, aucune liste à tenir à jour. */
  function templateSvgRefs(els){
    var out=[];
    (els||[]).forEach(function(e){
      if(!e||e.type!=='icon'||e.svg||!e.svgRef)return;
      if(TPL_SVG_CACHE[e.svgRef]||TPL_SVG_STATE[e.svgRef]==='ko')return;
      if(e.icon&&LOGOCAT[e.icon]&&LOGOCAT[e.icon].svg)return;   /* déjà couvert par le catalogue */
      if(out.indexOf(e.svgRef)<0)out.push(e.svgRef);
    });
    return out;
  }
  function requestTemplateSvgs(els,urgent){
    templateSvgRefs(els).forEach(function(ref){
      if(TPL_SVG_STATE[ref])return;                             /* déjà en file ou en cours */
      /* Greffe 8 (15/10) : une recette rouverte (« Modifier » du panier, lien #d=)
         arrive avant le catalogue des modèles, donc sans TPL_ASSETS. On la marquait
         'ko' pour toujours et le motif propre au modèle retombait sur ICONS.leaf —
         y compris dans le fichier laser. save.php range chaque svgRef sous
         template-assets/svg/<ref>.svg (156 sur 156) : on en déduit le chemin. */
      if(!TPL_ASSETS[ref]&&/^tpl_[A-Za-z0-9_-]+$/.test(ref))TPL_ASSETS[ref]='template-assets/svg/'+ref+'.svg';
      if(!TPL_ASSETS[ref]){TPL_SVG_STATE[ref]='ko';return;}
      TPL_SVG_STATE[ref]='wait';
      if(urgent)TPL_SVG_QUEUE.unshift(ref); else TPL_SVG_QUEUE.push(ref);
    });
    pumpTemplateSvgs();
  }
  function pumpTemplateSvgs(){
    while(TPL_SVG_INFLIGHT<TPL_SVG_MAX&&TPL_SVG_QUEUE.length){
      var next=TPL_SVG_QUEUE.shift();
      if(TPL_SVG_STATE[next]!=='wait')continue;
      TPL_SVG_STATE[next]='load';TPL_SVG_INFLIGHT++;
      delete TPL_SVG_ABSENT[next];   /* greffe 8 bis : « introuvable » ne vaut que pour la dernière réponse */
      (function(ref){
        fetch(templateAssetUrl(TPL_ASSETS[ref]),{cache:'force-cache'}).then(function(r){
          if(mtStatutIntrouvable(r.status))TPL_SVG_ABSENT[ref]=r.status;   /* greffe 8 bis : le serveur dit « n'existe pas » */
          if(!r.ok)throw new Error('HTTP '+r.status);
          return r.text();
        }).then(function(raw){
          var clean=sanitizeSvg(raw)||raw;
          if(!clean||String(clean).indexOf('<svg')<0)throw new Error('SVG invalide');
          TPL_SVG_CACHE[ref]=clean;TPL_SVG_STATE[ref]='ok';TPL_SVG_LOADED++;
          releaseTemplateSvg(ref);
        }).catch(function(err){
          TPL_SVG_STATE[ref]='ko';
          try{console.warn('[MT templates] SVG de modèle indisponible ('+ref+')',err);}catch(e){}
        }).then(function(){
          TPL_SVG_INFLIGHT--;pumpTemplateSvgs();
        });
      })(next);
    }
  }
  /* Redessine uniquement les cartes qui attendaient ce SVG, plus l'éditeur. */
  function releaseTemplateSvg(ref){
    var recs=TPL_SVG_WAITERS[ref]||[];delete TPL_SVG_WAITERS[ref];
    recs.forEach(function(rec){ rec.drawn=false; try{drawPreviewRecord(rec);}catch(e){} });
    if(TPL_SVG_REDRAW)clearTimeout(TPL_SVG_REDRAW);
    TPL_SVG_REDRAW=setTimeout(function(){
      TPL_SVG_REDRAW=null;
      try{console.log('[MT templates] SVG de modèles chargés :',TPL_SVG_LOADED,'| en file :',TPL_SVG_QUEUE.length);}catch(e){}
      refreshAfterAssets();
    },160);
  }
  /* Une carte déclare ce qui lui manque juste avant d'être dessinée. */
  function noteTemplateSvgNeed(rec){
    if(!rec||!rec.src)return;
    var refs=templateSvgRefs(rec.src.els);
    if(!refs.length)return;
    refs.forEach(function(ref){
      var w=TPL_SVG_WAITERS[ref]=TPL_SVG_WAITERS[ref]||[];
      if(w.indexOf(rec)<0)w.push(rec);
    });
    requestTemplateSvgs(rec.src.els,true);
  }
  /* Greffe 8 bis (15/10) : la course. Une recette rouverte (« Modifier », lien #d=) demande
     son motif propre (svgRef) à l'ouverture, mais le fetch est asynchrone : si le client valide
     avant son arrivée, renderPNG et buildLaserSVG retombent sur ICONS.leaf — la feuille part au
     laser. L'ajout au panier attend donc les motifs encore en route (svgRef, SVG du catalogue,
     petits catalogues des modèles), avec un plafond ; un motif qui ne vient pas bloque l'ajout
     avec un message, jamais un motif faux. Cas normal (tout est déjà là) : rappel SYNCHRONE,
     aucun délai. Même ordre de résolution que logoSvg(), puis ICONS. */
  var MT_MOTIFS_PLAFOND=15000;
  /* Finition de la greffe 8 bis (15/10, relecture : constats 3 et 4).
     - « Introuvable » n'est pas « pas encore arrivé ». Un motif dont le serveur répond qu'il n'existe
       pas (400/404/410 : logo supprimé, vieux panier), ou absent du catalogue complet bien lu, ne
       viendra pas en réessayant : on le dit (« remplacez-le ou retirez-le ») au lieu d'accuser la
       connexion. L'ajout reste refusé dans les deux cas : jamais un motif faux.
     - Le rappel part une fois et une seule ; une exception (bilan, relance) refuse l'ajout au lieu de
       laisser la barre de chargement et le verrou en plan. */
  var TPL_SVG_ABSENT={}, MT_CATALOGUE_COMPLET=false;
  function mtStatutIntrouvable(st){return st===400||st===404||st===410;}
  function mtMotifIntrouvable(e){   // vrai seulement sur preuve : réponse « n'existe pas », ou catalogue complet lu sans lui
    if(!e||e.type==='text'||e.svg||ICONS[e.icon])return false;
    if(e.svgRef&&!TPL_SVG_ABSENT[e.svgRef])return false;          /* son fichier propre peut encore venir */
    var rec=LOGOCAT[e.icon];
    if(rec&&rec.svgAbsent)return true;                            /* fiche au catalogue, fichier « n'existe pas » */
    return MT_CATALOGUE_COMPLET&&!(rec&&(rec.svg||rec.svgUrl));   /* catalogue complet lu : ni fiche, ni fichier */
  }
  function mtMotifEtat(e){   // 'ok' | 'attente' | 'manque'
    if(!e||e.type==='text'||e.svg)return 'ok';
    if(e.svgRef&&TPL_SVG_CACHE[e.svgRef])return 'ok';
    var rec=LOGOCAT[e.icon];
    if(rec&&rec.svg&&sanitizeSvg(rec.svg))return 'ok';
    var st=e.svgRef?TPL_SVG_STATE[e.svgRef]:'';
    if(st==='wait'||st==='load')return 'attente';
    if(rec&&rec.svgPromise)return 'attente';
    if(ICONS[e.icon])return 'ok';
    if(!TEMPLATE_LOGOS_READY&&(TEMPLATE_LOGOS_REQUEST_ID>0||TEMPLATE_LOGOS_ALL_READY))return 'attente';
    if(FULL_LOGOS_STARTED&&!FULL_LOGOS_READY)return 'attente';
    return 'manque';
  }
  function mtAttendreMotifs(els,cb,onAttente){   // cb(ok, manquants, introuvable)
    els=els||[];
    var debut=Date.now(),relance={},rendu=false;
    function rendre(ok,liste,introuvable){if(rendu)return;rendu=true;cb(ok,liste||[],!!introuvable);}
    function panne(err){try{console.error('[MT motifs] vérification impossible — ajout refusé',err);}catch(e){}rendre(false,[],false);}
    function bilan(){
      var b={attente:[],manque:[],introuvable:[]};
      els.forEach(function(e){
        var s=mtMotifEtat(e);if(s==='ok')return;
        var nom=String(e.icon||'')+(e.svgRef?'|'+e.svgRef:'');
        b[s].push(nom);
        if(s==='manque'&&mtMotifIntrouvable(e))b.introuvable.push(nom);
      });
      return b;
    }
    /* Relance, une seule fois par motif et par ajout : un svgRef tombé en 'ko' (réseau),
       un SVG du catalogue connu mais pas encore lu, le manifeste s'il manque une clé. */
    function relancer(){
      var sansFiche=false;
      els.forEach(function(e){
        if(!e||e.type==='text'||e.svg||mtMotifEtat(e)==='ok')return;
        if(e.svgRef&&TPL_SVG_STATE[e.svgRef]==='ko'&&!relance['r:'+e.svgRef]){relance['r:'+e.svgRef]=1;delete TPL_SVG_STATE[e.svgRef];}
        var rec=LOGOCAT[e.icon];
        if(rec&&rec.svgUrl&&!rec.svgPromise&&!relance['c:'+e.icon]){relance['c:'+e.icon]=1;ensureLogoSvg(e.icon,function(ok){if(ok)refreshAfterAssets();});}
        if(!(rec&&(rec.svg||rec.svgUrl))&&!ICONS[e.icon])sansFiche=true;
      });
      requestTemplateSvgs(els,true);
      if(sansFiche&&!FULL_LOGOS_STARTED&&!relance.cat){relance.cat=1;ensureFullLogos();}
      /* Un catalogue complet tombé en panne réseau n'était jamais redemandé : « réessayez » n'y pouvait rien. */
      if(sansFiche&&FULL_LOGOS_READY&&!MT_CATALOGUE_COMPLET&&!relance.cat){relance.cat=1;FULL_LOGOS_STARTED=false;FULL_LOGOS_READY=false;ensureFullLogos();}
    }
    var b0;
    try{b0=bilan();}catch(err){panne(err);return;}
    if(!b0.attente.length&&!b0.manque.length){rendre(true);return;}
    if(typeof onAttente==='function'){try{onAttente();}catch(e){}}
    (function tour(){
      var b,ms;
      try{relancer();b=bilan();}catch(err){panne(err);return;}
      ms=Date.now()-debut;
      if(!b.attente.length&&!b.manque.length){try{console.log('[MT motifs] arrivés après '+ms+' ms');}catch(e){}rendre(true);return;}
      /* Un motif introuvable ne viendra pas : inutile d'attendre les autres jusqu'au plafond. */
      if(b.introuvable.length||!b.attente.length||ms>=MT_MOTIFS_PLAFOND){
        try{console.warn('[MT motifs] ajout bloqué après '+ms+' ms — '+(b.introuvable.length?'introuvables :':'manquants :'),b.introuvable.length?b.introuvable:b.manque.concat(b.attente));}catch(e){}
        rendre(false,b.manque.concat(b.attente),b.introuvable.length>0);return;
      }
      setTimeout(tour,100);
    })();
  }
  function mtMotifsMessage(introuvable){
    if(introuvable){mtToastLong(window.MT_CONFIG_I18N.text("ui_0df9eebd4ade_html", "Un motif de cette tomette n’est plus disponible : remplacez-le ou retirez-le, puis réessayez. Rien n’a été ajouté au panier."),8000);return;}
    mtToastLong(window.MT_CONFIG_I18N.text("ui_f722ebdc82f1_html", "Un motif de votre tomette n’a pas pu être chargé. Vérifiez votre connexion puis réessayez : rien n’a été ajouté au panier."),8000);
  }

  function logoPreviewInto(node,key){
    var rec=LOGOCAT[key]||{},url=rec.previewUrl||'';
    if(url){
      var img=document.createElement('img');
      /* Ne pas renseigner src ici : Safari télécharge sinon toute la grille,
         même avec chargement="lazy" dans certains conteneurs défilants. */
      img.setAttribute('data-mt-logo-src',url);
      img.alt='';img.loading='lazy';img.decoding='async';
      img.style.cssText='width:46px;height:46px;object-fit:contain;display:block';
      node.appendChild(img);
      return;
    }
    node.innerHTML=logoSvg({icon:key})||rec.svg||'';
  }
  function observeLogoPreviews(grid){
    if (!grid)return;
    if(grid._mtLogoObserver){
      try{grid._mtLogoObserver.disconnect();}catch(e){}
      grid._mtLogoObserver=null;
    }
    var imgs=grid.querySelectorAll('img[data-mt-logo-src]');
    function load(img){
      var src=img.getAttribute('data-mt-logo-src');
      if (!src)return;
      img.removeAttribute('data-mt-logo-src');
      img.src=src;
    }
    if(!window.IntersectionObserver){
      for(var i=0;i<imgs.length;i++)load(imgs[i]);
      return;
    }
    var root=null,p=grid.parentElement;
    while(p&&p!==document.body&&p!==document.documentElement){
      try{
        var cs=getComputedStyle(p),oy=cs.overflowY;
        if((oy==='auto'||oy==='scroll')&&p.scrollHeight>p.clientHeight+2){root=p;break;}
      }catch(e){}
      p=p.parentElement;
    }
    var ob=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting)return;
        load(entry.target);
        ob.unobserve(entry.target);
      });
    },{root:root,rootMargin:'220px 0px',threshold:0.01});
    grid._mtLogoObserver=ob;
    for(var j=0;j<imgs.length;j++)ob.observe(imgs[j]);
  }
  function ensureLogoSvg(key,onReady){
    var rec=LOGOCAT[key];
    if(!rec){if(onReady)onReady(false);return;}
    if(rec.svg&&/<svg[\s>]/i.test(String(rec.svg))){if(onReady)onReady(true);return;}
    if(rec.svgPromise){rec.svgPromise.then(function(ok){if(onReady)onReady(ok);});return;}
    if(!rec.svgUrl){if(onReady)onReady(false);return;}
    rec.svgAbsent=false;   /* greffe 8 bis : verdict de la dernière réponse seulement */
    rec.svgPromise=fetch(rec.svgUrl,{cache:'force-cache'}).then(function(r){rec.svgAbsent=mtStatutIntrouvable(r.status);return r.ok?r.text():'';}).then(function(raw){
      var clean=sanitizeSvg(raw);
      if (!clean) return false ;
      rec.svg=clean;
      return true ;
    }).catch(function(){return false;});
    rec.svgPromise.then(function(ok){rec.svgPromise=null;if(onReady)onReady(ok);});
  }
  function addCatalogIcon(key,after){
    ensureLogoSvg(key,function(ok){
      if(!ok){
        toast('Ce motif n\'a pas pu être chargé. Réessayez dans un instant.');
        if(typeof after==='function')after(false);
        return;
      }
      addIcon(key);
      if(typeof after==='function')after(true);
    });
  }
  var ASSET_FLAGS={logos:false,fonts:false,tpl:false,photos:false}, CF_READY=false, CF_REVEAL_TIMER=null, CF_REVEAL_SOFT=null;
  function cfAllReady(){return ASSET_FLAGS.logos&&ASSET_FLAGS.fonts&&ASSET_FLAGS.tpl&&ASSET_FLAGS.photos;}
  function cfCoreReady(){return ASSET_FLAGS.tpl&&ASSET_FLAGS.photos;}
  function cfUpdateProgress(){
    var n=0; ['logos','fonts','tpl','photos'].forEach(function(k){if(ASSET_FLAGS[k])n++;});
    var f=document.getElementById('cfLoadFill'); if(f)f.style.width=Math.round(n/4*100)+'%';
    var t=document.getElementById('cfLoadTxt'); if(t)t.textContent=ASSET_FLAGS.tpl?(ASSET_FLAGS.photos?'Finalisation…':window.MT_CONFIG_I18N.text("ui_06c82dc625c0_html", "Chargement des visuels…")):window.MT_CONFIG_I18N.text("ui_f04b4244b3b7_html", "Préparation de vos modèles…");
  }
  function cfShowLoading(on){ var ov=document.getElementById("cfLoad"); if(ov)ov.style.display=on?"flex":"none"; }
  function cfReveal(){
    if(CF_READY)return; CF_READY=true;
    if(CF_REVEAL_TIMER){clearTimeout(CF_REVEAL_TIMER);CF_REVEAL_TIMER=null;}
    cfShowLoading(false);
    try{ buildChips(); buildInsp(cfFilter||"all"); }catch(e){}
    try{ if(document.getElementById("sInsp").classList.contains("on")) cfStartAuto(); }catch(e){}
  }
  function assetSettled(which){
    if(which&&ASSET_FLAGS.hasOwnProperty(which))ASSET_FLAGS[which]=true;
    cfUpdateProgress();
    if(CF_READY){
      try{
        if(which==='tpl'){
          buildChips();
          buildInsp(cfFilter||'all');
          buildRailModels();
        }else if(which==='logos'||which==='fonts'){
          refreshPrevCanvases();
        }
      }catch(e){}
      return;
    }
    if(cfAllReady()){ cfReveal(); return; }
    if(cfCoreReady() && !CF_REVEAL_SOFT){ CF_REVEAL_SOFT=setTimeout(cfReveal,450); }
  }
  function refreshAfterAssets(){
    try{ if(document.getElementById('sEdit').classList.contains('on')){ syncTextFromDom(); render(); } }catch(e){}
    try{ if(document.getElementById('sValid').classList.contains('on')){ drawValid(); } }catch(e){}
  }
  function loadLogos(){
    if(FULL_LOGOS_STARTED)return;
    FULL_LOGOS_STARTED=true;
    function finished(){
      FULL_LOGOS_READY=true;
      assetSettled('logos');
      var q=FULL_LOGOS_WAITERS.splice(0);q.forEach(function(cb){try{cb();}catch(e){}});
    }
    if(!URL_LOGOS || /REMPLACER/.test(URL_LOGOS)){ finished(); return; } // tant que l'URL n'est pas configurée -> motifs intégrés seuls
    try{
      /* Le catalogue depasse 3 Mo : il n'est demande qu'apres une action explicite
         sur « Motifs & ornements », jamais pendant l'ouverture du configurateur. */
      function applyCatalog(d){
        if(d&&d.logos){
          Object.keys(d.logos).forEach(function(key){
            var src=d.logos[key]||{},prev=LOGOCAT[key]||{},next={};
            Object.keys(prev).forEach(function(k){next[k]=prev[k];});
            Object.keys(src).forEach(function(k){if(k!=='svg'&&k!=='preview')next[k]=src[k];});
            if(src.preview)next.previewUrl=logoPublicFileUrl(src.preview);
            if(src.svg){
              if(/<svg[\s>]/i.test(String(src.svg)))next.svg=src.svg;
              else next.svgUrl=logoPublicFileUrl(src.svg);
            }
            LOGOCAT[key]=next;
          });
          LOGOCATS=d.categories||[];refreshAfterAssets();
          MT_CATALOGUE_COMPLET=true;   /* greffe 8 bis : le catalogue complet a vraiment été lu */
          return true ;
        }
        return false ;
      }
      fetch(URL_LOGOS,{cache:'no-cache',priority:'low'}).then(function(r){return r.ok?r.json():null;}).then(function(d){
        if(applyCatalog(d))return true;
        throw new Error('manifeste indisponible');
      }).catch(function(){
        return fetch(URL_LOGOS_FALLBACK,{cache:'no-cache',priority:'low'}).then(function(r){return r.ok?r.json():null;}).then(applyCatalog);
      }).then(function(){
        finished();
      }).catch(finished);
    }catch(e){finished();}
  }
  function ensureFullLogos(onReady){
    if(typeof onReady==='function'){
      if(FULL_LOGOS_READY){setTimeout(onReady,0);return;}
      FULL_LOGOS_WAITERS.push(onReady);
    }
    if(!FULL_LOGOS_STARTED)loadLogos();
  }
  function applyRemoteTemplatesIfReady(){
    if(!TEMPLATE_LOGOS_READY||!PENDING_TEMPLATES){
      try{console.log('[MT templates] injection différée — logos prêts:',TEMPLATE_LOGOS_READY,'| catalogue en attente:',!!PENDING_TEMPLATES);}catch(e){}
      return;
    }
    var d=PENDING_TEMPLATES;PENDING_TEMPLATES=null;
    try{console.log('[MT templates] avant application — TEMPLATES:',TEMPLATES.length);}catch(e){}
    if(d&&d.templates)buildTemplatesFrom(d);
    try{console.log('[MT templates] après application — TEMPLATES:',TEMPLATES.length,'| catégories:',OCCASIONS.length);}catch(e){}
    assetSettled('tpl');
  }
  function templateLogoUrlsForRecipe(r){
    var needed=[];
    ((r&&r.elements)||[]).forEach(function(e){if(e&&e.type==='logo'&&e.logo&&!e.svg&&needed.indexOf(e.logo)<0)needed.push(e.logo);});
    if(!needed.length)return [];
    var selected=[],missing=false;
    needed.forEach(function(key){
      var found=false;
      (URL_TEMPLATE_LOGO_KEYS||[]).forEach(function(keys,i){if(Array.isArray(keys)&&keys.indexOf(key)>=0){found=true;if(URL_TEMPLATE_LOGOS[i]&&selected.indexOf(URL_TEMPLATE_LOGOS[i])<0)selected.push(URL_TEMPLATE_LOGOS[i]);}});
      if(!found)missing=true;
    });
    /* Une clé inconnue peut provenir d'un modèle ajouté récemment : repli sûr
       sur les deux morceaux pour ne jamais risquer de perdre son logo. */
    return missing?URL_TEMPLATE_LOGOS.slice():selected;
  }
  function loadTemplateLogos(requestedUrls,requireAll){
    var requestId=++TEMPLATE_LOGOS_REQUEST_ID;
    TEMPLATE_LOGOS_READY=false;
    function done(parts){
      (parts||[]).forEach(function(d){if(d&&d.logos){for(var k in d.logos){if(d.logos.hasOwnProperty(k))LOGOCAT[k]=d.logos[k];}}});
      if(requestId!==TEMPLATE_LOGOS_REQUEST_ID)return;
      TEMPLATE_LOGOS_READY=true;
      if(requireAll)TEMPLATE_LOGOS_ALL_READY=true;
      /* Une recette produit s'affiche avant la fin de ces petits catalogues.
         Redessiner l'éditeur dès que son logo exact devient disponible. */
      refreshAfterAssets();
      applyRemoteTemplatesIfReady();
    }
    var urls=Array.isArray(requestedUrls)?requestedUrls:(requestedUrls?[requestedUrls]:[]);
    urls=urls.filter(function(u){return !!u;});
    if(!urls.length){done([]);return;}
    try{Promise.all(urls.map(function(u){
      if(!TEMPLATE_LOGO_PROMISES[u])TEMPLATE_LOGO_PROMISES[u]=fetch(u,{cache:'force-cache'}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
      return TEMPLATE_LOGO_PROMISES[u];
    })).then(done).catch(function(){done([]);});}
    catch(e){done([]);}
  }
  function ensureAllTemplateLogos(){
    if(TEMPLATE_LOGOS_ALL_READY)return;
    /* 30/09 : avec le selecteur en images, personne ne voit plus les 114 cartes dessinees :
       inutile de telecharger les motifs de tous les modeles (~890 Ko, sans compression).
       Le modele ouvert va chercher les siens (requestTemplateSvgs). */
    if(window.MT_SELECTEUR&&window.MT_SELECTEUR.actif){TEMPLATE_LOGOS_ALL_READY=true;TEMPLATE_LOGOS_READY=true;refreshAfterAssets();applyRemoteTemplatesIfReady();return;}
    TEMPLATE_LOGOS_ALL_READY=true;TEMPLATE_LOGOS_READY=false;
    var fini=function(){TEMPLATE_LOGOS_READY=true;refreshAfterAssets();applyRemoteTemplatesIfReady();};
    try{
      fetch('https://admin.mytomette.fr/save.php?public=template-logos',{cache:'no-cache',credentials:'omit',headers:{'Accept':'application/json'}})
        .then(function(r){return r.ok?r.json():null;})
        .then(function(j){
          var m=j&&j.logos;
          if(m)for(var k in m){if(m.hasOwnProperty(k)&&m[k]&&m[k].svg&&!TPL_SVG_CACHE[k])TPL_SVG_CACHE[k]=m[k].svg;}
          fini();
        }).catch(fini);
    }catch(e){fini();}
  }
  // ====== Polices (fonts.json sur Shopify Files) ======
  /* >>> À METTRE À JOUR après ré-upload de fonts.json : URL avec le bon ?v= <<< */
  var URL_FONTS='https://admin.mytomette.fr/json/fonts.json?v=20261006';
  var FONTDEFS=[
    {id:'Great Vibes',name:'Great Vibes',family:'Great Vibes',weights:'400',category:'manu',clientVisible:true},
    {id:'Allura',name:'Allura',family:'Allura',weights:'400',category:'manu',clientVisible:true},
    {id:'Parisienne',name:'Parisienne',family:'Parisienne',weights:'400',category:'manu',clientVisible:true},
    {id:'Sacramento',name:'Sacramento',family:'Sacramento',weights:'400',category:'manu',clientVisible:true},
    {id:'Dancing Script',name:'Dancing',family:'Dancing Script',weights:'400;500;600;700',category:'manu',clientVisible:true},
    {id:'Pacifico',name:'Pacifico',family:'Pacifico',weights:'400',category:'manu',clientVisible:true},
    {id:'Caveat',name:'Caveat',family:'Caveat',weights:'400;500;600;700',category:'manu',clientVisible:true},
    {id:'Cinzel',name:'Cinzel',family:'Cinzel',weights:'400;700',category:'eleg',clientVisible:true},
    {id:'Marcellus',name:'Marcellus',family:'Marcellus',weights:'400',category:'eleg',clientVisible:true},
    {id:'Amatic SC',name:'Amatic',family:'Amatic SC',weights:'400;700',category:'mod',clientVisible:true},
    {id:'Yellowtail',name:'Yellowtail',family:'Yellowtail',weights:'400',category:'manu',clientVisible:true},
    {id:'Inter',name:'Sans serif',family:'Inter',weights:'400;500;600;700',category:'mod',clientVisible:true},
    {id:'Pinyon Script',name:'Pinyon',family:'Pinyon Script',weights:'400',category:'manu',clientVisible:false}
  ];
  var FONTREG={}, FONTS=[], DEFAULT_FONT='cormorant';
  var FONT_ALIASES=[
    {id:'cormorant',label:'Cormorant',css:"'Cormorant Garamond',serif",grp:'eleg',family:'Cormorant Garamond'},
    {id:'cormorantI',label:'Cormorant it.',css:"'Cormorant Garamond',serif",grp:'eleg',italic:true,family:'Cormorant Garamond'},
    {id:'caveat',label:'Caveat',css:"'Caveat',cursive",grp:'manu',family:'Caveat'},
    {id:'allura',label:'Allura',css:"'Allura',cursive",grp:'manu',family:'Allura'},
    {id:'sacramento',label:'Sacramento',css:"'Sacramento',cursive",grp:'manu',family:'Sacramento'},
    {id:'dmsans',label:'DM Sans',css:"'DM Sans',sans-serif",grp:'mod',family:'DM Sans'},
    {id:'dmcaps',label:'DM Sans caps',css:"'DM Sans',sans-serif",grp:'mod',caps:true,family:'DM Sans'}
  ];
  function fbCss(cat){return cat==='eleg'?'serif':(cat==='mod'?'sans-serif':'cursive');}
  function buildFonts(defs){
    FONTREG={};FONTS=[];
    FONT_ALIASES.forEach(function(a){FONTREG[a.id]=a;});
    (defs||[]).forEach(function(d){
      /* Sans `source`, mteFontSpec() ne reconnait pas une famille Google et se rabat sur
         le TTF Regular de FONT_TTF : Amatic SC demande en 600 sortait gravee en 400.
         Le catalogue integre (FONTDEFS) ne porte pas ce champ -> on le deduit. */
      var _src=d.source||((d.url||d.ttf||d.laser||d.otf)?'url':'google');
      var e={id:d.id,label:d.name||d.id,css:"'"+d.family+"',"+fbCss(d.category),grp:d.category||'manu',family:d.family,weights:d.weights||'400',source:_src,url:d.url,ttf:d.ttf||d.laser||d.otf};
    if(Object.prototype.hasOwnProperty.call(FONTREG,e.id)){
      /* Deux polices declarees avec le meme identifiant dans fonts.json : sans cela le selecteur
         affiche l'une et applique l'autre. Celle dont l'identifiant correspond a sa famille garde
         l'identifiant (les creations deja enregistrees restent valides), l'autre est re-identifiee. */
      var prev=FONTREG[e.id];
      try{console.warn('[MT polices] identifiant en double dans fonts.json :',e.id,'->',prev&&prev.family,'/',e.family);}catch(_e){}
      if(prev&&String(prev.family)===String(e.id)){
        var nid2=e.family||(e.id+'_2'); while(Object.prototype.hasOwnProperty.call(FONTREG,nid2))nid2+='_'; e.id=nid2;
      }else if(prev){
        var nid1=prev.family||(prev.id+'_1'); while(Object.prototype.hasOwnProperty.call(FONTREG,nid1))nid1+='_'; prev.id=nid1; FONTREG[nid1]=prev;
      }
    }
    FONTREG[e.id]=e; if(d.clientVisible)FONTS.push(e);
    });
    ['cormorant','dmsans'].forEach(function(id){if(FONTREG[id])FONTS.push(FONTREG[id]);}); // polices de marque dans le sélecteur
  }
  function fontById(id){return FONTREG[id]||FONTREG[DEFAULT_FONT]||FONTS[0]||{id:'',css:'serif',grp:'eleg'};}
  function defaultWeight(fid){
    if(fid==='caveat'||fid==='dmcaps')return 700;
    if(fid==='cormorant'||fid==='cormorantI'||fid==='dmsans')return 600;
    return 400;
  }
  function injectFaces(defs){
    var css=(defs||[]).filter(function(d){return d.source==='url'&&d.url&&d.clientVisible;}).map(function(d){return "@font-face{font-family:'"+(d.family||d.id)+"';src:url('"+d.url+"');font-display:swap}";}).join('\n');
    var st=document.getElementById('cfFaces'); if(!st){st=document.createElement('style');st.id='cfFaces';document.head.appendChild(st);}
    st.textContent=css;
  }
  var _mtGoogleFontFamilies={}, DISPLAY_FONTS_ALL=false, CURRENT_FONTDEFS=FONTDEFS ;
  function mergeFontWeights(current,incoming){
    var seen={},out=[];
    String(current||'').split(';').concat(String(incoming||'400').split(';')).forEach(function(w){
      w=String(w||'').trim();if(w&&!seen[w]){seen[w]=1;out.push(w);}
    });
    out.sort(function(a,b){return (parseInt(a,10)||0)-(parseInt(b,10)||0);});
    return out.join(';')||'400';
  }
var MT_FONT_FACES_READY=false, _mtFontLinkPending=0;
function _mtIsAscii(s){return /^[\x20-\x7E]*$/.test(String(s||''));}
function _mtSelfHostedFams(){
  var out={};
  (CURRENT_FONTDEFS||[]).forEach(function(d){ if(d&&d.source==='url'&&d.family)out[d.family]=1; });
  return out;
}
function _mtFontLink(id,specs){
  if(!specs.length)return;
  var href='https://fonts.googleapis.com/css2?'+specs.map(function(p){return 'family='+p;}).join('&')+'&display=swap';
  var l=document.getElementById(id);
  if(!l){l=document.createElement('link');l.id=id;l.rel='stylesheet';document.head.appendChild(l);}
  if(l.href===href)return;
  _mtFontLinkPending++;
  var settled=false;
  var settle=function(){ if(settled)return; settled=true; if(--_mtFontLinkPending<=0){_mtFontLinkPending=0;MT_FONT_FACES_READY=true;} };
  l.onload=settle;
  l.onerror=function(){
    settle();
    /* Un lot rejete par Google (famille inconnue ou accentuee) : on le rejoue famille par famille
       pour que la seule fautive soit perdue, pas tout le reste. */
    if(specs.length>1){
      try{l.remove();}catch(e){}
      specs.forEach(function(p,i){ _mtFontLink(id+'_s'+i,[p]); });
    }
  };
  l.href=href;
}
function syncFontLink(){
  var skip=_mtSelfHostedFams(), specs=[], fam;
  for(fam in _mtGoogleFontFamilies){
    if(!_mtGoogleFontFamilies.hasOwnProperty(fam))continue;
    if(skip[fam])continue;      /* police hebergee par nous : jamais demandee a Google */
    if(!_mtIsAscii(fam))continue; /* Google refuse les noms accentues et fait echouer TOUTE la requete */
    specs.push(fam.replace(/ /g,'+')+':wght@'+_mtGoogleFontFamilies[fam]);
  }
  if(!specs.length){MT_FONT_FACES_READY=true;return;}
  specs.sort();
  for(var i=0;i<specs.length;i+=8){ _mtFontLink('mtConfiguratorFonts'+(i?('_'+i):''), specs.slice(i,i+8)); }
}
function applyFontLink(defs,extraFams){
  (defs||[]).forEach(function(d){
    if(d.source==='url'||!d.clientVisible||!d.family)return;
    _mtGoogleFontFamilies[d.family]=mergeFontWeights(_mtGoogleFontFamilies[d.family],d.weights||'400');
  });
  var skip=_mtSelfHostedFams();
  (extraFams||[]).forEach(function(f){ if(f&&!skip[f]&&_mtIsAscii(f))_mtGoogleFontFamilies[f]=mergeFontWeights(_mtGoogleFontFamilies[f],mergeFontWeights('400',TPL_FAMILY_WEIGHTS[f]||'')); });  /* les graisses reelles des modeles, pas seulement 400 */
  syncFontLink();
}
  function ensureCurrentDisplayFonts(){
    if(DISPLAY_FONTS_ALL){applyFontLink(CURRENT_FONTDEFS,TPL_FAMILIES);return;}
    (state.els||[]).forEach(function(e){
      if(!e||e.type!=='text')return;
      var f=fontById(e.font);
      if(!f||f.source==='url'||!f.family)return;
      _mtGoogleFontFamilies[f.family]=mergeFontWeights(_mtGoogleFontFamilies[f.family],e.weight||f.weights||defaultWeight(e.font));
    });
    syncFontLink();
  }
  function ensureAllDisplayFonts(){
    DISPLAY_FONTS_ALL=true;
    applyFontLink(CURRENT_FONTDEFS,TPL_FAMILIES);
  }
  function loadFontsCdn(){
    if(/REMPLACER/.test(URL_FONTS)){ assetSettled('fonts'); return; }
    function fdone(){function ready(){refreshAfterAssets();assetSettled('fonts');}if(document.fonts&&document.fonts.ready){document.fonts.ready.then(ready,ready);}else{ready();}}
    try{fetch(URL_FONTS,{cache:'no-cache'}).then(function(r){return r.ok?r.json():null;}).then(function(d){
      if(d&&d.fonts){CURRENT_FONTDEFS=d.fonts;buildFonts(d.fonts);injectFaces(d.fonts);if(DISPLAY_FONTS_ALL)ensureAllDisplayFonts();else ensureCurrentDisplayFonts();}
      fdone();
    }).catch(function(){ fdone(); });}catch(e){ fdone(); }
  }

  /* Catalogue public des modèles. La route save.php est prioritaire afin de
     garantir les en-têtes CORS ; l'ancien fichier JSON reste une réplique compatible. */
  /* Bundle client pré-généré, servi en statique : ~38 Ko gzip, ~30 ms, aucun PHP.
     La route save.php le régénère à chaque appel et dépasse la limite de temps
     du serveur au-delà d'une cinquantaine de modèles -> gardée en secours seulement.
     Le statique exige un en-tête CORS (voir /json/.htaccess). */
  var URL_TEMPLATES='https://admin.mytomette.fr/save.php?public=templates';
  var URL_TEMPLATES_FALLBACK='https://admin.mytomette.fr/json/templates-client.json';
  var TPLFULL={
    shopifyCategories:[
      {id:'maison',name:'Maison',emoji:'🏡'},{id:'mariage',name:'Mariage',emoji:'💍'},
      {id:'naissance',name:'Naissance',emoji:'👶'},{id:'apero',name:'Apéro',emoji:'🍷'},
      {id:'pro',name:'Pro',emoji:'🏢'},{id:'famille',name:'Famille',emoji:'👨‍👩‍👧'}
    ],
    templates:{
      "papi_amour":{name:"💕 Papi d'Amour",shopifyCategory:"famille",elements:[
        {type:"text",text:"Papi",x:0.5,y:0.19,font:"Caveat",size:50},
        {type:"text",text:"d'Amour",x:0.5,y:0.34,font:"Allura",size:42},
        {type:"logo",logo:"heart",x:0.5,y:0.49,size:50},
        {type:"text",text:"Juliette",x:0.5,y:0.63,font:"Inter",size:18,letterSpacing:200},
        {type:"text",text:"Valentina",x:0.5,y:0.73,font:"Inter",size:18,letterSpacing:200},
        {type:"text",text:"Anaïs",x:0.5,y:0.83,font:"Inter",size:18,letterSpacing:200}]},
      "maison_bonheur":{name:"🏡 Maison du bonheur",shopifyCategory:"maison",elements:[
        {type:"text",text:"La Maison",x:0.5,y:0.32,font:"Sacramento",size:48},
        {type:"text",text:"du Bonheur",x:0.5,y:0.52,font:"Sacramento",size:48},
        {type:"logo",logo:"palm",x:0.5,y:0.76,size:55}]},
      "lieu_coeur":{name:"📍 Hyères ❤",shopifyCategory:"maison",elements:[
        {type:"text",text:"Hyères",x:0.5,y:0.42,font:"Pinyon Script",size:56},
        {type:"logo",logo:"heart",x:0.66,y:0.66,size:40}]},
      "dolce_vita":{name:"🌿 La Dolce Vita",shopifyCategory:"maison",elements:[
        {type:"text",text:"La",x:0.5,y:0.23,font:"Allura",size:38},
        {type:"text",text:"Dolce",x:0.5,y:0.47,font:"Allura",size:58},
        {type:"text",text:"Vita",x:0.5,y:0.74,font:"Allura",size:58}]},
      "mariage":{name:"💍 Mariage",shopifyCategory:"mariage",elements:[
        {type:"text",text:"Marie",x:0.5,y:0.26,font:"Great Vibes",size:50},
        {type:"text",text:"&",x:0.5,y:0.45,font:"Sacramento",size:38},
        {type:"text",text:"Pierre",x:0.5,y:0.62,font:"Great Vibes",size:50},
        {type:"logo",logo:"heart_outline",x:0.5,y:0.79,size:28},
        {type:"text",text:"15 · 06 · 2024",x:0.5,y:0.91,font:"Inter",size:13,letterSpacing:200}]},
      "naissance":{name:"👶 Naissance",shopifyCategory:"naissance",elements:[
        {type:"logo",logo:"star",x:0.5,y:0.19,size:38},
        {type:"text",text:"Léa",x:0.5,y:0.46,font:"Parisienne",size:62},
        {type:"text",text:"née le 3 mai 2024",x:0.5,y:0.69,font:"Caveat",size:24},
        {type:"text",text:"3,4 kg · 51 cm",x:0.5,y:0.83,font:"Inter",size:13,letterSpacing:200}]},
      "voyage_gps":{name:"✈️ Souvenir voyage",shopifyCategory:"famille",elements:[
        {type:"logo",logo:"palm",x:0.5,y:0.20,size:50},
        {type:"text",text:"Bali",x:0.5,y:0.51,font:"Yellowtail",size:60},
        {type:"text",text:"8.4095° S",x:0.5,y:0.74,font:"Inter",size:14,letterSpacing:200},
        {type:"text",text:"115.1889° E",x:0.5,y:0.83,font:"Inter",size:14,letterSpacing:200}]},
      "famille":{name:"👨‍👩‍👧 Famille",shopifyCategory:"famille",elements:[
        {type:"text",text:"Famille",x:0.5,y:0.25,font:"Caveat",size:30},
        {type:"text",text:"Dupont",x:0.5,y:0.49,font:"Parisienne",size:58},
        {type:"logo",logo:"olive",x:0.5,y:0.75,size:55}]}
    }
  };
  var TEMPLATES=[], OCCASIONS=[], TPL_FAMILIES=[], TPL_FAMILY_WEIGHTS={};
  /* Nom de modèle nettoyé : retire un préfixe technique 'IA —' / 'IA -' / 'IA_' (non pro côté client). */
  function cleanTplName(n){ return (String(n||'').replace(/^\s*IA\s*[—–\-_:·]?\s*/i,'').trim()) || 'Modèle'; }
  /* Valeurs d'EXEMPLE pour les variables génériques (le libellé du champ reste 'Prénom' etc.,
     mais l'illustration montre un exemple concret). Une variable déjà spécifique ($Léa$) est gardée. */
  var VAR_EXAMPLES={'prénom':'Juliette','prenom':'Juliette','prénoms':'Emma & Louis','prenoms':'Emma & Louis',
    'nom':'Martin','nom de famille':'Martin','date':'3 juillet 2026','jour':'Samedi','année':'2026','annee':'2026',
    'poids':'3,2 kg','taille':'50 cm','heure':'14h32','lieu':'Hyères','ville':'Hyères','pays':'France','région':'Provence','region':'Provence',
    'gps':'43.12°N · 6.13°E','coordonnées':'43.12°N · 6.13°E','coordonnees':'43.12°N · 6.13°E',
    'message':'Notre plus belle histoire','mot':'Je t’aime','petit mot':'Je t’aime','texte':'Votre texte','titre':'Notre histoire',
    'âge':'30 ans','age':'30 ans','prénom1':'Emma','prenom1':'Emma','prénom2':'Louis','prenom2':'Louis'};
  function exampleForVar(nm){ var k=String(nm||'').trim().toLowerCase(); return (VAR_EXAMPLES[k]!=null)?VAR_EXAMPLES[k]:String(nm||'').trim(); }
  function exampleVars(s){
    if(s==null)return s;
    return String(s)
      .replace(/\\\$/g,'\u0000')
      .replace(/\$([^$\n]+)\$/g,function(m,nm){return exampleForVar(nm);}).replace(/[\[\]]/g,'')
      .replace(/\u0000/g,'$').replace(/ {2,}/g,' ').trim();
  }
  function buildTemplatesFrom(data){
    if(data&&data.assets){TPL_ASSETS=data.assets;try{console.log('[MT templates] SVG de modèles disponibles :',Object.keys(TPL_ASSETS).length,'(chargés à la demande)');}catch(e){}}                      /* svgRef -> template-assets/svg/tpl_xxx.svg */
    TEMPLATES=[];var cats=(data.shopifyCategories||[]);var lab={},catValid={};
    cats.forEach(function(c){lab[c.id]=(c.emoji?c.emoji+' ':'')+window.MT_CONFIG_I18N.label(c.name);catValid[c.id]=true;});
    var tpls=data.templates||{};var fams={},key,usedAdef=false;TPL_FAMILY_WEIGHTS={};
    for(key in tpls){ if(!tpls.hasOwnProperty(key))continue;
      /* LA CLÉ « blank » N'EST PAS TOUJOURS UNE PLACE VIDE.

         On la sautait sans regarder, par crainte d'une collision avec la
         carte « Page blanche ». Or celle-ci est construite à part, dans
         buildInsp, et ne vient jamais des données : la garde ne
         protégeait rien. Elle cachait en revanche un vrai modèle rangé
         sous cette clé — « Tu seras à jamais mon toujours », visible,
         classé premier dans l'admin, et que personne n'a jamais vu.

         On ne saute donc plus que ce qui est réellement vide. */
      if(key==='blank'&&!(((tpls[key]||{}).elements)||[]).length)continue;
      var t=tpls[key];
      if(t.clientVisible===false)continue;                            /* (1) désactivé dans l'admin -> jamais affiché */
      var occ=t.shopifyCategory;
      if(!occ||!catValid[occ]){ occ='adefinir'; usedAdef=true; }       /* (3) pas de catégorie valide -> "À définir" */
      var els=(t.elements||[]).map(function(e){
        var b={x:(e.x!=null?e.x:0.5),y:(e.y!=null?e.y:0.5),size:(e.size||40)/5};
        if(e.type==='logo'){b.type='icon';b.icon=e.logo;if(e.svg)b.svg=e.svg;if(e.svgRef)b.svgRef=e.svgRef;if(e.flip)b.flip=true;
             if(e.stroke!=null&&isFinite(+e.stroke))b.stroke=+e.stroke;}
        else{b.type='text';b.text=exampleVars(e.text||'');b.font=e.font||DEFAULT_FONT;if(e.letterSpacing)b.ls=e.letterSpacing/1000;  /* (4) variables -> exemple */
             /* 30/09 : la lecture ne gardait que position, taille, police et espacement. Graisse, courbure,
                petites capitales (et interligne, alignement) sautaient : « Si tu n'as pas de... » s'affichait
                droit et fin, 57 modeles publics s'affichaient autrement qu'a leur creation. Memes champs et
                memes unites que la recette (loadRecipe) et que l'admin (edRecipe). */
             if(e.weight!=null&&isFinite(+e.weight))b.weight=+e.weight;
             if(e.curve&&isFinite(+e.curve))b.curve=+e.curve;
             if(e.smallcaps)b.smallcaps=true;
             if(e.lh&&isFinite(+e.lh))b.lh=+e.lh;
             if(e.align&&e.align!=='center')b.align=e.align;
             var fr=FONTREG[b.font];if(fr&&fr.family){fams[fr.family]=1;if(b.weight)TPL_FAMILY_WEIGHTS[fr.family]=mergeFontWeights(TPL_FAMILY_WEIGHTS[fr.family],String(b.weight));}}
        if(e.rot&&normRot(e.rot))b.rot=normRot(e.rot);
        return b;
      });
      var o=t.options||{};
      var ashapes=(Array.isArray(o.shapes)&&o.shapes.length?o.shapes:['hexa','carree']).filter(function(x){return x==='hexa'||x==='carree';});
      if(!ashapes.length)ashapes=['hexa','carree'];
      var aholes=(Array.isArray(o.holes)&&o.holes.length?o.holes:['plein','perce']);
      var aPlein=aholes.indexOf('plein')>=0, aPerce=aholes.indexOf('perce')>=0;
      if(!aPlein&&!aPerce){aPlein=true;aPerce=true;}
      var dShape=(o.defaultShape&&ashapes.indexOf(o.defaultShape)>=0)?o.defaultShape:ashapes[0];
      var dHole=(o.defaultHole==='perce')&&aPerce; if(!aPlein&&aPerce)dHole=true;
      TEMPLATES.push({id:key,ord:(typeof t.order==='number'?t.order:1e9),name:cleanTplName(t.name||key),occ:occ,badge:(lab[occ]||(occ==='adefinir'?window.MT_CONFIG_I18N.label('À définir'):'')),badgeCls:'',shape:dShape,defaultHole:dHole,allowShapes:ashapes,allowPlein:aPlein,allowPerce:aPerce,els:els});  /* (2) nom sans 'IA —' */
    }
    /* L'ORDRE VIENT DE L'ADMIN, et personne ne le lisait.

       Chaque gabarit porte un champ « order » que l'admin réécrit à
       chaque glisser-déposer. Mais on parcourait data.templates avec un
       for…in : l'ordre obtenu était celui des clés du JSON, qui n'a
       aucune raison d'y correspondre — vérifié, les deux listes
       divergent dès le deuxième modèle. Classer ses modèles dans l'admin
       n'avait donc aucun effet à l'écran.

       Un tri suffit, et il gouverne aussi bien le carrousel que la vue
       en grille, qui parcourent tous deux ce tableau. Les gabarits sans
       « order » — importés hors admin — partent à la fin plutôt qu'au
       hasard. */
    TEMPLATES.sort(function(a,b){return a.ord-b.ord;});
    OCCASIONS=[['all',window.MT_CONFIG_I18N.label('Tous')]];cats.forEach(function(c){OCCASIONS.push([c.id,(c.emoji?c.emoji+' ':'')+window.MT_CONFIG_I18N.label(c.name)]);});
    if(usedAdef)OCCASIONS.push(['adefinir',window.MT_CONFIG_I18N.label('À définir')]);              /* onglet "À définir" seulement s'il contient des modèles */
    TPL_FAMILIES=[];for(var f in fams){if(fams.hasOwnProperty(f))TPL_FAMILIES.push(f);}
  }
  function loadTemplatesCdn(){
    if(/REMPLACER/.test(URL_TEMPLATES)){ PENDING_TEMPLATES=TPLFULL;applyRemoteTemplatesIfReady();return; }
    function validTemplates(d){
      return !!(d&&d.templates&&typeof d.templates==='object'&&Object.keys(d.templates).length);
    }
    function requestTemplates(url){
      try{console.log('[MT templates] URL',url);}catch(e){}
      return fetch(url,{cache:'no-cache',credentials:'omit',headers:{'Accept':'application/json'}}).then(function(r){
        if(!r.ok)throw new Error('HTTP '+r.status+' — '+url);
        return r.json();
      }).then(function(d){
        try{console.log('[MT templates] réponse',url,'| clés JSON',Object.keys(d||{}));}catch(e){}
        if(!validTemplates(d))throw new Error('Catalogue de modèles vide ou invalide — '+url);
        try{console.log('[MT templates] catalogue extrait',Object.keys(d.templates).length,'modèles');}catch(e){}
        return d;
      });
    }
    try{
      requestTemplates(URL_TEMPLATES).catch(function(err){
        try{console.warn('[MyTomette] Route publique des modèles indisponibles, réplique historique.',err);}catch(e){}
        return requestTemplates(URL_TEMPLATES_FALLBACK);
      }).then(function(d){
        PENDING_TEMPLATES=d;
        applyRemoteTemplatesIfReady();
        try{console.info('[MyTomette] Modèles distants chargés : '+Object.keys(d.templates).length);}catch(e){}
      }).catch(function(err){
        try{console.error('[MyTomette] Catalogue distant des modèles indisponibles.',err);}catch(e){}
        PENDING_TEMPLATES=TPLFULL;
        applyRemoteTemplatesIfReady();
      });
    }catch(e){
      try{console.error('[MyTomette] Erreur au démarrage du chargement des modèles.',e);}catch(_e){}
      PENDING_TEMPLATES=TPLFULL;
      applyRemoteTemplatesIfReady();
    }
  }
  function ensureRemoteTemplates(){
    if(REMOTE_TEMPLATES_STARTED)return;
    REMOTE_TEMPLATES_STARTED=true;
    loadTemplatesCdn();
  }

  var SHAPES = {
    hexa:{label:'Hexagonale', dim:'12 × 10 cm', cls:'hex', price:18.90, wcm:12, hcm:10},
    carree:{label:'Carrée', dim:'13 × 13 cm', cls:'sq', price:24.90, wcm:13, hcm:13}
  };
  var HOLE_FEE=3;
  var GIFT_FEE=4;
  /* Vrais prix des variantes transmis par la fiche produit (recette.prices = {"forme|trou":prix}).
     Absents -> repli sur les prix ci-dessus (SHAPES.price / HOLE_FEE). */
  var CFG_PRICES=null;
  /* TOMETTE PHOTO — greffe 1 (10/2026, Lot 0). Une pièce qui porte une photo (élément
     custom_photo, ou custom_photo_demo pour l'exemple) se paie au prix du produit photo, lu dans
     MT_PHOTO_EXPERT_CFG.prix (snippets/mt-photo-expert.liquid). On ne touche PAS à CFG_PRICES :
     le poser passerait par loadRecipe(prices), qui vide l'historique, et le prix photo resterait
     collé au modèle suivant. Ici le prix suit le contenu de la pièce à chaque calcul : updatePrice,
     puces de format, total, bouton du panier, prix-format.js. Fiche photo (state.photoProduct) :
     inchangé. Sans réglages photo : CFG_PRICES, comme avant. */
  function mtIsPhotoState(st,demoOnly){var a=(st&&st.els)||[];for(var i=0;i<a.length;i++){var e=a[i];if(e&&e.type==='icon'&&(e.icon==='custom_photo_demo'||(!demoOnly&&e.icon==='custom_photo')))return true;}return false;}
  function mtPriceTable(){if(state&&!state.photoProduct&&mtIsPhotoState(state)){var c=window.MT_PHOTO_EXPERT_CFG;if(c&&c.prix&&c.prix['hexa|0']!=null)return c.prix;}return CFG_PRICES;}
  /* CARTE GRAVÉE — greffe F5 (10/2026, Lot 0). Le FOND d'une pièce (la carte : élément custom_map dont
     le SVG porte data-mt-fond sur sa balise <svg>) est garanti par le MOTEUR, que le module carte tourne
     ou non : contexte inerte, module en 404, création « pour un client » (critique B1). `lock` seul ne
     suffisait pas : l'élément restait sélectionnable, 🔓 le libérait, et la graisse 2,2 ajoutait par
     thickenSvg un trait de ≈ 1,9 mm autour de chaque rue — une tache, et des traits dans le fichier
     laser. Ici : un fond ne se sélectionne pas, ne se déverrouille pas, ne s'épaissit pas, et il est
     posé centré (x = y = 0,5), à la taille du fond — max(W,H)/1,2, soit l'échelle 1 dans buildLaserSVG :
     le viewBox en mm = les mm gravés —, sans rotation ni miroir, graisse 1,7, à l'écran (render) comme
     au fichier laser et à l'aperçu (sur une COPIE, quel que soit src). Une seule carte par pièce : s'il
     y en a plusieurs, la dernière. On la reconnaît à data-mt-fond, jamais à son id. Le filet du gabarit
     (custom_filet, trait de 0,42 mm) garde la graisse 1,7 et au moins 75 % de sa taille posée, lue
     dans son viewBox en mm : à 75 %, son trait fait encore 0,315 mm (plancher laser 0,30). */
  var MT_FOND_RE=/^\s*<svg\b[^>]*\sdata-mt-fond=/;
  function mtEstFond(e){return !!(e&&e.type!=='text'&&typeof e.svg==='string'&&MT_FOND_RE.test(e.svg));}
  function mtHasFond(st){var a=(st&&st.els)||[];for(var i=0;i<a.length;i++){if(mtEstFond(a[i]))return true;}return false;}
  function mtFondTaille(shapeKey){var sh=SHAPES[shapeKey]||SHAPES.hexa;return Math.max(sh.wcm,sh.hcm)*10/1.2;}
  function mtEstFilet(e){return !!(e&&e.type!=='text'&&(e.icon||e.logo)==='custom_filet'&&typeof e.svg==='string');}
  function mtFiletMin(e){var b=logoBoxOf(e.svg);return Math.round(0.75*Math.max(b.w,b.h)/1.2*100)/100;}
  function mtFondPose(e,shapeKey){e.x=0.5;e.y=0.5;e.size=mtFondTaille(shapeKey);e.lock=true;delete e.rot;delete e.flip;delete e.stroke;return e;}
  function mtCopie(e){var c={};for(var k in e){if(Object.prototype.hasOwnProperty.call(e,k))c[k]=e[k];}return c;}
  /* Relecture du 15/10 : une carte n'est gravée que sur la forme pour laquelle elle a été dessinée.
     Posée sur l'autre forme (bouton « Carrée » sur une carte hexagonale, sans redessin), buildLaserSVG
     l'étirait (scale 1,0833 ou 0,9231) : les réserves, calculées dans le repère de la carte, tombaient
     à côté des textes (lettres gravées sur les rues), et une carte de carreau débordait de la tomette.
     « Accordée » = viewBox 0 0 W H de la forme (à 0,05 mm près) et data-mtcx-forme, s'il existe, égal
     à la forme. Une carte non accordée reste à l'écran, mais aucun fichier laser n'est produit. */
  function mtFondVb(e){
    var head=(String(e&&e.svg||'').match(/^\s*<svg\b[^>]*>/)||[''])[0];
    var vb=head.match(/\sviewBox\s*=\s*["']\s*([-\d.eE]+)[\s,]+([-\d.eE]+)[\s,]+([-\d.eE]+)[\s,]+([-\d.eE]+)\s*["']/);
    var fm=head.match(/\sdata-mtcx-forme="([^"]*)"/);
    return {x:vb?parseFloat(vb[1]):NaN,y:vb?parseFloat(vb[2]):NaN,w:vb?parseFloat(vb[3]):NaN,h:vb?parseFloat(vb[4]):NaN,forme:fm?fm[1]:null};
  }
  function mtFondDernier(src){var a=(src&&src.els)||[],f=null;for(var i=0;i<a.length;i++)if(mtEstFond(a[i]))f=a[i];return f;}
  function mtFondAccorde(src){
    src=src||state;var f=mtFondDernier(src);if(!f)return true;
    var sh=SHAPES[src.shape]||SHAPES.hexa,b=mtFondVb(f),T=0.05;
    if(b.forme!=null&&b.forme!==(SHAPES[src.shape]?src.shape:'hexa'))return false;
    return Math.abs(b.x)<=T&&Math.abs(b.y)<=T&&Math.abs(b.w-sh.wcm*10)<=T&&Math.abs(b.h-sh.hcm*10)<=T;
  }
  /* CIEL — greffe G1 (2026, Lot 0-ciel). Le fond n'est plus seulement une carte : un ciel (custom_ciel,
     data-mt-fond="ciel") est un fond au même titre. Tout ce que F1 à F8 font pour « un fond » vaut pour lui ;
     ce qui portait encore le mot « carte » (propriétés de panier, reprise, messages, événements) suit
     désormais le TYPE, lu ici sur la balise <svg> du dernier fond. Pour une carte, rien ne change. */
  function mtFondType(e){var m=String(e&&e.svg||'').match(/^\s*<svg\b[^>]*\sdata-mt-fond="([a-z]+)"/);return m?m[1]:'';}
  function mtFondTypeDe(src){return mtFondType(mtFondDernier(src||state));}
  /* pour l'export : une copie des éléments, fond forcé (graisse 1,7 explicite), filet borné ; l'état n'est pas touché */
  function mtFondEls(els,shapeKey){
    var a=els||[],der=-1,i,out=[];
    for(i=0;i<a.length;i++)if(mtEstFond(a[i]))der=i;
    for(i=0;i<a.length;i++){var e=a[i];
      if(mtEstFond(e)){if(i!==der)continue;var c=mtFondPose(mtCopie(e),shapeKey);c.stroke=1.7;out.push(c);continue;}
      if(mtEstFilet(e)){var f=mtCopie(e),mn=mtFiletMin(f);f.stroke=1.7;if(!(f.size>=mn))f.size=mn;out.push(f);continue;}
      out.push(e);
    }
    return out;
  }
  /* à l'écran : l'état lui-même, à chaque render(), sans entrée d'historique. Le fond passe en tête de
     state.els (dessous de tout) ; renvoie vrai si la pièce porte un fond. */
  function mtFondFige(st){
    var a=st&&st.els;if(!a||!a.length)return false;
    var der=-1,i;
    for(i=0;i<a.length;i++){var e=a[i];
      if(mtEstFond(e))der=i;
      else if(mtEstFilet(e)){var mn=mtFiletMin(e);delete e.stroke;if(!(e.size>=mn))e.size=mn;}
    }
    if(der<0)return false;
    var fond=a[der];
    for(i=a.length-1;i>=0;i--){if(mtEstFond(a[i])&&i!==der){try{console.warn('[carte] plusieurs fonds sur la pièce : seul le dernier est gardé');}catch(_){}if(String(st.sel)===String(a[i].id))st.sel=null;a.splice(i,1);}}
    i=a.indexOf(fond);if(i>0){a.splice(i,1);a.unshift(fond);}
    mtFondPose(fond,st.shape);
    if(String(st.sel)===String(fond.id))st.sel=null;
    try{var g=window.__MT_FOND_EXPORT__;if(g&&typeof g.prechauffer==='function')g.prechauffer();}catch(_){}
    return true;
  }
  function priceShape(shapeKey){
    var P=mtPriceTable();
    if(P){ var p0=P[shapeKey+'|0']; if(p0!=null)return p0;
           var p1=P[shapeKey+'|1']; if(p1!=null)return Math.max(0,p1-HOLE_FEE); }
    return (SHAPES[shapeKey]||SHAPES.hexa).price;
  }
  function holeFeeFor(shapeKey){
    var P=mtPriceTable();
    if(P){ var p0=P[shapeKey+'|0'],p1=P[shapeKey+'|1']; if(p0!=null&&p1!=null)return Math.max(0,Math.round((p1-p0)*100)/100); }
    return HOLE_FEE;
  }
  function eur(n){ n=Math.round(n*100)/100; return (Math.abs(n-Math.round(n))<0.005)?String(Math.round(n)):n.toFixed(2).replace('.',','); }
  // UI only: production/email payloads retain the canonical formatter above.
  function displayEuro(n){
    if(/^en/i.test(window.MT_CONFIG_I18N.locale || '')){
      try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:'EUR',minimumFractionDigits:2,maximumFractionDigits:2}).format(n);}
      catch(e){return '€'+Number(n).toFixed(2);}
    }
    return eur(n)+'€';
  }
  var SIZE_REF=12; // la taille stockée est physique (référence = tomette 12 cm)
  /* Face terre cuite dans la photo carree (bornes figees, mesurees sur --tom-photo-sq). Le carre a une
     marge (~6%) autour de la face -> on mappe la gravure sur la FACE (comme le SVG), pas sur la boite. */
  var MT_SQFACE={x0:0.0583,y0:0.0575,x1:0.9333,y1:0.9325};
  /* Les photos carrees sont maintenant recadrees sur MT_SQFACE avant dessin : la face
     physique 13 x 13 occupe donc tout le canvas, comme l'hexagone. */
  function mtFace(sq,W,H){ return {ox:0,oy:0,fw:W,fh:H}; }
  function renderSize(item){ return Math.round((item.size||6)*(SIZE_REF/SHAPES[state.shape].wcm)*100)/100; }
  function sizeBounds(item){
    if(mtEstFond(item)){var tf=mtFondTaille(state.shape);return {min:tf,max:tf};}   // greffe F5 : le fond garde sa taille
    if(item && item.type==='icon'){
      var l = item.icon ? LOGOCAT[item.icon] : null;
      var mn = (l && +l.minSize) ? +l.minSize/5 : 2;
      if(mtEstFilet(item))mn=Math.max(mn,mtFiletMin(item));                      // greffe F5 : le filet reste gravable
      var mx = (l && +l.maxSize) ? +l.maxSize/5 : 100;
      if(mx < mn+0.5) mx = mn+0.5;
      return {min:mn, max:mx};
    }
    return {min:2, max:60};
  }

  // ---- state ----
  var uid=1;
  var state={shape:'hexa', hole:false, allowShapes:['hexa','carree'], allowPlein:true, allowPerce:true, els:[], sel:null, tmpl:null, gift:{on:false,wrap:false,msg:'',ship:false}};
  var qtyMult=1, qtyCount=1;
  var pinching=false;
  var tutoSeen=false;
  var COARSE=!!(window.matchMedia&&window.matchMedia('(pointer:coarse)').matches); // true = tactile, false = souris
  try{document.documentElement.classList.add(COARSE?'is-touch':'is-mouse');}catch(e){}
  try{var _ast=document.querySelector('.rail .help');if(_ast)_ast.innerHTML='✍️ <b>Astuce</b> — '+(COARSE?window.MT_CONFIG_I18N.text("ui_a94bdb1b542d_html", "tapez deux fois sur un texte pour le réécrire, et glissez pour le placer."):window.MT_CONFIG_I18N.text("ui_397552097c16_html", "double-cliquez un texte pour le réécrire ; sélectionnez un élément puis les flèches du clavier pour le placer au millimètre."));}catch(e){}
  var _mtSavedRecipe='', _mtPhotoResumePending=false, _mtPricesBeforePhoto=null;
  var history=[], redoStack=[];

  function snapshot(){return JSON.stringify({shape:state.shape,hole:state.hole,els:state.els});}
  var histLabels=[], redoLabels=[];
  function pushHistory(lbl){history.push(snapshot());histLabels.push(lbl||'modification');if(history.length>40){history.shift();histLabels.shift();}redoStack=[];redoLabels=[];updateUndo();}
  function updateUndo(){
    var uT=window.MT_CONFIG_I18N.text("ui_46ad3916f6a0_html", "Annuler")+(histLabels.length?' : '+histLabels[histLabels.length-1]:'');
    var rT=window.MT_CONFIG_I18N.text("ui_4cf3fd72da6f_html", "Rétablir")+(redoLabels.length?' : '+redoLabels[redoLabels.length-1]:'');
    ['undoBtn','undoTop'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=history.length===0;b.title=uT;}});
    ['redoBtn','redoTop'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=redoStack.length===0;b.title=rT;}});
  }
  function restore(s){var o=JSON.parse(s);state.shape=o.shape;state.hole=o.hole;state.els=o.els;state.sel=null;syncShapeUI();render();updatePrice();}

  // ---- helpers ----
  function el(tag,cls){var e=document.createElement(tag);if(cls)e.className=cls;return e;}
  function clamp(v,a,b){return v<a?a:(v>b?b:v);}
  function stripVars(s){
    if(MT_ADMIN) return s;   /* admin : les $variables$ et [segments] restent tels quels */
    if(s==null) return s;
    return String(s)
      .replace(/\\\$/g,'\u0000')          // protege un dollar litteral \$
      .replace(/\$([^$\n]+)\$/g,'$1').replace(/[\[\]]/g,'')      // $Martin$ -> Martin
      .replace(/\u0000/g,'$');             // restaure les dollars litteraux
  }
  /* TOMETTE PHOTO — greffe 4a (10/2026, Lot 0). syncGrey recopie #stack dans #stackEngrave et
     #stackGrey à CHAQUE mouvement d'un glisser : sérialiser puis reparser deux fois tout le contenu.
     Avec une photo (≈ 300 Ko de SVG, 2 000 contours et plus), ce travail domine le glisser d'un texte
     posé par-dessus. Le nœud photo ne change pourtant jamais pendant un geste. On le clone donc UNE
     fois par calque et on le garde en place ; seuls les autres nœuds sont recopiés, comme avant, et
     les attributs du conteneur et du SVG photo (position, z-index, classes, style) sont recopiés à
     l'identique. Le clone est refait dès que le moteur reconstruit #stack (render). Sans photo : le
     code d'origine, qui oublie en plus le clone gardé. */
  /* CARTE GRAVÉE — greffe F2 (10/2026, Lot 0) : le fond (data-mt-fond) profite du même clone que la photo. */
  function _mtpxNoeudPhoto(s){var k=s.children;for(var i=0;i<k.length;i++){var f=k[i].firstElementChild;if(f&&f.hasAttribute&&(f.hasAttribute('data-mtp-cadre')||f.hasAttribute('data-mt-fond')))return k[i];}return null;}
  function _mtpxCopieAttributs(de,vers){
    var a=de.attributes,i;for(i=0;i<a.length;i++){if(vers.getAttribute(a[i].name)!==a[i].value)vers.setAttribute(a[i].name,a[i].value);}
    var b=vers.attributes;for(i=b.length-1;i>=0;i--){if(!de.hasAttribute(b[i].name))vers.removeAttribute(b[i].name);}
  }
  function syncGrey(){
    var s=document.getElementById('stack');
    if(!s)return;
    var ph=_mtpxNoeudPhoto(s);
    if(!ph){
    var html=s.innerHTML;
    ['stackEngrave','stackGrey'].forEach(function(id){
      var layer=document.getElementById(id);if(!layer)return;
      layer._mtpxPhoto=null;
      layer.innerHTML=html;
      var sel=layer.querySelector('.sel'); if(sel)sel.classList.remove('sel');
    });
    }else{
      var avant='',apres='',vu=false,k=s.children;
      for(var i=0;i<k.length;i++){if(k[i]===ph){vu=true;continue;}if(vu)apres+=k[i].outerHTML;else avant+=k[i].outerHTML;}
      ['stackEngrave','stackGrey'].forEach(function(id){
        var layer=document.getElementById(id);if(!layer)return;
        var c=layer._mtpxPhoto;
        if(!c||c.src!==ph.firstElementChild||c.noeud.parentNode!==layer){c=layer._mtpxPhoto={src:ph.firstElementChild,noeud:ph.cloneNode(true)};}
        _mtpxCopieAttributs(ph,c.noeud);
        if(c.noeud.firstElementChild)_mtpxCopieAttributs(ph.firstElementChild,c.noeud.firstElementChild);
        for(var n=layer.firstChild;n;){var nx=n.nextSibling;if(n!==c.noeud)layer.removeChild(n);n=nx;}
        if(c.noeud.parentNode!==layer)layer.appendChild(c.noeud);
        var t=document.createElement('template');
        if(avant){t.innerHTML=avant;layer.insertBefore(t.content,c.noeud);}
        if(apres){t.innerHTML=apres;layer.appendChild(t.content);}
        var sel=layer.querySelector('.sel'); if(sel)sel.classList.remove('sel');
      });
    }
    if(typeof scheduleLive==='function')scheduleLive();
  }
  // centres des trous (fraction de la tomette) selon la forme
  function holeCenters(shp){
    var sh=SHAPES[shp||state.shape];
    if(sh.cls==='sq'){
      // deux trous, un dans chaque coin haut, à 1,5 cm des bords
      return [{x:1.5/sh.wcm, y:1.5/sh.hcm},{x:1-1.5/sh.wcm, y:1.5/sh.hcm}];
    }
    // hexagone : un trou, en haut au centre, à 1,5 cm du bord
    return [{x:0.5, y:1.5/sh.hcm}];
  }
  function applyHole(wrap, on, shp){
    if(!wrap)return;
    var olds=wrap.querySelectorAll('.hole-window');
    for(var k=0;k<olds.length;k++){if(olds[k].parentNode)olds[k].parentNode.removeChild(olds[k]);}
    if(!on)return;
    var sh=SHAPES[shp||state.shape], centers=holeCenters(shp||state.shape);
    for(var i=0;i<centers.length;i++){
      var d=document.createElement('div');d.className='hole-window';
      d.style.width=(0.4/sh.wcm*100)+'%';          /* trou Ø 4 mm */
      d.style.left=(centers[i].x*100)+'%';
      d.style.top=(centers[i].y*100)+'%';
      wrap.appendChild(d);
    }
  }
  var _hcv=document.createElement('canvas'), _hcx=_hcv.getContext('2d');
  function _canvasFont(item,fpx){
    var f=fontById(item.font||'cormorant');
    var fam=f.italic?"'Cormorant Garamond',serif":f.css;
    var wt=(item.weight||defaultWeight(item.font||'cormorant'));
    return (f.italic?'italic ':'')+wt+' '+fpx+'px '+fam;
  }
  function usableWidthFrac(x,y,shapeKey){
    x=(x!=null?x:0.5); y=(y!=null?y:0.5);
    var sh=SHAPES[shapeKey||state.shape]||SHAPES.hexa;
    var edge=2*Math.min(x,1-x);                 // largeur dispo G/D pour une boîte centrée en x
    if(sh.cls==='sq'){
      return Math.max(0.2, Math.min(0.97, edge*0.985));   // carré : quasi bord à bord
    }
    var hexW=1-Math.abs(y-0.5);                 // largeur réelle de l'hexagone à cette hauteur
    return Math.max(0.2, Math.min(hexW*0.96, edge*0.96));  // hexagone : suit la pente
  }
  /* =====================================================================
     MISE EN PAGE DU TEXTE — fonction UNIQUE partagee par TOUS les rendus :
     apercu DOM, canvas de la photo, calque de gravure, test de collision avec
     le trou, et SVG envoye au laser.
     Regle : le texte reste sur les lignes voulues -- SEULS les retours a la
     ligne saisis a la main coupent le texte. Si le bloc deborde (ligne trop
     large, ou hauteur superieure a la place disponible), on REDUIT la taille
     de police jusqu'a ce qu'il rentre. Jamais de coupure automatique : c'est
     la mise en page dessinee qui fait foi.
     Avant : l'apercu DOM coupait tout seul (CSS max-width + pre-wrap), les
     canvas coupaient chacun a leur maniere, et le SVG laser ne coupait ni ne
     reduisait jamais (un simple split('\n')) -- la gravure ne correspondait
     donc pas a ce que le client avait valide a l'ecran.
     Retourne {lines:[...], size:<taille finale>, wFrac:<largeur utile>}.
     ===================================================================== */
  var MT_LH=1.12;                       /* interligne unique, identique partout */
  var _mtLayCv=null,_mtLayCx=null, MT_LAY_W=1000;
  var _mtLayCache={}, _mtLayCount=0;
  function mtLayCacheClear(){ _mtLayCache={}; _mtLayCount=0; }
  function mtLayoutText(txt,x,y,fontId,weight,size,ls,shapeKey,minSize){
    txt=String(txt==null?'':txt);
    var _ck=txt+'\u0001'+(x||0).toFixed(4)+'\u0001'+(y||0).toFixed(4)+'\u0001'+fontId+'\u0001'+weight+'\u0001'+size+'\u0001'+(ls||0)+'\u0001'+(shapeKey||state.shape)+'\u0001'+minSize;
    var _hit=_mtLayCache[_ck]; if(_hit)return _hit;
    if(!_mtLayCx){ _mtLayCv=document.createElement('canvas'); _mtLayCx=_mtLayCv.getContext('2d'); }
    var cxm=_mtLayCx, sh=SHAPES[shapeKey||state.shape]||SHAPES.hexa;
    var W=MT_LAY_W, H=W*(sh.hcm/sh.wcm);
    var s=size, lines=[txt], blockH=0, wFrac=usableWidthFrac(x,y,shapeKey);
    if(minSize==null)minSize=Math.max(2,size*0.5);
    for(var pass=0; pass<4; pass++){
      var fpx=(s*(SIZE_REF/sh.wcm))/100*W;
      cxm.font=(weight||400)+' '+fpx+'px '+engraveCss(fontId,weight);
      try{ cxm.letterSpacing=(ls?ls*fpx:0)+'px'; }catch(_){}
      /* largeur utile evaluee au BORD du bloc, la ou l'hexagone est le plus
         etroit dans la bande occupee par le texte : rien ne sort de la tomette. */
      var halfH=((blockH||fpx)*0.5)/H;
      var yEdge=Math.max(0,Math.min(1, y+(y>=0.5?halfH:-halfH)));
      wFrac=usableWidthFrac(x,yEdge,shapeKey);
      var maxW=wFrac*W;
      lines=txt.split('\n');                   /* AUCUNE coupure automatique */
      var wMax=0;
      for(var i=0;i<lines.length;i++){ var w=cxm.measureText(lines[i]).width; if(w>wMax)wMax=w; }
      blockH=lines.length*fpx*MT_LH;
      var availH=Math.max(0.15, 2*Math.min(y,1-y)*0.96)*H;
      var k=Math.min(wMax>0?maxW/wMax:1, blockH>0?availH/blockH:1);
      if(k>=0.995)break;                       /* ca rentre : taille conservee */
      var ns=Math.max(minSize, s*k);
      if(ns>=s-0.01){ s=ns; break; }           /* plancher atteint */
      s=ns;
    }
    try{ cxm.letterSpacing='0px'; }catch(_){}
    var _out={lines:lines, size:Math.round(s*100)/100, wFrac:wFrac};
    if(_mtLayCount>3000)mtLayCacheClear();
    _mtLayCache[_ck]=_out; _mtLayCount++;
    return _out;
  }
  function mtLayOf(it,shapeKey){
    var f=fontById(it.font||'cormorant');
    var txt=(f.caps?String(it.text||'').toUpperCase():String(it.text||''));
    if(it.smallcaps)txt=txt.toUpperCase();
    return mtLayoutText(txt,it.x,it.y,it.font||'cormorant',
      mteWeight(it.font||'cormorant',it.weight),(it.size||6.5),(it.ls||0),
      shapeKey||state.shape,Math.max(2,(it.size||6.5)*0.5));
  }
  function holeOverlap(){
    if(!state.hole)return false;
    var sh=SHAPES[state.shape];
    var v=document.getElementById('vtile');
    var W=(v&&v.clientWidth)?v.clientWidth:360; if(W>360)W=360; if(W<60)W=360;
    var H=W/sh.wcm*sh.hcm;
    var hr=Math.max(2,(0.2/sh.wcm)*W);
    var centers=holeCenters(state.shape).map(function(c){return {x:c.x*W,y:c.y*H};});
    var i,it,hi;
    // logos : test de boîte (formes denses) contre chaque trou
    for(i=0;i<state.els.length;i++){
      it=state.els[i]; if(it.type!=='icon'||mtEstFond(it))continue;   // greffe F5 : le trou est percé DANS la carte, ce n'est pas une alerte
      var s=(renderSize(it)/100)*W, ex=it.x*W, ey=it.y*H;
      for(hi=0;hi<centers.length;hi++){
        var hx=centers[hi].x, hy=centers[hi].y;
        var nx=Math.max(ex-s/2,Math.min(hx,ex+s/2)), ny=Math.max(ey-s/2,Math.min(hy,ey+s/2));
        var dx=hx-nx,dy=hy-ny; if(dx*dx+dy*dy<=hr*hr)return true;
      }
    }
    _hcv.width=W; _hcv.height=Math.ceil(H);
    var ctx=_hcx; ctx.clearRect(0,0,W,H);
    ctx.fillStyle='#000'; ctx.textAlign='center'; ctx.textBaseline='top';
    var hasText=false;
    function _drawCurvedText(ctx,it,txt,fpx,W,H){
      var sb=ctx.textBaseline;
      _drawCurvedInto(ctx,it,txt,fpx,it.x*W,it.y*H);
      ctx.textBaseline=sb;
    }
    for(i=0;i<state.els.length;i++){
      it=state.els[i]; if(it.type!=='text')continue; hasText=true;
      var fpx=(renderSize(it)/100)*W, f=fontById(it.font||'cormorant');
      ctx.font=_canvasFont(it,fpx);
      var raw=(f.caps?String(it.text).toUpperCase():String(it.text));
      if(it.smallcaps)raw=raw.toUpperCase();   // approx fidèle : le laser grave en capitales
      if(it.curve&&Math.abs(it.curve)>=1){ _drawCurvedText(ctx,it,raw.replace(/\n/g,' '),fpx,W,H); continue; }
      var _lay7=mtLayOf(it), maxw=_lay7.wFrac*W, lines=_lay7.lines;
      fpx=(_lay7.size*(SIZE_REF/SHAPES[state.shape].wcm))/100*W;   /* meme taille que l'apercu */
      ctx.font=_canvasFont({size:_lay7.size,font:it.font,weight:it.weight,ls:it.ls},fpx);
      var lh=fpx*(it.lh||MT_LH), top=(it.y*H)-(lines.length-1)*lh/2, cx=it.x*W;
      var al=it.align||'center';
      ctx.textAlign=(lines.length>1?al:'center');
      var edgeL=cx-maxw/2, edgeR=cx+maxw/2;
      var ax=(al==='left'?edgeL:(al==='right'?edgeR:cx));
      for(var k=0;k<lines.length;k++)ctx.fillText(lines[k],(lines.length>1?ax:cx),top+k*lh);
      ctx.textAlign='center';
    }
    if(!hasText)return false;
    for(hi=0;hi<centers.length;hi++){
      var chx=centers[hi].x, chy=centers[hi].y;
      var x0=Math.max(0,Math.floor(chx-hr)), y0=Math.max(0,Math.floor(chy-hr));
      var w0=Math.min(W-x0,Math.ceil(hr*2+1)), h0=Math.min(Math.ceil(H)-y0,Math.ceil(hr*2+1));
      if(w0<=0||h0<=0)continue;
      var data; try{ data=ctx.getImageData(x0,y0,w0,h0).data; }catch(e){ return false; }
      for(var p=0;p<data.length;p+=4){
        if(data[p+3]>24){
          var idx=p/4, px=x0+(idx%w0), py=y0+Math.floor(idx/w0);
          var ddx=px-chx, ddy=py-chy;
          if(ddx*ddx+ddy*ddy<=hr*hr)return true;
        }
      }
    }
    return false;
  }
  var MIN_LEGIBLE_SIZE=2.8; // taille physique ~3,4 mm (trait laser mini)
  function legibilityIssue(){
    for(var i=0;i<state.els.length;i++){
      var it=state.els[i];
      if(it.type==='text' && String(it.text).trim() && (it.size||0)<MIN_LEGIBLE_SIZE)return true;
    }
    return false;
  }
  function layoutEls(raw){
    var n=raw.length, gap=0.17, startY=clamp(0.5-(n-1)*gap/2,0.2,0.8);
    return raw.map(function(e,i){var c=JSON.parse(JSON.stringify(e));c.id=String(uid++);if(c.type==='text'&&c.text!=null)c.text=stripVars(c.text);if(c.x==null)c.x=0.5;if(c.y==null)c.y=clamp(startY+i*gap,0.2,0.82);return c;});
  }
  var SNAP_TOL=0.018;   // tolérance d'aimantation (fraction de la tomette)
  function snapGuides(){
    var s=document.getElementById('stack');if(!s)return null;
    var v=s.querySelector('.snapline.v'), h=s.querySelector('.snapline.h');
    var cv=s.querySelector('.snapchip.cv'), ch=s.querySelector('.snapchip.ch');
    if(!v){v=el('div','snapline v');s.appendChild(v);}
    if(!h){h=el('div','snapline h');s.appendChild(h);}
    if(!cv){cv=el('div','snapchip cv');s.appendChild(cv);}
    if(!ch){ch=el('div','snapchip ch');s.appendChild(ch);}
    return {v:v,h:h,cv:cv,ch:ch};
  }
  function hideGuides(){var s=document.getElementById('stack');if(!s)return;s.querySelectorAll('.snapline,.snapchip').forEach(function(g){g.classList.remove('on');});}
  function dimNodes(){
    var s=document.getElementById('stack');if(!s)return null;
    var box=s.querySelector('.dimset');
    if(!box){box=el('div','dimset');
      box.innerHTML='<span class="dimc dt"></span><span class="dimc db"></span><span class="dimc dl"></span><span class="dimc dr"></span>';
      s.appendChild(box);}
    return {box:box,t:box.querySelector('.dt'),b:box.querySelector('.db'),l:box.querySelector('.dl'),r:box.querySelector('.dr')};
  }
  function showDims(item){
    var d=dimNodes();if(!d)return;
    var sh=SHAPES[state.shape]||SHAPES.hexa;
    var x=(item.x!=null?item.x:0.5), y=(item.y!=null?item.y:0.5);
    var wmm=sh.wcm*10, hmm=sh.hcm*10;
    var mmL=Math.max(0,Math.round(x*wmm)), mmR=Math.max(0,Math.round((1-x)*wmm));
    var mmT=Math.max(0,Math.round(y*hmm)), mmB=Math.max(0,Math.round((1-y)*hmm));
    d.box.classList.add('on');
    d.t.textContent=mmT+' mm'; d.t.style.left=(x*100)+'%'; d.t.style.top=(y*100/2)+'%';
    d.b.textContent=mmB+' mm'; d.b.style.left=(x*100)+'%'; d.b.style.top=(y*100+(100-y*100)/2)+'%';
    d.l.textContent=mmL+' mm'; d.l.style.top=(y*100)+'%'; d.l.style.left=(x*100/2)+'%';
    d.r.textContent=mmR+' mm'; d.r.style.top=(y*100)+'%'; d.r.style.left=(x*100+(100-x*100)/2)+'%';
  }
  function hideDims(){var s=document.getElementById('stack');if(!s)return;var b=s.querySelector('.dimset');if(b)b.classList.remove('on');}
  function snapTargets(exceptId){
    var xs=[{v:0.5,k:'center'}], ys=[{v:0.5,k:'center'}];
    for(var i=0;i<state.els.length;i++){
      var it=state.els[i];if(String(it.id)===String(exceptId))continue;
      var x=(it.x!=null?it.x:0.5), y=(it.y!=null?it.y:0.5);
      xs.push({v:x,k:'align'}); ys.push({v:y,k:'align'});
      if(Math.abs(x-0.5)>0.03)xs.push({v:1-x,k:'mirror'});
      if(Math.abs(y-0.5)>0.03)ys.push({v:1-y,k:'mirror'});
    }
    return {xs:xs,ys:ys};
  }
  function nearest(v,list){
    var best=null,bd=SNAP_TOL;
    for(var i=0;i<list.length;i++){var d=Math.abs(v-list[i].v);if(d<bd){bd=d;best=list[i];}}
    return best;
  }
  var SNAP_LABELS={center:window.MT_CONFIG_I18N.text("ui_57428ce4089d_html", "Centré"),align:window.MT_CONFIG_I18N.text("ui_f0feea4bfe39_html", "Aligné"),mirror:window.MT_CONFIG_I18N.text("ui_42b6d5cd69fc_html", "Symétrique")};
  function equalGapSnap(curX,curY,exceptId){
    var col=[];
    for(var i=0;i<state.els.length;i++){
      var it2=state.els[i];if(String(it2.id)===String(exceptId))continue;
      var xx=(it2.x!=null?it2.x:0.5);
      if(Math.abs(xx-curX)<0.05)col.push(it2.y!=null?it2.y:0.5);
    }
    if(col.length<2)return null;
    col.sort(function(a,b){return a-b;});
    var above=null,below=null;
    for(var k=0;k<col.length;k++){
      if(col[k]<=curY)above=col[k];
      if(col[k]>=curY&&below==null)below=col[k];
    }
    if(above!=null&&below!=null&&above!==below){
      var mid=(above+below)/2;
      if(Math.abs(mid-curY)<SNAP_TOL*1.6)return mid;
    }
    return null;
  }
  function attachDrag(node,item){
    node.addEventListener('pointerdown',function(e){
      if(e.button!=null && e.button!==0)return;
      if(node.isContentEditable)return;   // édition en cours : le curseur texte prime
      if(mtEstFond(item)){if(!msel.on)select(item.id);return;}   // greffe F5 : ni glisser, ni multi-sélection, ni appui long sur le fond
      if(msel.on){e.preventDefault();mselToggle(item.id);return;}
      if((e.shiftKey||e.ctrlKey||e.metaKey)&&!COARSE){
        e.preventDefault();
        if(state.sel&&String(state.sel)!==String(item.id)){var pv=state.sel;mselStart(pv);mselToggle(item.id);}
        else mselStart(item.id);
        return;
      }
      select(item.id);
      if(item.lock)return;
      var cont=node.parentNode;var rect=cont.getBoundingClientRect();
      var sx=e.clientX,sy=e.clientY,ox=(item.x!=null?item.x:0.5),oy=(item.y!=null?item.y:0.5),moved=false;
      var tg=snapTargets(item.id), guides=snapGuides(), _hadSnap=false;
      var _lpDone=false;
      var _lpT=setTimeout(function(){_lpT=null;if(!moved&&!pinching){_lpDone=true;mselStart(item.id);}},500);
      function mv(ev){
        if(pinching)return;                 // un 2ᵉ doigt → on redimensionne, pas on déplace
        if(_lpDone)return;                  // l'appui long a ouvert la multi-sélection : plus de glisser
        var dx=ev.clientX-sx,dy=ev.clientY-sy;
        if(_lpT&&(Math.abs(dx)+Math.abs(dy))>6){clearTimeout(_lpT);_lpT=null;}
        if(!moved && (Math.abs(dx)+Math.abs(dy))>4){moved=true;pushHistory('déplacement');node.classList.add('dragging');}
        if(moved){ev.preventDefault();
          var nx=clamp(ox+dx/rect.width,-0.1,1.1);
          var ny=clamp(oy+dy/rect.height,-0.1,1.1);
          var snx=nearest(nx,tg.xs), sny=nearest(ny,tg.ys);
          if(snx!=null)nx=snx.v; if(sny!=null)ny=sny.v;
          var eqGap=null;
          if(sny==null){eqGap=equalGapSnap(nx,ny,item.id);if(eqGap!=null)ny=eqGap;}
          if(guides){
            guides.v.classList.toggle('on',snx!=null);
            guides.cv.classList.toggle('on',snx!=null);
            if(snx!=null){guides.v.style.left=(snx.v*100)+'%';guides.cv.style.left=(snx.v*100)+'%';guides.cv.textContent=SNAP_LABELS[snx.k]||window.MT_CONFIG_I18N.text("ui_f0feea4bfe39_html", "Aligné");}
            var hOn=(sny!=null)||(eqGap!=null);
            guides.h.classList.toggle('on',hOn);
            guides.ch.classList.toggle('on',hOn&&(snx==null||(sny&&sny.k!=='center')||(snx&&snx.k==='center')||eqGap!=null));
            if(sny!=null){guides.h.style.top=(sny.v*100)+'%';guides.ch.style.top=(sny.v*100)+'%';guides.ch.textContent=SNAP_LABELS[sny.k]||window.MT_CONFIG_I18N.text("ui_f0feea4bfe39_html", "Aligné");}
            else if(eqGap!=null){guides.h.style.top=(eqGap*100)+'%';guides.ch.style.top=(eqGap*100)+'%';guides.ch.textContent=window.MT_CONFIG_I18N.text("ui_89398babdddf_html", "Espacement égal");}
          }
          var _snapNow=(snx!=null)||(sny!=null)||(eqGap!=null);
          if(_snapNow&&!_hadSnap&&navigator.vibrate){try{navigator.vibrate(8);}catch(e){}}   // le « clic » physique de l'alignement
          _hadSnap=_snapNow;
          item.x=nx; item.y=ny;
          node.style.left=(item.x*100)+'%';node.style.top=(item.y*100)+'%';
          if(item.type==='text')node.style.maxWidth=(usableWidthFrac(item.x,item.y)*100).toFixed(1)+'%';
          showDims(item);
          syncGrey();positionFloat();scheduleLive();
        }
      }
      function up(){if(_lpT){clearTimeout(_lpT);_lpT=null;}document.removeEventListener('pointermove',mv);document.removeEventListener('pointerup',up);node.classList.remove('dragging');hideGuides();hideDims();if(moved)mtAutosave();}
      document.addEventListener('pointermove',mv);
      document.addEventListener('pointerup',up);
    });
  }

  function elStyle(item){
    var f=fontById(item.font||'cormorant');
    /* la taille affichee vient de la mise en page commune, pas de la taille brute */
    var _lay=(item.curve&&Math.abs(item.curve)>=1)?null:mtLayOf(item);
    var _rs=_lay?(Math.round(_lay.size*(SIZE_REF/SHAPES[state.shape].wcm)*100)/100):renderSize(item);
    var reqW=mteWeight(item.font||'cormorant',item.weight),spec=mteResolvedSpec(item.font||'cormorant',reqW),syn=mteSyntheticStroke(item.font||'cormorant',reqW,_rs);
    var s='';
    if(f.italic)s+='font-style:italic;';
    s+='font-family:'+engraveCss(item.font||'cormorant',reqW)+';';
    s+='font-size:'+_rs+'cqw;';
    if(f.caps)s+='text-transform:uppercase;';
    if(item.smallcaps)s+='font-variant:small-caps;font-feature-settings:"smcp" 1;';
    s+='line-height:'+(item.lh||MT_LH)+';';   /* interligne unifie (etait 1.08 au DOM, 1.12 au canvas) */
    s+='font-weight:'+spec.faceWeight+';';
    if(syn>0)s+='-webkit-text-stroke:'+syn.toFixed(3)+'cqw currentColor;paint-order:stroke fill;';
    if(item.ls)s+='letter-spacing:'+item.ls+'em;';
    if(item.curve&&Math.abs(item.curve)>=1){var _cb=curveBox(item);s+='width:'+_cb.w.toFixed(2)+'cqw;height:'+_cb.h.toFixed(2)+'cqw;max-width:none;white-space:nowrap;overflow:visible;';}
    /* white-space:pre => les retours a la ligne saisis sont conserves, mais le
       navigateur ne coupe JAMAIS tout seul (la classe .el est en pre-wrap). */
    else{s+='width:max-content;max-width:none;white-space:pre;';}
    var al=item.align||'center';
    s+='text-align:'+al+';';
    return s;
  }

  // ===== Courbure de texte (arc) =====
  // it.curve : -100..100 (0 = droit). >0 = arc concave vers le haut (sourire),
  // <0 = arc vers le bas. Rendu en SVG textPath, le div conteneur ne bouge pas.
  function _uidc(){return 'c'+(uid)+'_'+Math.floor(Math.random()*1e6);}
  var _measCtx=null;
  function _measureTextW(txt,fs,weight,italic,fam,lsEm){
    try{
      if(!_measCtx)_measCtx=document.createElement('canvas').getContext('2d');
      _measCtx.font=(italic?'italic ':'')+(weight||400)+' '+fs+'px '+fam;
      var w=_measCtx.measureText(txt).width;
      if(lsEm)w+=lsEm*fs*Math.max(0,txt.length-1);
      return w;
    }catch(e){return txt.length*fs*0.62;}
  }
  function _measEachW(txt,fs,weight,italic,fam){
    var out=[],i;
    try{
      if(!_measCtx)_measCtx=document.createElement('canvas').getContext('2d');
      _measCtx.font=(italic?'italic ':'')+(weight||400)+' '+fs+'px '+fam;
      for(i=0;i<txt.length;i++)out.push(_measCtx.measureText(txt.charAt(i)).width);
    }catch(e){for(i=0;i<txt.length;i++)out.push(fs*0.6);}
    return out;
  }
  function _arcLayout(widths,total,fs,cv){
    var aw=Math.max(total*1.12,fs*3),d=(cv>0)?1:-1,sag=Math.abs(cv)*aw*0.42;
    var P0x=-aw/2,P2x=aw/2,P1y=2*(-d*sag);
    function bez(t){var mt=1-t;return {x:mt*mt*P0x+t*t*P2x,y:2*mt*t*P1y};}
    function dbez(t){var mt=1-t;return {x:2*mt*(0-P0x)+2*t*(P2x-0),y:2*mt*P1y+2*t*(-P1y)};}
    var N=160,acc=[0],prev=bez(0),k;
    for(k=1;k<=N;k++){var p=bez(k/N);acc.push(acc[k-1]+Math.hypot(p.x-prev.x,p.y-prev.y));prev=p;}
    var aL=acc[N];
    function tAt(L){L=Math.max(0,Math.min(aL,L));for(var q=1;q<=N;q++){if(acc[q]>=L){var l0=acc[q-1],l1=acc[q],f=(l1>l0)?(L-l0)/(l1-l0):0;return (q-1+f)/N;}}return 1;}
    var run=(aL-total)/2,out=[];
    for(var i=0;i<widths.length;i++){var wc=widths[i],t=tAt(run+wc/2),pp=bez(t),dd=dbez(t);out.push({x:pp.x,y:pp.y,a:Math.atan2(dd.y,dd.x)});run+=wc;}
    return out;
  }
  function curveBox(it){
    var f=fontById(it.font||'cormorant'),tx=String(it.text||'').replace(/\n/g,' ');
    if(it.smallcaps||f.caps)tx=tx.toUpperCase();
    var fs=renderSize(it),ls=(it.ls||0)*fs;
    var rw=mteWeight(it.font||'cormorant',it.weight),sp=mteResolvedSpec(it.font||'cormorant',rw);
    var gw=_measEachW(tx,fs,sp.faceWeight,f.italic,engraveCss(it.font||'cormorant',rw));
    var widths=[],total=0,i;
    for(i=0;i<gw.length;i++){widths.push(gw[i]+ls);total+=gw[i]+ls;}
    if(total<=0)return {w:12,h:12,ox:0,oy:0};
    var cv=Math.max(-100,Math.min(100,it.curve||0))/100;
    var pos=_arcLayout(widths,total,fs,cv),hy=fs*0.5;
    var L=1e9,R=-1e9,T=1e9,B=-1e9;
    for(i=0;i<pos.length;i++){
      var hx=gw[i]/2,ca=Math.abs(Math.cos(pos[i].a)),sn=Math.abs(Math.sin(pos[i].a));
      var ex=hx*ca+hy*sn,ey=hx*sn+hy*ca;
      L=Math.min(L,pos[i].x-ex);R=Math.max(R,pos[i].x+ex);
      T=Math.min(T,pos[i].y-ey);B=Math.max(B,pos[i].y+ey);
    }
    return {w:R-L,h:B-T,ox:(L+R)/2,oy:(T+B)/2};
  }
  function curvedSvg(item){
    var f=fontById(item.font||'cormorant');
    var txt=String(item.text||'').replace(/\n/g,' ');
    if(item.smallcaps||f.caps)txt=txt.toUpperCase();
    var fs=renderSize(item);
    var _wt0=(item.weight||defaultWeight(item.font||'cormorant'));
    var _spec0=mteResolvedSpec(item.font||'cormorant',_wt0),_fam0=engraveCss(item.font||'cormorant',_wt0),_syn0=mteSyntheticStroke(item.font||'cormorant',_wt0,fs);
    var textW=_measureTextW(txt,fs,_spec0.faceWeight,f.italic,_fam0,(item.ls||0));
    var cv=Math.max(-100,Math.min(100,item.curve||0))/100;
    // le chemin doit être un peu PLUS long que le texte, sinon il déborde/comprime
    var W=Math.max(textW*1.12, fs*3);
    var H;
    var pathId=_uidc();
    var d, viewH;
    if(Math.abs(cv)<0.01){
      // sécurité : quasi-droit
      H=fs*1.4; viewH=H;
      d='M 0 '+(H*0.72)+' L '+W+' '+(H*0.72);
    }else{
      // flèche de l'arc : proportionnelle à la courbure et à la largeur
      var sag=Math.abs(cv)*W*0.42; 
      viewH=fs*1.4+sag;
      var yBase=(cv>0)?(fs*1.15+sag):(fs*1.15);
      var yPeak=(cv>0)?(fs*1.15):(fs*1.15+sag);
      // arc quadratique symétrique : depuis (0,yBase) sommet au milieu (W/2,yPeak) vers (W,yBase)
      // control point y pour un Bézier quadratique passant au sommet : yc = 2*yPeak - yBase
      var yc=2*yPeak-yBase;
      d='M 0 '+yBase.toFixed(2)+' Q '+(W/2).toFixed(2)+' '+yc.toFixed(2)+' '+W.toFixed(2)+' '+yBase.toFixed(2);
      H=viewH;
    }
    var fam=_fam0;
    var wt=_spec0.faceWeight;
    var ls=(item.ls?(item.ls+'em'):'0');
    var svg='<svg class="curvedtxt" viewBox="0 0 '+W.toFixed(1)+' '+viewH.toFixed(1)+'" '
      +'style="width:'+W.toFixed(1)+'cqw;height:'+viewH.toFixed(1)+'cqw;overflow:visible;display:block" xmlns="http://www.w3.org/2000/svg">'
      +'<defs><path id="'+pathId+'" d="'+d+'" fill="none"/></defs>'
      +'<text font-family="'+esc(fam)+'" font-size="'+fs.toFixed(2)+'" font-weight="'+wt+'"'
      +(f.italic?' font-style="italic"':'')+' letter-spacing="'+ls+'" fill="currentColor"'+(_syn0>0?(' stroke="currentColor" stroke-width="'+_syn0.toFixed(3)+'" stroke-linejoin="round" paint-order="stroke fill"'):'')+'>'
      +'<textPath href="#'+pathId+'" xlink:href="#'+pathId+'" startOffset="50%" text-anchor="middle">'
      +esc(txt)+'</textPath></text></svg>';
    return svg;
  }
  // applique le contenu visuel du noeud texte : droit (textContent) ou courbé (SVG)
  function applyTextContent(node,item){
    if(!node)return;
    if(item.curve&&Math.abs(item.curve)>=1&&!node.isContentEditable){
      node.classList.add('curved');
      node.innerHTML=curvedSvg(item);
    }else{
      node.classList.remove('curved');
      node.textContent=item.text;
    }
  }
  function _applySize(node,it){
    if(!node)return;
    if(it.type!=='text'){applyLogoSize(node,it);return;}
    if(it.curve&&Math.abs(it.curve)>=1){applyStyle(node,it);return;}
    var _l=mtLayOf(it), _rs2=Math.round(_l.size*(SIZE_REF/SHAPES[state.shape].wcm)*100)/100;
    node.style.fontSize=_rs2+'cqw';
    node.style.maxWidth='none';
    var _rw=mteWeight(it.font||'cormorant',it.weight), _syn=mteSyntheticStroke(it.font||'cormorant',_rw,_rs2);
    node.style.webkitTextStroke=(_syn>0?(_syn.toFixed(3)+'cqw currentColor'):'');
  }
  function applyStyle(node,item){
    node.style.cssText=elStyle(item);
    node.style.left=((item.x!=null?item.x:0.5)*100)+'%';
    node.style.top=((item.y!=null?item.y:0.5)*100)+'%';
    applyRot(node,item);
    if(item.type==='text'&&typeof applyTextContent==='function')applyTextContent(node,item);
  }
  function applyRot(node,item){
    if(!node)return;
    var r=normRot(item.rot),ox=0,oy=0;
    if(item.type==='text'&&item.curve&&Math.abs(item.curve)>=1&&!node.isContentEditable){var _c=curveBox(item);ox=_c.ox;oy=_c.oy;}
    node.style.transform='translate(-50%,-50%)'+(r?(' rotate('+r+'deg)'):'')+((ox||oy)?(' translate('+ox.toFixed(2)+'cqw,'+oy.toFixed(2)+'cqw)'):'');
  }
  function normRot(r){r=Math.round(+r||0)%360;if(r>180)r-=360;if(r<-180)r+=360;if(Math.abs(r)<4)r=0;return r;}
  function buildStack(container, els, editable){
    container.innerHTML='';
    for(var i=0;i<els.length;i++){
      var item=els[i];
      var node;
      if(item.type==='text'){
        node=el('div','el text');
        node.dataset.id=item.id;
        applyStyle(node,item);
        applyTextContent(node,item);
      } else {
        var full=logoSvg(item);
        if(full){
          node=el('div','el logo');
          node.dataset.id=item.id;
          node.innerHTML=svgSized(full,renderSize(item),item.flip);
        } else {
          node=el('div','el icon');
          node.dataset.id=item.id;
          node.innerHTML='<svg viewBox="0 0 24 24" style="width:'+renderSize(item)+'cqw;height:'+renderSize(item)+'cqw;stroke-width:'+(item.stroke||1.7)+(item.flip?';transform:scaleX(-1)':'')+'">'+ (ICONS[item.icon]||ICONS.leaf) +'</svg>';
        }
        node.style.left=((item.x!=null?item.x:0.5)*100)+'%';
        node.style.top=((item.y!=null?item.y:0.5)*100)+'%';
        applyRot(node,item);
      }
      container.appendChild(node);
      node.classList.toggle('locked',!!item.lock);
      if(editable) attachDrag(node,item);
    }
    if(editable){requestAnimationFrame(restackByFootprint);}
  }
  var _rsTries=0;
  function restackByFootprint(){
    var c=document.getElementById('stack');if(!c)return;
    var list=Array.prototype.slice.call(c.querySelectorAll('.el'));
    if(!list.length)return;
    var pending=false;
    list.forEach(function(n){if(n.offsetWidth<2&&n.offsetHeight<2)pending=true;});
    list.sort(function(na,nb){return (nb.offsetWidth*nb.offsetHeight)-(na.offsetWidth*na.offsetHeight);});
    for(var k=0;k<list.length;k++)list[k].style.zIndex=String(2+k);   // 2..n : sous les guides (7+) et la barre (9)
    if(pending&&_rsTries<8){_rsTries++;setTimeout(restackByFootprint,300);}else{_rsTries=0;}
  }

  function render(){
    mtFondFige(state);   // greffe F5 : le fond à sa place, à sa taille, sous tout le reste
    mtePrepFonts(state.els);
    var sq=SHAPES[state.shape].cls==='sq';
    var wrap=document.getElementById('tilewrap');
    if(wrap)wrap.className='tilewrap'+(sq?' sq':'');
    var tile=document.getElementById('tile');
    tile.className='tom '+(sq?'sq photo':'hex photo');
    var sh=SHAPES[state.shape];
    var ew=document.getElementById('edimW');if(ew)ew.textContent=sh.wcm+' cm';
    var eh=document.getElementById('edimH');if(eh)eh.textContent=sh.hcm+' cm';
    buildStack(document.getElementById('stack'), state.els, true);
    if(state.sel){var sn=document.querySelector('#stack .el[data-id="'+state.sel+'"]');if(sn)sn.classList.add('sel');}
    var eng=document.getElementById('stackEngrave');
    if(eng){var cp=sq?'inset(0 round 12px)':'polygon(25% 0,75% 0,100% 50%,75% 100%,25% 100%,0 50%)';eng.style.clipPath=cp;eng.style.webkitClipPath=cp;}
    syncGrey();
    applyHole(wrap, state.hole);
    positionFloat();
    initLiveRO();
    scheduleLive();
  }

  function getItem(id){id=String(id);for(var i=0;i<state.els.length;i++){if(String(state.els[i].id)===id)return state.els[i];}return null;}

  function select(id){
    /* CARTE GRAVÉE — greffe F5 (10/2026, Lot 0) : un fond ne se sélectionne jamais, par aucun chemin (appui,
       liste des calques, clavier), et n'entre jamais dans la multi-sélection. Un appui sur lui vaut un appui
       à côté (désélection) ; le module carte l'apprend par 'mt:fond-appui' pour déplier sa pastille. */
    if(mtEstFond(getItem(id))){
      if(typeof msel!=='undefined'&&msel.on)return;
      deselect();
      try{document.dispatchEvent(new CustomEvent('mt:fond-appui',{detail:{id:String(id),type:mtFondType(getItem(id))}}));}catch(_){}   // greffe G4 : + type
      return;
    }
    if(typeof msel!=='undefined'&&msel.on){mselToggle(id);return;}   // mode multi : tout clic bascule, aucun chemin ne casse le mode
    id=String(id);state.sel=id;
    var all=document.querySelectorAll('#stack .el');for(var i=0;i<all.length;i++)all[i].classList.remove('sel');
    var node=document.querySelector('#stack .el[data-id="'+id+'"]');
    if(node)node.classList.add('sel');
    positionFloat();
    if(!COARSE){lpTab('edit');}                     // le panneau suit la sélection : éditeur contextuel
  }
  function deselect(){
    if(typeof closeStrips==='function')closeStrips();
    var prev=state.sel?document.querySelector('#stack .el[data-id="'+state.sel+'"]'):null;
    state.sel=null;var all=document.querySelectorAll('#stack .el');for(var i=0;i<all.length;i++)all[i].classList.remove('sel');
    if(prev){prev.classList.add('byebye');setTimeout(function(){prev.classList.remove('byebye');},380);}
    if(typeof closeFcPop==='function')closeFcPop();positionFloat();if(!COARSE){var lpv=document.querySelector('.lpage.on');if(lpv&&lpv.id==='lp-edit'&&typeof buildEditPanel==='function')buildEditPanel();}
  }

  function selHandlesEl(){
    var s=document.getElementById('stack');if(!s)return null;
    var hb=s.querySelector('#selHandles');
    if(!hb){
      hb=el('div','selhandles');hb.id='selHandles';
      hb.innerHTML=window.MT_CONFIG_I18N.text("ui_a0a2eaa67e1c_html", "<span class=\"hd-c hd-tl\"></span><span class=\"hd-c hd-tr\"></span><span class=\"hd-c hd-bl\"></span><span class=\"hd-c hd-br\"></span><span class=\"hd-rot\" id=\"hdRot\" title=\"Faire pivoter\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\"><path d=\"M20 12a8 8 0 11-2.34-5.66\"/><path d=\"M20 4v4.2h-4.2\"/></svg></span><span class=\"hd-angle\" id=\"hdAngle\">0°</span><button class=\"hd-btn hd-lockbtn\" id=\"hdLock\" title=\"Verrouiller la position\">🔓</button><button class=\"hd-btn hd-delbtn\" id=\"hdDel\" title=\"Supprimer\">✕</button>");
      var lb=hb.querySelector('#hdLock');
      lb.addEventListener('pointerdown',function(e){e.stopPropagation();});
      lb.addEventListener('click',function(e){e.stopPropagation();toggleLock();});
      var db=hb.querySelector('#hdDel');
      db.addEventListener('pointerdown',function(e){e.stopPropagation();});
      db.addEventListener('click',function(e){e.stopPropagation();delSel();});
      s.appendChild(hb);
      var corners=hb.querySelectorAll('.hd-c');
      for(var ci=0;ci<corners.length;ci++)corners[ci].addEventListener('pointerdown',startResizeHandle);
      var rt=hb.querySelector('#hdRot');if(rt)rt.addEventListener('pointerdown',startRotateHandle);
    }
    return hb;
  }
  function positionHandles(){
    var hb=selHandlesEl();if(!hb)return;
    var it=state.sel?getItem(state.sel):null;
    var node=it?document.querySelector('#stack .el[data-id="'+state.sel+'"]'):null;
    if(!it||!node){hb.classList.remove('on');return;}
    hb.classList.toggle('locked',!!it.lock);
    var lkb=hb.querySelector('#hdLock');
    if(lkb){lkb.textContent=it.lock?'🔒':'🔓';lkb.classList.toggle('on',!!it.lock);lkb.title=it.lock?window.MT_CONFIG_I18N.text("ui_a0556d833661_html", "Déverrouiller la position"):window.MT_CONFIG_I18N.text("ui_429ac8c8d19e_html", "Verrouiller la position");}
    hb.classList.add('on');
    var rot=normRot(it.rot);
    var _sE=document.getElementById('stack'),_sR=_sE?_sE.getBoundingClientRect():null,_nR=node.getBoundingClientRect();
    if(_sR){
      hb.style.left=(_nR.left-_sR.left+_nR.width/2)+'px';
      hb.style.top=(_nR.top-_sR.top+_nR.height/2)+'px';
    }else{
      hb.style.left=((it.x!=null?it.x:0.5)*100)+'%';
      hb.style.top=((it.y!=null?it.y:0.5)*100)+'%';
    }
    hb.style.width=node.offsetWidth+'px';
    hb.style.height=node.offsetHeight+'px';
    hb.style.transform='translate(-50%,-50%) rotate('+rot+'deg)';
    var ang=document.getElementById('hdAngle');if(ang)ang.textContent=Math.round(rot)+'°';
  }
  function startResizeHandle(e){
    e.stopPropagation();e.preventDefault();
    if(!state.sel)return;var it=getItem(state.sel);if(!it||it.lock)return;pushHistory('taille');it.manual=true;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(!node)return;
    var wrap=document.getElementById('stack'),wr=wrap.getBoundingClientRect();
    var cx=wr.left+(it.x!=null?it.x:0.5)*wr.width, cy=wr.top+(it.y!=null?it.y:0.5)*wr.height;
    if(it.type==='text'&&it.curve&&Math.abs(it.curve)>=1){var _cc=curveBox(it),_rr=normRot(it.rot)*Math.PI/180,_ox=_cc.ox*wr.width/100,_oy=_cc.oy*wr.width/100;cx+=_ox*Math.cos(_rr)-_oy*Math.sin(_rr);cy+=_ox*Math.sin(_rr)+_oy*Math.cos(_rr);}
    var d0=Math.hypot(e.clientX-cx,e.clientY-cy)||1, s0=it.size||6;
    function mv(ev){
      var d=Math.hypot(ev.clientX-cx,ev.clientY-cy), b=sizeBounds(it);
      it.size=Math.round(clamp(s0*(d/d0),b.min,b.max)*10)/10;
      if(it.type==='text'){if(it.curve&&Math.abs(it.curve)>=1){applyStyle(node,it);}else{node.style.fontSize=renderSize(it)+'cqw';node.style.maxWidth=(usableWidthFrac(it.x,it.y)*100).toFixed(1)+'%';}}
      else{applyLogoSize(node,it);}
      syncGrey();positionFloat();scheduleLive();
    }
    function up(){document.removeEventListener('pointermove',mv);document.removeEventListener('pointerup',up);mtAutosave();}
    document.addEventListener('pointermove',mv);document.addEventListener('pointerup',up);
  }
  function startRotateHandle(e){
    e.stopPropagation();e.preventDefault();
    if(!state.sel)return;var it=getItem(state.sel);if(!it||it.lock)return;pushHistory('rotation');
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(!node)return;
    var wrap=document.getElementById('stack'),wr=wrap.getBoundingClientRect();
    var cx=wr.left+(it.x!=null?it.x:0.5)*wr.width, cy=wr.top+(it.y!=null?it.y:0.5)*wr.height;
    if(it.type==='text'&&it.curve&&Math.abs(it.curve)>=1){var _cc=curveBox(it),_rr=normRot(it.rot)*Math.PI/180,_ox=_cc.ox*wr.width/100,_oy=_cc.oy*wr.width/100;cx+=_ox*Math.cos(_rr)-_oy*Math.sin(_rr);cy+=_ox*Math.sin(_rr)+_oy*Math.cos(_rr);}
    var hb=document.getElementById('selHandles');if(hb)hb.classList.add('rotating');
    function mv(ev){
      var a=Math.atan2(ev.clientY-cy,ev.clientX-cx)*180/Math.PI, raw=a;   // poignée à droite : 0° = position de repos
      var snapped=Math.round(raw/15)*15;
      if(Math.abs(raw-snapped)<4)raw=snapped;
      it.rot=normRot(raw);
      applyRot(node,it);
      positionHandles();syncGrey();scheduleLive();
    }
    function up(){document.removeEventListener('pointermove',mv);document.removeEventListener('pointerup',up);if(hb)hb.classList.remove('rotating');mtAutosave();}
    document.addEventListener('pointermove',mv);document.addEventListener('pointerup',up);
  }

  function positionBubble(elem,nr,sr){
    if(!elem)return;
    var fw=elem.offsetWidth, fh=elem.offsetHeight;
    var cx=(nr.left+nr.width/2)-sr.left;
    var above=(nr.top-sr.top)-fh-12;
    var top=above;
    if(above<6){var below=(nr.bottom-sr.top)+12; top=(below+fh>sr.height-6)?Math.max(6,above):below;}
    elem.style.left=clamp(cx-fw/2,6,Math.max(6,sr.width-fw-6))+'px';
    elem.style.top=clamp(top,6,Math.max(6,sr.height-fh-6))+'px';
  }
  function positionFloat(){
    var fc=document.getElementById('floatctl');
    var fcm=document.getElementById('floatctlM');
    if(!state.sel){fc.classList.remove('on');if(fcm)fcm.classList.remove('on');var fwv=document.getElementById('fontWheel');if(fwv)fwv.classList.remove('on');positionHandles();return;}
    var item=getItem(state.sel);
    fc.classList.add('on');
    fc.classList.toggle('icon-sel', !!(item && item.type==='icon'));
    if(fcm){fcm.classList.add('on');fcm.classList.toggle('icon-sel', !!(item && item.type==='icon'));}
    updateWeightBtns();
    // meta : nom de la police + taille courante
    var fl=document.getElementById('fcFontLbl');
    if(fl&&item){
      if(item.type==='text'){var fr=fontById(item.font);var lb=String(fr.label||'Aa');fl.textContent=lb.length>9?lb.slice(0,8)+'…':lb;fl.style.fontFamily=fr.italic?"'Cormorant Garamond',serif":fr.css;}
      else{fl.textContent='Aa';}
    }
    updateLockBtns(item);
    var fk=document.getElementById('fcKind');
    if(fk&&item)fk.textContent=(item.type==='text'?window.MT_CONFIG_I18N.text("ui_0e480c439cd2_html", "Texte sélectionné"):window.MT_CONFIG_I18N.text("ui_7383d370cc1b_html", "Motif sélectionné"));
    var fs=document.getElementById('fcSize');
    if(fs&&item){var sv=Math.round((item.size||0)*10)/10;fs.textContent=(sv%1===0)?String(Math.round(sv)):sv.toFixed(1);}
    var node=document.querySelector('#stack .el[data-id="'+state.sel+'"]');
    var stage=document.querySelector('.stage');
    if(!node||!stage)return;
    var sr=stage.getBoundingClientRect(), nr=node.getBoundingClientRect();
    var fw=fc.offsetWidth, fh=fc.offsetHeight;
    var cx=(nr.left+nr.width/2)-sr.left;
    var below=(nr.bottom-sr.top)+14;
    var top=below;
    if(below+fh>sr.height-6){var above=(nr.top-sr.top)-fh-46; top=above>6?above:Math.max(6,below);}
    fc.style.left=clamp(cx-fw/2,6,Math.max(6,sr.width-fw-6))+'px';
    fc.style.top=clamp(top,6,Math.max(6,sr.height-fh-6))+'px';
    if(fcm){
      if(window.matchMedia&&window.matchMedia('(max-width:760px)').matches){fcm.style.left='';fcm.style.top='';updateFontWheel(item);}   // mobile : ancrée en bas via CSS
      else positionBubble(fcm,nr,sr);
    }
    positionHandles();
  }
  function weightBounds(){
    if(!state.sel)return null;var it=getItem(state.sel);if(!it)return null;
    if(it.type==='text')return {val:(it.weight||defaultWeight(it.font)),min:300,max:800};
    return {val:(it.stroke||1.7),min:1.7,max:2.2};
  }
  function updateWeightBtns(){
    var b=weightBounds();
    function setDis(node,dis){ if(!node)return; node.disabled=!!dis; node.classList.toggle('disabled',!!dis); }
    var sMinus=document.getElementById('wMinus'), sPlus=document.getElementById('wPlus');
    var atMin=b?(b.val<=b.min+0.001):false, atMax=b?(b.val>=b.max-0.001):false;
    setDis(sMinus,atMin); setDis(sPlus,atMax);
  }

  // ---- mutations ----
  function syncTextFromDom(){
    var nodes=document.querySelectorAll('#stack .el.text');
    for(var i=0;i<nodes.length;i++){
      var id=nodes[i].dataset.id;var it=getItem(id);
      if(it) it.text=nodes[i].innerText.replace(/\n$/,'');
    }
  }
  /* TOMETTE PHOTO — greffe 7 (10/2026, intégration). La photo couvre toute la pièce, centrée en
     0.5,0.5 : comptée comme un occupant, elle poussait tout ajout dans un coin de la grille, à moitié
     hors de l'hexagone. En mode photo on l'ignore, on reste sous le trou (y ≥ 0.30) et on ne garde que
     les points où l'élément tient dans la forme (texte : colonne centrale). Premier ajout : bas centre. */
  /* CARTE GRAVÉE — greffe F1 (10/2026, Lot 0) : la carte est un fond, comme la photo — même règle. */
  function freeSpot(kind){
    var occ=state.els, photo=mtIsPhotoState(state)||mtHasFond(state);
    if(photo){occ=[];for(var k=0;k<state.els.length;k++){var e0=state.els[k];if(!(e0&&e0.type==='icon'&&(e0.icon==='custom_photo'||e0.icon==='custom_photo_demo'))&&!mtEstFond(e0))occ.push(e0);}
      if(occ.length===0)return {x:0.5,y:0.80};}
    if(occ.length===0)return {x:0.5,y:0.5};
    var best={x:0.5,y:photo?0.80:0.5}, bestD=-1, sq=(SHAPES[state.shape]||SHAPES.hexa).cls==='sq';
    for(var gy=0;gy<=6;gy++){
      for(var gx=0;gx<=4;gx++){
        var x=0.22+gx*0.14, y=0.20+gy*0.10;          // grille interne à la tomette
        if(photo){var xl=sq?0:Math.abs(y-0.5)/2, room=Math.min(x-xl,1-xl-x);
          if(y<0.30||room<(kind==='text'?0.35:0.12))continue;}
        var md=99;
        for(var i=0;i<occ.length;i++){
          var ex=(occ[i].x!=null?occ[i].x:0.5), ey=(occ[i].y!=null?occ[i].y:0.5);
          var d=Math.sqrt((x-ex)*(x-ex)+(y-ey)*(y-ey));
          if(d<md)md=d;
        }
        if(md>bestD){bestD=md;best={x:x,y:y};}         // on garde le point le + dégagé
      }
    }
    return best;
  }
  function addText(opts,edit){
    syncTextFromDom();pushHistory();
    opts=opts||{};
    var p=freeSpot('text');
    var item={id:String(uid++),type:'text',text:stripVars(opts.text||'Votre texte'),font:opts.font||(RECENT_FONTS&&RECENT_FONTS[0])||'cormorant',size:opts.size||6.5,x:p.x,y:p.y};
    state.els.push(item);ensureCurrentDisplayFonts();render();select(item.id);
    syncGrey();mtAutosave();mtTrack('cfg_add_text');
    if(edit)openSheet('edittext');
  }
  function addIcon(key){
    syncTextFromDom();pushHistory();
    var p=freeSpot();
    var item={id:String(uid++),type:'icon',icon:key,x:p.x,y:p.y};
    var b=sizeBounds(item), hasMin=LOGOCAT[key]&&+LOGOCAT[key].minSize;
    item.size=hasMin?b.min:clamp(LOGOCAT[key]?13:9,b.min,b.max);  // se réfère à la taille mini du logo si définie
    state.els.push(item);render();select(item.id);mtAutosave();mtTrack('cfg_add_motif',{motif:key});
  }
  function addCustomSvg(svg,meta){
    syncTextFromDom();pushHistory();
    var p=freeSpot();
    var item={id:String(uid++),type:'icon',icon:'custom_'+uid,svg:svg,size:13,x:p.x,y:p.y};
    if(meta)item.qrMeta=meta;
    state.els.push(item);render();select(item.id);mtAutosave();
  }
window.MT_LAB={sanitizeSvg:sanitizeSvg,toast:toast,el:el};

  // Applique la taille d'un logo en respectant son ratio réel (viewBox) -> la hitbox reste calée
  function applyLogoSize(node,it){
    var svg=node&&node.querySelector('svg');if(!svg)return;
    var wh=svgRatioWH('<svg viewBox="'+(svg.getAttribute('viewBox')||'')+'">',renderSize(it));
    svg.style.width=wh.w+'cqw';svg.style.height=wh.h+'cqw';
  }
  function changeSize(delta){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;
    if(it.lock){toast(window.MT_CONFIG_I18N.text("ui_c7a88072b23d_html", "Élément verrouillé 🔒"));return;}
    pushHistory('taille');it.manual=true;
    var b=sizeBounds(it); it.size=Math.round(clamp(it.size+delta*0.35,b.min,b.max)*10)/10;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(!node)return;
    if(it.type==='text'){_applySize(node,it);}
    else{applyLogoSize(node,it);}
    syncGrey();positionFloat();mtAutosave();
  }
  function changeWeight(delta){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;pushHistory();
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(!node)return;
    if(it.type==='text'){
      it.weight=clamp((it.weight||defaultWeight(it.font))+delta*100,300,800);
      ensureCurrentDisplayFonts();
      applyStyle(node,it);
    } else {
      it.stroke=Math.round(clamp((it.stroke||1.7)+delta*0.1,1.7,2.2)*10)/10;  // logos : progressif de 1,7 (fin) à 2,2 (épais)
      var svg=node.querySelector('svg');if(svg)svg.style.strokeWidth=it.stroke;
    }
    syncGrey();positionFloat();mtAutosave();
  }
  function weightLabel(){
    if(!state.sel)return '–';var it=getItem(state.sel);if(!it)return '–';
    if(it.type==='text')return String(it.weight||defaultWeight(it.font));
    return (it.stroke||1.7).toFixed(1);
  }
  function changeLs(delta){
    if(!state.sel)return;var it=getItem(state.sel);if(!it||it.type!=='text')return;pushHistory();
    it.ls=Math.round(clamp((it.ls||0)+delta*0.02,0,0.4)*100)/100;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node)applyStyle(node,it);
    syncGrey();positionFloat();scheduleLive();mtAutosave();
  }
  var RECENT_FONTS=(function(){try{var r=JSON.parse(localStorage.getItem('mt_recent_fonts_v1')||'[]');return Array.isArray(r)?r:[];}catch(e){return [];}})();
  function recordFontUse(fid){
    if(!fid)return;
    var i=RECENT_FONTS.indexOf(fid);if(i>=0)RECENT_FONTS.splice(i,1);
    RECENT_FONTS.unshift(fid);if(RECENT_FONTS.length>6)RECENT_FONTS.length=6;
    try{localStorage.setItem('mt_recent_fonts_v1',JSON.stringify(RECENT_FONTS));}catch(e){}
  }
  function setFont(fid){
    if(!state.sel)return;var it=getItem(state.sel);if(!it||it.type!=='text')return;
    pushHistory('changement de police');it.font=fid;recordFontUse(fid);ensureCurrentDisplayFonts();mtTrack('cfg_font',{font:fid});
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node)applyStyle(node,it);
    syncGrey();positionFloat();mtAutosave();
  }
  function rotSel(delta){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;pushHistory();
    it.rot=normRot((it.rot||0)+delta);
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    applyRot(node,it);
    syncGrey();positionFloat();scheduleLive();mtAutosave();
  }
  function toggleLock(){
    if(!state.sel)return;var it=getItem(state.sel);if(!it||mtEstFond(it))return;   // greffe F5 : un fond ne se déverrouille pas
    it.lock=!it.lock;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node)node.classList.toggle('locked',it.lock);
    updateLockBtns(it);positionFloat();mtAutosave();
    toast(it.lock?window.MT_CONFIG_I18N.text("ui_0e4a371377cd_html", "Position verrouillée 🔒"):window.MT_CONFIG_I18N.text("ui_bb87cb0d6ede_html", "Position déverrouillée 🔓"));
  }
  function updateLockBtns(it){
    document.querySelectorAll('[data-act="lock"]').forEach(function(b){
      var locked=!!(it&&it.lock);
      if(b.querySelector('.fc-mi'))b.querySelector('.fc-mi').textContent=locked?'🔒':'🔓';
      else b.textContent=locked?'🔒':'🔓';
      b.title=locked?window.MT_CONFIG_I18N.text("ui_a0556d833661_html", "Déverrouiller la position"):window.MT_CONFIG_I18N.text("ui_429ac8c8d19e_html", "Verrouiller la position");
      b.classList.toggle('fc-on',locked);
    });
  }
  function flipSel(){
    if(!state.sel)return;var it=getItem(state.sel);if(!it||it.type!=='icon')return;pushHistory();
    it.flip=!it.flip;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');var svg=node&&node.querySelector('svg');
    if(svg)svg.style.transform=it.flip?'scaleX(-1)':'';
    syncGrey();positionFloat();mtAutosave();
  }
  function dupSel(){
    if(!state.sel)return;syncTextFromDom();pushHistory('duplication');
    var it=getItem(state.sel);if(!it)return;var copy=JSON.parse(JSON.stringify(it));copy.id=String(uid++);
    copy.x=clamp((copy.x!=null?copy.x:0.5)+0.06,0.16,0.84);copy.y=clamp((copy.y!=null?copy.y:0.5)+0.06,0.18,0.84);
    state.els.push(copy);render();select(copy.id);mtAutosave();
  }
  function delSel(){
    if(!state.sel)return;syncTextFromDom();pushHistory('suppression');
    state.els=state.els.filter(function(x){return String(x.id)!==String(state.sel);});
    state.sel=null;render();positionFloat();mtAutosave();
  }
  function centerSel(){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;pushHistory();
    it.x=0.5;
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node){node.style.left='50%';if(it.type==='text')node.style.maxWidth=(usableWidthFrac(it.x,it.y)*100).toFixed(1)+'%';}
    syncGrey();positionFloat();mtAutosave();
  }

  function harmonizeAll(){
    syncTextFromDom();
    var n=state.els.length;
    if(!n){toast(window.MT_CONFIG_I18N.text("ui_dafc3e75339c_html", "Ajoutez d'abord un texte ou un motif"));return;}
    pushHistory();
    var order=state.els.slice().sort(function(a,b){return (a.y||0.5)-(b.y||0.5);});
    var top=0.24, bot=0.80;
    if(n===1){order[0].x=0.5;order[0].y=0.5;}
    else{
      var span=bot-top, gap=span/(n-1);
      if(gap>0.17){gap=0.17;var h=gap*(n-1);top=0.5-h/2;}
      for(var i=0;i<n;i++){order[i].x=0.5;order[i].y=Math.round((top+i*gap)*1000)/1000;}
    }
    render();scheduleLive();mtAutosave();
    toast(window.MT_CONFIG_I18N.text("ui_95d33a8ccbd4_html", "Mise en page harmonisée ✨"));
  }

  // ---- rail gauche (Texte / Motifs / Modèles / Format) ----
  function lpTab(name){
    if(!name)return;
    document.querySelectorAll('.lritem').forEach(function(t){t.classList.toggle('on',t.dataset.lp===name);});
    document.querySelectorAll('.lpage').forEach(function(p){p.classList.toggle('on',p.id==='lp-'+name);});
    if(name==='text'){ensureAllDisplayFonts();buildFontPanel();}
    if(name==='motif')buildMotifPanel();
    if(name==='edit'&&typeof buildEditPanel==='function')buildEditPanel();
  }
  document.querySelectorAll('.lritem').forEach(function(t){if(!t.dataset.lp)return;t.addEventListener('click',function(){lpTab(t.dataset.lp);});});

  var _fpCat=null, _fpQuery='';
  function fpPreviewText(){
    var cur=state.sel?getItem(state.sel):null;
    var t=(cur&&cur.type==='text')?String(cur.text||'').replace(/\s+/g,' ').trim():'';
    if(!t)return 'Votre texte';
    return t.length>16?(t.slice(0,16).replace(/\s+$/,'')+'…'):t;
  }
  function buildFontPanel(){
    var cats=document.getElementById('fontCats');if(!cats)return;
    var hasRecent=RECENT_FONTS.length>0;
    if(hasRecent&&_fpCat==null)_fpCat='recent';
    if(_fpCat==='recent'&&!hasRecent)_fpCat='all';
    cats.innerHTML='';
    var defs=[];
    if(hasRecent)defs.push(['recent',window.MT_CONFIG_I18N.text("ui_29b278ac70d7_html", "Récentes")]);
    defs=defs.concat([['all',window.MT_CONFIG_I18N.text("ui_42623b97b481_html", "Toutes")],['manu',window.MT_CONFIG_I18N.text("ui_7a62012d3c4e_html", "Manuscrites")],['eleg',window.MT_CONFIG_I18N.text("ui_f4fbb76c8ce7_html", "Classiques")],['mod',window.MT_CONFIG_I18N.text("ui_f1f6d21e12f7_html", "Modernes")]]);
    defs.forEach(function(c){
      var b=el('button','fcat'+(_fpCat===c[0]?' on':''));b.textContent=c[1];b.dataset.cat=c[0];
      b.addEventListener('click',function(){_fpCat=c[0];cats.querySelectorAll('.fcat').forEach(function(x){x.classList.remove('on');});b.classList.add('on');fillFontList();});
      cats.appendChild(b);
    });
    var srch=document.getElementById('fontSearch');
    if(srch&&!srch._wired){srch._wired=true;srch.addEventListener('input',function(){_fpQuery=srch.value.trim().toLowerCase();fillFontList();});}
    fillFontList();
  }
  function fillFontList(){
    var list=document.getElementById('fontList');if(!list)return;
    list.innerHTML='';
    var cur=state.sel?getItem(state.sel):null;
    var isTxt=!!(cur&&cur.type==='text');
    var lab=document.getElementById('fontFor');
    if(lab)lab.textContent=isTxt?window.MT_CONFIG_I18N.text("ui_544cb0dbcd4d_html", "— appliquée au texte sélectionné"):window.MT_CONFIG_I18N.text("ui_4ad14f95677e_html", "— cliquez pour créer un texte");
    var srch2=document.getElementById('fontSearch');
    var h4p=(lab&&lab.parentNode)?lab.parentNode:null;
    var catsEl=document.getElementById('fontCats');
    if(!isTxt){
      if(srch2)srch2.style.display='none';
      if(catsEl)catsEl.style.display='none';
      if(h4p)h4p.style.display='none';
      var e1=el('div','rhint');e1.textContent=window.MT_CONFIG_I18N.text("ui_8a5efe93a571_html", "Sélectionnez un texte sur la tomette (ou ajoutez-en un) pour choisir sa police, sa taille et son épaisseur depuis la barre flottante.");
      list.appendChild(e1);
      return;
    }
    if(srch2)srch2.style.display='';
    if(catsEl)catsEl.style.display='';
    if(h4p)h4p.style.display='';
    var pv=fpPreviewText();
    var srcList=(_fpCat==='recent')?RECENT_FONTS.map(function(id){return FONTREG[id]?FONTS.filter(function(f){return f.id===id;})[0]:null;}).filter(Boolean):FONTS;
    srcList.forEach(function(f){
      if(_fpCat!=='all'&&_fpCat!=='recent'&&f.grp!==_fpCat)return;
      if(_fpQuery&&String(f.label||f.id).toLowerCase().indexOf(_fpQuery)<0)return;
      var row=el('div','font-row'+(isTxt&&cur.font===f.id?' sel':''));
      var w=el('span','fprev');w.textContent=pv;
      if(f.italic){w.style.fontStyle='italic';w.style.fontFamily="'Cormorant Garamond',serif";}
      else w.style.fontFamily=f.css;
      if(f.caps){w.style.textTransform='uppercase';w.style.fontSize='.88rem';w.style.letterSpacing='.05em';}
      var n=el('span','fname');n.textContent=f.label;
      row.appendChild(n);row.appendChild(w);
      row.addEventListener('click',function(){
        if(isTxt){setFont(f.id);}
        else{addText({text:'Votre texte',font:f.id},false);recordFontUse(f.id);}
        fillFontList();
      });
      list.appendChild(row);
    });
    if(!list.children.length){var e0=el('div','rhint');e0.textContent=(_fpCat==='recent')?window.MT_CONFIG_I18N.text("ui_f44b30f1296b_html", "Pas encore de police utilisée."):window.MT_CONFIG_I18N.text("ui_3d343c016a28_html", "Aucune police ne correspond à votre recherche.");list.appendChild(e0);}
  }

  var _mpN=-1;
  var _mpWaiting=false;
  function buildMotifPanel(){
    var box=document.getElementById('motifPanel');if(!box)return;
    if(!FULL_LOGOS_READY&&!_mpWaiting){
      _mpWaiting=true;
      ensureFullLogos(function(){
        _mpWaiting=false;_mpN=-1;
        var pane=document.getElementById('lp-motif');
        if(pane&&pane.classList.contains('on'))buildMotifPanel();
      });
    }
    var count=Object.keys(LOGOCAT).length;
    if(_mpN===count&&box.children.length)return;
    _mpN=count;box.innerHTML='';
    var hero=el('div','logo-hero');
    hero.innerHTML='<div class="lh-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M12 16V4M8 8l4-4 4 4M5 16v3a1 1 0 001 1h12a1 1 0 001-1v-3"/></svg></div>'
      +window.MT_CONFIG_I18N.text("ui_6179a443eb93_html", "<b>Votre logo, gravé pour durer</b>")
      +window.MT_CONFIG_I18N.text("ui_0bbfa1465bcf_html", "<p>SVG, PNG, JPG… — on le prépare automatiquement pour le laser : noir, fond transparent, détails calibrés.</p>")
      +window.MT_CONFIG_I18N.text("ui_144840d1017a_html", "<button type=\"button\" class=\"lh-go\" id=\"impSvgBtn2\">Importer mon fichier</button>")
      +'<input type="file" id="impSvgInput2" accept="'+LL_ACCEPT+'" hidden>';
    box.appendChild(hero);
    var fi=hero.querySelector('#impSvgInput2');
    hero.querySelector('#impSvgBtn2').addEventListener('click',function(){fi.click();});
    fi.addEventListener('change',function(){
      var f=fi.files&&fi.files[0];if(!f)return;
      llOpenFile(f,function(svg){addCustomSvg(svg);});
      fi.value='';
    });
    var sep=el('div','logo-orsep');sep.innerHTML=window.MT_CONFIG_I18N.text("ui_bbcc9c4d7f50_html", "<span>Ou choisissez un motif</span>");
    box.appendChild(sep);
    var tabs=el('div','fgtabs'), ig=el('div','igrid');
    function addM(key){
      if(LOGOCAT[key] && LOGOCAT[key].clientVisible===false)return;
      var it=el('div','iitem cat');
      logoPreviewInto(it,key);
      it.title=LOGOCAT[key].name||key;
      it.addEventListener('click',function(){
        if (it.classList.contains('loading')) return ;
        it.classList.add('loading');
        addCatalogIcon(key, function(){it.classList.remove('loading');});
      });
      ig.appendChild(it);
    }
    function fill(cat){
      ig.innerHTML='';
      if(cat==='all'){
        Object.keys(LOGOCAT).forEach(function(k){addM(k);});
      }else{
        Object.keys(LOGOCAT).forEach(function(k){if(LOGOCAT[k].category===cat)addM(k);});
      }
      observeLogoPreviews(ig);
    }
    if(LOGOCATS.length){
      var cats=[['all',window.MT_CONFIG_I18N.text("ui_2ff599814388_html", "Tous")]];LOGOCATS.forEach(function(c){cats.push([c.id,window.MT_CONFIG_I18N.label(c.name)]);});
      cats.forEach(function(c,i){
        var tb=el('span','fgtab'+(i===0?' on':''));tb.textContent=c[1];
        tb.addEventListener('click',function(){tabs.querySelectorAll('.fgtab').forEach(function(x){x.classList.remove('on');});tb.classList.add('on');fill(c[0]);});
        tabs.appendChild(tb);
      });
      box.appendChild(tabs);
    }
    box.appendChild(ig);fill('all');
  }

  function inlineEdit(node){
    var it=node?getItem(node.dataset.id):null;if(!it||it.type!=='text')return;
    if(node.isContentEditable)return;
    pushHistory();
    node.classList.remove('curved');node.textContent=it.text;
    if(it.curve&&Math.abs(it.curve)>=1){node.style.width='max-content';node.style.height='auto';node.style.transform='translate(-50%,-50%)'+(normRot(it.rot)?(' rotate('+normRot(it.rot)+'deg)'):'');}
    node.contentEditable='true';node.classList.add('editing');node.focus();
    try{var r=document.createRange();r.selectNodeContents(node);var sl=window.getSelection();sl.removeAllRanges();sl.addRange(r);}catch(e){}
    function oninput(){it.text=node.innerText.replace(/\n$/,'');syncGrey();positionFloat();scheduleLive();mtAutosave();fillFontList();}
    function onkey(ev){
      if(ev.key==='Enter'&&!ev.shiftKey){ev.preventDefault();node.blur();}
      if(ev.key==='Escape'){ev.preventDefault();node.blur();}
    }
    function onblur(){
      node.contentEditable='false';node.classList.remove('editing');
      node.removeEventListener('input',oninput);node.removeEventListener('keydown',onkey);node.removeEventListener('blur',onblur);
      it.text=node.innerText.replace(/\n$/,'');
      if(!String(it.text).trim()){it.text='Votre texte';}
      applyStyle(node,it);
      syncGrey();scheduleLive();mtAutosave();
    }
    node.addEventListener('input',oninput);node.addEventListener('keydown',onkey);node.addEventListener('blur',onblur);
  }

  function toDMS(v,isLat){
    var d=Math.abs(v),deg=Math.floor(d),mf=(d-deg)*60,min=Math.floor(mf),sec=Math.round((mf-min)*60);
    if(sec===60){sec=0;min++;} if(min===60){min=0;deg++;}
    var hemi=isLat?(v>=0?'N':'S'):(v>=0?'E':'O');
    function p2(n){return (n<10?'0':'')+n;}
    return deg+'°'+p2(min)+'′'+p2(sec)+'″'+hemi;
  }
  function addGpsPoint(q,btn){
    if(!q){toast(window.MT_CONFIG_I18N.text("ui_937cc44d74f5_html", "Indiquez un lieu"));return;}
    if(btn){btn.disabled=true;btn.textContent=window.MT_CONFIG_I18N.text("ui_d074331c5d34_html", "Recherche…");}
    function done(){if(btn){btn.disabled=false;btn.textContent=window.MT_CONFIG_I18N.text("ui_00f9c5334547_html", "Ajouter");}}
    fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language='+encodeURIComponent(window.MT_CONFIG_I18N.locale||'fr')+'&q='+encodeURIComponent(q))
      .then(function(r){return r.json();})
      .then(function(j){
        done();
        if(!j||!j.length){toast('Lieu introuvable — essayez « ville, pays »');return;}
        var la=parseFloat(j[0].lat),lo=parseFloat(j[0].lon);
        addText({text:toDMS(la,true)+'  '+toDMS(lo,false),font:'dmsans',size:3.4},false);
        var it=state.sel?getItem(state.sel):null;if(it){it.ls=0.14;var nd=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(nd)applyStyle(nd,it);syncGrey();scheduleLive();}
        toast(window.MT_CONFIG_I18N.text("ui_efd104007fac_html", "Point GPS ajouté ✓"));
      })['catch'](function(){done();toast(window.MT_CONFIG_I18N.text("ui_2bbb6fe09bc1_html", "Recherche indisponible — réessayez"));});
  }
  (function(){
    var gb=document.getElementById('gpsBtn'),gi=document.getElementById('gpsInput');
    if(gb&&gi){
      gb.addEventListener('click',function(){addGpsPoint(gi.value.trim(),gb);});
      gi.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();addGpsPoint(gi.value.trim(),gb);}});
    }
  })();

  // ---- barre de commande (desktop) ----
  (function(){
    var b=document.getElementById('etopBack');if(b)b.addEventListener('click',goInsp);
    var u=document.getElementById('undoTop');if(u)u.addEventListener('click',function(){var x=document.getElementById('undoBtn');if(x&&!x.disabled)x.click();});
    var r=document.getElementById('redoTop');if(r)r.addEventListener('click',function(){var x=document.getElementById('redoBtn');if(x&&!x.disabled)x.click();});
    var h=document.getElementById('harmonizeTop');if(h)h.addEventListener('click',harmonizeAll);
    var rs=document.getElementById('resetTop');if(rs)rs.addEventListener('click',function(){var x=document.getElementById('resetBtn');if(x)x.click();});
    var sv=document.getElementById('saveTop');if(sv)sv.addEventListener('click',function(){openSheet('save');});
    var tv=document.getElementById('toValidTop');if(tv)tv.addEventListener('click',goValid);
    var sm=document.getElementById('saveM');if(sm)sm.addEventListener('click',function(){openSheet('save');});
    var al=document.getElementById('addLineBtn');if(al)al.addEventListener('click',function(){addText(null,false);});
  })();

  var SHAPE_GLYPHS={
    hexa:'<svg viewBox="0 0 48 40" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="12,3 36,3 46,20 36,37 12,37 2,20"/></svg>',
    carree:'<svg viewBox="0 0 48 40" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="7" y="3" width="34" height="34" rx="4"/></svg>'
  };
  var SHAPE_CARD_TARGETS=[{cards:'shapeCards',hole:'holeCard',sub:'holeCardSub'},{cards:'shapeCardsM',hole:'holeCardM',sub:'holeCardSubM'}];
  function buildShapeCards(){
    SHAPE_CARD_TARGETS.forEach(function(t){
      var box=document.getElementById(t.cards);if(!box)return;
      box.innerHTML='';
      var allow=state.allowShapes||['hexa','carree'];
      allow.forEach(function(key){
        var sh=SHAPES[key];if(!sh)return;
        var c=el('button','shapecard'+(state.shape===key?' on':''));
        c.innerHTML='<span class="sg">'+(SHAPE_GLYPHS[key]||'')+'</span><span><b>'+window.MT_CONFIG_I18N.label(sh.label)+'</b><small>'+sh.dim+(/^en/.test(window.MT_CONFIG_I18N.locale)?'':' · gravée au laser')+'</small></span><span class="scp">'+displayEuro(priceShape(key))+'</span>';
        c.addEventListener('click',function(){setShape(key);});
        box.appendChild(c);
      });
      var hc=document.getElementById(t.hole);
      if(hc){
        var holeOptional=(state.allowPerce!==false)&&(state.allowPlein!==false);
        hc.style.display=(state.allowPerce===false)?'none':'';
        hc.disabled=!holeOptional;
        hc.classList.toggle('on',state.hole);
        var sub=document.getElementById(t.sub);
        if(sub)sub.textContent=state.hole?(window.MT_CONFIG_I18N.text("ui_cd37e6d2b9bc_html", "Ajouté ✓ (+")+displayEuro(holeFeeFor(state.shape))+')'):(window.MT_CONFIG_I18N.text("ui_cbe302f533b1_html", "Pour accrocher votre tomette au mur (+")+displayEuro(holeFeeFor(state.shape))+')');
        if(!hc._wired){hc._wired=true;hc.addEventListener('click',toggleHole);}
      }
    });
  }

  var _railModelsN=-1;
  function buildRailModels(){
    var box=document.getElementById('railModels');if(!box)return;
    if(_railModelsN===TEMPLATES.length&&box.children.length)return;
    _railModelsN=TEMPLATES.length;box.innerHTML='';
    TEMPLATES.forEach(function(t){
      var sqp=(t.shape==='carree');
      var m=el('div','rmodel');
      var pv=el('div','rmprev'+(sqp?' sq':''));
      var tomd=el('div','tom '+(sqp?'sq photo':'hex photo'));pv.appendChild(tomd);
      var cv=el('canvas');pv.appendChild(cv);
      m.appendChild(pv);
      var nm=el('div','rmn');nm.textContent=t.name;m.appendChild(nm);
      var psrc={shape:(sqp?'carree':'hexa'),hole:!!t.defaultHole,els:layoutEls(t.els)};
      try{drawPrevCanvas(cv,psrc);}catch(e){}
      m.addEventListener('click',function(){
        syncTextFromDom();
        var snap=snapshot();      // loadTemplate remet l'historique à zéro : on préserve un cran d'annulation
        loadTemplate(t);
        history=[snap];redoStack=[];updateUndo();
        buildShapeCards();mtAutosave();
        toast(window.MT_CONFIG_I18N.text("ui_57d71209a409_html", "Modèle chargé — ↺ pour revenir à votre création"));
      });
      box.appendChild(m);
    });
  }

  // ---- shapes ----
  function syncShapeUI(){
    var btns=document.querySelectorAll('#shapebar button[data-shape]');
    var allow=state.allowShapes||['hexa','carree'];
    var holeOptional=(state.allowPerce!==false)&&(state.allowPlein!==false);
    for(var i=0;i<btns.length;i++){var s=btns[i].dataset.shape;
      if(s==='hole'){ btns[i].style.display=(state.allowPerce===false)?'none':''; btns[i].disabled=!holeOptional; btns[i].classList.toggle('on',state.hole); }
      else { var ok=allow.indexOf(s)>=0; btns[i].style.display=ok?'':'none'; btns[i].classList.toggle('on',state.shape===s); }
    }
    var sep=document.querySelector('#shapebar .shape-sep'); if(sep)sep.style.display=(state.allowPerce===false)?'none':'';
    buildShapeCards();
  }
  function setShape(s){
    if(s===state.shape)return;
    if(state.allowShapes && state.allowShapes.indexOf(s)<0)return;
    var oldSh=SHAPES[state.shape]||SHAPES.hexa, newSh=SHAPES[s]||SHAPES.hexa;
    var coef=newSh.hcm/oldSh.hcm;
    syncTextFromDom();pushHistory();
    if(coef!==1){
      for(var i=0;i<state.els.length;i++){
        var it=state.els[i];
        if(typeof it.size==='number') it.size=Math.round(it.size*coef*100)/100;   // positions (x,y) conservées en fractions
      }
    }
    state.shape=s;render();syncShapeUI();updatePrice();mtAutosave();mtTrack('cfg_shape',{shape:s});
  }
  function toggleHole(){
    var want=!state.hole;
    if(want&&state.allowPerce===false)return;
    if(!want&&state.allowPlein===false)return;
    pushHistory();state.hole=want;render();syncShapeUI();updatePrice();mtAutosave();
  }

  function updatePrice(){
    var base=priceShape(state.shape)+(state.hole?holeFeeFor(state.shape):0);
    document.getElementById('edPrice').textContent=displayEuro(base);
    var p2=document.getElementById('edPrice2');if(p2)p2.textContent=displayEuro(base);
    var p3=document.getElementById('mCartPrice');if(p3)p3.textContent=displayEuro(base);
    document.getElementById('edDim').textContent=window.MT_CONFIG_I18N.label(SHAPES[state.shape].label)+(state.hole?window.MT_CONFIG_I18N.text("ui_f2d2659fc7b3_html", " percée (+")+displayEuro(holeFeeFor(state.shape))+')':'')+' · '+SHAPES[state.shape].dim+(/^en/.test(window.MT_CONFIG_I18N.locale)?'':' · gravée au laser');
  }

  // ---- inspiration (carrousel coverflow + vue grille) ----
  var CF_BOUND=false, cfActive=0, cfItems=[], frHintTimer=null, cfWheelLock=false, cfView='carousel', cfFilter='all', cfAuto=null, cfUserTook=false, cfAutoStop=null;
  function doLoad(it){ if(!it)return; if(it.blank)loadBlank(); else loadTemplate(it.t); }
  function buildInsp(filter){
    cfFilter=filter||'all';
    var grid=document.getElementById('tgrid');resetPreviewRendering();grid.innerHTML='';cfItems=[];
    TEMPLATES.forEach(function(t){
      if(cfFilter!=='all'&&t.occ!==cfFilter)return;
      var card=el('div','tcard');
      var sqp=(t.shape==='carree');
      var prev=el('div','tom '+(sqp?'sq photo':'hex photo')+' prev');
      var cvp=el('canvas','prevcv');
      prev.appendChild(cvp);card.appendChild(prev);
      var psrc={shape:(sqp?'carree':'hexa'),hole:!!t.defaultHole,els:layoutEls(t.els)};
      queuePreviewCanvas(cvp,psrc);
      var nm=el('div','cardnm');nm.textContent=t.name;card.appendChild(nm);
      var idx=cfItems.length;
      card.addEventListener('click',function(){ cfUserControl(); if(cfView==='grid'){doLoad(cfItems[idx]);} else if(idx===cfActive){cfActivate();} else {cfSet(idx);} });
      grid.appendChild(card);
      cfItems.push({name:t.name, occ:(t.badge||''), t:t, blank:false});
    });
    // page blanche = dernière carte de la boucle
    var blank=el('div','tcard blank');
    var bprev=el('div','prev');
    bprev.innerHTML='<svg class="blankhex" viewBox="0 0 120 100" preserveAspectRatio="none" aria-hidden="true"><polygon points="30,1.5 90,1.5 118.5,50 90,98.5 30,98.5 1.5,50"/></svg>'
      +window.MT_CONFIG_I18N.text("ui_f1cc6eb5e8f8_html", "<span class=\"plus\">+</span><div class=\"bnm\">Page blanche</div><div class=\"bsub\">Je crée tout</div>");
    blank.appendChild(bprev);
    var bnm=el('div','cardnm');bnm.textContent=window.MT_CONFIG_I18N.text("ui_1aef3efcd702_html", "Page blanche");blank.appendChild(bnm);
    var bidx=cfItems.length;
    blank.addEventListener('click',function(){ cfUserControl(); if(cfView==='grid'){loadBlank();} else if(bidx===cfActive){cfActivate();} else {cfSet(bidx);} });
    grid.appendChild(blank);
    cfItems.push({blank:true});
    cfActive=0; cfBind(); applyView();
  }
  function buildChips(){
    var c=document.getElementById('chips');if(!c)return;c.innerHTML='';
    var counts={};TEMPLATES.forEach(function(t){counts[t.occ]=(counts[t.occ]||0)+1;});
    OCCASIONS.forEach(function(o,idx){
      if(o[0]!=='all' && !counts[o[0]])return; // masquer les occasions sans modèle
      var ch=el('span','chip'+(idx===0?' on':''));ch.textContent=o[1];ch.dataset.occ=o[0];
      ch.addEventListener('click',function(){
        cfUserControl();
        document.querySelectorAll('#chips .chip').forEach(function(x){x.classList.remove('on');});ch.classList.add('on');
        buildInsp(o[0]);
      });
      c.appendChild(ch);
    });
  }
  function applyView(){
    var insp=document.querySelector('.insp');if(!insp)return;
    insp.classList.toggle('view-grid', cfView==='grid');
    var grid=document.getElementById('tgrid'),ch=grid?grid.children:[],i;
    if(cfView==='grid'){
      for(i=0;i<ch.length;i++){var c=ch[i];c.style.transform='';c.style.opacity='';c.style.zIndex='';c.classList.remove('is-center');}
      observeGridPreviews();
    } else {
      if(_cfPrevObserver){_cfPrevObserver.disconnect();_cfPrevObserver=null;}
      renderCarouselPreviews();
      setTimeout(cfLayout,40);
    }
  }
  function cfLayout(){
    if(cfView!=='carousel')return;
    var grid=document.getElementById('tgrid');if(!grid||!grid.children.length)return;
    var stage=document.getElementById('cfstage'),W=stage?stage.clientWidth:360,n=cfItems.length,ch=grid.children,i;
    /* Largeur de reference = la plus grande carte (l'hexagone). Les decalages se
       calculent a la fois par rapport a la scene ET a la carte :
        - le terme en W garde la composition d'origine sur mobile ;
        - le terme en base force le chevauchement meme sur un large ecran, ou un
          decalage purement proportionnel a la scene ecartait tout ;
        - le dernier terme garantit que la voisine de premier plan tient
          entierement dans la scene : plus de tomette tranchee en deux. */
    var base=0; for(i=0;i<ch.length;i++){var bw=ch[i].offsetWidth; if(bw>base)base=bw;}
    if(!base)base=W*0.6;
    var SC1=.70, SC2=.50;
    var TX1=Math.min(W*0.30, base*0.72, Math.max(base*0.34, W/2 - SC1*base/2 - 6));
    var TX2=Math.min(W*0.47, base*1.16, W/2 - SC2*base/2 + 34);
    for(i=0;i<ch.length;i++){
      var o=i-cfActive; if(o>n/2)o-=n; if(o<-n/2)o+=n;
      var ao=Math.abs(o), s=o<0?-1:1, tx,ry,sc,op,z,tz;
      /* Opacites remontees : les voisines etaient a .42 et .15 AVEC un blur(),
         on n'y lisait plus les gravures. Plus de flou du tout, et de quoi voir
         ce qui arrive. Seules transform / opacity / z-index sont ecrites : le
         compositeur suffit, aucun repeint. */
      if(ao===0){tx=0;ry=0;sc=1;op=1;z=50;tz=80;}
      else if(ao===1){tx=s*TX1;ry=-s*18;sc=SC1;op=.82;z=40;tz=-10;}   // reculee derriere la centrale, mais lisible
      else if(ao===2){tx=s*TX2;ry=-s*24;sc=SC2;op=.42;z=30;tz=-90;}
      else{tx=s*TX2*1.25;ry=-s*28;sc=.42;op=0;z=10;tz=-160;}
      var c=ch[i];
      c.style.transform='translate(-50%,-50%) translateX('+tx+'px) translateZ('+tz+'px) rotateY('+ry+'deg) scale('+sc+')';
      c.style.opacity=op;c.style.zIndex=z;
      c.classList.toggle('is-center',ao===0);
    }
    var it=cfItems[cfActive]||{},go=document.getElementById('cfGo');
    if(go)go.innerHTML=it.blank?window.MT_CONFIG_I18N.text("ui_a64c7d33e99a_html", "Créer librement &rarr;"):window.MT_CONFIG_I18N.text("ui_67238d3e5816_html", "Personnaliser ce modèle &rarr;");
  }
  function cfSet(i){var n=cfItems.length;if(!n)return;cfActive=((i%n)+n)%n;renderCarouselPreviews();cfLayout();}
  function cfStep(d){if(cfView!=='carousel')return;cfSet(cfActive+d);}
  function cfActivate(){doLoad(cfItems[cfActive]);}
  function frHideHint(){var h=document.getElementById('frhint');if(h)h.classList.add('hide');if(frHintTimer){clearTimeout(frHintTimer);frHintTimer=null;}}
  function cfStartAuto(){
    if(!COARSE)return;   // desktop (souris) : pas d'autoplay du carrousel ; l'animation reste sur mobile (tactile)
    if(!CF_READY||cfUserTook||cfView!=='carousel')return;
    var d=document.getElementById('tgrid');if(d)d.classList.add('autoplay');
    /* LA MAIN RESTE, LE DÉFILEMENT PART. Le carrousel avançait tout seul
       d'une carte par seconde pendant deux secondes et demie — et cela ne
       se produit QUE sur tactile, c'est-à-dire précisément là où ça coûte
       le plus cher. Chaque pas repeint des vignettes de 900 px de large
       et fait sauter la pièce sous le doigt de qui commençait déjà à
       faire défiler.

       La main animée, elle, dit la même chose sans rien coûter : elle est
       posée par la classe `autoplay` et reste tant que personne n'a
       touché. On garde donc l'invitation et l'on retire le mouvement. */
    if(cfAutoStop)clearTimeout(cfAutoStop);
    cfAutoStop=setTimeout(cfStopAuto,2500); // la main s'efface au bout de 2,5 s, comme avant
  }
  function cfStopAuto(){ if(cfAuto){clearInterval(cfAuto);cfAuto=null;} if(cfAutoStop){clearTimeout(cfAutoStop);cfAutoStop=null;} var d=document.getElementById('tgrid');if(d)d.classList.remove('autoplay'); }
  function cfUserControl(){ if(cfUserTook)return; cfUserTook=true; cfStopAuto(); frHideHint(); }
  function cfBind(){
    if(CF_BOUND)return;CF_BOUND=true;
    var stage=document.getElementById('cfstage');if(!stage)return;
    var p=document.getElementById('frPrev'),n=document.getElementById('frNext'),go=document.getElementById('cfGo');
    if(p)p.addEventListener('click',function(){cfUserControl();cfStep(-1);});
    if(n)n.addEventListener('click',function(){cfUserControl();cfStep(1);});
    if(go)go.addEventListener('click',function(e){e.stopPropagation();cfActivate();});
    // bascule carrousel / grille
    var vt=document.getElementById('viewtog');
    if(vt)vt.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        cfUserControl();
        cfView=b.dataset.v;
        vt.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
        applyView();
      });
    });
    // swipe tactile / souris (carrousel only)
    var sx=null;
    stage.addEventListener('pointerdown',function(e){if(cfView!=='carousel')return;sx=e.clientX;cfUserControl();});
    window.addEventListener('pointerup',function(e){if(sx===null)return;var dx=e.clientX-sx;sx=null;if(Math.abs(dx)>45){cfStep(dx<0?1:-1);}});
    // molette (carrousel only)
    stage.addEventListener('wheel',function(e){
      if(cfView!=='carousel')return;
      var d=Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY;
      if(Math.abs(d)<6)return;e.preventDefault();
      if(cfWheelLock)return;cfWheelLock=true;setTimeout(function(){cfWheelLock=false;},380);
      cfUserControl();cfStep(d>0?1:-1);
    },{passive:false});
    // clavier
    document.addEventListener('keydown',function(e){
      if(!document.getElementById('sInsp').classList.contains('on')||cfView!=='carousel')return;
      if(e.key==='ArrowRight'){cfUserControl();cfStep(1);}else if(e.key==='ArrowLeft'){cfUserControl();cfStep(-1);}
    });
    /* La barre d'URL mobile qui se retracte declenche un resize en hauteur : on ne
       refait le travail que si la largeur change vraiment. */
    var _cfW=window.innerWidth,_cfRT=null;
    window.addEventListener('resize',function(){
      if(window.innerWidth===_cfW)return;
      _cfW=window.innerWidth;
      if(_cfRT)clearTimeout(_cfRT);
      _cfRT=setTimeout(function(){cfLayout();refreshPrevCanvases();},160);
    });
  }

  function loadTemplate(t){
    mtClearPhotoContext();
    state.allowShapes=(t.allowShapes&&t.allowShapes.length)?t.allowShapes.slice():['hexa','carree'];
    state.allowPlein=(t.allowPlein!==false);state.allowPerce=(t.allowPerce!==false);
    state.shape=(state.allowShapes.indexOf(t.shape)>=0)?t.shape:state.allowShapes[0];
    state.hole=!!t.defaultHole; if(state.hole&&state.allowPerce===false)state.hole=false; if(!state.hole&&state.allowPlein===false&&state.allowPerce!==false)state.hole=true;
    state.sel=null;state.gift={on:false,wrap:false,msg:'',ship:false};
    state.els=layoutEls(t.els);
    requestTemplateSvgs(state.els,true);   /* le modèle ouvert passe devant la file */
    state.tmpl=JSON.stringify({shape:state.shape,hole:state.hole,els:t.els,allowShapes:state.allowShapes,allowPlein:state.allowPlein,allowPerce:state.allowPerce});
    history=[];updateUndo();
    syncShapeUI();render();updatePrice();goEditor();
  }
  function loadBlank(){
    mtClearPhotoContext();
    state.allowShapes=['hexa','carree'];state.allowPlein=true;state.allowPerce=true;
    state.shape='hexa';state.hole=false;state.sel=null;state.gift={on:false,wrap:false,msg:'',ship:false};
    state.els=layoutEls([{type:'text',text:'Votre texte',font:'cormorant',size:7}]);
    state.tmpl=JSON.stringify({shape:'hexa',hole:false,els:[{type:'text',text:'Votre texte',font:'cormorant',size:7}],allowShapes:['hexa','carree'],allowPlein:true,allowPerce:true});
    history=[];updateUndo();
    syncShapeUI();render();updatePrice();goEditor();
  }
  function reloadTemplate(){
    if(!state.tmpl)return;var o=JSON.parse(state.tmpl);pushHistory();
    state.allowShapes=(o.allowShapes&&o.allowShapes.length)?o.allowShapes.slice():['hexa','carree'];
    state.allowPlein=(o.allowPlein!==false);state.allowPerce=(o.allowPerce!==false);
    state.shape=o.shape;state.hole=!!o.hole;state.sel=null;
    state.els=layoutEls(o.els);
    syncShapeUI();render();updatePrice();
  }

  // ---- recette (source de vérité) + deep-link (#d=) ----
  function mtPhotoProductContext(value){
    if(!value||typeof value!=='object')return null;
    var id=String(value.id||''),path=String(value.url||'');
    if(!/^\d{6,20}$/.test(id)||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(path))return null;
    return {id:id,url:path.replace(/\/$/,'')};
  }
  function mtPhotoResumeUrl(recipe,encoded){
    var context=recipe&&mtPhotoProductContext(recipe.photoProduct);
    if(!context)return '';
    var data=encoded||recipeToHash(recipe).slice(3);
    if(!/^[A-Za-z0-9_-]+$/.test(data))return '';
    try{
      var path=new URL(window.MT_CONFIG_I18N.absoluteUrl(context.url)).pathname;
      return 'https://www.mytomette.fr'+path+'#photo-resume='+data;
    }catch(e){return '';}
  }
  function mtResumePhoto(recipe,encoded){
    _mtPhotoResumePending=true;
    var target=mtPhotoResumeUrl(recipe,encoded);
    if(target){try{window.location.replace(target);return true;}catch(e){}}
    var ov=document.getElementById('sheetOv'),body=document.getElementById('sheetBody');
    if(ov&&body){
      document.getElementById('sheetTitle').textContent=window.MT_CONFIG_I18N.text("ui_9311fc1f7b54_html", "Atelier momentanément indisponible");
      document.getElementById('sheetHint').hidden=true;body.innerHTML='';ov.dataset.kind='photo-resume';
      if(target){
        var retry=el('button','sheet-ok');retry.type='button';retry.textContent=window.MT_CONFIG_I18N.text("ui_af273d956b5b_html", "Réessayer");
        retry.addEventListener('click',function(){mtResumePhoto(recipe,encoded);});body.appendChild(retry);
      }
      ov.classList.remove('closing');ov.classList.add('on');
    }
    return false;
  }
  function mtPhotoNativeBlocked(){
    if(!state.photoProduct&&!_mtPhotoResumePending)return false;
    if(state.photoProduct&&!mtcfgEmbedded()&&!MT_ADMIN)mtResumePhoto(getRecipe());
    else toast(window.MT_CONFIG_I18N.text("ui_9311fc1f7b54_html", "Atelier momentanément indisponible"));
    return true;
  }
  function mtClearPhotoContext(){
    if(state.photoProduct){CFG_PRICES=_mtPricesBeforePhoto;state.photoProduct=null;}
  }
  function getRecipe(src){
    src=src||state;var sh=SHAPES[src.shape]||SHAPES.hexa;
    var recipe={
      v:1, shape:src.shape, hole:!!src.hole, allowShapes:(src.allowShapes||['hexa','carree']), allowPlein:src.allowPlein!==false, allowPerce:src.allowPerce!==false,
      dims:{w_mm:sh.wcm*10, h_mm:sh.hcm*10},
      gift:src.gift?{on:!!src.gift.on,wrap:!!src.gift.wrap,msg:src.gift.msg||'',ship:!!src.gift.ship}:null,
      elements:(src.els||[]).map(function(e){
        if(e.type==='text'){var t={type:'text',text:e.text,x:e.x,y:e.y,font:e.font,size:e.size,weight:e.weight||defaultWeight(e.font),ls:e.ls||0,color:'#4a2616'};if(e.align&&e.align!=='center')t.align=e.align;if(e.lh&&e.lh!==1.1)t.lh=e.lh;if(e.smallcaps)t.smallcaps=true;if(e.curve)t.curve=e.curve;if(normRot(e.rot))t.rot=normRot(e.rot);if(e.lock)t.lock=true;if(e._adm)t._adm=e._adm;return t;}
        var o={type:'logo',logo:e.icon,x:e.x,y:e.y,size:e.size,color:'#4a2616'};
        if(e.flip)o.flip=true; if(e.svg)o.svg=e.svg; // logo importé (custom) embarqué dans la recette
        if(e.svgRef)o.svgRef=e.svgRef; // sans elle, 23 modèles sur 59 perdent leur logo au retour
        if(e.qrMeta)o.qrMeta=e.qrMeta; // QR : type + champs pour ré-édition
        if(normRot(e.rot))o.rot=normRot(e.rot);
        if(e.lock)o.lock=true;
        if(e.stroke!=null&&Math.abs(e.stroke-1.7)>0.001)o.stroke=e.stroke; // épaisseur (gravée par l'artisan) -> persistée
        if(e._adm)o._adm=e._adm;
        return o;
      })
    };
    if(src.photoProduct)recipe.photoProduct=mtPhotoProductContext(src.photoProduct);
    return recipe;
  }
  /* Les polices voyagent DANS la recette (id, famille, graisses, source). Le moteur
     guide s'en sert depuis toujours ; ici on ne lisait que fonts.json — or ce fichier
     n'est pas joignable quand le configurateur est ouvert dans l'iframe blob: de la
     fiche produit (origine opaque). FONTREG restait alors sur le catalogue integre,
     sans `source`, et la gravure repartait en Regular. */
  function mergeRecipeFonts(list){
    if(!list||!list.length)return;
    list.forEach(function(f){
      if(!f||!f.id)return;
      var prev=FONTREG[f.id]||{};
      var fam=f.family||prev.family||f.id;
      FONTREG[f.id]={id:f.id,label:prev.label||f.id,css:"'"+fam+"',"+fbCss(f.category||prev.grp),
        grp:f.category||prev.grp||'manu',family:fam,
        weights:f.weights||prev.weights||'400',
        source:f.source||prev.source||'google',
        url:f.url||prev.url, ttf:f.ttf||prev.ttf};
    });
    try{ if(typeof _fontCache!=='undefined')_fontCache={}; }catch(e){}
    try{ mtLayCacheClear(); }catch(e){}
  }
  function loadRecipe(r){
    if(!r||!r.elements||!r.elements.length)return false;
    var photo=Object.prototype.hasOwnProperty.call(r,'photoProduct')?mtPhotoProductContext(r.photoProduct):null;
    if(Object.prototype.hasOwnProperty.call(r,'photoProduct')&&!photo)return false;
    if(photo&&!state.photoProduct)_mtPricesBeforePhoto=CFG_PRICES;
    if(!photo)mtClearPhotoContext();
    state.photoProduct=photo;
    mergeRecipeFonts(r.fonts);
    if(r.prices&&typeof r.prices==='object')CFG_PRICES=r.prices;
    state.shape=SHAPES[r.shape]?r.shape:'hexa';
    state.hole=!!r.hole;state.sel=null;
    state.allowShapes=(r.allowShapes&&r.allowShapes.length)?r.allowShapes.slice():['hexa','carree'];
    state.allowPlein=(r.allowPlein!==false);state.allowPerce=(r.allowPerce!==false);
    state.gift=r.gift?{on:!!r.gift.on,wrap:!!r.gift.wrap,msg:r.gift.msg||'',ship:!!r.gift.ship}:{on:false,wrap:false,msg:'',ship:false};
    state.els=r.elements.map(function(e){
      if(e.type==='text'){var t={id:String(uid++),type:'text',text:stripVars(e.text||''),x:(e.x!=null?e.x:0.5),y:(e.y!=null?e.y:0.5),font:e.font||DEFAULT_FONT,size:e.size||6.5,weight:e.weight,ls:e.ls||0};if(e.align)t.align=e.align;if(e.lh)t.lh=e.lh;if(e.smallcaps)t.smallcaps=true;if(e.curve)t.curve=e.curve;if(e.rot)t.rot=normRot(e.rot);if(e.lock)t.lock=true;if(e._adm)t._adm=e._adm;return t;}
      var o={id:String(uid++),type:'icon',icon:e.logo||'leaf',x:(e.x!=null?e.x:0.5),y:(e.y!=null?e.y:0.5),size:e.size||13};
      if(e.flip)o.flip=true;
      if(e.svg)o.svg=e.svg;
      if(e.svgRef)o.svgRef=e.svgRef;
      if(e.qrMeta)o.qrMeta=e.qrMeta;
      if(e.stroke!=null)o.stroke=e.stroke;
      if(e.rot)o.rot=normRot(e.rot);
      if(e.lock)o.lock=true;
      if(e._adm)o._adm=e._adm;
      return o;
    });
    state.tmpl=JSON.stringify({shape:state.shape,hole:state.hole,els:state.els,allowShapes:state.allowShapes,allowPlein:state.allowPlein,allowPerce:state.allowPerce});
    history=[];updateUndo();
    requestTemplateSvgs(state.els,true);   /* Greffe 8 : le motif propre au modèle (svgRef) revient avec la recette */
    return true;
  }
  function b64urlEnc(str){return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');}
  function b64urlDec(s){s=String(s).replace(/-/g,'+').replace(/_/g,'/');while(s.length%4)s+='=';return decodeURIComponent(escape(atob(s)));}
  function recipeToHash(r){try{return '#d='+b64urlEnc(JSON.stringify(r));}catch(e){return '';}}
  function hashToRecipe(){
    var m=(location.hash||'').match(/[#&]d=([^&]+)/);if(!m)return null;
    try{return JSON.parse(b64urlDec(decodeURIComponent(m[1])));}catch(e){return null;}
  }
  var _asTimer=null, AUTOSAVE_KEY='mt_autosave_v1';
  function mtAutosave(){
    if(MT_ADMIN)return;   /* admin : pas d'autosave localStorage côté boutique */
    if(_asTimer)clearTimeout(_asTimer);
    _asTimer=setTimeout(function(){
      _asTimer=null;
      try{
        syncTextFromDom();
        restackByFootprint();   // les tailles ont pu changer : on re-classe les calques
        var r=getRecipe();
        if(!r.elements||!r.elements.length){localStorage.removeItem(AUTOSAVE_KEY);return;}   // jamais d'écriture vide
        localStorage.setItem(AUTOSAVE_KEY,JSON.stringify({t:Date.now(),r:r}));
      }catch(e){}
    },900);
  }
  function mtAutosaveGet(){
    try{
      var raw=localStorage.getItem(AUTOSAVE_KEY);if(!raw)return null;
      var o=JSON.parse(raw);
      if(!o||!o.r||!o.r.elements||!o.r.elements.length)return null;
      if(Date.now()-(o.t||0)>1000*3600*24*30)return null;   // on ne propose plus au-delà de 30 jours
      return o.r;
    }catch(e){return null;}
  }
  function mtOfferResume(){
    var r=mtAutosaveGet();if(!r)return;
    var head=document.querySelector('.insphead');if(!head||document.getElementById('resumePill'))return;
    var p=el('button','resumepill');p.id='resumePill';
    p.innerHTML=window.MT_CONFIG_I18N.text("ui_8f055bea011f_html", "⟲ Reprendre ma création en cours <span>là où vous l'aviez laissée</span>");
    p.addEventListener('click',function(){
      var rr=mtAutosaveGet();
      if(rr&&loadRecipe(rr)){render();updatePrice();goEditor();toast(window.MT_CONFIG_I18N.text("ui_268228014eb0_html", "Création restaurée ✓"));}
      else{toast(window.MT_CONFIG_I18N.text("ui_fff198f86d21_html", "Création introuvable"));p.remove();}
    });
    head.insertBefore(p,head.firstChild);
  }

  function shareCurrent(){
    if(mtHasFond(state)){   // greffe F8 : l'image seule, sans lien ; sinon le message
      var txt0=window.MT_CONFIG_I18N.text("ui_4e34d2fc79e1_html", "Regarde ma tomette personnalisée — dis-moi ce que tu en penses !");
      try{
        if(navigator.share&&navigator.canShare&&window.File){
          renderPNG(state,function(png){
            try{
              if(!png){toast(mtFondMessageReste(mtFondTypeDe(state)));return;}
              var bin0=atob(png.split(',')[1]),u80=new Uint8Array(bin0.length);
              for(var j=0;j<bin0.length;j++)u80[j]=bin0.charCodeAt(j);
              var f0=new File([u80],'ma-tomette.png',{type:'image/png'});
              if(navigator.canShare({files:[f0]}))navigator.share({files:[f0],title:'Ma tomette MyTomette',text:txt0})['catch'](function(){});
              else toast(mtFondMessageReste(mtFondTypeDe(state)));
            }catch(e){toast(mtFondMessageReste(mtFondTypeDe(state)));}
          });
          return;
        }
      }catch(e){}
      toast(mtFondMessageReste(mtFondTypeDe(state)));return;
    }
    var url=modelLink();
    var txt=window.MT_CONFIG_I18N.text("ui_4e34d2fc79e1_html", "Regarde ma tomette personnalisée — dis-moi ce que tu en penses !");
    function fallback(){
      if(navigator.share){navigator.share({title:'Ma tomette MyTomette',text:txt,url:url})['catch'](function(){});return;}
      if(!copyText(url)){try{window.prompt(window.MT_CONFIG_I18N.text("ui_0fee539f3131_html", "Copiez votre lien :"),url);}catch(e){}}
      else toast(window.MT_CONFIG_I18N.text("ui_bb962cbd1c8c_html", "Lien copié ✓"));
    }
    if(navigator.share&&navigator.canShare&&window.File){
      try{
        renderPNG(state,function(png){
          try{
            if(!png){fallback();return;}
            var bin=atob(png.split(',')[1]);
            var u8=new Uint8Array(bin.length);
            for(var i=0;i<bin.length;i++)u8[i]=bin.charCodeAt(i);
            var f=new File([u8],'ma-tomette.png',{type:'image/png'});
            if(navigator.canShare({files:[f]})){
              navigator.share({files:[f],title:'Ma tomette MyTomette',text:txt+' '+url})['catch'](function(){});
            }else fallback();
          }catch(e){fallback();}
        });
        return;
      }catch(e){}
    }
    fallback();
  }

  var EMAILJS_PUBLIC='REMPLACER', EMAILJS_SERVICE='REMPLACER', EMAILJS_TEMPLATE='REMPLACER';
  var SHARE_BASE=window.MT_CONFIG_I18N.absoluteUrl("https://mytomette.fr/pages/configurateur-app");
  var PUBLIC_HOST='mytomette.fr';   // domaine public affiché dans les liens (jamais *.myshopify.com)
  function publicize(u){
      try{return u.replace(/https?:\/\/[a-z0-9-]+\.myshopify\.com/i,'https://'+PUBLIC_HOST)
                .replace(/https?:\/\/[a-z0-9-]+\.shopifypreview\.com/i,'https://'+PUBLIC_HOST);}
    catch(e){return u;}
  }
  function baseUrl(){
    // An embedded editor inherits the product URL. Resume always opens the expert page.
    var path=(/^en(?:-|$)/i.test(window.MT_CONFIG_I18N.locale||'')?'/en':'')+'/pages/configurateur-app';
    try{
      var candidate=new URL(SHARE_BASE,'https://www.mytomette.fr').pathname;
      if(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/configurateur-app\/?$/i.test(candidate))path=candidate.replace(/\/$/,'');
    }catch(e){}
    return 'https://www.mytomette.fr'+path;
  }
  /* CARTE GRAVÉE — greffe F8 (10/2026, Lot 0, relecture) : une recette qui porte une carte (15 à 560 Ko)
     ne quitte jamais l'appareil par un lien, que la couche d'édition tourne ou non. La garde de
     lien-court.js ne vivait que dans la couche : si celle-ci tombait, l'envoi natif de la feuille
     « Gardez votre création » postait tout le #d= à send-tomette.php (qui le raccourcit par c.php).
     Ici : pas de recette dans le lien, pas d'e-mail, partage de l'image seule. */
  function mtCarteMessageReste(){return window.MT_CONFIG_I18N.text("ui_4d2cb65500e4_html", "Votre carte reste sur cet appareil : pour la garder à coup sûr, ajoutez-la au panier.");}
  /* CIEL — greffe G3 (2026, Lot 0-ciel) : F8 vaut pour tout fond ; seule la phrase suit le type. */
  function mtFondMessageReste(ty){if(ty==='ciel')return window.MT_CONFIG_I18N.text("ui_1dcc49503620_html", "Votre ciel reste sur cet appareil : pour le garder à coup sûr, ajoutez-le au panier.");return mtCarteMessageReste();}
  function modelLink(){syncTextFromDom();if(mtHasFond(state))return baseUrl();return baseUrl()+recipeToHash(getRecipe());}   // greffe F8
  function mtHasUnsavedCreation(){
    syncTextFromDom();
    var recipe=getRecipe();
    if(!recipe.elements||!recipe.elements.length)return false;
    var current=JSON.stringify(recipe);
    return current!==_mtSavedRecipe;
  }
  function mtLeaveEditor(){
    window._mtLeaveAfterSave=false;
    if(mtcfgEmbedded()){try{window.parent.postMessage({mtcfg:'close'},'*');}catch(e){}}
    else{window.location.href=window.MT_CONFIG_I18N.url('/');}
  }
  function copyText(t){
    try{
      var ta=document.createElement('textarea');ta.value=t;ta.setAttribute('readonly','');
      ta.style.cssText='position:fixed;top:-1000px;left:0;opacity:0';
      document.body.appendChild(ta);ta.focus();ta.select();
      try{ta.setSelectionRange(0,99999);}catch(e){}
      var ok=false;try{ok=document.execCommand('copy');}catch(e){ok=false;}
      document.body.removeChild(ta);
      if(ok)return true;
    }catch(e){}
    try{if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t);return true;}}catch(e){}
    return false;
  }
  function newsletterSubscribe(email){
    if(!isLive())return;            // en démo on ne poste rien
    try{
      var fd=new FormData();
      fd.append('form_type','customer');fd.append('utf8','✓');
      fd.append('contact[email]',email);
      fd.append('contact[accepts_marketing]','true');
      fd.append('contact[tags]','configurateur,newsletter');
      fetch('/contact',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})['catch'](function(){});
    }catch(e){}
  }
  function emailjsReady(){return EMAILJS_PUBLIC.indexOf('REMPLACER')<0&&EMAILJS_SERVICE.indexOf('REMPLACER')<0&&EMAILJS_TEMPLATE.indexOf('REMPLACER')<0;}
  var MTE_MAIL_ENDPOINT='https://admin.mytomette.fr/send-tomette.php';
  function mailEndpointReady(){return /^https:\/\//.test(MTE_MAIL_ENDPOINT);}
  function sendViaOvh(email,link,news,cb,newsletterMetadata){
    renderPNG(state,function(png){
      var s=SHAPES[state.shape]||{label:'',dim:''};
      var payload={email:email,link:link,png:png||'',forme:s.label||'',dimensions:s.dim||'',prix:eur(priceShape(state.shape)+(state.hole?holeFeeFor(state.shape):0))+'€',newsletter:news?1:0,newsletter_consent_version:'configurateur-newsletter-2026-09-29-v3',newsletter_default_checked:true,newsletter_user_changed:!!(newsletterMetadata&&newsletterMetadata.user_changed),newsletter_locale:/^en(?:-|$)/i.test(window.MT_CONFIG_I18N.locale||'')?'en':'fr',logos:(typeof _collectClientLogos==='function'?_collectClientLogos():[])};
      var ctrl=(window.AbortController?new AbortController():null);
      var tmo=setTimeout(function(){try{ctrl&&ctrl.abort();}catch(e){}},15000);
      fetch(MTE_MAIL_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:ctrl?ctrl.signal:undefined})
        .then(function(r){return r.json();})
        .then(function(j){clearTimeout(tmo);cb(!!(j&&j.ok));})
        ['catch'](function(){clearTimeout(tmo);cb(false);});
    });
  }
  function sendModelEmail(email,news,cb,preparedLink,newsletterMetadata){
    if(mtHasFond(state)){cb&&cb(false,'');return;}   // greffe F8 : aucune recette carte vers send-tomette.php
    var link=preparedLink||modelLink();
    if(news)newsletterSubscribe(email);
    if(mailEndpointReady()){
      sendViaOvh(email,link,news,function(ok){
        if(ok){cb&&cb(true,link);return;}
        if(emailjsReady()){_sendViaEmailjs(email,link,cb);}else{cb&&cb(false,link);}
      },newsletterMetadata);
      return;
    }
    if(!emailjsReady()){cb&&cb(false,link);return;}   // pas configuré -> on renvoie le lien
    _sendViaEmailjs(email,link,cb);
  }
  function _sendViaEmailjs(email,link,cb){
    function go(){
      try{
        window.emailjs.init(EMAILJS_PUBLIC);
        var s=SHAPES[state.shape]||{label:'',dim:''};
        window.emailjs.send(EMAILJS_SERVICE,EMAILJS_TEMPLATE,{to_email:email,link:link,forme:s.label,dimensions:s.dim}).then(
          function(){cb&&cb(true,link);},function(){cb&&cb(false,link);});
      }catch(e){cb&&cb(false,link);}
    }
    if(window.emailjs){go();return;}
    var sc=document.createElement('script');
    sc.src='https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
    sc.onload=go;sc.onerror=function(){cb&&cb(false,link);};
    document.head.appendChild(sc);
  }

  function photoUrl(sq){
    try{var v=getComputedStyle(document.documentElement).getPropertyValue(sq?'--tom-photo-sq':'--tom-photo');
        var m=v.match(/url\((['"]?)(.*?)\1\)/);return m?m[2]:'';}catch(e){return '';}
  }
  function sizeCqwFor(item,shapeKey){var sh=SHAPES[shapeKey]||SHAPES.hexa;return (item.size||6)*(SIZE_REF/sh.wcm);}
  function hexPath(ctx,W,H){ctx.beginPath();ctx.moveTo(0.25*W,0);ctx.lineTo(0.75*W,0);ctx.lineTo(W,0.5*H);ctx.lineTo(0.75*W,H);ctx.lineTo(0.25*W,H);ctx.lineTo(0,0.5*H);ctx.closePath();}
  function roundRectPath(ctx,x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();}
  function drawContain(ctx,img,W,H){var iw=img.naturalWidth||img.width,ih=img.naturalHeight||img.height;if(!iw||!ih){ctx.drawImage(img,0,0,W,H);return;}var sc=Math.min(W/iw,H/ih),dw=iw*sc,dh=ih*sc;ctx.drawImage(img,(W-dw)/2,(H-dh)/2,dw,dh);}
  function drawTilePhoto(ctx,img,W,H,sq){
    if(!sq){drawContain(ctx,img,W,H);return;}
    var iw=img.naturalWidth||img.width,ih=img.naturalHeight||img.height;
    if(!iw||!ih){ctx.drawImage(img,0,0,W,H);return;}
    var b=MT_SQFACE,sx=b.x0*iw,sy=b.y0*ih,sw=(b.x1-b.x0)*iw,sh=(b.y1-b.y0)*ih;
    ctx.drawImage(img,sx,sy,sw,sh,0,0,W,H);
  }
  function renderPNG(src,cb){
    src=src||state;
    var sh=SHAPES[src.shape]||SHAPES.hexa, sq=sh.cls==='sq', BURN='#4a2616', els=mtFondEls(src.els||[],src.shape);   // greffe F5 : fond forcé, sur une copie
    var logoImgs={}, logoBox={}, pending=0, started=false;
    function tintMask(src,color){
      var c=document.createElement('canvas');c.width=src.width;c.height=src.height;
      var x=c.getContext('2d');x.drawImage(src,0,0);
      x.globalCompositeOperation='source-in';x.fillStyle=color;x.fillRect(0,0,c.width,c.height);
      return c;
    }
    function paint(ctx,W,H,bgImg){
      if(bgImg){drawTilePhoto(ctx,bgImg,W,H,sq);}
      else{ctx.fillStyle='#c2643c';if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}ctx.fill();}
      var mk=document.createElement('canvas');mk.width=W;mk.height=H;var mc=mk.getContext('2d');
      mc.textAlign='center';mc.textBaseline='middle';
      var F=mtFace(sq,W,H);
      els.forEach(function(e,i){
        var cx=F.ox+(e.x!=null?e.x:0.5)*F.fw, cy=F.oy+(e.y!=null?e.y:0.5)*F.fh;
        var _rot=normRot(e.rot);
        if(_rot){mc.save();mc.translate(cx,cy);mc.rotate(_rot*Math.PI/180);cx=0;cy=0;}
        if(e.type==='text'){
          var f=fontById(e.font), fpx=sizeCqwFor(e,src.shape)/100*F.fw;
          mc.fillStyle='#000';
          try{mc.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
          var reqWeight=mteWeight(e.font,e.weight),face=mteResolvedSpec(e.font,reqWeight),synStroke=mteSyntheticStroke(e.font,reqWeight,fpx);
          mc.font=(f.italic?'italic ':'')+face.faceWeight+' '+fpx+'px '+engraveCss(e.font,reqWeight);
          var txt=(f.caps?String(e.text||'').toUpperCase():String(e.text||''));
          if(e.smallcaps)txt=txt.toUpperCase();
          if(e.curve&&Math.abs(e.curve)>=1){
            _drawCurvedInto(mc,e,txt.replace(/\n/g,' '),fpx,cx,cy,synStroke);
          }else{
            var _l8=mtLayOf(e,src.shape);
            fpx=(_l8.size*(SIZE_REF/(SHAPES[src.shape]||SHAPES.hexa).wcm))/100*F.fw;
            mc.font=(f.italic?'italic ':'')+face.faceWeight+' '+fpx+'px '+engraveCss(e.font,reqWeight);
            try{mc.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
            synStroke=mteSyntheticStroke(e.font,reqWeight,fpx);
            var lines=_l8.lines, lh=fpx*MT_LH, y0=cy-(lines.length-1)*lh/2;
            lines.forEach(function(ln,li){if(synStroke>0){mc.save();mc.lineJoin='round';mc.miterLimit=2;mc.lineWidth=synStroke;mc.strokeStyle='#000';mc.strokeText(ln,cx,y0+li*lh);mc.restore();}mc.fillText(ln,cx,y0+li*lh);});
          }
        } else {
          var im=logoImgs[i]; if(!im||!im.naturalWidth)return;
          var s=sizeCqwFor(e,src.shape)/100*F.fw, bx=logoBox[i]||{w:1,h:1}, k=Math.min(s/bx.w,s/bx.h), dw=bx.w*k, dh=bx.h*k;
          if(e.flip){mc.save();mc.translate(cx,cy);mc.scale(-1,1);mc.drawImage(im,-dw/2,-dh/2,dw,dh);mc.restore();}
          else{mc.drawImage(im,cx-dw/2,cy-dh/2,dw,dh);}
        }
        if(_rot)mc.restore();
      });
      try{mc.letterSpacing='0px';}catch(_){}
      var _sf=ctx.filter;
      try{ctx.filter='blur('+Math.max(.3,W*0.0004).toFixed(2)+'px)';}catch(_){}
      ctx.globalCompositeOperation='multiply'; ctx.globalAlpha=1;
      ctx.drawImage(tintMask(mk,'#6f5331'),0,0);
      try{ctx.filter=_sf||'none';}catch(_){}
      ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
      ctx.globalCompositeOperation='destination-in';
      if(bgImg){drawTilePhoto(ctx,tileMaskOf(bgImg,sq)||bgImg,W,H,sq);}
      else{ctx.fillStyle='#000';if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}ctx.fill();}
      ctx.globalCompositeOperation='source-over';
      if(sq){ // angles arrondis comme le fond -> pas de coins noirs sur la photo carrée (panier + email artisan)
        ctx.globalCompositeOperation='destination-in';
        ctx.fillStyle='#000'; roundRectPath(ctx,0,0,W,H,Math.round(W*0.03)); ctx.fill();
        ctx.globalCompositeOperation='source-over';
      }
    }
    function build(useBg){
      var W=1200, H=Math.round(W*(sh.hcm/sh.wcm));
      function finish(bgImg){
        var cv=document.createElement('canvas');cv.width=W;cv.height=H;
        var ctx=cv.getContext('2d');paint(ctx,W,H,bgImg);
        var url=null;try{url=cv.toDataURL('image/png');}catch(err){url=null;}
        if(!url&&useBg){build(false);return;} // photo cross-origin -> repli fond terre cuite
        cb(url);
      }
      if(useBg){
        var p=photoUrl(sq); if(!p){build(false);return;}
        var bg=new Image();bg.crossOrigin='anonymous';
        bg.onload=function(){finish(bg);};bg.onerror=function(){build(false);};bg.src=p;
      }else{finish(null);}
    }
    function go(){
      if(started)return; started=true;
      els.forEach(function(e,i){
        if(e.type!=='icon')return;
        var raw=logoSvg(e), svg;
        if(raw){svg=thickenSvg(String(raw),e).replace(/currentColor/g,BURN);}
        else{svg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="'+BURN+'" stroke-width="'+((e.stroke||1.7)).toFixed(2)+'">'+(ICONS[e.icon]||ICONS.leaf)+'</svg>';}
        if(!/xmlns=/.test(svg)) svg=svg.replace(/<svg\b/i,'<svg xmlns="http://www.w3.org/2000/svg"');
        svg=ensureSvgSize(svg);   // width/height explicites -> chargement fiable (Safari)
        var bx={w:24,h:24}, vbm=svg.match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);
        if(vbm){var aa=vbm[1].trim().split(/\s+/);if(aa.length===4){bx.w=parseFloat(aa[2])||24;bx.h=parseFloat(aa[3])||24;}}
        logoBox[i]=bx;
        pending++;
        var im=new Image();
        (function(idx){function ok(){logoImgs[idx]=im;if(--pending<=0)build(true);} im.onload=function(){if(im.decode){im.decode().then(ok).catch(ok);}else ok();};im.onerror=function(){if(--pending<=0)build(true);};})(i);
        im.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg);
      });
      if(pending===0)build(true);
    }
    if(document.fonts&&document.fonts.ready){document.fonts.ready.then(go,go);}else{go();}
  }
  function downloadPNG(){
    syncTextFromDom();
    renderPNG(state,function(url){
      if(!url){toast(window.MT_CONFIG_I18N.text("ui_2fe074657351_html", "Aperçu indisponible"));return;}
      var a=document.createElement('a');a.href=url;a.download='ma-tomette.png';document.body.appendChild(a);a.click();a.remove();
      toast(window.MT_CONFIG_I18N.text("ui_f365134586fe_html", "Aperçu téléchargé ✓"));
    });
  }

  var BURN_LIVE='#4a2616';
  var _bgImgCache={}, _logoImgCache={}, _liveRaf=0, _liveRO=null, _maskCv=null;
  var _tintCv=null,_tintCx=null;
  function tintMaskC(srcCanvas,color){
    if(!_tintCv){_tintCv=document.createElement('canvas');_tintCx=_tintCv.getContext('2d');}
    if(_tintCv.width!==srcCanvas.width||_tintCv.height!==srcCanvas.height){_tintCv.width=srcCanvas.width;_tintCv.height=srcCanvas.height;}
    var x=_tintCx;x.globalCompositeOperation='source-over';x.clearRect(0,0,_tintCv.width,_tintCv.height);
    x.drawImage(srcCanvas,0,0);
    x.globalCompositeOperation='source-in';x.fillStyle=color;x.fillRect(0,0,_tintCv.width,_tintCv.height);
    x.globalCompositeOperation='source-over';
    return _tintCv;
  }
  function shapePathLive(ctx,sq,W,H){
    if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}
  }
  function wrapCanvasLines(ctx,txt,maxW){
    var out=[];
    String(txt).split('\n').forEach(function(para){
      var words=para.split(' '), cur=words.length?words[0]:'';
      for(var i=1;i<words.length;i++){
        if(ctx.measureText(cur+' '+words[i]).width>maxW){out.push(cur);cur=words[i];}
        else cur=cur+' '+words[i];
      }
      out.push(cur);
    });
    return out;
  }
  /* TOMETTE PHOTO — greffe 4b (10/2026, Lot 0). À chaque image de l'aperçu vivant, burnSvgOf
     repasse le SVG de chaque logo dans sanitizeSvg, thickenSvg, un remplacement de couleur et
     ensureSvgSize : une dizaine de passes d'expressions régulières sur ≈ 300 Ko pour une photo, et
     une NOUVELLE chaîne à chaque fois, que getLogoImg doit rehacher pour retrouver son image. Pour un
     SVG embarqué (item.svg) le résultat ne dépend que de ce SVG et de l'épaisseur : on le garde.
     Réservé aux grands SVG (> 20 000 caractères) ; les autres suivent le chemin d'origine. */
  var _mtpxBrulure=(typeof Map==='function')?new Map():null;
  function burnSvgOf(item){
    var _mtpxGrand=!!(_mtpxBrulure&&item&&typeof item.svg==='string'&&item.svg.length>20000),_mtpxEp=(item&&item.stroke)||1.7;
    if(_mtpxGrand){var _mtpxM=_mtpxBrulure.get(item.svg);if(_mtpxM&&_mtpxM.ep===_mtpxEp)return _mtpxM.v;}
    var _mtpxV=_mtpxBurnSvgOf(item);
    if(_mtpxGrand){if(_mtpxBrulure.size>=8)_mtpxBrulure.clear();_mtpxBrulure.set(item.svg,{ep:_mtpxEp,v:_mtpxV});}
    return _mtpxV;
  }
  function _mtpxBurnSvgOf(item){
    var raw=logoSvg(item), svg;
    if(raw){ svg=thickenSvg(String(raw),item).replace(/currentColor/g,BURN_LIVE); }
    else{ svg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="'+BURN_LIVE+'" stroke-width="'+((item.stroke||1.7)).toFixed(2)+'">'+(ICONS[item.icon]||ICONS.leaf)+'</svg>'; }
    if(!/xmlns=/.test(svg)) svg=svg.replace(/<svg\b/i,'<svg xmlns="http://www.w3.org/2000/svg"');
    return ensureSvgSize(svg);
  }
  function thickenSvg(svg,item){
    var sw=(item&&item.stroke)||1.7;
    if(Math.abs(sw-1.7)<0.06) return String(svg);             // défaut 1.7 = inchangé
    var bx=logoBoxOf(svg), maxd=Math.max(bx.w,bx.h)||24, factor=sw/1.7;
    var openM=String(svg).match(/^[\s\S]*?<svg[^>]*>/i); if(!openM) return String(svg);
    var open=openM[0], inner=String(svg).replace(/^[\s\S]*?<svg[^>]*>/i,'').replace(/<\/svg>\s*$/i,'');
    var scaled=inner
      .replace(/stroke-width\s*=\s*("|')\s*([\d.]+)[a-z%]*\s*\1/gi,function(m,q,n){return 'stroke-width="'+(parseFloat(n)*factor).toFixed(2)+'"';})
      .replace(/stroke-width\s*:\s*([\d.]+)[a-z%]*/gi,function(m,n){return 'stroke-width:'+(parseFloat(n)*factor).toFixed(2);});
    if(sw<1.7) return open+scaled+'</svg>';                    // plus fin : scaling seul, pas de halo
    var addW=((sw-1.7)*0.032*maxd).toFixed(2);
    var halo=inner
      .replace(/\sfill\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'').replace(/fill\s*:\s*[^;"'}>)]+;?/gi,'')
      .replace(/\sstroke-width\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'').replace(/stroke-width\s*:\s*[^;"'}>)]+;?/gi,'')
      .replace(/\sstroke\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'').replace(/stroke\s*:\s*[^;"'}>)]+;?/gi,'');
    return open
      +'<g fill="none" stroke="currentColor" stroke-width="'+addW+'" stroke-linejoin="round" stroke-linecap="round">'+halo+'</g>'
      +scaled+'</svg>';
  }
  function ensureSvgSize(svg){
    var bx=logoBoxOf(svg);
    return String(svg).replace(/<svg\b([^>]*)>/i,function(m,attrs){
      attrs=attrs.replace(/\s(width|height)\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'');
      return '<svg'+attrs+' width="'+bx.w+'" height="'+bx.h+'">';
    });
  }
  function logoBoxOf(svg){
    var bx={w:24,h:24}, m=String(svg).match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);
    if(m){var a=m[1].trim().split(/\s+/);if(a.length===4){bx.w=parseFloat(a[2])||24;bx.h=parseFloat(a[3])||24;}}
    return bx;
  }
  /* TOMETTE PHOTO — greffe 4c (10/2026, Lot 0). L'aperçu vivant redessine toute la pièce à chaque
     image d'un geste, et drawImage d'une image SVG RE-RASTÉRISE ses vecteurs à chaque appel : pour
     une photo, plus de 2 000 contours, le quart du temps d'un glisser (profil mesuré). On garde donc
     le bitmap de chaque grand SVG (> 20 000 caractères) à la taille ET au décalage sous-pixel exacts
     où il est peint, puis on le recopie 1:1 à une position entière : aucun rééchantillonnage, les
     mêmes pixels. Deux bitmaps au plus (la photo, un grand logo) ; les autres sont libérés. Rotation,
     miroir et petits SVG : le chemin d'origine. */
  var _mtpxRasters=[];
  function _mtpxRaster(slot,x,y,dw,dh){
    try{
      var ix=Math.floor(x),iy=Math.floor(y),fx=x-ix,fy=y-iy,r=slot._mtpxR;
      if(!r||r.dw!==dw||r.dh!==dh||r.fx!==fx||r.fy!==fy){
        var W=Math.ceil(dw+fx)+1,H=Math.ceil(dh+fy)+1;if(W<2||H<2||W*H>16e6)return null;
        var cv=(r&&r.cv)||document.createElement('canvas');cv.width=W;cv.height=H;
        var c=cv.getContext('2d');c.clearRect(0,0,W,H);try{c.imageSmoothingQuality='high';}catch(_){}
        c.drawImage(slot.img,fx,fy,dw,dh);
        r=slot._mtpxR={cv:cv,dw:dw,dh:dh,fx:fx,fy:fy};
        var j=_mtpxRasters.indexOf(slot);if(j>=0)_mtpxRasters.splice(j,1);_mtpxRasters.push(slot);
        while(_mtpxRasters.length>2){var v=_mtpxRasters.shift();if(v._mtpxR){v._mtpxR.cv.width=0;v._mtpxR.cv.height=0;v._mtpxR=null;}}
      }
      return {cv:r.cv,x:ix,y:iy};
    }catch(e){return null;}
  }
  function getLogoImg(svg){
    if(_logoImgCache[svg])return _logoImgCache[svg];
    var slot={img:null,ready:false};_logoImgCache[svg]=slot;
    var im=new Image();
    function done(){slot.img=im;slot.ready=true;imgReady();}
    im.onload=function(){ if(im.decode){im.decode().then(done).catch(done);} else done(); };  // decode() : pas de dessin avant rasterisation -> plus de bloc noir Safari
    im.onerror=function(){slot.ready=true;imgReady();};
    im.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg);
    return slot;
  }
  function tileMaskOf(im,sq){
    if(!im) return null;
    var ck=sq?'_mtMaskSq':'_mtMask';
    if(im[ck]!==undefined) return im[ck];
    var m=null;
    try{
      var iw=im.naturalWidth||im.width, ih=im.naturalHeight||im.height;
      if(iw&&ih){
        if(!sq){
          var c=document.createElement('canvas');c.width=iw;c.height=ih;
          var x=c.getContext('2d');x.drawImage(im,0,0);
          var d=x.getImageData(0,0,iw,ih),pp=d.data,i;
          for(i=0;i<pp.length;i+=4){ pp[i+3]=pp[i+3]>=150?255:0; }
          x.putImageData(d,0,0); m=c;
        } else {
          var scale=Math.min(1, 768/Math.max(iw,ih));
          var w=Math.max(1,Math.round(iw*scale)), h=Math.max(1,Math.round(ih*scale));
          var c=document.createElement('canvas');c.width=w;c.height=h;
          var x=c.getContext('2d');x.drawImage(im,0,0,w,h);
          var d=x.getImageData(0,0,w,h),pp=d.data,N=w*h,i,keep=new Uint8Array(N);
          for(i=0;i<N;i++){ var a=pp[i*4+3],r=pp[i*4],g=pp[i*4+1],b=pp[i*4+2]; keep[i]=(a>=150 && !(r>=226&&g>=226&&b>=226))?1:0; }
          var seen=new Uint8Array(N), bg=new Uint8Array(N), stack=[], q;
          var seed=function(px){ if(px>=0&&px<N&&!seen[px]&&!keep[px]){seen[px]=1;stack.push(px);} };
          for(q=0;q<w;q++){ seed(q); seed((h-1)*w+q); }
          for(q=0;q<h;q++){ seed(q*w); seed(q*w+(w-1)); }
          while(stack.length){ var pI=stack.pop(); bg[pI]=1; var px=pI%w, py=(pI-px)/w; if(px>0)seed(pI-1); if(px<w-1)seed(pI+1); if(py>0)seed(pI-w); if(py<h-1)seed(pI+w); }
          for(var _p=0;_p<3;_p++){ var _bd=bg.slice(); for(i=0;i<N;i++){ if(_bd[i])continue; var _px=i%w,_py=(i-_px)/w; if((_px>0&&_bd[i-1])||(_px<w-1&&_bd[i+1])||(_py>0&&_bd[i-w])||(_py<h-1&&_bd[i+w])){bg[i]=1;} } }
          for(i=0;i<N;i++){ pp[i*4+3]= bg[i]?0:255; }
          x.putImageData(d,0,0); m=c;
        }
      }
    }catch(e){ m=null; }
    try{ im[ck]=m; }catch(e){}
    return m;
  }
  function getBgImg(sq){
    var key=sq?'sq':'hex';
    if(_bgImgCache[key])return _bgImgCache[key];
    var slot={img:null,ready:false};_bgImgCache[key]=slot;
    var url=photoUrl(sq);
    if(!url){slot.ready=true;return slot;}
    /* URL absolue : dans l'iframe de la fiche produit (blob: / about:blank) une URL
       relative peut se résoudre ailleurs que sur la boutique. */
    try{ url=new URL(url, document.baseURI).href; }catch(e){}
    function fin(im){
      slot.img=im;
      try{slot.mask=tileMaskOf(im,sq);}catch(e){slot.mask=null;}   /* le masque n'empêche jamais l'affichage */
      slot.ready=true;imgReady();
    }
    function abandon(raison){
      /* Sans photo, la gravure est posée seule (pas de fusion « multiply ») et paraît pâle. */
      try{ console.warn('[MyTomette] photo de tuile indisponible ('+key+') : '+raison+' — gravure sans fusion'); }catch(e){}
      slot.ready=true;imgReady();
    }
    /* Voie classique : Image + CORS, avec une seconde tentative sans cache. Safari peut
       resservir la réponse sans CORS mise en cache par le fond CSS (constaté sur le carré). */
    function classique(u,tentative){
      var im=new Image();im.crossOrigin='anonymous';
      im.onload=function(){ if(im.decode){im.decode().then(function(){fin(im);}).catch(function(){fin(im);});} else fin(im); };
      im.onerror=function(){ if(!tentative){ classique(u+(u.indexOf('?')>-1?'&':'?')+'mtcors=1',1); } else abandon('chargement Image refusé'); };
      im.src=u;
    }
    /* Voie principale : fetch en forçant le rechargement -> blob local -> Image sans CORS.
       Le cache du navigateur n'entre plus en jeu et le canevas ne peut pas être « teinté ». */
    if(typeof fetch==='function' && typeof URL!=='undefined' && URL.createObjectURL){
      fetch(url,{mode:'cors',cache:'reload',credentials:'omit'})
        .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.blob(); })
        .then(function(b){ var bu=URL.createObjectURL(b); var im=new Image(); im.onload=function(){ fin(im); }; im.onerror=function(){ classique(url,0); }; im.src=bu; })
        .catch(function(){ classique(url,0); });
    } else { classique(url,0); }
    return slot;
  }
  function _drawCurvedInto(mc,e,txt,fpx,cx,cy,synStroke){
    var cv=Math.max(-100,Math.min(100,e.curve))/100;
    var chars=txt.split(''), lsPx=(e.ls||0)*fpx;
    var _pls='';try{_pls=mc.letterSpacing||'';mc.letterSpacing='0px';}catch(_){}
    var widths=chars.map(function(c){return mc.measureText(c).width+lsPx;});
    var total=widths.reduce(function(a,b){return a+b;},0);
    if(total<=0){try{if(_pls)mc.letterSpacing=_pls;}catch(_){}return;}
    var pos=_arcLayout(widths,total,fpx,cv), sa=mc.textAlign, sb=mc.textBaseline;
    mc.textAlign='center';mc.textBaseline='middle';
    for(var i=0;i<chars.length;i++){var p=pos[i];mc.save();mc.translate(cx+p.x,cy+p.y);mc.rotate(p.a);if(synStroke>0){mc.lineJoin='round';mc.miterLimit=2;mc.lineWidth=synStroke;mc.strokeStyle='#000';mc.strokeText(chars[i],0,0);}mc.fillText(chars[i],0,0);mc.restore();}
    mc.textAlign=sa;mc.textBaseline=sb;
    try{if(_pls)mc.letterSpacing=_pls;}catch(_){}
  }
  function paintEngraveLive(ctx,W,H,src,doClip){
    var sq=(SHAPES[src.shape]||SHAPES.hexa).cls==='sq', els=src.els||[];
    if(!_maskCv){_maskCv=document.createElement('canvas');}
    if(_maskCv.width!==W||_maskCv.height!==H){_maskCv.width=W;_maskCv.height=H;}
    var mk=_maskCv, mc=mk.getContext('2d'); mc.setTransform(1,0,0,1,0,0); mc.clearRect(0,0,W,H);
    try{mc.imageSmoothingQuality='high';}catch(_){}
    mc.textAlign='center';mc.textBaseline='middle';mc.fillStyle='#000';
    var F=mtFace(sq,W,H);
    els.forEach(function(e){
      var cx=F.ox+(e.x!=null?e.x:0.5)*F.fw, cy=F.oy+(e.y!=null?e.y:0.5)*F.fh;
      var _rot=normRot(e.rot);
      if(_rot){mc.save();mc.translate(cx,cy);mc.rotate(_rot*Math.PI/180);cx=0;cy=0;}
      if(e.type==='text'){
        var f=fontById(e.font), fpx=sizeCqwFor(e,src.shape)/100*F.fw;
        try{mc.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
        var reqWeight=mteWeight(e.font,e.weight), face=mteResolvedSpec(e.font,reqWeight);
        mc.font=(f.italic?'italic ':'')+face.faceWeight+' '+fpx+'px '+engraveCss(e.font,reqWeight);
        var synStroke=mteSyntheticStroke(e.font,reqWeight,fpx);
        var txt=(f.caps?String(e.text||'').toUpperCase():String(e.text||''));
        if(e.smallcaps)txt=txt.toUpperCase();
        if(e.curve&&Math.abs(e.curve)>=1){
          _drawCurvedInto(mc,e,txt.replace(/\n/g,' '),fpx,cx,cy,synStroke);
        }else{
          var _l9=mtLayOf(e,src.shape);
          fpx=(_l9.size*(SIZE_REF/(SHAPES[src.shape]||SHAPES.hexa).wcm))/100*F.fw;
          mc.font=(f.italic?'italic ':'')+face.faceWeight+' '+fpx+'px '+engraveCss(e.font,reqWeight);
          try{mc.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
          synStroke=mteSyntheticStroke(e.font,reqWeight,fpx);
          var lines=_l9.lines, lh=fpx*(e.lh||MT_LH), y0=cy-(lines.length-1)*lh/2;
          lines.forEach(function(ln,li){
            if(synStroke>0){mc.save();mc.lineJoin='round';mc.miterLimit=2;mc.lineWidth=synStroke;mc.strokeStyle='#000';mc.strokeText(ln,cx,y0+li*lh);mc.restore();}
            mc.fillText(ln,cx,y0+li*lh);
          });
        }
      } else {
        var svg=burnSvgOf(e), slot=getLogoImg(svg); if(!slot.ready||!slot.img||!slot.img.naturalWidth)return;
        var bx=logoBoxOf(svg), s=sizeCqwFor(e,src.shape)/100*F.fw, k=Math.min(s/bx.w,s/bx.h), dw=bx.w*k, dh=bx.h*k;
        if(e.flip){mc.save();mc.translate(cx,cy);mc.scale(-1,1);mc.drawImage(slot.img,-dw/2,-dh/2,dw,dh);mc.restore();}
        else if(svg.length>20000&&!_rot){var _mtpxR=_mtpxRaster(slot,cx-dw/2,cy-dh/2,dw,dh);if(_mtpxR)mc.drawImage(_mtpxR.cv,_mtpxR.x,_mtpxR.y);else mc.drawImage(slot.img,cx-dw/2,cy-dh/2,dw,dh);}
        else{mc.drawImage(slot.img,cx-dw/2,cy-dh/2,dw,dh);}
      }
      if(_rot)mc.restore();
    });
    try{mc.letterSpacing='0px';}catch(_){}
    ctx.save();
    if(doClip){ shapePathLive(ctx,sq,W,H); ctx.clip(); }   // repli sans photo : forme géométrique
    var _sf=ctx.filter;
    try{ctx.filter='blur('+Math.max(.3,W*0.0004).toFixed(2)+'px)';}catch(_){}
    ctx.globalCompositeOperation='multiply'; ctx.globalAlpha=1; ctx.drawImage(tintMaskC(mk,'#6f5331'),0,0);
    try{ctx.filter=_sf||'none';}catch(_){}
    ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
    ctx.restore();
  }
  function scheduleLive(){ if(_liveRaf)return; _liveRaf=requestAnimationFrame(function(){_liveRaf=0;try{drawLive();}catch(e){}}); }
  function imgReady(){ scheduleLive(); refreshPrevCanvases(); try{ if(document.getElementById('sValid').classList.contains('on'))drawValid(); }catch(e){} }
  function renderTileTo(cv,box,src){
    if(!cv||!box)return;
    var rect=box.getBoundingClientRect(); var Wl=Math.round(rect.width), Hl=Math.round(rect.height);
    if(Wl<2||Hl<2)return;
    var dpr=Math.min(3,window.devicePixelRatio||1);
    var W=Math.round(Wl*dpr), H=Math.round(Hl*dpr);
    if(cv.width!==W||cv.height!==H){cv.width=W;cv.height=H;}
    var ctx=cv.getContext('2d'); ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,W,H);
    ctx.imageSmoothingEnabled=true; try{ctx.imageSmoothingQuality='high';}catch(_){}
    var sq=(SHAPES[src.shape]||SHAPES.hexa).cls==='sq';
    var bg=getBgImg(sq);
    if(bg.img&&bg.img.naturalWidth){
      drawTilePhoto(ctx,bg.img,W,H,sq);      paintEngraveLive(ctx,W,H,src,false);       ctx.globalCompositeOperation='destination-in';
      drawTilePhoto(ctx,bg.mask||bg.img,W,H,sq);      ctx.globalCompositeOperation='source-over';
    } else {
      /* Le parent .tom.photo porte deja la vraie photo en CSS. Le canvas doit rester
         transparent pendant le decodage (notamment Safari), sinon l'aplat masque la photo. */
      ctx.save(); shapePathLive(ctx,sq,W,H); ctx.clip();
      paintEngraveLive(ctx,W,H,src,false);      ctx.restore();
    }
  }
  function drawLive(){ renderTileTo(document.getElementById('liveEngrave'),document.getElementById('tilewrap'),state); }
  function drawValid(){ renderTileTo(document.getElementById('vEngrave'),document.getElementById('vtile'),state); }
  var _cfPrevCanvas=[], _cfPrevObserver=null;
  function resetPreviewRendering(){
    if(_cfPrevObserver){_cfPrevObserver.disconnect();_cfPrevObserver=null;}
    _cfPrevCanvas=[];
  }
  function queuePreviewCanvas(cv,src){
    var rec={cv:cv,src:src,drawn:false};
    cv._mtPreviewRecord=rec;
    _cfPrevCanvas.push(rec);
  }
  function drawPreviewRecord(rec){
    if(!rec||rec.drawn)return;
    noteTemplateSvgNeed(rec);          /* charge à la demande ce qui manque à CETTE carte */
    try{drawPrevCanvas(rec.cv,rec.src);rec.drawn=true;}catch(e){}
    if(rec.drawn&&_cfPrevObserver){try{_cfPrevObserver.unobserve(rec.cv);}catch(e){}}
  }
  function drawPreviewAt(index){
    var rec=_cfPrevCanvas[index];
    if(rec)drawPreviewRecord(rec);
  }
  /* Avant : seules les cartes a +/-2 crans de la centrale etaient dessinees. Des
     qu'on enchainait les crans un peu vite on tombait sur des tomettes vides, et
     il fallait cliquer pour que le modele se rende enfin. Le catalogue est petit :
     on dessine tout, tout de suite, en etalant le travail sur plusieurs frames
     (~9 ms par frame) en partant de la carte centrale. */
  var _cfDrawAllRun=false;
  function _mtNow(){try{return performance.now();}catch(e){return Date.now();}}
  function drawAllPreviews(){
    /* 30/09 : le selecteur en images (mt-selecteur.js) remplace ce carrousel : ne rien dessiner,
       ni telecharger les polices de tout le catalogue pour des cartes que personne ne voit. */
    if(window.MT_SELECTEUR&&window.MT_SELECTEUR.actif)return;
    if(_cfDrawAllRun)return;
    var pending=[],i;
    for(i=0;i<_cfPrevCanvas.length;i++)if(!_cfPrevCanvas[i].drawn)pending.push(i);
    if(!pending.length)return;
    var a=cfActive;
    pending.sort(function(x,y){return Math.abs(x-a)-Math.abs(y-a);});
    _cfDrawAllRun=true;
    var k=0;
    function chunk(){
      var t0=_mtNow();
      try{
        while(k<pending.length){
          try{drawPreviewAt(pending[k]);}catch(e){}   /* une carte en echec ne doit pas
                                                        stopper le rendu des suivantes */
          k++;
          if(_mtNow()-t0>9)break;
        }
      }catch(e){}
      if(k<pending.length){requestAnimationFrame(chunk);return;}
      _cfDrawAllRun=false;
      for(var j=0;j<_cfPrevCanvas.length;j++){   /* un SVG arrive entre-temps ? on repasse */
        if(!_cfPrevCanvas[j].drawn){drawAllPreviews();break;}
      }
    }
    requestAnimationFrame(chunk);
  }
  function renderCarouselPreviews(){ drawAllPreviews(); }
  function observeGridPreviews(){
    if(_cfPrevObserver){_cfPrevObserver.disconnect();_cfPrevObserver=null;}
    drawAllPreviews();
  }
  /* Avant : bitmap fige a 600 px. Net sur un ecran DPR 1 (desktop), mais etire
     ~1,3x sur un telephone DPR 3 -> d'ou le rendu mou sur mobile. On dimensionne
     desormais sur la taille reellement affichee x la densite de l'ecran.
     offsetWidth et non getBoundingClientRect : ce dernier inclut l'echelle de la
     carte (0,72 hors centre) et ferait sous-echantillonner. */
  function prevCanvasW(cv){
    var dpr=Math.min(window.devicePixelRatio||1,3);
    var css=(cv&&cv.offsetWidth)||0;
    if(!css)return 600;
    var cap=(_cfPrevCanvas.length>30)?900:1100;
    return Math.max(600,Math.min(cap,Math.round(css*dpr)));
  }
  function drawPrevCanvas(cv,src){
    if(!cv)return;
    var sq=(SHAPES[src.shape]||SHAPES.hexa).cls==='sq';
    var W=prevCanvasW(cv), H=sq?W:Math.round(W/1.2);
    if(cv.width!==W||cv.height!==H){cv.width=W;cv.height=H;}
    var ctx=cv.getContext('2d'); ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,W,H);
    ctx.imageSmoothingEnabled=true; try{ctx.imageSmoothingQuality='high';}catch(_){}
    var bg=getBgImg(sq);
    if(bg.img&&bg.img.naturalWidth){
      drawTilePhoto(ctx,bg.img,W,H,sq);
      paintEngraveLive(ctx,W,H,src,false);
      ctx.globalCompositeOperation='destination-in'; drawTilePhoto(ctx,bg.mask||bg.img,W,H,sq); ctx.globalCompositeOperation='source-over';
    }else{
      /* Fond transparent : la photo CSS reste visible si Safari refuse/retarde l'image canvas. */
      ctx.save(); shapePathLive(ctx,sq,W,H); ctx.clip(); paintEngraveLive(ctx,W,H,src,false); ctx.restore();
    }
  }
  var _cfPrevRaf=0;
  function refreshPrevCanvases(){ if(_cfPrevRaf)return; _cfPrevRaf=requestAnimationFrame(function(){ _cfPrevRaf=0; for(var i=0;i<_cfPrevCanvas.length;i++){ if(!_cfPrevCanvas[i].drawn)continue; try{drawPrevCanvas(_cfPrevCanvas[i].cv,_cfPrevCanvas[i].src);}catch(e){} } }); }
  function initLiveRO(){
    if(_liveRO||!window.ResizeObserver)return;
    var box=document.getElementById('tilewrap'); if(!box)return;
    _liveRO=new ResizeObserver(function(){scheduleLive();}); _liveRO.observe(box);
  }

  var OPENTYPE_URL='https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js';
  /* Table police -> fichier TTF (miroir public Google Fonts). À vérifier/compléter si une police ne sort pas en tracé. */
  /* Une police est toujours resolue par le couple famille + graisse.
     - Google : fichier statique WOFF v1 au poids exact (jamais WOFF2).
     - OVH/URL : TTF/OTF d'origine ; les graisses absentes sont epaissies sur le contour,
       de facon identique dans le canvas client et dans le SVG laser. */
  var MTE_VARDEF={'Cormorant Garamond':300,'DM Sans':400,'Caveat':400,'Cinzel':400,'Inter':400,'Dancing Script':400,'Playfair Display':400,'EB Garamond':400};
  function mteSlug(fam){return String(fam||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  /* Statique par poids via @fontsource (jsDelivr) : woff v1 lisible par opentype.js ET par le canvas
     -> meme fichier des deux cotes = meme graisse. Generalise a toute police Google (poids declares en admin). */
  function fontsourceWoff(fam,weight){var sl=mteSlug(fam);if(!sl)return null;return 'https://cdn.jsdelivr.net/npm/@fontsource/'+sl+'@5/files/'+sl+'-latin-'+(weight||400)+'-normal.woff';}
  function mteWeight(fontId,w){return Math.round(clamp(parseInt(w,10)||defaultWeight(fontId)||400,100,900)/100)*100;}
  function mteFontRecord(fontId){
    var fr=FONTREG[fontId]||{}, fam=famOf(fontId), k;
    if(fr.source||fr.url||fr.ttf)return fr;
    for(k in FONTREG){if(FONTREG.hasOwnProperty(k)){var r=FONTREG[k];if(r&&r.family===fam&&(r.source||r.url||r.ttf))return r;}}
    return fr;
  }
  function mteDeclaredWeights(fr){
    var a=String((fr&&fr.weights)||'400').match(/\d+/g)||['400'];
    return a.map(function(x){return parseInt(x,10)||400;});
  }
  function mteNearestWeight(list,w){var best=list[0]||400,d=Math.abs(best-w);for(var i=1;i<list.length;i++){var nd=Math.abs(list[i]-w);if(nd<d){d=nd;best=list[i];}}return best;}
  function mteFontKey(fontId,w){return famOf(fontId)+'|'+mteWeight(fontId,w);}
  function mteFontSpec(fontId,w){
    w=mteWeight(fontId,w);var fam=famOf(fontId),fr=mteFontRecord(fontId),decl=mteDeclaredWeights(fr),base=mteNearestWeight(decl,w);
    if(fr.source==='google'||MTE_VARDEF[fam]!=null){
      /* @fontsource ne sert QUE les graisses reellement declarees par la famille :
         demander un 600 a Amatic SC (qui ne declare que 400 et 700) renvoie un 404.
         On prend donc la graisse declaree la plus proche et on comble la difference
         au trait, exactement comme pour une police importee -- c'est aussi la regle
         du moteur guide, sans quoi les deux SVG ne sortent pas identiques. */
      return{key:mteFontKey(fontId,w),family:fam,url:fontsourceWoff(fam,base),faceWeight:base,requestedWeight:w,synthetic:Math.max(0,w-base),
        fallback:(FONT_TTF[fam]||(fr&&(fr.ttf||fr.url))||null),fallbackWeight:base,source:'google'};
    }
    var u=(fr&&(fr.ttf||fr.url))||FONT_TTF[fam]||null;
    return{key:mteFontKey(fontId,w),family:fam,url:u,faceWeight:base,requestedWeight:w,synthetic:Math.max(0,w-base),fallback:null,fallbackWeight:base,source:'url'};
  }
  function mteResolvedSpec(fontId,w){var spec=mteFontSpec(fontId,w),rec=(typeof _fontCache!=='undefined'&&_fontCache&&_fontCache[spec.key]);return rec||spec;}
  function mteSyntheticStroke(fontId,w,fontSize){
    var spec=mteResolvedSpec(fontId,w),delta=spec.synthetic;
    return delta>0?(fontSize*0.055*(delta/400)):0;
  }
  function mteSvgInk(rec,fontSize){
    var sw=rec&&rec.synthetic>0?(fontSize*0.055*(rec.synthetic/400)):0;
    return sw>0?(' fill="#000" stroke="#000" stroke-width="'+sw.toFixed(3)+'" stroke-linejoin="round" paint-order="stroke fill"'):' fill="#000"';
  }
  var _mtePrepSig=null;
  /* Prechauffe chaque combinaison police + graisse avant l'aperçu et l'export. */
  function mtePrepFonts(els){
    try{
      els=els||[];
      var sig=els.map(function(e){return e&&e.type==='text'?mteFontKey(e.font,mteWeight(e.font,e.weight)):'';}).join(',');
      if(sig!==_mtePrepSig){ _mtePrepSig=sig; var seen={};
        els.forEach(function(e){if(e&&e.type==='text'){var w=mteWeight(e.font,e.weight),k=mteFontKey(e.font,w);if(!seen[k]){seen[k]=1;try{loadOTFont(e.font,w,function(){try{scheduleLive();}catch(_){}});}catch(_){}}}});
      }
    }catch(_){}
  }
  var FONT_TTF={
    'Great Vibes':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/greatvibes/GreatVibes-Regular.ttf',
    'Allura' : 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/allura/Allura-Regular.ttf',
    'Parisienne' : 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/parisienne/Parisienne-Regular.ttf',
    'Allura':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/allura/Allura-Regular.ttf',
    'Dancing Script':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/dancingscript/DancingScript%5Bwght%5D.ttf',
    'Pacifico':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/pacifico/Pacifico-Regular.ttf',
    'Caveat':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/caveat/Caveat%5Bwght%5D.ttf',
    'Cinzel':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cinzel/Cinzel%5Bwght%5D.ttf',
    'Marcellus':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/marcellus/Marcellus-Regular.ttf',
    'Amatic SC':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/amaticsc/AmaticSC-Regular.ttf',
    'Yellowtail':'https://cdn.jsdelivr.net/gh/google/fonts@main/apache/yellowtail/Yellowtail-Regular.ttf',
    'Inter':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/inter/Inter%5Bopsz,wght%5D.ttf',
    'Pinyon Script':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/pinyonscript/PinyonScript-Regular.ttf',
    'Cormorant Garamond':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cormorantgaramond/CormorantGaramond%5Bwght%5D.ttf',
    'DM Sans':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/dmsans/DMSans%5Bopsz,wght%5D.ttf'
  };
  var _otReady=null, _fontCache={};
  function ensureOpentype(cb){
    if(window.opentype){cb(true);return;}
    if(_otReady){_otReady.push(cb);return;}
    _otReady=[cb];
    var fired=false;
    function flush(ok){if(fired)return;fired=true;var q=_otReady;_otReady=null;for(var i=0;i<q.length;i++)q[i](ok&&!!window.opentype);}
    var sc=document.createElement('script');sc.src=OPENTYPE_URL;
    sc.onload=function(){flush(true);};
    sc.onerror=function(){flush(false);};
    document.head.appendChild(sc);
    setTimeout(function(){flush(!!window.opentype);},7000); // garde-fou : pas de blocage si le CDN ne répond pas
  }
  function famOf(fontId){var fr=FONTREG[fontId];return (fr&&fr.family)?fr.family:fontId;}
  function loadOTFont(fontId,weight,cb){
    var spec=mteFontSpec(fontId,weight),ck=spec.key;
    if(!spec.url){cb(null);return;}
    if(_fontCache[ck]){cb(_fontCache[ck]);return;}
    ensureOpentype(function(ok){
      if(!ok||!window.opentype){cb(null);return;}
      function tryLoad(u,isFallback){
        try{opentype.load(u,function(err,font){
          if(err||!font){if(!isFallback&&spec.fallback&&spec.fallback!==u){tryLoad(spec.fallback,true);}else{cb(null);}}
          else{var rec={font:font,key:ck,url:u,faceWeight:isFallback?spec.fallbackWeight:spec.faceWeight,requestedWeight:spec.requestedWeight,synthetic:isFallback?Math.max(0,spec.requestedWeight-spec.fallbackWeight):spec.synthetic};_fontCache[ck]=rec;cb(rec);}
        });}catch(e){if(!isFallback&&spec.fallback&&spec.fallback!==u){tryLoad(spec.fallback,true);}else{cb(null);}}
      }
      tryLoad(spec.url,false);
    });
  }
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  /* Decalage de ligne de base, mesure en dessinant "Hg" au canvas. Comme la mise en
     page, cette mesure est FAUSSE tant que la police n'est pas chargee -- et elle
     etait mise en cache DEFINITIVEMENT. D'ou un texte grave 0,2 a 0,7 mm plus haut
     ou plus bas selon que la police etait deja en cache navigateur ou non. */
  var _mtMidCache={};
  function mtMidCacheClear(){ _mtMidCache={}; }
  /* La ligne de base est mesuree en dessinant "Hg" au canvas. Elle DOIT l'etre avec
     la police exactement utilisee pour les contours (l'alias MTE_ au bon poids), et
     non avec la famille CSS nue : le canvas prendrait alors le 400 par defaut, alors
     que le trace sort en 700. C'est ce qui laissait 0,2 a 0,7 mm d'ecart vertical
     entre le moteur guide et le configurateur expert. */
  function mtMidOff(cssFam,w){
    var _mk=cssFam+'|'+(w||400);
    if(_mtMidCache[_mk]!=null) return _mtMidCache[_mk];
    var off=0.34;
    try{
      var fz=200, cv=document.createElement('canvas'); cv.width=600; cv.height=600;
      var x=cv.getContext('2d'); x.textAlign='center'; x.fillStyle='#000'; x.font=(w||400)+' '+fz+'px '+cssFam;
      function inkMid(bl){
        x.clearRect(0,0,600,600); x.textBaseline=bl; x.fillText('Hg',300,300);
        var d=x.getImageData(0,0,600,600).data, t=-1, b=-1;
        for(var yy=0; yy<600; yy++){ var ba=yy*2400; for(var xx=0; xx<600; xx++){ if(d[ba+xx*4+3]>40){ if(t<0)t=yy; b=yy; break; } } }
        return t<0 ? null : (t+b)/2;
      }
      var m=inkMid('middle'), a=inkMid('alphabetic');
      if(m!=null && a!=null) off=(m-a)/fz;
    }catch(e){}
    _mtMidCache[_mk]=off; return off;
  }
  var _mteInjected={};
  function engraveTtfUrl(fontId,weight){return mteFontSpec(fontId,weight).url;}
  function engraveFamFor(fontId,weight){
    var spec=mteResolvedSpec(fontId,weight),fam=spec.family||famOf(fontId),url=spec.url;if(!url)return null;
    var alias='MTE_'+String(fam).replace(/[^A-Za-z0-9]+/g,'_')+'_'+spec.requestedWeight+'_'+spec.faceWeight;
    if(!_mteInjected[alias]){
      _mteInjected[alias]=1;
      try{ mtLayCacheClear(); }catch(_){}   /* les largeurs changent avec la vraie police */
      var st=document.getElementById('mtpEngraveFaces'); if(!st){st=document.createElement('style');st.id='mtpEngraveFaces';document.head.appendChild(st);}
      st.textContent+="@font-face{font-family:'"+alias+"';src:url('"+url+"');font-weight:"+spec.faceWeight+";font-display:swap}";
      try{if(document.fonts&&document.fonts.load){document.fonts.load(spec.faceWeight+" 24px '"+alias+"'").then(function(){try{mtLayCacheClear();mtMidCacheClear();mtRestyleTexts();scheduleLive();}catch(e){}
        /* 30/09 : les cartes du carrousel deja dessinees avant l'arrivee de la police gardaient
           la police de secours (« Jonah » de « Cadeau naissance - dans le ciel ») : on les repeint. */
        try{refreshPrevCanvases();}catch(e){}},function(){});}}catch(e){}
    }
    return alias;
  }
  /* La mise en page mesure le texte au canvas. Si la police n'est pas encore
     chargee, la mesure se fait sur la police de repli -- des metriques plus
     etroites -> moins de reduction -> texte trop grand. Le canvas etait bien
     redessine a l'arrivee de la police (scheduleLive), mais PAS les noeuds DOM
     de l'apercu : ils gardaient la taille calculee a vide. */
  function mtRestyleTexts(){
    try{
      var nodes=document.querySelectorAll('#stack .el.text');
      for(var i=0;i<nodes.length;i++){
        var it=getItem(nodes[i].dataset.id);
        if(it&&it.type==='text')_applySize(nodes[i],it);
      }
    }catch(e){}
  }
  /* 05/10/2026 : un caractere absent de la police (le ♡ de « Ambre ♡ » en Allura, commande #1033)
     sortait au laser en « tofu », un rectangle barre, alors que l'apercu le dessinait avec la police
     de secours du navigateur. On fait comme le navigateur, mais avec UNE police connue des deux cotes :
     les glyphes manquants passent par DejaVu Sans (♡ ♥ ❤ ★ ✿ ✓ ∞ ♪…), declaree en CSS juste apres la
     police gravee (apercu) et chargee par opentype pour le SVG. unicode-range : seuls les blocs de
     symboles la font telecharger, jamais un texte ordinaire. */
  var MTE_SYMB_URL='https://cdn.jsdelivr.net/npm/dejavu-fonts-ttf@2.37.3/ttf/DejaVuSans.ttf', MTE_SYMB_ALIAS='MTE_Symboles', _symbFont=null, _symbWait=null;
  function mteSymbFace(){
    if(_mteInjected[MTE_SYMB_ALIAS])return; _mteInjected[MTE_SYMB_ALIAS]=1;
    try{
      var st=document.getElementById('mtpEngraveFaces'); if(!st){st=document.createElement('style');st.id='mtpEngraveFaces';document.head.appendChild(st);}
      st.textContent+="@font-face{font-family:'"+MTE_SYMB_ALIAS+"';src:url('"+MTE_SYMB_URL+"');unicode-range:U+2190-23FF,U+2460-24FF,U+2500-27BF,U+2B00-2BFF;font-display:swap}";
      if(document.fonts&&document.fonts.addEventListener){document.fonts.addEventListener('loadingdone',function(ev){
        var ff=(ev&&ev.fontfaces)||[],hit=false;for(var i=0;i<ff.length;i++){if(String(ff[i].family).replace(/['"]/g,'')===MTE_SYMB_ALIAS)hit=true;}
        if(hit){try{mtLayCacheClear();mtMidCacheClear();mtRestyleTexts();scheduleLive();refreshPrevCanvases();}catch(e){}}
      });}
    }catch(e){}
  }
  function mteHas(font,ch){try{return font.charToGlyphIndex(ch)>0;}catch(e){return true;}}
  function mteBlank(ch){return /\s/.test(ch);}
  function mteNeedsSymb(font,str){str=String(str||'');for(var i=0;i<str.length;i++){var c=str.charAt(i);if(!mteBlank(c)&&!mteHas(font,c))return true;}return false;}
  function loadSymbFont(cb){
    if(_symbFont){cb(_symbFont);return;}
    if(_symbWait){_symbWait.push(cb);return;}
    _symbWait=[cb];
    function done(f){_symbFont=f||null;var q=_symbWait;_symbWait=null;for(var i=0;i<q.length;i++)q[i](_symbFont);}
    ensureOpentype(function(ok){
      if(!ok||!window.opentype){done(null);return;}
      try{opentype.load(MTE_SYMB_URL,function(err,f){done(err?null:f);});}catch(e){done(null);}
    });
  }
  /* police a utiliser pour UN caractere : la police gravee, sinon les symboles, sinon rien
     (le caractere est alors omis plutot que grave en rectangle barre). */
  function mteFontFor(font,ch){
    if(mteBlank(ch)||mteHas(font,ch))return font;
    if(_symbFont&&mteHas(_symbFont,ch))return _symbFont;
    try{console.warn('[MT gravure] caractere sans dessin, omis :',ch,'U+'+ch.charCodeAt(0).toString(16).toUpperCase());}catch(e){}
    return null;
  }
  function mteRuns(font,str){
    var runs=[],cur=null;str=String(str||'');
    for(var i=0;i<str.length;i++){var c=str.charAt(i),f=mteFontFor(font,c);if(!f)continue;if(cur&&cur.f===f)cur.t+=c;else{cur={f:f,t:c};runs.push(cur);}}
    return runs;
  }
  function mteRunsWidth(runs,fs,opt){var w=0;for(var i=0;i<runs.length;i++)w+=runs[i].f.getAdvanceWidth(runs[i].t,fs,opt);return w;}
  function mteRunsPath(runs,x,y,fs,opt){var d='';for(var i=0;i<runs.length;i++){var r=runs[i];d+=r.f.getPath(r.t,x,y,fs,opt).toPathData(3);x+=r.f.getAdvanceWidth(r.t,fs,opt);}return d;}
  function engraveCss(fontId,weight){var fr=fontById(fontId),base=(fr&&fr.css)||'serif',al=engraveFamFor(fontId,weight);if(al)mteSymbFace();return al?("'"+al+"','"+MTE_SYMB_ALIAS+"',"+base):base;}
  /* GREFFE 6 (15/10/2026, revue après relecture et contre-relecture) — le fichier laser d'une tomette qui porte un logo importé.
     1) buildLaserSVG recopie le CONTENU de chaque logo sans sa balise <svg> : les déclarations
        qu'elle portait (xmlns:inkscape, xmlns:sodipodi, xmlns:xlink…) restent en route, et le
        « _Gravure SVG » envoyé à l'atelier devient du XML invalide (mesuré : export Inkscape,
        glyphes Canva <use xlink:href>). Chaque préfixe orphelin d'un logo est redéclaré SUR CE LOGO
        (une enveloppe <g xmlns:…>), avec l'adresse que le logo lui donnait, même s'il le redéclare
        aussi plus bas (un <svg> ou un <a> imbriqué : ses autres usages resteraient orphelins, et une
        redéclaration en trop est sans effet). Deux logos peuvent donner au même préfixe deux adresses
        (exports Python « ns1 » : Inkscape chez l'un, xlink chez l'autre) : une seule déclaration à la
        racine en aurait trahi un. Un préfixe que le logo ne déclarait pas (ou par une entité : vieux
        Illustrator, « &ns_ai; ») prend à la racine une adresse connue, sinon une adresse neutre.
     2) Les entités que sanitizeSvg laisse sans définition (il retire le DOCTYPE) : celles des exports
        Illustrator (&ns_svg;, &ns_xlink;, &ns_sfw;…) prennent leur vraie adresse — un <g xmlns="&ns_svg;">
        reste un dessin SVG au lieu de devenir invisible ; une entité HTML d'un outil web (&nbsp;,
        &eacute;…) devient sa référence numérique, le caractère que l'éditeur affichait ; une entité
        inconnue ou un « & » nu devient &amp; (dans un xmlns="…", une adresse neutre). Jamais dans un
        <![CDATA[…]]>, un commentaire ou une instruction <?…?>, où ils sont déjà valides (« R&D Durand »
        doit rester tel quel). Même correction que le Lot D (photo-panier.js, redeclarerEspaces).
        Un fichier déjà lisible ressort tel quel, au caractère près.
     3) Deux logos qui portent les mêmes id (deux exports Canva/Cairo « glyph-0-0 », deux Figma
        « clip0_1_2 »…) : dans un seul fichier, url(#id) et href="#id" visent la PREMIÈRE définition
        du fichier, et l'atelier graverait les lettres ou le masque de l'autre logo. Les id d'un logo
        IMPORTÉ PAR LE CLIENT (icône custom_*) déjà pris AILLEURS dans le fichier (plus haut, ou par un
        motif du catalogue ou d'un modèle placé après lui : on relève leurs id d'abord) sont préfixés
        « mtl<n>- » — « mtl<n>-<k>- » si l'un de ces noms existe déjà —, ainsi que leurs renvois,
        guillemets et id écrits en entités compris (url(&quot;#id&quot;), « R&amp;D »). Les autres id ne
        bougent pas, et rien n'est renommé dans un CDATA, un commentaire ou une instruction. Les motifs
        du catalogue et des modèles ne sont jamais réécrits (sanitizeSvg a déjà retiré les <style> :
        pas de sélecteur #id à suivre). */
  var MT_LASER_NS={xlink:'http://www.w3.org/1999/xlink',svg:'http://www.w3.org/2000/svg',sodipodi:'http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd',inkscape:'http://www.inkscape.org/namespaces/inkscape',rdf:'http://www.w3.org/1999/02/22-rdf-syntax-ns#',cc:'http://creativecommons.org/ns#',dc:'http://purl.org/dc/elements/1.1/',i:'http://ns.adobe.com/AdobeIllustrator/10.0/',x:'adobe:ns:meta/',serif:'http://www.serif.com/',sketch:'http://www.bohemiancoding.com/sketch/ns'};
  var MT_LASER_ENT={ns_svg:'http://www.w3.org/2000/svg',ns_xlink:'http://www.w3.org/1999/xlink',ns_extend:'http://ns.adobe.com/Extensibility/1.0/',ns_ai:'http://ns.adobe.com/AdobeIllustrator/10.0/',ns_graphs:'http://ns.adobe.com/Graphs/1.0/',ns_vars:'http://ns.adobe.com/Variables/1.0/',ns_imrep:'http://ns.adobe.com/ImageReplacement/1.0/',ns_sfw:'http://ns.adobe.com/SaveForWeb/1.0/',ns_custom:'http://ns.adobe.com/GenericCustomNamespace/1.0/',ns_adobe_xpath:'http://ns.adobe.com/XPath/1.0/',ns_flows:'http://ns.adobe.com/Flows/1.0/',ns_a:'http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/'};   // le DOCTYPE des exports Illustrator
  var MT_LASER_BRUT=/(<!\[CDATA\[[\s\S]*?\]\]>|<!--[\s\S]*?-->|<\?[\s\S]*?\?>)/;   // laissés tels quels : leur contenu n'est pas du balisage
  var MT_LASER_XML=/^(?:amp|lt|gt|quot|apos)$/, MT_LASER_HTML=Object.create(null);
  function mtLaserA(o,k){return Object.prototype.hasOwnProperty.call(o,k)?o[k]:null;}
  function mtLaserImporte(e){return !!(e&&e.svg)&&String(e.icon||'').indexOf('custom_')===0;}   // logo importé par le client (llOpenFile, QR, photo) ; un modèle porte son motif en e.svg sous son propre nom
  function mtLaserEnt(n){   // « &n; » sans définition : adresse Illustrator, ou entité HTML en références numériques (1 ou 2 caractères), sinon null
    var v=mtLaserA(MT_LASER_ENT,n),t,s,i,c,d,k=0;if(v!=null)return v;
    if(!(n in MT_LASER_HTML)){
      try{t=document.createElement('textarea');t.innerHTML='&'+n+';';s=t.value;
        if(s&&s!=='&'+n+';'){v='';for(i=0;i<s.length;i++){c=s.charCodeAt(i);if(c>=0xD800&&c<=0xDBFF&&i+1<s.length){d=s.charCodeAt(i+1);if(d>=0xDC00&&d<=0xDFFF){c=(c-0xD800)*0x400+(d-0xDC00)+0x10000;i++;}}v+='&#'+c+';';k++;}if(k>2)v=null;}
      }catch(e){v=null;}
      MT_LASER_HTML[n]=v;
    }
    return MT_LASER_HTML[n];
  }
  function mtLaserIds(inner,vus,pre){
    var seg=String(inner).split(MT_LASER_BRUT),ids=[],mien=Object.create(null),ren=Object.create(null),dbl=[],re=/\sid\s*=\s*(?:"([^"]*)"|'([^']*)')/g,m,k,n=1,p0=pre,
        f=function(a,b,i){return ren[i]?b+ren[i]:a;},pris=function(i){return !!(vus[pre+i]||mien[pre+i]);};
    for(k=0;k<seg.length;k+=2){re.lastIndex=0;while((m=re.exec(seg[k]))){ids.push(m[1]!=null?m[1]:m[2]);mien[ids[ids.length-1]]=1;}}
    if(pre)ids.forEach(function(i){if(vus[i]&&!ren[i]){ren[i]=1;dbl.push(i);}});
    if(dbl.length){
      while(dbl.some(pris))pre=p0+(n++)+'-';   // « mtl2-x » existe déjà (un laser MyTomette réimporté…) : mtl2-1-x
      dbl.forEach(function(i){ren[i]=pre+i;});
      for(k=0;k<seg.length;k+=2)seg[k]=seg[k].replace(/(\sid\s*=\s*["'])([^"']*)/g,f).replace(/(url\(\s*(?:['"]|&quot;|&#34;|&#39;|&apos;)?\s*#)((?:[^'"&)\s]|&(?!quot;|#34;|#39;|apos;))+)/g,f).replace(/(href\s*=\s*["']\s*#)([^"'\s]+)/g,f);
    }
    ids.forEach(function(i){vus[ren[i]||i]=1;});
    return seg.join('');
  }
  function mtLaserNs(attrs,inner,rac){
    var s=String(inner).split(MT_LASER_BRUT).filter(function(x,k){return !(k%2);}).join(''),vu=Object.create(null),dec=Object.create(null),adr=Object.create(null),out='',re,m,p;
    re=/<\/?([A-Za-z_][\w.-]*):[A-Za-z_]/g;while((m=re.exec(s)))vu[m[1]]=1;
    re=/\s([A-Za-z_][\w.-]*):[A-Za-z_][\w.-]*\s*=/g;while((m=re.exec(s)))vu[m[1]]=1;
    re=/\sxmlns:([A-Za-z_][\w.-]*)\s*=/g;while((m=re.exec(s)))dec[m[1]]=1;
    re=/\sxmlns:([A-Za-z_][\w.-]*)\s*=\s*(?:"([^"<&]*)"|'([^'"<&]*)')/g;while((m=re.exec(' '+attrs)))if(!(m[1] in adr))adr[m[1]]=m[2]!=null?m[2]:m[3];
    for(p in vu)if(p!=='xmlns'&&p!=='xml'){if(adr[p])out+=' xmlns:'+p+'="'+adr[p]+'"';else if(!dec[p])rac[p]=1;}   // déclaré par la racine du logo : sur lui, même s'il le redéclare plus bas
    return out?'<g'+out+'>'+inner+'</g>':inner;
  }
  function mtLaserEspaces(svg,rac){
    var aj='',p,s2=svg.split(MT_LASER_BRUT).map(function(x,k){return k%2?x:x
      .replace(/(\sxmlns(?::[\w.-]+)?\s*=\s*["'])&([A-Za-z_][\w.-]*);/g,function(a,b,n){return MT_LASER_XML.test(n)?a:b+(mtLaserA(MT_LASER_ENT,n)||'urn:mytomette:espace:'+n);})
      .replace(/&([A-Za-z_][\w.-]*);/g,function(a,n){var v=MT_LASER_XML.test(n)?null:mtLaserEnt(n);return v==null?a:v;})
      .replace(/&(?!(?:amp|lt|gt|quot|apos);|#\d+;|#x[0-9a-fA-F]+;)/g,'&amp;');}).join('');
    for(p in rac)aj+=' xmlns:'+p+'="'+(mtLaserA(MT_LASER_NS,p)||'urn:mytomette:espace:'+p)+'"';
    return aj?'<svg'+aj+s2.slice(4):s2;
  }
  function buildLaserSVG(src,cb){
    src=src||state;
    var sh=SHAPES[src.shape]||SHAPES.hexa, Wmm=sh.wcm*10, Hmm=sh.hcm*10, els=mtFondEls(src.els||[],src.shape);   // greffe F5 : fond forcé (place, taille, graisse 1,7), sur une copie
    if(!mtFondAccorde(src)){setTimeout(function(){cb(null,{code:'FOND_FORME'});},0);return;}   // greffe F6 (relecture) : une carte dessinée pour l'autre forme ne se grave pas
    var fids={};els.forEach(function(e){if(e.type==='text'){var fid=e.font||DEFAULT_FONT,w=mteWeight(fid,e.weight),k=mteFontKey(fid,w);fids[k]={fontId:fid,weight:w};}});
    var list=Object.keys(fids),fonts={},left=list.length,done=false,symbAsked=false;
    function assemble(){
      if(done)return;
      var missing=list.filter(function(k){return !fonts[k]||!fonts[k].font;});
      if(missing.length){done=true;cb(null,{code:'FONT_LOAD_FAILED',fonts:missing});return;}
      if(!symbAsked){
        symbAsked=true;
        var needSymb=!_symbFont&&els.some(function(e){if(e.type!=='text')return false;var fid=e.font||DEFAULT_FONT,fr=fonts[mteFontKey(fid,mteWeight(fid,e.weight))];return !!(fr&&fr.font&&mteNeedsSymb(fr.font,e.text));});
        if(needSymb){loadSymbFont(function(){assemble();});return;}
      }
      done=true;
      var parts=[];
      var _lRac=Object.create(null),_lIds=Object.create(null),_lN=0;els.forEach(function(e){var r=(e.type!=='text'&&!mtLaserImporte(e))?logoSvg(e):null;if(r)mtLaserIds(String(r),_lIds,'');});   // Greffe 6 : préfixes à déclarer à la racine ; id déjà pris — ceux des motifs du catalogue et des modèles d'abord, où qu'ils soient
      if(sh.cls==='sq'){parts.push('<rect x="0" y="0" width="'+Wmm+'" height="'+Hmm+'" rx="'+(Wmm*0.03).toFixed(1)+'" fill="none" stroke="#00FF00" stroke-width="0.2"/>');}
      else{var pts=[[0.25*Wmm,0],[0.75*Wmm,0],[Wmm,0.5*Hmm],[0.75*Wmm,Hmm],[0.25*Wmm,Hmm],[0,0.5*Hmm]].map(function(p){return p[0].toFixed(2)+','+p[1].toFixed(2);}).join(' ');parts.push('<polygon points="'+pts+'" fill="none" stroke="#00FF00" stroke-width="0.2"/>');}
      els.forEach(function(e){
        var cx=(e.x!=null?e.x:0.5)*Wmm, cy=(e.y!=null?e.y:0.5)*Hmm;
        var _rot=normRot(e.rot), _p0=parts.length;   // rotation : on enveloppe les tracés de CET élément à la fin
        if(e.type==='text'){
          var fs=(e.size||6.5)*1.2,fid=e.font||DEFAULT_FONT,reqW=mteWeight(fid,e.weight),fontRec=fonts[mteFontKey(fid,reqW)],font=fontRec&&fontRec.font,ink=mteSvgInk(fontRec,fs),f=fontById(e.font);
          var txt=(f.caps?String(e.text||'').toUpperCase():String(e.text||''));
          if(e.smallcaps)txt=txt.toUpperCase();
          if(e.curve&&Math.abs(e.curve)>=1){
            var t1=txt.replace(/\n/g,' ');
            var moff2=(typeof f.midOff==='number')?f.midOff:mtMidOff(engraveCss(e.font,reqW)||f.css||famOf(e.font),reqW);
            var lsm=(e.ls||0)*fs, cvL=Math.max(-100,Math.min(100,e.curve))/100, ci;
            if(font){
              var gws=[],wds=[],tot2=0;
              var cfs=[];
              for(ci=0;ci<t1.length;ci++){var cf=mteFontFor(font,t1.charAt(ci)),gw2=cf?cf.getAdvanceWidth(t1.charAt(ci),fs):0;cfs.push(cf);gws.push(gw2);wds.push(cf?gw2+lsm:0);tot2+=cf?gw2+lsm:0;}
              if(tot2>0){
                var posL=_arcLayout(wds,tot2,fs,cvL);
                for(ci=0;ci<t1.length;ci++){
                  if(!cfs[ci])continue;
                  var ph=cfs[ci].getPath(t1.charAt(ci),-gws[ci]/2,fs*moff2,fs), dd2=ph.toPathData(3);
                  if(dd2)parts.push('<g transform="translate('+(cx+posL[ci].x).toFixed(2)+' '+(cy+posL[ci].y).toFixed(2)+') rotate('+(posL[ci].a*180/Math.PI).toFixed(2)+')"><path d="'+dd2+'"'+ink+'/></g>');
                }
              }
            }
          }else{
          /* EXACTEMENT la mise en page de l'apercu : lignes ET taille finale.
             Avant, ce bloc faisait seulement txt.split('\n') a la taille brute :
             un texte reduit a l'ecran ressortait en pleine taille au laser. */
          var _lay=mtLayOf(e,src.shape);
          var lines=_lay.lines;
          fs=_lay.size*1.2;
          ink=mteSvgInk(fontRec,fs);
          var lh=fs*MT_LH, y0=cy-(lines.length-1)*lh/2;
          var _al=(e.align==='left'?'left':(e.align==='right'?'right':'center'));
          var _halfW=(_lay.wFrac*Wmm)/2;                       /* l'alignement etait ignore au SVG */
          var _ax=(_al==='left')?(cx-_halfW):((_al==='right')?(cx+_halfW):cx);
          lines.forEach(function(ln,li){
            var moff=(typeof f.midOff==='number')?f.midOff:mtMidOff(engraveCss(e.font,reqW)||f.css||famOf(e.font),reqW); var baseY=y0+li*lh+fs*moff; var _otopt={letterSpacing:(e.ls||0),kerning:true};
            if(font){
              var _runs=mteRuns(font,ln), adv=mteRunsWidth(_runs,fs,_otopt);
              var _x=(_al==='left')?_ax:((_al==='right')?(_ax-adv):(cx-adv/2));
              var d=mteRunsPath(_runs,_x,baseY,fs,_otopt);
              if(d)parts.push('<path d="'+d+'"'+ink+'/>');
            }
          });
          }
        }else{
          var s=(e.size||13)*1.2, raw=logoSvg(e), inner='', vbX=0, vbY=0, vbW=24, vbH=24, pres='';
          if(raw){
            raw=thickenSvg(String(raw),e).replace(/currentColor/g,'#000');   // même graisse que le PNG (contour ajouté)
            var head=raw.match(/<svg\b([^>]*)>/i), attrs=head?head[1]:'';
            var vb=attrs.match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);
            if(vb){var arr=vb[1].trim().split(/\s+/);if(arr.length===4){vbX=parseFloat(arr[0])||0;vbY=parseFloat(arr[1])||0;vbW=parseFloat(arr[2])||24;vbH=parseFloat(arr[3])||24;}}
            ['fill','stroke','stroke-width','stroke-linecap','stroke-linejoin','stroke-miterlimit','fill-rule','clip-rule'].forEach(function(pp){
              var mm=attrs.match(new RegExp(pp+'\\s*=\\s*("[^"]*"|\'[^\']*\')','i'));
              if(mm) pres+=' '+pp+'='+mm[1];
            });
            inner=raw.replace(/^[\s\S]*?<svg[^>]*>/i,'').replace(/<\/svg>\s*$/i,'');
            inner=mtLaserNs(attrs,mtLaserIds(inner,_lIds,mtLaserImporte(e)?'mtl'+(++_lN)+'-':''),_lRac);   // Greffe 6 : seuls les id déjà pris d'un logo importé par le client sont renommés ; ses préfixes orphelins sont déclarés sur lui
          }else{
            inner=ICONS[e.icon]||ICONS.leaf; pres=' fill="none" stroke="#000" stroke-width="'+((e.stroke||1.7)).toFixed(2)+'"';
          }
          var scl=s/Math.max(vbW,vbH);
          var pre=e.flip?('translate('+cx.toFixed(2)+' '+cy.toFixed(2)+') scale(-1 1) translate('+(-cx).toFixed(2)+' '+(-cy).toFixed(2)+') '):'';
          parts.push('<g transform="'+pre+'translate('+(cx-vbW*scl/2).toFixed(2)+' '+(cy-vbH*scl/2).toFixed(2)+') scale('+scl.toFixed(4)+') translate('+(-vbX).toFixed(2)+' '+(-vbY).toFixed(2)+')"'+pres+'>'+inner+'</g>');
        }
        if(_rot && parts.length>_p0){
          var seg=parts.splice(_p0).join('');
          parts.push('<g transform="rotate('+_rot+' '+cx.toFixed(2)+' '+cy.toFixed(2)+')">'+seg+'</g>');
        }
      });
      cb(mtLaserEspaces('<svg xmlns="http://www.w3.org/2000/svg" width="'+Wmm+'mm" height="'+Hmm+'mm" viewBox="0 0 '+Wmm+' '+Hmm+'">'+parts.join('')+'</svg>',_lRac));   // Greffe 6
    }
    if(!list.length){assemble();return;}
    list.forEach(function(k){var rq=fids[k];loadOTFont(rq.fontId,rq.weight,function(rec){if(rec)fonts[k]=rec;if(--left<=0)assemble();});});
    setTimeout(assemble,12000); // aucun repli <text> : l'export echoue proprement si une police manque
  }
  function downloadSVG(){
    syncTextFromDom();
    buildLaserSVG(state,function(svg){
      if(!svg){toast(window.MT_CONFIG_I18N.text("ui_1ad3ca300935_html", "Impossible de vectoriser une police — SVG non généré"));return;}
      var blob=new Blob([svg],{type:'image/svg+xml'}), url=URL.createObjectURL(blob);
      var a=document.createElement('a');a.href=url;a.download='tomette-laser.svg';document.body.appendChild(a);a.click();a.remove();
      setTimeout(function(){URL.revokeObjectURL(url);},2000);
      toast(window.MT_CONFIG_I18N.text("ui_19ba48504723_html", "SVG laser téléchargé ✓"));
    });
  }
  function showSVGPreview(){
    syncTextFromDom();
    var title=document.getElementById('sheetTitle'),body=document.getElementById('sheetBody'),hint=document.getElementById('sheetHint');
    title.textContent=window.MT_CONFIG_I18N.text("ui_0e15249b5994_html", "SVG laser — aperçu");hint.hidden=true;body.innerHTML=window.MT_CONFIG_I18N.text("ui_a82d15ab0a97_html", "<p class=\"sm-note\">Génération du tracé… (récupération des polices)</p>");
    document.getElementById('sheetOv').classList.add('on');
    buildLaserSVG(state,function(svg){
      body.innerHTML='';
      if(!svg){body.innerHTML=window.MT_CONFIG_I18N.text("ui_e9b869bf0076_html", "<p class=\"sm-note\">Une police n'a pas pu être vectorisée. Aucun fichier incomplet n'a été généré : réessayez dans quelques secondes.</p>");return;}
      var box=el('div','');box.style.cssText='background:#fff;border:1px solid var(--line);border-radius:12px;padding:12px;text-align:center';
      box.innerHTML=svg;
      var s=box.querySelector('svg');if(s){s.removeAttribute('width');s.removeAttribute('height');s.style.width='100%';s.style.height='auto';s.style.maxHeight='44vh';}
      body.appendChild(box);
      var note=el('p','sm-note');note.textContent=window.MT_CONFIG_I18N.text("ui_2c569bf3e0f9_html", "Le texte doit apparaître en contours (tracés). Si une police sort comme du texte simple, dis-le-moi.");body.appendChild(note);
      try{
        var blob=new Blob([svg],{type:'image/svg+xml'}),url=URL.createObjectURL(blob);
        var a=document.createElement('a');a.href=url;a.download='tomette-laser.svg';a.textContent=window.MT_CONFIG_I18N.text("ui_178e2f3772ee_html", "⬇️ Télécharger le SVG");
        a.style.cssText='display:block;text-align:center;text-decoration:none;background:var(--terra);color:#fff;padding:11px;border-radius:12px;font-weight:600;margin-top:10px';
        body.appendChild(a);
      }catch(e){}
    });
  }

  // ---- screens ----
  function mtcfgStep(n,canBack){ try{ if(window.parent && window.parent!==window.self) window.parent.postMessage({mtcfg:'step',step:n,canBack:!!canBack},'*'); }catch(e){} }
  function setProg(n){for(var i=1;i<=3;i++){document.getElementById('d'+i).classList.toggle('on',i<=n);} mtcfgStep(n, n>1); }
  function show(id){document.querySelectorAll('.screen').forEach(function(s){s.classList.remove('on');});document.getElementById(id).classList.add('on');try{document.body.classList.toggle('mt-editing',id==='sEdit');}catch(e){}if(typeof updateAllCues==='function')setTimeout(updateAllCues,50);}
  function goInsp(){ensureCurrentDisplayFonts();show('sInsp');setProg(1);document.getElementById('backBtn').hidden=true;document.getElementById('hdrTitle').textContent='MyTomette';if(!CF_READY)cfShowLoading(true);ensureAllTemplateLogos();ensureRemoteTemplates();cfStartAuto();}
  function goEditor(){if(state.photoProduct&&!mtcfgEmbedded()&&!MT_ADMIN){mtResumePhoto(getRecipe());return;}show('sEdit');setProg(2);var b=document.getElementById('backBtn');b.hidden=false;b.onclick=goInsp;document.getElementById('hdrTitle').textContent=window.MT_CONFIG_I18N.label("Personnalisez");deselect();syncShapeUI();applyHole(document.getElementById('tilewrap'), state.hole);updatePrice();initLiveRO();getBgImg(state.shape==='carree');scheduleLive();setTimeout(scheduleLive,60);if(!tutoSeen){tutoSeen=true;setTimeout(function(){openSheet('help');},450);}if(!window._mtStarted){window._mtStarted=true;mtTrack('cfg_start');}}
  function goValid(){
    if(mtPhotoNativeBlocked())return;
    syncTextFromDom();
    mtTrack('cfg_checkout_step');
    var v=document.getElementById('vtile');
    v.className='tom '+(SHAPES[state.shape].cls==='sq'?'sq photo':'hex photo')+' vtile';
    buildStack(document.getElementById('vstack'), state.els, false);
    var txt=state.els.filter(function(e){return e.type==='text';}).map(function(e){return String(e.text).replace(/\s*\n\s*/g,' ').trim();}).filter(function(t){return t;}).join('  —  ');
    document.getElementById('spellLine').textContent=txt||'(aucun texte)';
    refreshQtyLabels();updateTotal();
    show('sValid');setProg(3);var b=document.getElementById('backBtn');b.hidden=false;b.onclick=goEditor;document.getElementById('hdrTitle').textContent=window.MT_CONFIG_I18N.text("ui_fdddd3f7c122_html", "Votre tomette");
    var ve=document.querySelector('.valid');if(ve){ve.scrollTop=0;}
    var vr=document.querySelector('.vright');if(vr){vr.scrollTop=0;}
    refreshHoleUI();
    syncGiftUI();
    playLaser();
    if(isLive()){try{ensureOpentype(function(){});}catch(e){}}  // préchauffe la vectorisation pendant que le client vérifie
  }
  function refreshHoleUI(){
    var t=document.getElementById('holeToggle');if(t)t.classList.toggle('on',state.hole);
    applyHole(document.getElementById('vtile'), state.hole);
    refreshQtyLabels();updateTotal();
    var w=document.getElementById('holeWarn');if(w)w.hidden=!(state.hole && holeOverlap());
    var lw=document.getElementById('legibWarn');if(lw)lw.hidden=!legibilityIssue();
  }
  function syncGiftUI(){
    var g=state.gift||{};
    var tog=document.getElementById('giftToggle');if(tog)tog.classList.toggle('on', !!g.on);
    var body=document.getElementById('giftBody');if(body)body.hidden=!g.on;
    var gw=document.getElementById('giftWrap');if(gw)gw.checked=!!g.wrap;
    var gs=document.getElementById('giftShip');if(gs)gs.checked=!!g.ship;
    var gm=document.getElementById('giftMsg');if(gm)gm.value=g.msg||'';
    var gc=document.getElementById('giftCount');if(gc)gc.textContent=(g.msg||'').length;
  }
  function playLaser(){
    drawValid();
    var l=document.getElementById('laser');var st=document.getElementById('vEngrave')||document.getElementById('vstack');
    l.classList.remove('run');st.classList.remove('reveal');void l.offsetWidth;
    l.classList.add('run');st.classList.add('reveal');
  }

  // ---- pricing valid ----
  function basePrice(){return priceShape(state.shape);}
  function refreshQtyLabels(){
    var b=basePrice(), fee=state.hole?holeFeeFor(state.shape):0;
    var t1=b+fee, t2=b*2+fee*2, t10=b*10+fee*10;
    document.getElementById('q1s').textContent=displayEuro(t1);
    document.getElementById('q2s').textContent=displayEuro(t2)+" · "+displayEuro(t2/2)+'/pc';
    document.getElementById('q3s').textContent=displayEuro(t10)+" · "+displayEuro(t10/10)+'/pc';
  }
  /* TOMETTE PHOTO — greffe 1b (relecture du 14/10). Pas d'emballage cadeau sur une tomette photo
     (arbitrage Q7) : la greffe 2 envoie cadeau:null, le total annoncé ne compte donc pas les 4 €,
     même quand une recette reprise arrive cadeau coché (loadRecipe recopie r.gift). state.gift
     reste tel quel : si la photo quitte la pièce, le cadeau choisi revient avec son prix. Fiche
     photo (state.photoProduct) : inchangé. */
  function computeTotal(){return Math.round((basePrice()*qtyMult)*100)/100+(state.hole?holeFeeFor(state.shape)*qtyCount:0)+((state.gift&&state.gift.on&&state.gift.wrap&&(state.photoProduct||!mtIsPhotoState(state)))?GIFT_FEE:0);}
  function updateTotal(){
    document.getElementById('addCart').textContent=(EDIT_KEY?window.MT_CONFIG_I18N.text("ui_ab95e3e1b36c_html", "Mettre à jour — "):window.MT_CONFIG_I18N.text("ui_ca56e7818f7a_html", "Ajouter au panier — "))+displayEuro(computeTotal());
  }

  // ---- sheets ----
  function openSheet(kind){
    var ov=document.getElementById('sheetOv');var title=document.getElementById('sheetTitle');
    var hint=document.getElementById('sheetHint');var body=document.getElementById('sheetBody');
    if(kind!=='save')window._mtLeaveAfterSave=false;
    ov.dataset.kind=kind||'';
    if(_sheetCloseT){clearTimeout(_sheetCloseT);_sheetCloseT=null;}
    ov.classList.remove('closing');
    hint.hidden=true;body.innerHTML='';ov.classList.remove('peek');
    if(kind==='gps'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_c05045ad979f_html", "Point GPS");
      var gwrap=el('div');
      gwrap.innerHTML=window.MT_CONFIG_I18N.text("ui_ce174189ae6e_html", "<div class=\"gps-row\"><input type=\"text\" id=\"gpsQ\" placeholder=\"Ville, rue, restaurant…\" autocomplete=\"off\"></div><div class=\"gps-list\" id=\"gpsRes\"></div><div class=\"rhint\">Cherchez un lieu qui compte : une maison, un lieu de rencontre, un restaurant…</div>");
      body.appendChild(gwrap);
      var gq=gwrap.querySelector('#gpsQ'), gres=gwrap.querySelector('#gpsRes'), gT=null, gSeq=0;
      function gpsFmtDec(v,isLat){   // décimal limité à 5 chiffres : 43.120
        var hemi=isLat?(v>=0?'N':'S'):(v>=0?'E':'O');
        return Math.abs(v).toFixed(2)+'°'+hemi;
      }
      function pickPlace(lat,lon,name){
        var dms=toDMS(lat,true)+'  '+toDMS(lon,false);
        var dec=gpsFmtDec(lat,true)+'  '+gpsFmtDec(lon,false);
        body.innerHTML='';
        title.textContent=window.MT_CONFIG_I18N.label("Comment graver ce lieu ?");
        var fw=el('div','gps-fmt');
        var hint2=el('div','rhint');hint2.textContent=name;fw.appendChild(hint2);
        [[dms,window.MT_CONFIG_I18N.text("ui_2e4f69a30adc_html", "Degrés · minutes · secondes")],[dec,window.MT_CONFIG_I18N.text("ui_21ae20e058e2_html", "Décimal, plus épuré")]].forEach(function(f){
          var b=el('button','gps-fmt-b');
          b.innerHTML='<span class="g-prev">'+f[0]+'</span><span class="g-lbl">'+f[1]+'</span>';
          b.addEventListener('click',function(){
            addText({text:f[0],font:'dmsans',size:3.4},false);
            var it=state.sel?getItem(state.sel):null;
            if(it){it.ls=0.14;var nd=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(nd)applyStyle(nd,it);syncGrey();scheduleLive();}
            mtTrack('cfg_add_gps');
            closeSheet();toast(window.MT_CONFIG_I18N.text("ui_efd104007fac_html", "Point GPS ajouté ✓"));
          });
          fw.appendChild(b);
        });
        var back=el('button','gps-back');back.textContent=window.MT_CONFIG_I18N.text("ui_34de07913dda_html", "← Chercher un autre lieu");
        back.addEventListener('click',function(){openSheet('gps');});
        body.appendChild(fw);body.appendChild(back);
      }
      function gpsSearch(q){
        var seq=++gSeq;
        fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5&accept-language='+encodeURIComponent(window.MT_CONFIG_I18N.locale||'fr')+'&q='+encodeURIComponent(q))
          .then(function(r){return r.json();})
          .then(function(list){
            if(seq!==gSeq)return;   // une frappe plus récente a relancé la recherche
            gres.innerHTML='';
            if(!list||!list.length){var e0=el('div','gps-empty');e0.textContent=window.MT_CONFIG_I18N.text("ui_9cb791706b23_html", "Aucun lieu trouvé — essayez « nom, ville »");gres.appendChild(e0);return;}
            list.forEach(function(pl){
              var nm=String(pl.display_name||'').split(',').slice(0,3).join(',');
              var it2=el('button','gps-item');
              it2.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 21.5s-6.5-5.4-6.5-10.3A6.5 6.5 0 0112 4.7a6.5 6.5 0 016.5 6.5c0 4.9-6.5 10.3-6.5 10.3z"/><circle cx="12" cy="11.2" r="2.2"/></svg><span>'+nm.replace(/</g,'&lt;')+'</span>';
              it2.addEventListener('click',function(){pickPlace(parseFloat(pl.lat),parseFloat(pl.lon),nm);});
              gres.appendChild(it2);
            });
          })['catch'](function(){if(seq===gSeq){gres.innerHTML=window.MT_CONFIG_I18N.text("ui_cbc254c644e7_html", "<div class=\"gps-empty\">Recherche indisponible — réessayez</div>");}});
      }
      gq.addEventListener('input',function(){
        var q=gq.value.trim();
        if(gT)clearTimeout(gT);
        if(q.length<3){gres.innerHTML='';return;}
        gT=setTimeout(function(){gpsSearch(q);},380);
      });
      ov.classList.add('on');
      setTimeout(function(){gq.focus();},60);
      return;
    } else if(kind==='adjust'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_4ed117e09c53_html", "Réglages");
      var it3=state.sel?getItem(state.sel):null;
      if(!it3){hint.hidden=false;hint.textContent=window.MT_CONFIG_I18N.text("ui_156ba036e02a_html", "Sélectionnez d'abord un élément sur la tomette.");ov.classList.add('on');return;}
      var wrap3=el('div','adjust-sheet');
      var _histOnce=false;
      function histOnce(){if(!_histOnce){_histOnce=true;pushHistory();}}
      function endGesture(){_histOnce=false;mtAutosave();}
      function nodeSel(){return state.sel?document.querySelector('#stack .el[data-id="'+state.sel+'"]'):null;}
      function sliderRow(label,min,max,step,get,set,fmt){
        var row=el('div','adj-slider');
        row.innerHTML='<div class="adj-top"><span class="adj-lbl">'+label+'</span><span class="adj-val"></span></div><input type="range" class="adj-range">';
        var r=row.querySelector('input'), v=row.querySelector('.adj-val');
        r.min=min;r.max=max;r.step=step;r.value=get();
        v.textContent=fmt();
        r.addEventListener('pointerdown',histOnce);
        r.addEventListener('touchstart',histOnce,{passive:true});
        r.addEventListener('input',function(){set(parseFloat(r.value));v.textContent=fmt();});
        r.addEventListener('change',endGesture);
        return row;
      }
      var b0=sizeBounds(it3);
      wrap3.appendChild(sliderRow(window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),b0.min,b0.max,0.1,
        function(){var i2=getItem(state.sel);return i2?(i2.size||b0.min):b0.min;},
        function(v){var i2=getItem(state.sel);if(!i2)return;var b=sizeBounds(i2);i2.size=Math.round(clamp(v,b.min,b.max)*10)/10;i2.manual=true;var nd=nodeSel();if(nd){if(i2.type==='text'){_applySize(nd,i2);}else{applyLogoSize(nd,i2);}}syncGrey();positionFloat();scheduleLive();},
        function(){var i2=getItem(state.sel);var v=i2?Math.round((i2.size||0)*10)/10:0;return (v%1===0)?String(Math.round(v)):v.toFixed(1);}));
      if(it3.type==='text'){
        wrap3.appendChild(sliderRow(window.MT_CONFIG_I18N.text("ui_04a55203e107_html", "Espacement des lettres"),0,0.4,0.01,
          function(){var i2=getItem(state.sel);return i2?(i2.ls||0):0;},
          function(v){var i2=getItem(state.sel);if(!i2)return;i2.ls=Math.round(clamp(v,0,0.4)*100)/100;var nd=nodeSel();if(nd)applyStyle(nd,i2);syncGrey();positionFloat();scheduleLive();},
          function(){var i2=getItem(state.sel);return Math.round(((i2&&i2.ls)||0)*100)+'%';}));
        wrap3.appendChild(sliderRow(window.MT_CONFIG_I18N.text("ui_3fa528fe0ab8_html", "Courbure"),-100,100,10,
          function(){var i2=getItem(state.sel);return i2?(i2.curve||0):0;},
          function(v){var i2=getItem(state.sel);if(!i2)return;i2.curve=Math.round(clamp(v,-100,100));var nd=nodeSel();if(nd)applyStyle(nd,i2);syncGrey();positionFloat();scheduleLive();},
          function(){var i2=getItem(state.sel);var c=i2?(i2.curve||0):0;return c===0?'Droit':(c>0?'Sourire '+c:window.MT_CONFIG_I18N.text("ui_9a2eff3c1b65_html", "Arqué ")+Math.abs(c));}));
      }
      wrap3.appendChild(sliderRow(window.MT_CONFIG_I18N.text("ui_bc301ef97255_html", "Pivoter"),-180,180,1,
        function(){var i2=getItem(state.sel);return i2?normRot(i2.rot):0;},
        function(v){var i2=getItem(state.sel);if(!i2)return;var sn=Math.round(v/15)*15;if(Math.abs(v-sn)<3)v=sn;i2.rot=normRot(v);var nd=nodeSel();if(nd)applyRot(nd,i2);syncGrey();positionFloat();scheduleLive();},
        function(){var i2=getItem(state.sel);return Math.round(normRot(i2&&i2.rot))+'°';}));
      var wrow=el('div','adj-row');
      wrow.innerHTML=window.MT_CONFIG_I18N.text("ui_d95283e8fb8b_html", "<div class=\"adj-lbl\">Épaisseur</div><div class=\"fcp-step\"><button class=\"adjM\">−</button><span class=\"adjV\"></span><button class=\"adjP\">＋</button></div>");
      wrow.querySelector('.adjV').textContent=weightLabel();
      wrow.querySelector('.adjM').addEventListener('click',function(){changeWeight(-1);wrow.querySelector('.adjV').textContent=weightLabel();});
      wrow.querySelector('.adjP').addEventListener('click',function(){changeWeight(1);wrow.querySelector('.adjV').textContent=weightLabel();});
      wrap3.appendChild(wrow);
      if(it3.type==='icon'){
        var mbtn=el('button','rline');
        mbtn.innerHTML=window.MT_CONFIG_I18N.text("ui_eb02798dad2c_html", "<span class=\"ric\">⇋</span><span><b>Effet miroir</b><small>Retourne le motif horizontalement</small></span>");
        mbtn.addEventListener('click',function(){flipSel();});
        wrap3.appendChild(mbtn);
      }
      var alTitle=el('div','adj-lbl');alTitle.style.marginTop='2px';alTitle.textContent=window.MT_CONFIG_I18N.text("ui_42092827bf96_html", "Aligner sur la tomette");wrap3.appendChild(alTitle);
      var alGrid=el('div','al-grid');
      alGrid.innerHTML=window.MT_CONFIG_I18N.text("ui_494259f0f212_html", "<button data-al=\"l\" title=\"À gauche\">⇤</button><button data-al=\"cx\" title=\"Centré horizontalement\">↔</button><button data-al=\"r\" title=\"À droite\">⇥</button>")+
        window.MT_CONFIG_I18N.text("ui_e5a2a18523bf_html", "<button data-al=\"t\" title=\"En haut\">⤒</button><button data-al=\"cy\" title=\"Centré verticalement\">↕</button><button data-al=\"b\" title=\"En bas\">⤓</button>");
      wrap3.appendChild(alGrid);
      var alFull=el('button','al-full');alFull.textContent=window.MT_CONFIG_I18N.text("ui_fe46f6f5bd79_html", "◎ Centrer sur la tomette");wrap3.appendChild(alFull);
      var alBtns=alGrid.querySelectorAll('[data-al]');
      for(var ai=0;ai<alBtns.length;ai++){(function(b2){b2.addEventListener('click',function(){alignSel(b2.dataset.al);});})(alBtns[ai]);}
      alFull.addEventListener('click',function(){alignSel('c');});
      body.appendChild(wrap3);
      ov.classList.add('on');ov.classList.add('peek');
      pinStageTop(true);
      return;
    } else if(kind==='addmenu'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_00f9c5334547_html", "Ajouter");
      var rows=[
        ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 6V4.5h14V6M12 4.5V20M9 20h6"/></svg>',window.MT_CONFIG_I18N.text("ui_bbb0bd5ff551_html", "Texte"),window.MT_CONFIG_I18N.text("ui_5edb8a69a873_html", "Un titre, un prénom, une date…"),'text'],
        ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"><path d="M12 20s-6.8-4.4-8.8-8.8C1.9 8.2 4 5.4 6.9 5.4c1.9 0 3.2 1 4.1 2.5.9-1.5 2.2-2.5 4.1-2.5 2.9 0 5 2.8 3.7 5.8C16.8 15.6 12 20 12 20z"/></svg>',window.MT_CONFIG_I18N.text("ui_c89ac8f0d41a_html", "Motif"),window.MT_CONFIG_I18N.text("ui_896ea9853844_html", "Cœur, feuille, ou votre logo"),'motif'],
        ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 21.5s-6.5-5.4-6.5-10.3A6.5 6.5 0 0112 4.7a6.5 6.5 0 016.5 6.5c0 4.9-6.5 10.3-6.5 10.3z"/><circle cx="12" cy="11.2" r="2.2"/></svg>',window.MT_CONFIG_I18N.text("ui_c05045ad979f_html", "Point GPS"),window.MT_CONFIG_I18N.text("ui_8bba731fb1cb_html", "Les coordonnées d'un lieu qui compte"),'gps'],
        ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3.5" y="3.5" width="7" height="7" rx="1"/><rect x="13.5" y="3.5" width="7" height="7" rx="1"/><rect x="3.5" y="13.5" width="7" height="7" rx="1"/><path d="M13.5 13.5h3v3h-3zM18 15.5h2.5M15.5 18v2.5M18 18h2.5v2.5"/></svg>','QR code',window.MT_CONFIG_I18N.text("ui_6d5a5118241e_html", "Site, contact, Wi-Fi, agenda…"),'qr']
      ];
      rows.forEach(function(r){
        var b=el('button','addmenu-row'); b.dataset.add = r[3];
        b.innerHTML='<span class="amic">'+r[0]+'</span><span><b>'+r[1]+'</b><small>'+r[2]+'</small></span>';
        b.addEventListener('click',function(){if(r[3]==='qr'){closeSheet();qrStart(function(svg){addCustomSvg(svg);});}else openSheet(r[3]);});
        body.appendChild(b);
      });
      ov.classList.add('on');
      return;
    } else if(kind==='format'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_0400ea4c1b3a_html", "Format de la tomette");
      body.innerHTML=window.MT_CONFIG_I18N.text("ui_36068ac08ed8_html", "<div id=\"shapeCardsM\"></div><div class=\"rhint\">Votre création s'adapte automatiquement à la nouvelle forme — comparez, rien n'est perdu.</div><h4 style=\"font-size:.78rem;font-weight:700;margin:14px 0 9px\">Suspension</h4><button class=\"rline\" id=\"holeCardM\"><span class=\"ric\">○</span><span><b>Trou de suspension</b><small id=\"holeCardSubM\">Pour accrocher votre tomette au mur</small></span><span class=\"rsw\"></span></button>");
      buildShapeCards();
      ov.classList.add('on');
      return;
    } else if (kind === 'font') {
      ensureAllDisplayFonts();
      title.textContent=window.MT_CONFIG_I18N.text("ui_7c42d811a552_html", "Choisir une police");
      if(!state.sel||getItem(state.sel).type!=='text'){hint.hidden=false;hint.textContent=window.MT_CONFIG_I18N.text("ui_6a6067fa302a_html", "Sélectionnez d'abord un texte sur la tomette.");}
      var tabs=el('div','fgtabs');
      var grid=el('div','fgrid');
      function fontPreviewText(){
        var cur=state.sel?getItem(state.sel):null;
        var t=(cur&&cur.type==='text')?String(cur.text||'').replace(/\s+/g,' ').trim():'';
        if(!t)return 'Bonheur';
        return t.length>14?(t.slice(0,14).replace(/\s+$/,'')+'…'):t;
      }
    function _mtFontPend(itEl,w,f){
      try{
        if(!document.fonts||!document.fonts.check)return;
        var fam=f.italic?"'Cormorant Garamond'":String(f.css||'').split(',')[0].trim();
        if(!fam)return;
        var spec=(f.italic?'italic ':'')+'1.5rem '+fam;
        var okNow=false;try{okNow=document.fonts.check(spec);}catch(e){okNow=false;}
        if(MT_FONT_FACES_READY&&okNow)return;
        itEl.classList.add('fload');
        var started=false;
        var go=function(){
          if(started)return; started=true;
          _mtWaitFont(spec,w.textContent,function(){itEl.classList.remove('fload');});
        };
        if(window.IntersectionObserver){
          var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){try{io.disconnect();}catch(e){}go();}});},{rootMargin:'300px'});
          io.observe(itEl);
          setTimeout(function(){if(!started){try{io.disconnect();}catch(e){}go();}},900);
        } else { go(); }
      }catch(e){}
    }
      function fill(g){
        grid.innerHTML='';
        var pvTxt=fontPreviewText();
        var flist=(g==='recent')?RECENT_FONTS.map(function(id){return FONTS.filter(function(f){return f.id===id;})[0];}).filter(Boolean):FONTS.filter(function(f){return f.grp===g;});
        flist.forEach(function(f){
          var it=el('div','fitem');
          var cur=state.sel?getItem(state.sel):null;
          if(cur&&cur.font===f.id)it.classList.add('on');
          var w=el('div','w');w.textContent=pvTxt;
          if(f.italic){w.style.fontStyle='italic';w.style.fontFamily="'Cormorant Garamond',serif";}
          else w.style.font='1.5rem '+f.css;
          if(f.caps){w.style.textTransform='uppercase';w.style.fontSize='1.1rem';}
          var n=el('div','n');n.textContent=f.label;
      it.appendChild(w);it.appendChild(n);_mtFontPend(it,w,f);
          it.addEventListener('click',function(){setFont(f.id);fill(g);buildFontGroupsTabs();document.getElementById('sheetOv').classList.add('peek');});
          grid.appendChild(it);
        });
      }
      function buildFontGroupsTabs(){
        var g2=RECENT_FONTS.length?[['recent',window.MT_CONFIG_I18N.text("ui_97efed97e320_html", "Dernières utilisées")],['eleg',window.MT_CONFIG_I18N.text("ui_50c85d9f4522_html", "Élégante")],['manu','Manuscrite'],['mod','Moderne']]:[['eleg',window.MT_CONFIG_I18N.text("ui_50c85d9f4522_html", "Élégante")],['manu','Manuscrite'],['mod','Moderne']];
        var active=tabs.querySelector('.fgtab.on');var activeTxt=active?active.textContent:g2[0][1];
        tabs.innerHTML='';
        g2.forEach(function(g){
          var tb=el('span','fgtab'+(g[1]===activeTxt?' on':''));tb.textContent=g[1];
          tb.addEventListener('click',function(){tabs.querySelectorAll('.fgtab').forEach(function(x){x.classList.remove('on');});tb.classList.add('on');fill(g[0]);});
          tabs.appendChild(tb);
        });
      }
      buildFontGroupsTabs();
      body.appendChild(tabs);body.appendChild(grid);
      fill(RECENT_FONTS.length?'recent':'eleg');
    } else if(kind==='motif'){
      if(!FULL_LOGOS_READY){
        ensureFullLogos(function(){
          var cur=document.getElementById('sheetOv');
          if(cur&&cur.dataset.kind==='motif'&&(cur.classList.contains('on')||cur.classList.contains('peek')))openSheet('motif');
        });
      }
      title.textContent=window.MT_CONFIG_I18N.text("ui_a39d9adaecda_html", "Ajouter un motif");
      // --- Import de logo mis en héros (sans PRO, sans QR) ---
      var imp=el('div','logo-hero');
      imp.innerHTML=window.MT_CONFIG_I18N.text("ui_72ebf3e02dd5_html", "<div class=\"lh-ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\"><path d=\"M12 16V4M8 8l4-4 4 4M5 16v3a1 1 0 001 1h12a1 1 0 001-1v-3\"/></svg></div><b>Votre logo, gravé pour durer</b><p>SVG, PNG, JPG… — on le prépare automatiquement pour la gravure.</p><button type=\"button\" class=\"lh-go\" id=\"impSvgBtn\">Importer mon fichier</button><input type=\"file\" id=\"impSvgInput\" accept=\"")+LL_ACCEPT+'" hidden>';
      body.appendChild(imp);
      var fileInput=imp.querySelector('#impSvgInput');
      imp.querySelector('#impSvgBtn').addEventListener('click',function(){fileInput.click();});
      fileInput.addEventListener('change',function(){
        var f=fileInput.files&&fileInput.files[0];if(!f)return;
        llOpenFile(f,function(svg){addCustomSvg(svg);closeSheet();});
        fileInput.value='';
      });
      var orsep=el('div','logo-orsep');orsep.innerHTML=window.MT_CONFIG_I18N.text("ui_bbcc9c4d7f50_html", "<span>Ou choisissez un motif</span>");body.appendChild(orsep);
      // --- Grille + onglets catégories ---
      var ig=el('div','igrid');
      function addMotif(key,builtin){
        if(!builtin && LOGOCAT[key] && LOGOCAT[key].clientVisible===false) return;   // logo masqué côté client : absent du sélecteur (mais toujours affiché s'il fait partie d'un modèle)
        var it=el('div','iitem'+(builtin?'':' cat'));
        if(builtin)it.innerHTML='<svg viewBox="0 0 24 24">'+ICONS[key]+'</svg>';
        else logoPreviewInto(it,key);
        if(!builtin)it.title=LOGOCAT[key].name||key;
        it.addEventListener('click',function(){
          if(builtin){addIcon(key);closeSheet();return;}
          if (it.classList.contains('loading')) return ;
          it.classList.add('loading');
          addCatalogIcon(key, function(ok){it.classList.remove('loading');if(ok)closeSheet();});
        });
        ig.appendChild(it);
      }
      function fillMotif(cat){
        ig.innerHTML='';
        if(cat==='all'){
          Object.keys(LOGOCAT).forEach(function(k){addMotif(k,false);});
        } else {
          Object.keys(LOGOCAT).forEach(function(k){if(LOGOCAT[k].category===cat)addMotif(k,false);});
        }
        observeLogoPreviews(ig);
      }
      if(LOGOCATS.length){
        var mtabs=el('div','fgtabs');
        var cats=[['all',window.MT_CONFIG_I18N.text("ui_2ff599814388_html", "Tous")]];
        LOGOCATS.forEach(function(c){cats.push([c.id,window.MT_CONFIG_I18N.label(c.name)]);});
        cats.forEach(function(c,i){
          var tb=el('span','fgtab'+(i===0?' on':''));tb.textContent=c[1];
          tb.addEventListener('click',function(){document.querySelectorAll('#sheetBody .fgtab').forEach(function(x){x.classList.remove('on');});tb.classList.add('on');fillMotif(c[0]);});
          mtabs.appendChild(tb);
        });
        body.appendChild(mtabs);
      }
      body.appendChild(ig);
      fillMotif('all');
    } else if(kind==='weight'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_9930487b4208_html", "Épaisseur");
      if(!state.sel){hint.hidden=false;hint.textContent=window.MT_CONFIG_I18N.text("ui_6bfd4de63936_html", "Sélectionnez d'abord un texte ou un logo sur la tomette.");}
      var sp=el('div','spacing');
      sp.innerHTML='<button id="wMinus">−</button><div class="v" id="weightVal">'+weightLabel()+'</div><button id="wPlus">+</button>';
      body.appendChild(sp);
      sp.querySelector('#wMinus').addEventListener('click',function(){changeWeight(-1);var d=document.getElementById('weightVal');if(d)d.textContent=weightLabel();});
      sp.querySelector('#wPlus').addEventListener('click',function(){changeWeight(1);var d=document.getElementById('weightVal');if(d)d.textContent=weightLabel();});
      updateWeightBtns();
    } else if(kind==='save'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_6ade81a70e23_html", "Gardez votre création");
      hint.hidden=false;hint.textContent=window.MT_CONFIG_I18N.text("ui_29553f36e15a_html", "Recevez votre lien par e-mail pour la reprendre plus tard.");
      var saveDialog=ov.querySelector('.sheet');
      if(saveDialog){saveDialog.setAttribute('role','dialog');saveDialog.setAttribute('aria-modal','true');saveDialog.setAttribute('aria-labelledby','sheetTitle');saveDialog.setAttribute('aria-describedby','sheetHint');saveDialog.setAttribute('tabindex','-1');}
      var sv=el('form','savesheet');sv.id='mtSaveForm';
      sv.innerHTML=window.MT_CONFIG_I18N.text("ui_68dd48d1b447_html", "<label class=\"sm-label\" for=\"smInput\">Votre e-mail</label><input type=\"email\" id=\"smInput\" placeholder=\"vous@exemple.fr\" inputmode=\"email\" autocomplete=\"email\" aria-describedby=\"sheetHint smStatus\" required><label class=\"sm-opt\"><input type=\"checkbox\" id=\"smNews\" checked><span>Recevoir les nouveautés et offres MyTomette</span></label><button id=\"smSend\" type=\"submit\">Enregistrer ma création</button><p id=\"smStatus\" role=\"alert\" tabindex=\"-1\" hidden></p><button id=\"smLeave\" type=\"button\" hidden>Quitter sans enregistrer</button>");
      body.appendChild(sv);
      var newsInput=sv.querySelector('#smNews'),newsletterChanged=false;newsInput.checked=true;
      newsInput.addEventListener('change',function(ev){if(ev.isTrusted)newsletterChanged=true;});
      var leaveBtn=sv.querySelector('#smLeave');leaveBtn.hidden=!window._mtLeaveAfterSave;
      leaveBtn.addEventListener('click',mtLeaveEditor);
      sv.addEventListener('submit',function(ev){
        ev.preventDefault();
        var btn=sv.querySelector('#smSend'),input=sv.querySelector('#smInput'),status=sv.querySelector('#smStatus');
        if(btn.disabled)return;
        if(mtHasFond(state)){status.textContent=mtFondMessageReste(mtFondTypeDe(state));status.hidden=false;try{status.focus();}catch(_){}return;}   // greffe F8 : rien ne part, couche d'édition ou non
        var val=input.value.trim();input.value=val;
        if(!input.checkValidity()){input.reportValidity();return;}
        var news=newsInput.checked;
        var newsletterMetadata={default_checked:true,user_changed:newsletterChanged};
        syncTextFromDom();
        var submittedRecipe=JSON.stringify(getRecipe());
        var link=baseUrl()+recipeToHash(JSON.parse(submittedRecipe));
        status.hidden=true;btn.disabled=true;
        var lbl0=btn.textContent;btn.textContent=window.MT_CONFIG_I18N.text("ui_33131e9caf96_html", "Envoi en cours…");
        sendModelEmail(val,news,function(emailed){
          if(emailed){
            _mtSaved=true;_mtSavedRecipe=submittedRecipe;mtTrack('cfg_save_email');
            var active=document.getElementById('mtSaveForm')===sv&&ov.dataset.kind==='save'&&!ov.classList.contains('closing');
            var leave=active&&window._mtLeaveAfterSave&&!mtHasUnsavedCreation();
            if(active)closeSheet();
            toast(window.MT_CONFIG_I18N.text("ui_b12fbdd376c7_html", "Création enregistrée. Lien envoyé par e-mail."));
            if(leave)mtLeaveEditor();
            return;
          }
          btn.disabled=false;btn.textContent=lbl0;
          status.textContent=window.MT_CONFIG_I18N.text("ui_0f3405b137d0_html", "Enregistrement indisponible. Réessayez.");status.hidden=false;status.focus();
        },link,newsletterMetadata);
      });
      ov.classList.add('on');
      setTimeout(function(){var i=sv.querySelector('#smInput');if(COARSE){if(saveDialog)saveDialog.focus();}else if(i)i.focus();},60);
      return;
    } else if(kind==='text'){
      addText(null,true);return;
    } else if(kind==='edittext'){
      title.textContent=window.MT_CONFIG_I18N.text("ui_c170d750ef45_html", "Modifier le texte");
      var cur=state.sel?getItem(state.sel):null;
      if(!cur||cur.type!=='text'){hint.hidden=false;hint.textContent=window.MT_CONFIG_I18N.text("ui_6a6067fa302a_html", "Sélectionnez d'abord un texte sur la tomette.");ov.classList.add('on');return;}
      var ta=el('textarea','edit-ta');ta.value=cur.text;ta.setAttribute('rows','3');
      var cnt=el('div','edit-count');
      function updCount(){
        var lines=String(ta.value||'').split('\n');
        var mx=0;lines.forEach(function(l){if(l.length>mx)mx=l.length;});
        if(mx>18){cnt.classList.add('warn');cnt.textContent='Ligne de '+mx+window.MT_CONFIG_I18N.text("ui_07b2cc745d0e_html", " caractères — la taille s'adaptera pour rester nette à la gravure");}
        else{cnt.classList.remove('warn');cnt.textContent=mx?(mx+window.MT_CONFIG_I18N.text("ui_5ad6793e2abb_html", " caractères")):'';}
      }
      updCount();
      ta.addEventListener('input',function(){
        cur.text=ta.value;
        var node=document.querySelector('#stack .el[data-id="'+cur.id+'"]');
        if(node)node.textContent=cur.text;
        updCount();
        syncGrey();positionFloat();scheduleLive();mtAutosave();
      });
      var ok=el('button','sheet-ok');ok.textContent=window.MT_CONFIG_I18N.text("ui_f28acc85bfcb_html", "Terminé");
      ok.addEventListener('click',closeSheet);
      body.appendChild(ta);body.appendChild(cnt);body.appendChild(ok);
      ov.classList.add('on');
      setTimeout(function(){ta.focus();},60); // ouverture clavier voulue par l'utilisateur
      return;
    } else if(kind==='help'){
      title.textContent=window.MT_CONFIG_I18N.label("Comment personnaliser");
      var rows = COARSE ? [
        ['<span class="t-tile"></span><span class="t-finger tap"></span><span class="t-ring"></span>',window.MT_CONFIG_I18N.text("ui_9ec1e79363c4_html", "Modifier un texte"),window.MT_CONFIG_I18N.text("ui_bf72e9617617_html", "Tapez deux fois sur un texte de la tomette pour le réécrire.")],
['<span class="t-tile"></span><span class="t-dot d1"></span><span class="t-dot d2"></span>',window.MT_CONFIG_I18N.text("ui_95c76b8fbebd_html", "Agrandir & pivoter"),window.MT_CONFIG_I18N.text("ui_17da5360496d_html", "Pincez à deux doigts pour la taille — et faites tourner ces deux doigts pour incliner l'élément.")],
        ['<span class="t-tile"></span><span class="t-finger drag"></span>',window.MT_CONFIG_I18N.text("ui_96d83ee0e080_html", "Déplacer"),window.MT_CONFIG_I18N.text("ui_f2b97bd233bd_html", "Glissez un texte ou un motif avec le doigt pour le positionner.")]
      ] : [
        ['<span class="t-tile"></span><span class="t-cursor click"></span><span class="t-ring"></span>',window.MT_CONFIG_I18N.text("ui_2eeceee460dd_html", "Ajoutez, puis cliquez"),window.MT_CONFIG_I18N.text("ui_746e4655fff2_html", "Ajoutez un texte, un motif, un logo ou un QR. Cliquez un élément sur la tomette : tous ses réglages s'ouvrent à gauche.")],
        ['<span class="t-tile"></span><span class="t-cursor drag"></span>',window.MT_CONFIG_I18N.text("ui_414bc53d4fa6_html", "Déplacez au millimètre"),window.MT_CONFIG_I18N.text("ui_b55679aaf4cc_html", "Glissez à la souris — les distances aux bords s'affichent en mm. Ou sélectionnez et utilisez les flèches du clavier : 1 mm, ou 5 mm avec Maj.")],
        ['<span class="t-tile"></span><span class="t-ring"></span>',window.MT_CONFIG_I18N.text("ui_12a02a5a0a79_html", "Réécrivez, alignez, dupliquez"),window.MT_CONFIG_I18N.text("ui_f5e9f9c78595_html", "Double-cliquez un texte pour le réécrire, alignez-le à gauche/centre/droite comme dans un traitement de texte, et dupliquez d'un ⌘/Ctrl+D.")]
      ];
      var rowsHtml='';
      for(var ri=0;ri<rows.length;ri++){
        rowsHtml+='<div class="tuto-row"><div class="tuto-ic">'+rows[ri][0]+'</div><div class="tuto-tx"><b>'+rows[ri][1]+'</b><span>'+rows[ri][2]+'</span></div></div>';
      }
      var h=''+
        '<div class="tuto">'+
          rowsHtml+
          '<div class="tuto-bar">'+
            '<div class="tuto-bar-h">'+(COARSE?window.MT_CONFIG_I18N.text("ui_a409dbe037b3_html", "La barre qui apparaît sur l'élément sélectionné"):window.MT_CONFIG_I18N.text("ui_3388fe6d53da_html", "Raccourcis clavier — un élément sélectionné"))+'</div>'+
            '<div class="tuto-keys">'+(COARSE?(
              window.MT_CONFIG_I18N.text("ui_17b56976c49c_html", "<span><b>−&nbsp;+</b>taille</span>")+
              window.MT_CONFIG_I18N.text("ui_c912b81a005a_html", "<span><b>✎</b>réécrire</span>")+
              window.MT_CONFIG_I18N.text("ui_03b0a4ca3dd4_html", "<span><b>Aa</b>police</span>")+
              window.MT_CONFIG_I18N.text("ui_faff7b8ddde0_html", "<span><b>⟲ ⟳</b>pivoter</span>")+
              window.MT_CONFIG_I18N.text("ui_8b260ca07898_html", "<span><b>⎘</b>dupliquer</span>")+
              window.MT_CONFIG_I18N.text("ui_75260d524bf2_html", "<span><b>✕</b>supprimer</span>")
            ):(
              window.MT_CONFIG_I18N.text("ui_2af1031a8cab_html", "<span><b>← → ↑ ↓</b>déplacer 1 mm</span>")+
              window.MT_CONFIG_I18N.text("ui_28b0c72ecf38_html", "<span><b>⇧ + flèche</b>déplacer 5 mm</span>")+
              window.MT_CONFIG_I18N.text("ui_e6266daa187b_html", "<span><b>⌘/Ctrl D</b>dupliquer</span>")+
              window.MT_CONFIG_I18N.text("ui_0b51269792b9_html", "<span><b>⌫</b>supprimer</span>")+
              window.MT_CONFIG_I18N.text("ui_d6aa4569377a_html", "<span><b>Échap</b>désélectionner</span>")
            ))+
            '</div>'+
          '</div>'+
          window.MT_CONFIG_I18N.text("ui_3fcb969f5927_html", "<button class=\"sheet-ok\" id=\"tutoOk\">J'ai compris</button>")+
        '</div>';
      body.innerHTML=h;
      var tk=document.getElementById('tutoOk');if(tk)tk.addEventListener('click',closeSheet);
      ov.classList.add('on');
      return;
    }
    ov.classList.add('on');
    if(typeof updateAllCues==='function')setTimeout(updateAllCues,50);
  }
  function pinStageTop(on){var s=document.querySelector('.stage');if(s)s.classList.toggle('pinned-top',!!on);}
  var _sheetCloseT=null;
  function closeSheet(){
    window._mtLeaveAfterSave=false;
    var o=document.getElementById('sheetOv');
    var wasSave=o&&o.dataset.kind==='save';
    if(o&&!wasSave)o.dataset.kind='';
    if(!o.classList.contains('on')||o.classList.contains('closing'))return;
    o.classList.add('closing');pinStageTop(false);
    _sheetCloseT=setTimeout(function(){_sheetCloseT=null;o.classList.remove('on');o.classList.remove('peek');o.classList.remove('closing');if(wasSave&&o.dataset.kind==='save')o.dataset.kind='';},300);
  }

  // ---- cart ----
  var cartItems=[];
  var VARIANTS={
    'hexa|0':'56022650126676',   'hexa|1':'56022650159444',
    'carree|0':'56022650192212', 'carree|1':'56022650224980'
  };
  var SRC_VARIANTS=null, SRC_DONE=false;
  function srcVariants(){
    if(SRC_DONE)return SRC_VARIANTS; SRC_DONE=true;
    try{var m=(location.hash||'').match(/[#&]v=([^&]+)/);
      if(m){var o=JSON.parse(b64urlDec(decodeURIComponent(m[1])));if(o&&typeof o==='object')SRC_VARIANTS=o;}}catch(e){}
    return SRC_VARIANTS;
  }
  /* CIEL — greffe G5 (2026, correcteur ciel ; décision de Benjamin du 15/10, 17 h 40) : une carte ou un ciel
     part sous les variantes de SON produit (statistiques). Table posée par snippets/mt-fond-garde.liquid
     (window.MT_FOND_VARIANTES, produits publiés et disponibles seulement). Jamais un autre prix que celui
     affiché : sinon, chemin classique inchangé. Sans fond : '' (rien ne change). */
  function mtFondVariante(k){
    try{
      if(!mtHasFond(state))return '';
      var t=mtFondTypeDe(state),T=window.MT_FOND_VARIANTES,v=T&&T[t]&&T[t][k];
      if(!v||!/^\d{6,20}$/.test(String(v.id||''))||v.dispo===false||!isFinite(+v.prix))return '';
      var sh=(k.split('|')[0]),attendu=priceShape(sh)+(k.split('|')[1]==='1'?holeFeeFor(sh):0);
      return Math.abs(+v.prix-attendu)<0.005?String(v.id):'';
    }catch(e){return '';}
  }
  function variantId(){if(state.photoProduct||_mtPhotoResumePending)return '';var k=state.shape+'|'+(state.hole?1:0),s=srcVariants(),f=mtFondVariante(k);return f||(s&&s[k])||VARIANTS[k]||'';}
  var GIFT_VARIANT='56023636476244'; // produit "Emballage cadeau" 4€
  var SHOP_LIVE=false;
  try{
    fetch(window.MT_CONFIG_I18N.url("/cart.js"),{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(c){if(c&&typeof c.item_count!=='undefined')SHOP_LIVE=true;})
      ['catch'](function(){});
  }catch(e){}
  function isLive(){return SHOP_LIVE || /myshopify\.com|shopifypreview\.com|mytomette/i.test(location.hostname);}
  function dataUrlToBlob(u){try{var b=atob(u.split(',')[1]),a=new Uint8Array(b.length);for(var i=0;i<b.length;i++)a[i]=b.charCodeAt(i);return new Blob([a],{type:'image/png'});}catch(e){return null;}}
  var _loadCreep=null;
  function setLoad(pct,cap,sub){ var f=document.getElementById('loadBarFill'); if(f&&pct!=null)f.style.width=Math.max(0,Math.min(100,pct))+'%'; var c=document.getElementById('loadCap'); if(c&&cap!=null)c.textContent=cap; var s=document.getElementById('loadSub'); if(s&&sub!=null)s.textContent=sub; }
  function startCreep(from,to,ms){ stopCreep(); var f=document.getElementById('loadBarFill'); if(!f)return; var t0=Date.now(); f.style.width=from+'%'; _loadCreep=setInterval(function(){ var k=Math.min(1,(Date.now()-t0)/ms), w=from+(to-from)*k; f.style.width=w.toFixed(1)+'%'; if(k>=1)stopCreep(); },200); }
  function stopCreep(){ if(_loadCreep){clearInterval(_loadCreep);_loadCreep=null;} }
  function showLoading(){var o=document.getElementById('loadOv');if(o){o.classList.add('on');o.setAttribute('aria-hidden','false');}setLoad(0,null,null);}
  function hideLoading(){stopCreep();var o=document.getElementById('loadOv');if(o){o.classList.remove('on');o.setAttribute('aria-hidden','true');}}
  var EDIT_KEY=''; // clé de la ligne panier à remplacer (mode « Modifier ma tomette » depuis le panier)
  var EDIT_HASH='',EDIT_ANC=null; // Greffe 5 : le fragment de « Modifier » (#d=…, #photo-ligne=…) et la ligne relevée avant l'ajout
  /* TOMETTE PHOTO — greffe 2, ses messages (relecture du 14/10). toast() retire son texte au bout
     de 1,9 s, en dur : assez pour « Ajouté ✓ », trop peu pour deux phrases qui expliquent pourquoi
     rien ne part au panier (WCAG 2.2.1). On garde donc CES messages-là 6 s, sans toucher au toast()
     des autres : on passe par lui, puis un observateur remet la classe 'on' tant que le texte est
     encore le nôtre. L'observateur répond avant le rendu suivant : pas de clignotement quand
     l'échéance de 1,9 s d'un toast précédent tombe. Un autre message prend la place : on s'efface.
     Largeur : centré par left:50%, le toast ne peut pas dépasser la moitié de l'écran, et ces
     phrases y tenaient sur cinq lignes au téléphone. Le temps de NOTRE message, il prend la largeur
     de son texte, bornée à 92 % de l'écran (40 rem au bureau : une ligne), centré ; on rend le style
     d'origine ensuite. */
  function mtToastLong(msg,ms){
    toast(msg);
    var t=document.getElementById('toast');if(!t)return;
    ms=ms||6000;if(mtToastLong._fin)mtToastLong._fin();
    var gen=mtToastLong._g=(mtToastLong._g||0)+1,s=t.style,o=null,fini=false,fin=Date.now()+ms;
    s.boxSizing='border-box';s.width='max-content';s.maxWidth='min(92vw,40rem)';s.textAlign='center';
    var rendre=function(){if(mtToastLong._g===gen){s.boxSizing='';s.width='';s.maxWidth='';s.textAlign='';}};
    var arreter=mtToastLong._fin=function(){if(fini)return;fini=true;if(o)o.disconnect();if(mtToastLong._fin===arreter)mtToastLong._fin=null;};
    if(typeof MutationObserver==='function'){
      o=new MutationObserver(function(){
        if(t.textContent!==msg){arreter();rendre();return;}
        if(Date.now()<fin&&!t.classList.contains('on'))t.classList.add('on');
      });
      o.observe(t,{attributes:true,attributeFilter:['class'],childList:true,characterData:true,subtree:true});
    }
    setTimeout(function(){if(fini)return;arreter();if(t.textContent!==msg){rendre();return;}
      t.classList.remove('on');setTimeout(function(){if(!t.classList.contains('on')||t.textContent!==msg)rendre();},260);},ms);
  }
  /* GREFFE 5 (15/10/2026, revue après relecture et contre-relecture) — « Mettre à jour » depuis le panier (lien « Modifier » : &k=<clé>).
     Pourquoi : la remise automatique « 2ᵉ tomette −20 % » fait RENOMMER par Shopify les clés des
     lignes dès que le panier change (mesuré le 14/10 : 3d1cce… → 599c57… à l'arrivée d'une autre
     tomette), et couper une ligne ×2 en deux « jumelles » ×1, deux cartes au panier, chacune avec son
     « Modifier » (ou les refondre en une seule ligne quand la remise s'en va). Le change.js sur
     EDIT_KEY, envoyé APRÈS l'ajout, visait donc une clé périmée : l'ancienne tomette RESTAIT au
     panier pendant que le client lisait « Tomette mise à jour ✓ ».
     Même correction que le Lot D pour la photo (photo-panier.js : releverAncienne, terminerRemplacement) :
     - AVANT l'ajout, on relève l'ancienne ligne dans /cart.js : par sa clé ; par ce qu'un premier
       essai avait relevé ; par la requête photo du lien (#photo-ligne=) ; par la recette du lien
       (#d= porte toute la création : deux lignes au même #d= sont la même tomette, on prend la
       1ʳᵉ). On garde ce qui, lui, ne change pas — la variante et les propriétés (fichiers compris) —
       et la quantité de la CARTE cliquée : c'est elle seule que « Mettre à jour » remplace, comme le
       faisait le change.js d'avant quand la clé était bonne (retirer toutes les jumelles ferait
       disparaître la 2ᵉ tomette d'une commande ×2, sans un mot). Clé périmée (le panier a changé
       ailleurs depuis l'affichage) : la quantité de la carte n'est plus connue — les jumelles ont pu
       être refondues —, on n'en retire qu'UNE, jamais plus que ce que le client a cliqué.
     - Elle n'y est plus : RIEN n'est envoyé ; un dialogue propose d'ajouter celle-ci quand même
       (jamais une tomette de plus sans le dire, jamais « mise à jour » à tort).
     - APRÈS l'ajout, on retrouve ses lignes par ce couple, jumelles comprises, et on ramène leur
       total à « total − quantité de la carte ». Ce calcul couvre aussi l'ajout FONDU par Shopify dans
       l'ancienne ligne (création inchangée, mêmes propriétés : il additionne). Le retrait passe par
       change.js, une ligne à la fois, sur une clé lue dans le panier du moment : une clé disparue
       entre-temps répond 400 et ne touche rien (update.js, lui, l'appliquerait à une AUTRE ligne de la
       variante — mesuré : la plus récente, parfois la nouvelle version) ; on relit alors le panier et
       on recommence. La cible est fixée une fois pour toutes : « Réessayer » ne retire jamais deux
       fois. Réponse en erreur : on relit le panier avant de conclure (Shopify a pu appliquer le
       retrait). Retrait raté : dialogue « Réessayer », qui ne fait que retirer — jamais un second
       ajout —, sous le verrou du bouton. Partie entre-temps : la mise à jour est faite.
     Sans &k= (ajout simple), rien de tout cela ne s'exécute : le chemin est celui d'avant. */
  function mtMemesProps(a,b){var t=function(p){p=p||{};return JSON.stringify(Object.keys(p).sort().map(function(k){return [k,p[k]];}));};return t(a)===t(b);}
  function mtDeLaLigne(i,d){return !!(i&&d)&&String(i.variant_id)===String(d.variant_id)&&mtMemesProps(i.properties,d.properties);}
  function mtFrag(h,n){var m=new RegExp('[#&]'+n+'=([^&]+)').exec(String(h||''));if(!m)return '';try{return decodeURIComponent(m[1]);}catch(e){return m[1];}}
  function mtQte(items,d){return (items||[]).filter(function(i){return mtDeLaLigne(i,d);}).reduce(function(s,i){return s+(+i.quantity||0);},0);}
  function mtLirePanier(sig){return fetch(window.MT_CONFIG_I18N.url("/cart.js"),{headers:{'Accept':'application/json'},cache:'no-store',signal:sig}).then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);return r.json();});}
  function mtReleverAncienne(cart){
    var items=(cart&&cart.items)||[],k=EDIT_KEY,memo=(EDIT_ANC&&EDIT_ANC.editKey===k)?EDIT_ANC:null,pr=mtFrag(EDIT_HASH,'photo-ligne'),d=mtFrag(EDIT_HASH,'d'),un=function(f){return items.filter(f)[0]||null;},l=un(function(i){return i.key===k;}),q=l?+l.quantity:0;
    if(!l&&memo&&(l=un(function(i){return mtDeLaLigne(i,memo);})))q=memo.retire;
    l=l||(pr&&un(function(i){return !!i.properties&&i.properties._photo_request===pr;}))||(d&&un(function(i){return mtFrag(i.properties&&i.properties._modifier,'d')===d;}))||null;
    /* CARTE GRAVÉE — greffe F4b (10/2026, Lot 0) : une ligne carte n'a pas de #d= (son « Modifier » est léger,
       #carte-ligne=<requête>) ; on la retrouve par sa requête, comme la photo. */
    var cr=mtFrag(EDIT_HASH,'carte-ligne');
    l=l||(cr&&un(function(i){return !!i.properties&&i.properties._carte_request===cr;}))||null;
    /* CIEL — greffe G2 (2026, Lot 0-ciel) : une ligne ciel non plus n'a pas de #d= (#ciel-ligne=<requête>) ;
       cherchée EN DERNIER, après tout le reste : pour une autre ligne, rien ne change. */
    var ci=mtFrag(EDIT_HASH,'ciel-ligne');
    l=l||(ci&&un(function(i){return !!i.properties&&i.properties._ciel_request===ci;}))||null;
    if(!l)return null;
    EDIT_ANC={editKey:k,variant_id:l.variant_id,properties:l.properties||{},retire:q||1};   // retire : la quantité de la carte ; retrouvée sans sa clé (#photo-ligne=, #d=) : 1, sa quantité n'est plus connue
    return EDIT_ANC;
  }
  function mtRetirerAncienne(anc,sig,ok,ko){
    var n=0,fait=function(c){return mtQte(c&&c.items,anc)<=anc.cible;};
    function suite(c){
      var reste,cle=null,q=0;
      if(anc.cible==null)anc.cible=Math.max(0,mtQte(c&&c.items,anc)-anc.retire);   // une fois pour toutes, sur le panier d'après l'ajout
      if(fait(c)){ok();return;}
      if(++n>6){ko(new Error('ancienne toujours au panier'));return;}
      reste=anc.cible;((c&&c.items)||[]).forEach(function(i){if(!mtDeLaLigne(i,anc))return;var v=Math.min(+i.quantity||0,reste);reste-=v;if(cle===null&&v!==+i.quantity){cle=i.key;q=v;}});
      fetch(window.MT_CONFIG_I18N.url("/cart/change.js"),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:cle,quantity:q}),signal:sig})
        .then(function(r){if(r.ok)return r.json();var e=new Error('HTTP '+r.status);e.cle=r.status===400;throw e;})
        .then(function(c2){return (c2&&c2.items)?c2:mtLirePanier(sig);},function(e){if(e&&e.name==='AbortError')throw e;   // le panier dit ce qui a été fait :
          return mtLirePanier(sig).then(function(c){if(!(e&&e.cle)&&!fait(c))throw e;return c;});})   // 400 = clé renommée entre-temps, rien n'a bougé : on recommence sur le panier relu ; autre erreur : fini si Shopify a pu l'appliquer, sinon dialogue
        .then(suite,ko);
    }
    mtLirePanier(sig).then(suite,ko);
  }
  function mtDialoguePanier(titre,texte,actions){
    var vieux=document.getElementById('mtPanierDlg');if(vieux&&vieux.parentNode)vieux.parentNode.removeChild(vieux);
    var retour=document.activeElement,ov=document.createElement('div'),bx=document.createElement('div'),h=document.createElement('div'),p=document.createElement('p'),z=document.createElement('div'),bs=[];
    ov.className='confirm-ov on mtpx-panier-ov';ov.id='mtPanierDlg';ov.setAttribute('aria-hidden','false');
    bx.className='confirm-box';bx.setAttribute('role','alertdialog');bx.setAttribute('aria-modal','true');bx.setAttribute('aria-labelledby','mtPanierDlgT');bx.setAttribute('aria-describedby','mtPanierDlgP');
    h.className='confirm-h';h.id='mtPanierDlgT';h.textContent=titre;p.className='confirm-p';p.id='mtPanierDlgP';p.textContent=texte;z.className='confirm-actions';
    function fermer(){if(!ov.parentNode)return;ov.parentNode.removeChild(ov);try{if(retour&&retour.focus&&document.contains(retour))retour.focus({preventScroll:true});}catch(e){}}
    actions.forEach(function(a,n){var b=document.createElement('button');b.type='button';b.className=n?'confirm-leave':'confirm-stay';b.textContent=a.l;b.addEventListener('click',function(){fermer();if(a.f)a.f();});z.appendChild(b);bs.push(b);});
    ov.addEventListener('keydown',function(e){if(e.key==='Escape'){e.preventDefault();e.stopPropagation();fermer();return;}if(e.key!=='Tab')return;var i=bs.indexOf(document.activeElement);if(e.shiftKey&&i<=0){e.preventDefault();bs[bs.length-1].focus();}else if(!e.shiftKey&&i===bs.length-1){e.preventDefault();bs[0].focus();}});
    ov.addEventListener('click',function(e){if(e.target===ov)fermer();});
    if(!document.getElementById('mtpxPanierStyle')){var st=document.createElement('style');st.id='mtpxPanierStyle';st.textContent='.mtpx-panier-ov button:focus{outline:none}.mtpx-panier-ov button:focus-visible{outline:2px solid var(--terra-dark,#8a3b1f);outline-offset:3px}';document.head.appendChild(st);}
    bx.appendChild(h);bx.appendChild(p);bx.appendChild(z);ov.appendChild(bx);(document.querySelector('.app')||document.body).appendChild(ov);
    setTimeout(function(){if(bs[0])bs[0].focus({preventScroll:true});},30);
  }
  function mtAvantRemplacement(after){
    addToShopify._busy=true;showLoading();setLoad(6,window.MT_CONFIG_I18N.text("ui_4f6b213f5805_html", "Préparation de votre tomette…"),window.MT_CONFIG_I18N.text("ui_c2d4f18bde72_html", "on prépare votre fichier"));
    var ac=(window.AbortController?new AbortController():null),t=setTimeout(function(){try{if(ac)ac.abort();}catch(e){}},20000);
    mtLirePanier(ac?ac.signal:undefined).then(function(c){
      clearTimeout(t);addToShopify._busy=false;var a=mtReleverAncienne(c);
      if(a){addToShopify(after,a);return;}
      hideLoading();
      mtDialoguePanier(window.MT_CONFIG_I18N.text("ui_e5a87f5fbc01_html", "Cette tomette n’est plus dans votre panier"),window.MT_CONFIG_I18N.text("ui_65cadf9e2325_html", "La version que vous modifiez n’y est plus. Voulez-vous ajouter celle-ci à votre panier ?"),
        [{l:window.MT_CONFIG_I18N.text("ui_d18abced4ca2_html", "Ajouter au panier"),f:function(){EDIT_KEY='';EDIT_ANC=null;updateTotal();addToShopify(after);}},{l:window.MT_CONFIG_I18N.text("ui_711e5f2e198d_html", "Fermer")}]);
    },function(){clearTimeout(t);addToShopify._busy=false;hideLoading();mtToastLong(window.MT_CONFIG_I18N.text("ui_dbdab28977f5_html", "La connexion semble bloquée — vérifiez votre réseau puis réessayez"));});
  }
  function mtEchecRemplacement(anc,fin){   // « Réessayer » retire seulement, sous le verrou : un 2ᵉ appui (le focus est revenu au bouton) n'ajoute rien
    mtDialoguePanier(window.MT_CONFIG_I18N.text("ui_fd8345807594_html", "Mise à jour presque terminée"),window.MT_CONFIG_I18N.text("ui_ae5e8091fc7c_html", "La nouvelle version est dans votre panier, mais l’ancienne n’a pas pu être retirée. Réessayez pour terminer."),
      [{l:window.MT_CONFIG_I18N.text("ui_af273d956b5b_html", "Réessayer"),f:function(){addToShopify._busy=true;showLoading();setLoad(92,window.MT_CONFIG_I18N.text("ui_847fc20d1043_html", "Ajout au panier…"),window.MT_CONFIG_I18N.text("ui_2e4bd22123d2_html", "presque terminé"));
        mtRetirerAncienne(anc,undefined,fin,function(e){try{console.warn('[panier] remplacement',e);}catch(_){}addToShopify._busy=false;hideLoading();mtEchecRemplacement(anc,fin);});}},
       {l:window.MT_CONFIG_I18N.text("ui_711e5f2e198d_html", "Fermer")}]);
  }
  /* CARTE GRAVÉE — greffe F6 (10/2026, Lot 0). Les RÉSERVES de la carte (la terre laissée nue sous chaque
     texte ou motif posé dessus) étaient calculées par le module carte, 500 ms après le dernier geste et
     jamais pendant une saisie : taper le lieu puis toucher « Ajouter » envoyait les anciennes, et un
     contexte inerte n'en calculait aucune — un texte gravé sur des rues (critique B1, B2). Désormais, juste
     avant tout export, le moteur attend window.__MT_FOND_EXPORT__ (garde en ligne du snippet
     mt-carte-expert, jamais inerte) : une différence Clipper sur le SVG courant, sans tuiles ni réseau.
     Échec, échéance ou garde absente : l'export est refusé — jamais un fichier sans réserves.
     Les boîtes viennent d'ici, de la même mise en page que le fichier laser (mtLayOf, size × 1,2 en mm) :
     elles valent sans DOM, dans une iframe cachée comme sous un clavier ouvert. */
  function mtFondLargeurTexte(e,lay,shapeKey,Wmm){
    if(!_mtLayCx){_mtLayCv=document.createElement('canvas');_mtLayCx=_mtLayCv.getContext('2d');}
    var sh=SHAPES[shapeKey]||SHAPES.hexa,fid=e.font||'cormorant',w=mteWeight(fid,e.weight),fpx=(lay.size*(SIZE_REF/sh.wcm))/100*MT_LAY_W,mx=0;
    _mtLayCx.font=(w||400)+' '+fpx+'px '+engraveCss(fid,w);
    try{_mtLayCx.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
    for(var i=0;i<lay.lines.length;i++){var m=_mtLayCx.measureText(lay.lines[i]).width;if(m>mx)mx=m;}
    try{_mtLayCx.letterSpacing='0px';}catch(_){}
    return mx/MT_LAY_W*Wmm;
  }
  function mtFondBoites(src){
    src=src||state;
    var sh=SHAPES[src.shape]||SHAPES.hexa,W=sh.wcm*10,H=sh.hcm*10,out=[];
    /* Relecture du 15/10 : les boîtes sont rendues dans le repère du viewBox du FOND (c'est là que
       CarteRendu.reserver les retire), en inversant la pose du fichier laser : X = tx + s·(x − vbX).
       Carte accordée à la forme (seul cas exporté) : s = 1, tx = ty = 0, ce sont les mm de la pièce. */
    var fd=mtFondDernier(src),ps={s:1,tx:0,ty:0,vx:0,vy:0};
    if(fd){var vb=mtFondVb(fd);if(vb.w>0&&vb.h>0){ps.s=Math.max(W,H)/Math.max(vb.w,vb.h);ps.tx=W/2-vb.w*ps.s/2;ps.ty=H/2-vb.h*ps.s/2;ps.vx=vb.x||0;ps.vy=vb.y||0;}}
    (src.els||[]).forEach(function(e){
      if(!e||mtEstFond(e))return;
      var cx=(e.x!=null?e.x:0.5)*W,cy=(e.y!=null?e.y:0.5)*H,w=0,h=0,x0=null,y0=null,o;
      if(e.type==='text'){
        if(!String(e.text==null?'':e.text).trim())return;
        var lay=mtLayOf(e,src.shape),fs=lay.size*1.2;
        w=mtFondLargeurTexte(e,lay,src.shape,W);h=lay.lines.length*fs*MT_LH;
        if(e.curve&&Math.abs(e.curve)>=1){h+=Math.min(1,Math.abs(e.curve)/100)*w;}   // texte courbé : l'arc monte ou descend, boîte prudente des deux côtés
        else{var al=(e.align==='left'?'left':(e.align==='right'?'right':'center')),hw=(lay.wFrac*W)/2;
          if(al==='left')x0=cx-hw;else if(al==='right')x0=cx+hw-w;}
        o={type:'text',texte:String(e.text),id:String(e.id)};
      }else{
        var raw=logoSvg(e),b=raw?logoBoxOf(raw):{w:24,h:24},k=((e.size||13)*1.2)/Math.max(b.w,b.h);
        w=b.w*k;h=b.h*k;o={type:'logo',cle:String(e.icon||e.logo||''),id:String(e.id)};
      }
      if(x0==null)x0=cx-w/2;y0=cy-h/2;
      var r=normRot(e.rot);
      if(r){   // boîte englobante du rectangle tourné autour de (cx, cy), comme rotate(r cx cy) du fichier laser
        var a=r*Math.PI/180,ca=Math.cos(a),sa=Math.sin(a),xs=[],ys=[];
        [[x0,y0],[x0+w,y0],[x0,y0+h],[x0+w,y0+h]].forEach(function(p){var dx=p[0]-cx,dy=p[1]-cy;xs.push(cx+dx*ca-dy*sa);ys.push(cy+dx*sa+dy*ca);});
        x0=Math.min.apply(null,xs);y0=Math.min.apply(null,ys);w=Math.max.apply(null,xs)-x0;h=Math.max.apply(null,ys)-y0;
      }
      x0=(x0-ps.tx)/ps.s+ps.vx;y0=(y0-ps.ty)/ps.s+ps.vy;w=w/ps.s;h=h/ps.s;   // repère du viewBox du fond (identité pour une carte accordée)
      o.x=Math.round(x0*100)/100;o.y=Math.round(y0*100)/100;o.w=Math.round(w*100)/100;o.h=Math.round(h*100)/100;
      out.push(o);
    });
    return out;
  }
  function mtFondPret(src,cb){
    src=src||state;
    if(!mtHasFond(src)){cb(true);return;}
    var g=window.__MT_FOND_EXPORT__,fini=false,t=0;
    function fin(ok,e){if(fini)return;fini=true;clearTimeout(t);if(!ok){try{console.warn('[carte] export refusé : réserves non refaites',e||'');}catch(_){}}cb(!!ok,ok?'':(e==='forme'?'forme':'reserves'),(!ok&&e&&typeof e==='object'&&e.code)?String(e.code):'');}   // greffe G3 bis (Lot 0-ciel, reprise) : + le code du refus (VERROU, CANONIQUE…), 3e argument que la carte ignore
    /* relecture du 15/10 : une carte dessinée pour l'autre forme attend son redessin (module carte) —
       la garde n'est même pas appelée : ses réserves seraient dans un autre repère que le fichier laser */
    if(!mtFondAccorde(src)){
      try{document.dispatchEvent(new CustomEvent('mt:fond-redessiner',{detail:{forme:src.shape,formeCarte:mtFondVb(mtFondDernier(src)).forme,type:mtFondTypeDe(src)}}));}catch(_){}   // greffe G4 : + type
      fin(false,'forme');return;
    }
    if(typeof g!=='function'){fin(false,'garde absente');return;}
    try{setLoad(null,mtFondTypeDe(src)==='ciel'?window.MT_CONFIG_I18N.text("ui_78077e14480b_html", "Préparation de votre ciel…"):window.MT_CONFIG_I18N.text("ui_3f48e960b80f_html", "Préparation de votre carte…"),null);}catch(_){}   // greffe G3
    t=setTimeout(function(){fin(false,'échéance');},15000);
    try{var p=g(src);if(p&&typeof p.then==='function')p.then(function(){fin(true);},function(e){fin(false,e);});else fin(true);}
    catch(e){fin(false,e);}
  }
  function mtFondPretP(src){return new Promise(function(ok){mtFondPret(src||state,ok);});}
  /* greffe F4 : les propriétés cachées d'une ligne carte, dérivées des marques du SVG (aucun module requis),
     puis surchargées par window.__MT_CARTE_PROPS__ (module carte) quand elles sont valides. */
  function mtFondProps(src){
    src=src||state;var a=src.els||[],f=null,i;
    for(i=0;i<a.length;i++)if(mtEstFond(a[i]))f=a[i];
    if(!f)return null;
    var ty=mtFondType(f);                                   // greffe G1 : le préfixe suit le type du fond
    if(ty==='ciel')return mtCielProps(f);
    if(ty!=='carte')return null;                            // jamais de _carte_* sur un fond qui n'est pas une carte
    var head=(String(f.svg).match(/^\s*<svg\b[^>]*>/)||[''])[0];
    function at(n){var m=head.match(new RegExp('\\s'+n+'="([^"]*)"'));return m?m[1]:'';}
    var tx=null;try{var b=at('data-mtcx-textes');if(b)tx=JSON.parse(b64urlDec(b));}catch(_){tx=null;}
    var p={};['version','lieu','centre','echelle','style','eau','repere','fenetre','forme','source','retrait','eaulieu'].forEach(function(n){var v=at('data-mtcx-'+n);if(v)p[n]=v;});
    var req='mtcx'+Date.now().toString(36)+Math.random().toString(36).slice(2,8).replace(/[^a-z0-9]/g,'0');
    var ch='/pages/configurateur-app';
    try{ch=new URL(window.MT_CONFIG_I18N.url(ch),'https://www.mytomette.fr').pathname.replace(/\/$/,'');}catch(_){}
    var o={_carte_lieu:String((tx&&typeof tx.lieu==='string'&&tx.lieu)||p.lieu||'').slice(0,200),_carte_params:JSON.stringify(p).slice(0,1990),_carte_origine:'configurateur',_carte_request:req};
    var x=window.__MT_CARTE_PROPS__;
    if(x&&typeof x==='object'){
      Object.keys(x).forEach(function(k){if(/^_carte_[a-z]+$/.test(k)&&typeof x[k]==='string'&&x[k].length<2000&&(k!=='_carte_request'||/^[A-Za-z0-9_-]{8,100}$/.test(x[k])))o[k]=x[k];});
    }
    o._modifier='https://www.mytomette.fr'+ch+'#carte-ligne='+o._carte_request;
    var m=x&&x._modifier;
    if(typeof m==='string'&&/^https:\/\/www\.mytomette\.fr\/[a-z0-9\/-]*#carte-ligne=[A-Za-z0-9_-]{8,100}$/.test(m)&&m.split('#carte-ligne=')[1]===o._carte_request)o._modifier=m;
    return o;
  }
  /* CIEL — greffe G1 (2026, Lot 0-ciel) : les propriétés cachées d'une ligne CIEL, dérivées des marques
     data-mtci-* (aucun module requis), puis surchargées par window.__MT_CIEL_PROPS__ (module ciel) quand
     elles sont valides. Mêmes règles que la carte (F4) ; même sortie que ciel-commun.js › proprietesCiel. */
  function mtCielProps(f){
    var head=(String(f.svg).match(/^\s*<svg\b[^>]*>/)||[''])[0];
    function at(n){var m=head.match(new RegExp('\\s'+n+'="([^"]*)"'));return m?m[1]:'';}
    var tx=null;try{var b=at('data-mtci-textes');if(b)tx=JSON.parse(b64urlDec(b));}catch(_){tx=null;}
    var p={};['version','visuel','forme','lieu','utc','local','zone','heure','trou','langue','catalogue'].forEach(function(n){var v=at('data-mtci-'+n);if(v)p[n]=v;});
    var req='mtci'+Date.now().toString(36)+Math.random().toString(36).slice(2,8).replace(/[^a-z0-9]/g,'0');
    var ch='/pages/configurateur-app';
    try{ch=new URL(window.MT_CONFIG_I18N.url(ch),'https://www.mytomette.fr').pathname.replace(/\/$/,'');}catch(_){}
    var inst=(p.local||p.utc)?((p.local||'')+' '+(p.zone||'')+' = '+(p.utc||'')):'';
    var o={_ciel_lieu:String((tx&&typeof tx.lieu==='string'&&tx.lieu)||p.lieu||'').slice(0,200),_ciel_instant:inst.slice(0,200),_ciel_params:JSON.stringify(p).slice(0,1990),_ciel_origine:'configurateur',_ciel_request:req};
    var x=window.__MT_CIEL_PROPS__;
    if(x&&typeof x==='object'){
      Object.keys(x).forEach(function(k){if(/^_ciel_[a-z]+$/.test(k)&&typeof x[k]==='string'&&x[k].length<2000&&(k!=='_ciel_request'||/^[A-Za-z0-9_-]{8,100}$/.test(x[k])))o[k]=x[k];});
    }
    o._modifier='https://www.mytomette.fr'+ch+'#ciel-ligne='+o._ciel_request;
    var m=x&&x._modifier;
    if(typeof m==='string'&&/^https:\/\/www\.mytomette\.fr\/[a-z0-9\/-]*#ciel-ligne=[A-Za-z0-9_-]{8,100}$/.test(m)&&m.split('#ciel-ligne=')[1]===o._ciel_request)o._modifier=m;
    return o;
  }
  function addToShopify(after,_anc){
    if(mtPhotoNativeBlocked())return;
    /* TOMETTE PHOTO — greffe 2 (10/2026, Lot 0). Une pièce qui porte une photo ne part JAMAIS par
       le chemin classique : VARIANTS la vendrait 18,90 € sous le produit tomette, sans le fichier
       photo. Elle part par le module photo (window.__MT_PHOTO_PANIER__, posé par la couche
       d'édition) avec le produit, les variantes et les fichiers de la fiche photo. On passe AVANT
       addToShopify._busy : le module tient son propre verrou. Sans produit ou sans module, on
       bloque avec un message — jamais de repli sur VARIANTS. Pas d'emballage cadeau sur une
       tomette photo (arbitrage du 14/10) : cadeau:null. L'exemple ne se commande pas : on le dit
       par 'mtp:demo-refusee' (annulable — le mode photo y rouvre la feuille « Ajouter une photo »),
       et par un message si personne ne l'a pris.
       Relecture du 14/10 :
       - « se charge encore » seulement si le module peut encore venir. S'il a échoué
         (__MTPX_ECHEC__, posé aussi quand toute la couche tombe) ou si la couche est éteinte
         (?sans-editeur : pas de mt-kiosk), ou si le mode photo s'est déclaré inerte (admin, création
         « pour un client » : MT_PHOTO_EXPERT.inerte), il ne viendra jamais : c'est « indisponible ».
       - ajouter() est asynchrone (rendu, lecture du produit, /cart/add.js) : un try/catch ne voit
         pas sa promesse rejetée. On l'écoute donc aussi, pour fermer la barre et le dire. */
    if(mtIsPhotoState(state)){
      var _ppC=window.MT_PHOTO_EXPERT_CFG,_ppM=window.__MT_PHOTO_PANIER__;
      var _ppV=_ppC&&_ppC.produit&&_ppC.produit.variantes&&_ppC.produit.variantes[state.shape+'|'+(state.hole?1:0)];
      var _ppX=window.MT_PHOTO_EXPERT,_ppPerdu=!!window.__MTPX_ECHEC__||!document.documentElement.classList.contains('mt-kiosk')||!!(_ppX&&_ppX.inerte);
      syncTextFromDom();
      if(!_ppC||!_ppV||_ppV.dispo===false||_ppPerdu){mtToastLong(window.MT_CONFIG_I18N.text("ui_d07a67f47bf8_html", "La tomette photo est momentanément indisponible. Votre création reste sur cet appareil."));return;}
      if(mtIsPhotoState(state,true)){var _ppE=null;try{_ppE=new CustomEvent('mtp:demo-refusee',{cancelable:true});document.dispatchEvent(_ppE);}catch(e){}
        if(!_ppE||!_ppE.defaultPrevented)mtToastLong(window.MT_CONFIG_I18N.text("ui_e1d15c93e830_html", "Ajoutez d’abord votre photo : l’exemple ne peut pas être commandé."));return;}
      if(!_ppM||typeof _ppM.ajouter!=='function'){mtToastLong(window.MT_CONFIG_I18N.text("ui_bf6a0595b61f_html", "L’atelier photo se charge encore. Réessayez dans un instant."));return;}
      var _ppEchec=function(e){try{console.error('[photo] panier',e);}catch(_){}hideLoading();mtToastLong(window.MT_CONFIG_I18N.text("ui_d445e8f57f16_html", "L’atelier photo n’a pas pu préparer votre tomette. Réessayez."));};
      /* Greffe 8 bis : le module photo exporte aussi renderPNG + buildLaserSVG — il part une fois les motifs arrivés.
         Finition (15/10) : le verrou _motifs est rendu quoi qu'il arrive — rappel, exception, ou échéance
         (plafond des motifs + 5 s, l'équivalent du hardcap du chemin classique) — et un rappel tardif,
         arrivé après l'échéance, n'ajoute rien. */
      if(addToShopify._motifs)return;
      addToShopify._motifs=true;
      var _ppLibre=false,_ppEcheance=0;
      var _ppLiberer=function(){if(_ppLibre)return false;_ppLibre=true;clearTimeout(_ppEcheance);addToShopify._motifs=false;return true;};
      _ppEcheance=setTimeout(function(){if(_ppLiberer()){try{console.warn('[MT motifs] photo : échéance atteinte, ajout abandonné');}catch(_){}hideLoading();mtMotifsMessage(false);}},MT_MOTIFS_PLAFOND+5000);
      try{
      mtAttendreMotifs(state.els,function(ok,manquants,introuvable){
        if(!_ppLiberer())return;
        if(!ok){hideLoading();mtMotifsMessage(introuvable);return;}
        var _ppR=null;
        try{_ppR=_ppM.ajouter({after:after,quantite:qtyCount||1,editKey:EDIT_KEY,cadeau:null,
          notifier:notifyCartUpdated,chargement:{montrer:showLoading,cacher:hideLoading,etape:setLoad,avancer:startCreep,arreter:stopCreep},
          fini:function(){EDIT_KEY='';state.gift={on:false,wrap:false,msg:'',ship:false};}});}
        catch(e){_ppEchec(e);return;}
        if(_ppR&&typeof _ppR.then==='function'){try{_ppR.then(null,_ppEchec);}catch(e){}}
      },function(){showLoading();setLoad(4,window.MT_CONFIG_I18N.text("ui_4f6b213f5805_html", "Préparation de votre tomette…"),window.MT_CONFIG_I18N.text("ui_c2d4f18bde72_html", "on prépare votre fichier"));});
      }catch(e){if(_ppLiberer())_ppEchec(e);else{try{console.error('[photo] panier',e);}catch(_){}}}
      return;
    }
    if(addToShopify._busy)return;
    syncTextFromDom();
    var vid=variantId(); if(!vid){toast('Variante introuvable');return;}
    if(EDIT_KEY&&!_anc){mtAvantRemplacement(after);return;}   // Greffe 5 : l'ancienne ligne est relevée AVANT tout envoi (voir mtReleverAncienne)
    addToShopify._busy=true; showLoading(); setLoad(6,window.MT_CONFIG_I18N.text("ui_4f6b213f5805_html", "Préparation de votre tomette…"),window.MT_CONFIG_I18N.text("ui_c2d4f18bde72_html", "on prépare votre fichier")); startCreep(6,24,2000);
    var ac=(window.AbortController?new AbortController():null), stopped=false;
    var reassure=setTimeout(function(){ if(addToShopify._busy){ setLoad(null,window.MT_CONFIG_I18N.text("ui_ac3af37364e8_html", "Presque terminé…"),window.MT_CONFIG_I18N.text("ui_11877cb4f1f6_html", "connexion un peu lente — on continue, patientez")); } },12000);
    var hardcap=setTimeout(function(){ if(!addToShopify._busy)return; stopped=true; try{if(ac)ac.abort();}catch(e){} clearTimeout(reassure); stopCreep(); addToShopify._busy=false; hideLoading(); toast(window.MT_CONFIG_I18N.text("ui_dbdab28977f5_html", "La connexion semble bloquée — vérifiez votre réseau puis réessayez")); },60000);
    function cleanup(){ clearTimeout(reassure); clearTimeout(hardcap); stopCreep(); }
    /* Greffe 8 bis : renderPNG et buildLaserSVG ne partent qu'avec tous les motifs (rappel immédiat s'ils sont déjà là). */
    mtAttendreMotifs(state.els,function(ok,manquants,introuvable){
    if(stopped)return;
    if(!ok){stopped=true;cleanup();addToShopify._busy=false;hideLoading();mtMotifsMessage(introuvable);return;}
    /* CARTE GRAVÉE — greffe F6 (10/2026, Lot 0) : avant l'aperçu et le fichier laser, les réserves de la
       carte sont refaites sur le SVG courant (critique B1, B2). Sans carte : rappel synchrone, rien ne change. */
    mtFondPret(state,function(fondOk,raison,code){
    if(stopped)return;
    if(!fondOk){stopped=true;cleanup();addToShopify._busy=false;hideLoading();
      /* CIEL — greffe G3 (2026, Lot 0-ciel) : le message suit le type du fond ; pour une carte, inchangé. */
      if(mtFondTypeDe(state)==='ciel'){
        /* G3 bis (reprise après relecture) : un refus DÉFINITIF du verrou (code VERROU ou CANONIQUE) ne se
           réessaie pas tel quel ; le module ciel l'écoute et redessine le ciel depuis ses marques. */
        try{document.dispatchEvent(new CustomEvent('mt:fond-refus',{detail:{type:'ciel',raison:raison,code:code||''}}));}catch(_){}
        if(raison==='forme'){var _ciX=window.MT_CIEL_EXPERT,_ciVient=!!(_ciX&&typeof _ciX.ouvrir==='function'&&!_ciX.inerte&&!window.__MTCI_ECHEC__);
          mtToastLong(_ciVient?window.MT_CONFIG_I18N.text("ui_e1b09480dcc9_html", "Votre ciel se redessine pour cette forme. Réessayez dans un instant."):window.MT_CONFIG_I18N.text("ui_96eba4ee3412_html", "Ce ciel a été dessiné pour l’autre forme de tomette : revenez-y pour le commander."));}
        else mtToastLong(window.MT_CONFIG_I18N.text("ui_ede57b8fde89_html", "Votre ciel n’a pas pu être préparé. Réessayez dans un instant."));
      }else
      if(raison==='forme'){   // relecture du 15/10 : le module carte redessine (mt:fond-redessiner) ; sans lui, il faut revenir à la forme d'origine
        var _cxX=window.MT_CARTE_EXPERT,_cxVient=!!(_cxX&&typeof _cxX.ouvrir==='function'&&!_cxX.inerte&&!window.__MTCX_ECHEC__);
        mtToastLong(_cxVient?window.MT_CONFIG_I18N.text("ui_405f687d61a0_html", "Votre carte se redessine pour cette forme. Réessayez dans un instant."):window.MT_CONFIG_I18N.text("ui_f4aff5367dfb_html", "Cette carte a été dessinée pour l’autre forme de tomette : revenez-y pour la commander."));
      }else mtToastLong(window.MT_CONFIG_I18N.text("ui_83b5eae0ea3b_html", "Votre carte n’a pas pu être préparée. Réessayez dans un instant."));
      return;}
    renderPNG(state,function(pngUrl){
      if(stopped)return;
      setLoad(46,window.MT_CONFIG_I18N.text("ui_c75e2f0e1966_html", "Création de l'aperçu…"),window.MT_CONFIG_I18N.text("ui_095ceb44698d_html", "rendu de votre tomette"));
      buildLaserSVG(state,function(svg){
        if(stopped)return;
        if(!svg){stopped=true;cleanup();addToShopify._busy=false;hideLoading();toast(window.MT_CONFIG_I18N.text("ui_85c6022d4bf2_html", "Une police n'a pas pu être vectorisée — commande non ajoutée"));return;}
        setLoad(70,window.MT_CONFIG_I18N.text("ui_dd24e1dd763e_html", "Génération de la gravure…"),window.MT_CONFIG_I18N.text("ui_911b7b26a3e1_html", "fichier laser haute précision"));
        var recipe=getRecipe(state);
        /* CARTE GRAVÉE — greffe F4 (10/2026, Lot 0) : une ligne carte porte un « Modifier » LÉGER
           (#carte-ligne=<requête>, D32) au lieu de la recette entière en #d= (55 à 560 Ko, rendue dans le
           tiroir du panier et envoyée au webhook), et ses propriétés cachées _carte_*. */
        var _cxP=mtHasFond(state)?mtFondProps(state):null;
        var editUrl=_cxP?_cxP._modifier:baseUrl()+recipeToHash(recipe);
        var resume=recipe.elements.filter(function(e){return e.type==='text';}).map(function(e){return e.text;}).join(' / ')||'(motif seul)';
        var fd=new FormData();
        fd.append('id', vid);
        fd.append('quantity', String(qtyCount||1));
        fd.append('properties[Texte]', resume);
        fd.append('properties[Forme]', SHAPES[state.shape].label+(state.hole?' (percée)':''));
        fd.append('properties[_modifier]', editUrl);
        fd.append('properties[_source]', 'config');
        if(_cxP){Object.keys(_cxP).forEach(function(k){if(k!=='_modifier')fd.append('properties['+k+']',_cxP[k]);});}   // greffe F4
        if(state.gift&&state.gift.on){fd.append('properties[Emballage cadeau]', state.gift.wrap?'Oui':'Souhaité'); if(state.gift.msg)fd.append('properties[Message cadeau]', state.gift.msg);}
        fd.append('properties[_Gravure SVG]', new Blob([svg],{type:'image/svg+xml'}), 'tomette-laser.svg');
        var pb=dataUrlToBlob(pngUrl); if(pb)fd.append('properties[_Aperçu]', pb, 'apercu.png');
        fd.append('properties[_Recette]', new Blob([JSON.stringify(recipe)],{type:'application/json'}), 'recette.json');
        var giftWanted=!!(state.gift&&state.gift.on&&state.gift.wrap);
        var textProps={'Texte':resume,'Forme':SHAPES[state.shape].label+(state.hole?' (percée)':''),'_modifier':editUrl,'_source':'config'};
        if(_cxP){Object.keys(_cxP).forEach(function(k){if(k!=='_modifier')textProps[k]=_cxP[k];});}   // greffe F4 : aussi dans le repli JSON
        if(state.gift&&state.gift.on){textProps['Emballage cadeau']=state.gift.wrap?'Oui':'Souhaité'; if(state.gift.msg)textProps['Message cadeau']=state.gift.msg;}
        var sig=ac?ac.signal:undefined;
        function addGiftThen(next){
          if(giftWanted){fetch(window.MT_CONFIG_I18N.url("/cart/add.js"),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(GIFT_VARIANT),quantity:1,properties:{'Pour':resume}}]}),signal:sig}).then(next,next);}
          else next();
        }
        function finishAdd(){
          function done(){cleanup();addToShopify._busy=false;setLoad(100,window.MT_CONFIG_I18N.text("ui_c3a35d84884b_html", "Ajouté ✓"),'');setTimeout(hideLoading,240);state.gift={on:false,wrap:false,msg:'',ship:false};notifyCartUpdated();toast(EDIT_KEY?window.MT_CONFIG_I18N.text("ui_cda9e7aaac9c_html", "Tomette mise à jour ✓"):window.MT_CONFIG_I18N.text("ui_6d08e54801ad_html", "Ajouté au panier ✓"));EDIT_KEY='';if(after)after();}
          /* Greffe 5 : l'ancienne ligne est retrouvée par variante + propriétés, plus par sa clé (périmée dès que la remise a renommé les lignes) ; seule la quantité de la carte cliquée part. */
          if(EDIT_KEY&&_anc){ mtRetirerAncienne(_anc,sig,done,function(e){ try{console.warn('[panier] remplacement',e);}catch(_){} var k0=EDIT_KEY; cleanup();addToShopify._busy=false;hideLoading();EDIT_KEY='';updateTotal();notifyCartUpdated(); mtEchecRemplacement(_anc,function(){EDIT_KEY=k0;done();}); }); }
          else if(EDIT_KEY){ fetch(window.MT_CONFIG_I18N.url("/cart/change.js"),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:EDIT_KEY,quantity:0}),signal:sig}).then(done,done); }
          else { done(); }
        }
        setLoad(88,window.MT_CONFIG_I18N.text("ui_847fc20d1043_html", "Ajout au panier…"),window.MT_CONFIG_I18N.text("ui_2e4bd22123d2_html", "presque terminé")); startCreep(88,97,20000);
        fetch(window.MT_CONFIG_I18N.url("/cart/add.js"),{method:'POST',body:fd,signal:sig})
          .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
          .then(function(){addGiftThen(finishAdd);})
          ['catch'](function(err){
            if(stopped||(err&&err.name==='AbortError'))return;
            fetch(window.MT_CONFIG_I18N.url("/cart/add.js"),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:(qtyCount||1),properties:textProps}]}),signal:sig})
              .then(function(r){if(!r.ok){return r.json().then(function(j){throw new Error((j&&(j.description||j.message))||('HTTP '+r.status));},function(){throw new Error('HTTP '+r.status);});}return r.json();})
              .then(function(){addGiftThen(finishAdd);})
              ['catch'](function(err2){ if(stopped||(err2&&err2.name==='AbortError'))return; cleanup();addToShopify._busy=false;hideLoading();var m=(err2&&err2.message)?String(err2.message):window.MT_CONFIG_I18N.text("ui_7d2988c9e76f_html", "erreur");try{console.error('Ajout panier:',err2);}catch(e){}toast(window.MT_CONFIG_I18N.text("ui_f51825eb9f15_html", "Panier : ")+m);});
          });
      });
    });
    });   // greffe F6 : fin de mtFondPret
    });
  }
  function cartSnapshot(){
    syncTextFromDom();
    return {shape:state.shape,hole:state.hole,els:JSON.parse(JSON.stringify(state.els)),qtyMult:qtyMult,qtyCount:qtyCount,total:computeTotal(),gift:JSON.parse(JSON.stringify(state.gift||{}))};
  }
  function addCurrentToCart(){
    if(mtPhotoNativeBlocked())return;
    cartItems.push(cartSnapshot());
    state.gift={on:false,wrap:false,msg:'',ship:false};
  }
  function editCartItem(idx){
    var it=cartItems[idx];if(!it)return;
    state.shape=it.shape;state.hole=it.hole;state.els=JSON.parse(JSON.stringify(it.els));state.sel=null;
    state.gift=JSON.parse(JSON.stringify(it.gift||{on:false,wrap:false,msg:'',ship:false}));
    qtyMult=it.qtyMult;qtyCount=it.qtyCount;
    cartItems.splice(idx,1);
    closeCart();syncShapeUI();render();updatePrice();goEditor();
  }
  function buildCartList(){
    var list=document.getElementById('cartList');list.innerHTML='';
    var grand=0;
    cartItems.forEach(function(item,idx){
      grand+=item.total;
      var li=el('div','li');
      var thumb=el('div','tom '+(SHAPES[item.shape].cls==='sq'?'sq photo':'hex photo')+' thumb');
      var st=el('div','stack');st.style.padding='14% 14%';thumb.appendChild(st);
      li.appendChild(thumb);
      var info=el('div','info');
      var meta=window.MT_CONFIG_I18N.label(SHAPES[item.shape].label)+(item.hole?window.MT_CONFIG_I18N.text("ui_31e56b4017d6_html", " · percée"):'')+' · '+SHAPES[item.shape].dim+(item.qtyCount>1?' · ×'+item.qtyCount:'');
      var giftLine='';
      if(item.gift&&item.gift.on){
        var bits=[];
        if(item.gift.wrap)bits.push('emballage cadeau');
        if(item.gift.ship)bits.push('envoi au destinataire');
        giftLine='<div class="m" style="color:var(--terra-dark)">🎁 '+(bits.length?bits.join(' · '):'cadeau')+'</div>';
        if(item.gift.msg)giftLine+='<div class="m" style="font-style:italic">« '+item.gift.msg.replace(/</g,'&lt;')+' »</div>';
      }
      var txt=item.els.filter(function(e){return e.type==='text';}).map(function(e){return String(e.text||'').replace(/\s*\n\s*/g,' ').trim();}).filter(function(t){return t;}).join(' · ');
      var txtLine=txt?'<div class="m" style="font-style:italic;color:var(--engrave)">« '+txt.replace(/</g,'&lt;')+' »</div>':'';
      info.innerHTML=window.MT_CONFIG_I18N.text("ui_db67d1eb3095_html", "<div class=\"n\">Tomette personnalisée</div><div class=\"m\">")+meta+'</div>'+txtLine+giftLine;
      var actions=el('div');actions.style.cssText='display:flex;gap:12px;margin-top:4px';
      var edit=el('button','edit');edit.textContent=window.MT_CONFIG_I18N.text("ui_42e37604b638_html", "Modifier");edit.addEventListener('click',function(){editCartItem(idx);});
      var del=el('button','edit');del.textContent=window.MT_CONFIG_I18N.text("ui_41e22ed93372_html", "Retirer");del.style.color='#0D0D0D';
      del.addEventListener('click',function(){cartItems.splice(idx,1);buildCartList();if(cartItems.length===0)closeCart();});
      actions.appendChild(edit);actions.appendChild(del);info.appendChild(actions);
      li.appendChild(info);
      var price=el('div','price');price.textContent=displayEuro(item.total);li.appendChild(price);
      list.appendChild(li);
      buildStack(st, item.els, false);
      applyHole(thumb, item.hole, item.shape);
    });
    document.getElementById('cartTotal').textContent=displayEuro(grand);
  }
  function openCart(){
    buildCartList();
    document.getElementById('cartOv').classList.add('on');
    if(typeof updateAllCues==='function')setTimeout(updateAllCues,50);
  }
  function closeCart(){
    var o=document.getElementById('cartOv');
    if(!o.classList.contains('on')||o.classList.contains('closing'))return;
    o.classList.add('closing');
    setTimeout(function(){o.classList.remove('on');o.classList.remove('closing');},300);
  }
  function mtcfgEmbedded(){ try{ return !!(window.parent && window.parent!==window.self); }catch(e){ return true; } }
  function navTop(url){
    if(mtcfgEmbedded()){
      try{ window.parent.postMessage({mtcfg:'nav', url:url}, '*'); }catch(e){}
      try{ if(window.top && window.top!==window.self) window.top.location.href=url; }catch(e){}
      return;
    }
    window.location.assign(url);
  }
  function goCheckout(express){
    if(mtPhotoNativeBlocked())return;
    if(isLive()){navTop(express ? window.MT_CONFIG_I18N.url("/checkout") : window.MT_CONFIG_I18N.url("/cart")); return;}
    toast(window.MT_CONFIG_I18N.text("ui_444a641184fa_html", "Aperçu — le paiement (carte,  Pay, Shop Pay) s'affiche sur la boutique en ligne"));
  }
  function notifyCartUpdated(){
    setTimeout(function(){
      try{
        fetch(window.MT_CONFIG_I18N.url("/cart.js"),{headers:{'Accept':'application/json'}})
          .then(function(r){return r.ok?r.json():null;})
          .then(function(cart){
            var n=(cart&&typeof cart.item_count!=='undefined')?cart.item_count:undefined;
            try{document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{data:{itemCount:n,source:'mytomette-configurateur'},cart:cart}}));}catch(e){}
            try{document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));}catch(e){}
            try{document.dispatchEvent(new CustomEvent('cart:build'));}catch(e){}
          })['catch'](function(){});
      }catch(e){}
    },280);
  }

  function toast(msg){var t=document.getElementById('toast');t.textContent=msg;t.classList.add('on');setTimeout(function(){t.classList.remove('on');},1900);}

  // ---- events ----
  // stack delegation (editor)
  var stack=document.getElementById('stack');
  stack.addEventListener('click',function(e){
    var node=e.target.closest('.el');if(node){select(node.dataset.id);}
  });
  stack.addEventListener('dblclick',function(e){
    var node=e.target.closest('.el.text');
    if(node){select(node.dataset.id);if(window.__MT_TEXTE__)window.__MT_TEXTE__(node);else if(COARSE)openSheet('edittext');else inlineEdit(node);return;}
    var ic=e.target.closest('.el');
    if(ic){select(ic.dataset.id);if(COARSE)openAdjStrip('size');}
  });
  (function(){
    var pts={}, pinch=null;
  function ang(){var k=Object.keys(pts);if(k.length<2)return 0;var a=pts[k[0]],b=pts[k[1]];return Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI;}
    function dist(){var k=Object.keys(pts);if(k.length<2)return 0;var a=pts[k[0]],b=pts[k[1]];return Math.sqrt((a.x-b.x)*(a.x-b.x)+(a.y-b.y)*(a.y-b.y));}
    stack.addEventListener('pointerdown',function(e){
      pts[e.pointerId]={x:e.clientX,y:e.clientY};
      var node=e.target.closest('.el');
      if(node && Object.keys(pts).length===1){select(node.dataset.id);}
      if(Object.keys(pts).length===2 && state.sel){
        var it=getItem(state.sel);
        if(it&&it.lock)return;
        pinch={d0:dist(),s0:it?it.size:6,a0:ang(),r0:it?normRot(it.rot):0,rotOn:false,id:state.sel};pinching=true;pushHistory('taille & rotation');
      }
    });
    stack.addEventListener('pointermove',function(e){
      if(pts[e.pointerId]){pts[e.pointerId].x=e.clientX;pts[e.pointerId].y=e.clientY;}
      if(!pinch)return;
      var d=dist();if(!d||!pinch.d0)return;
      var it=getItem(pinch.id);if(!it)return;
      it.manual=true;
      var b=sizeBounds(it); it.size=Math.round(clamp(pinch.s0*(d/pinch.d0),b.min,b.max)*10)/10;
      var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
      if(node){
        if(it.type==='text'){_applySize(node,it);}
        else{applyLogoSize(node,it);}
      }
      var _da=ang()-pinch.a0;
      while(_da>180)_da-=360; while(_da<-180)_da+=360;
      if(!pinch.rotOn && Math.abs(_da)>8){pinch.rotOn=true;}
      if(pinch.rotOn){
        var _rv=pinch.r0+_da, _sn=Math.round(_rv/15)*15;
        if(Math.abs(_rv-_sn)<4)_rv=_sn;
        it.rot=normRot(_rv);
        if(node)applyRot(node,it);
      }
      syncGrey();positionFloat();scheduleLive();e.preventDefault();mtAutosave();
    });
    function end(e){
      delete pts[e.pointerId];
      if(Object.keys(pts).length<2 && pinch){pinch=null;setTimeout(function(){pinching=false;},0);}
    }
    stack.addEventListener('pointerup',end);
    stack.addEventListener('pointercancel',end);
    document.addEventListener('pointerup',end);
    document.addEventListener('pointercancel',end);
  })();
  document.querySelector('.stage').addEventListener('click',function(e){
    var t=e.target;
    if(t.classList.contains('stage')||t.classList.contains('stack')||t.classList.contains('tom')){
      if(msel.on){mselEnd();return;}
      deselect();
    }
  });

  var _fcPopKind=null;
  function closeFcPop(){_fcPopKind=null;var p=document.getElementById('fcPop');if(p)p.classList.remove('on');}
  function openFcPop(kind){
    var p=document.getElementById('fcPop'),fc=document.getElementById('floatctl');
    if(!p||!fc||!state.sel)return;
    if(_fcPopKind===kind){closeFcPop();return;}
    _fcPopKind=kind;p.innerHTML='';
    if(kind==='spacing'){
      p.innerHTML=window.MT_CONFIG_I18N.text("ui_8532b202ffce_html", "<h5>Espacement des lettres</h5><div class=\"fcp-step\"><button id=\"fcpM\">−</button><span id=\"fcpV\"></span><button id=\"fcpP\">＋</button></div>");
      var vv=function(){var i2=getItem(state.sel);return i2?((i2.ls||0)*100).toFixed(0)+'%':'0%';};
      p.querySelector('#fcpV').textContent=vv();
      p.querySelector('#fcpM').addEventListener('click',function(){changeLs(-1);p.querySelector('#fcpV').textContent=vv();});
      p.querySelector('#fcpP').addEventListener('click',function(){changeLs(1);p.querySelector('#fcpV').textContent=vv();});
    } else if(kind==='weight'){
      p.innerHTML=window.MT_CONFIG_I18N.text("ui_284e5cd263e8_html", "<h5>Épaisseur</h5><div class=\"fcp-step\"><button id=\"wMinus\">−</button><span id=\"weightVal\"></span><button id=\"wPlus\">＋</button></div>");
      p.querySelector('#weightVal').textContent=weightLabel();
      p.querySelector('#wMinus').addEventListener('click',function(){changeWeight(-1);var d=p.querySelector('#weightVal');if(d)d.textContent=weightLabel();});
      p.querySelector('#wPlus').addEventListener('click',function(){changeWeight(1);var d=p.querySelector('#weightVal');if(d)d.textContent=weightLabel();});
      updateWeightBtns();
    } else if(kind==='tune'){
      var itT=getItem(state.sel);if(!itT){closeFcPop();return;}
      p.innerHTML=window.MT_CONFIG_I18N.text("ui_48e51527c6ec_html", "<h5>Réglages</h5><div class=\"fcpt\"></div>");
      var host=p.querySelector('.fcpt');
      var bT=sizeBounds(itT), _h1=false;
      function sld(lbl,min,max,step,get,set,fmt){
        var row=el('div','adj-slider');row.style.marginBottom='9px';
        row.innerHTML='<div class="adj-top"><span class="adj-lbl" style="font-size:.7rem;font-weight:700">'+lbl+'</span><span class="adj-val" style="font-size:.8rem"></span></div><input type="range" class="adj-range" style="height:34px">';
        var r=row.querySelector('input'),v=row.querySelector('.adj-val');
        r.min=min;r.max=max;r.step=step;r.value=get();v.textContent=fmt();
        r.addEventListener('pointerdown',function(){if(!_h1){_h1=true;pushHistory(lbl.toLowerCase());}});
        r.addEventListener('input',function(){set(parseFloat(r.value));v.textContent=fmt();syncGrey();positionHandles();scheduleLive();});
        r.addEventListener('change',function(){_h1=false;mtAutosave();});
        host.appendChild(row);
      }
      sld(window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),bT.min,bT.max,0.1,
        function(){var i2=getItem(state.sel);return i2?(i2.size||bT.min):bT.min;},
        function(v){var i2=getItem(state.sel);if(!i2)return;var bb=sizeBounds(i2);i2.size=Math.round(clamp(v,bb.min,bb.max)*10)/10;i2.manual=true;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd){if(i2.type==='text'){_applySize(nd,i2);}else{applyLogoSize(nd,i2);}}},
        function(){var i2=getItem(state.sel);var v=i2?Math.round((i2.size||0)*10)/10:0;return (v%1===0)?String(Math.round(v)):v.toFixed(1);});
      if(itT.type==='text'){
        sld(window.MT_CONFIG_I18N.text("ui_04a55203e107_html", "Espacement des lettres"),0,0.4,0.01,
          function(){var i2=getItem(state.sel);return i2?(i2.ls||0):0;},
          function(v){var i2=getItem(state.sel);if(!i2)return;i2.ls=Math.round(clamp(v,0,0.4)*100)/100;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyStyle(nd,i2);},
          function(){var i2=getItem(state.sel);return Math.round(((i2&&i2.ls)||0)*100)+'%';});
        sld(window.MT_CONFIG_I18N.text("ui_3fa528fe0ab8_html", "Courbure"),-100,100,10,
          function(){var i2=getItem(state.sel);return i2?(i2.curve||0):0;},
          function(v){var i2=getItem(state.sel);if(!i2)return;i2.curve=Math.round(clamp(v,-100,100));var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyStyle(nd,i2);},
          function(){var i2=getItem(state.sel);var c=i2?(i2.curve||0):0;return c===0?'Droit':(c>0?'Sourire '+c:window.MT_CONFIG_I18N.text("ui_9a2eff3c1b65_html", "Arqué ")+Math.abs(c));});
      }
      var wr=el('div','adj-row');
      wr.innerHTML=window.MT_CONFIG_I18N.text("ui_67504d1fe363_html", "<div class=\"adj-lbl\" style=\"font-size:.7rem;font-weight:700\">Épaisseur</div><div class=\"fcp-step\" style=\"width:130px\"><button id=\"wMinus\">−</button><span id=\"weightVal\"></span><button id=\"wPlus\">＋</button></div>");
      host.appendChild(wr);
      wr.querySelector('#weightVal').textContent=weightLabel();
      wr.querySelector('#wMinus').addEventListener('click',function(){changeWeight(-1);var d=wr.querySelector('#weightVal');if(d)d.textContent=weightLabel();});
      wr.querySelector('#wPlus').addEventListener('click',function(){changeWeight(1);var d=wr.querySelector('#weightVal');if(d)d.textContent=weightLabel();});
      updateWeightBtns();
    } else if(kind==='align'){
      p.innerHTML=window.MT_CONFIG_I18N.text("ui_0f1e49e6e3e2_html", "<h5>Aligner sur la tomette</h5><div class=\"al-grid\">")+
        window.MT_CONFIG_I18N.text("ui_494259f0f212_html", "<button data-al=\"l\" title=\"À gauche\">⇤</button><button data-al=\"cx\" title=\"Centré horizontalement\">↔</button><button data-al=\"r\" title=\"À droite\">⇥</button>")+
        window.MT_CONFIG_I18N.text("ui_e5a2a18523bf_html", "<button data-al=\"t\" title=\"En haut\">⤒</button><button data-al=\"cy\" title=\"Centré verticalement\">↕</button><button data-al=\"b\" title=\"En bas\">⤓</button>")+
        window.MT_CONFIG_I18N.text("ui_4893e3674413_html", "</div><button class=\"al-full\" data-al=\"c\">◎ Centrer sur la tomette</button><button class=\"as-msel\" id=\"popMsel\">⇅ Égaliser les écarts avec d'autres éléments…</button>");
      p.querySelectorAll('[data-al]').forEach(function(b2){b2.addEventListener('click',function(){alignSel(b2.dataset.al);});});
      var pm=p.querySelector('#popMsel');
      if(pm)pm.addEventListener('click',function(){var id0=state.sel;closeFcPop();if(id0)mselStart(id0);});
    } else {closeFcPop();return;}
    p.classList.add('on');
    var fr=fc.getBoundingClientRect(), sr=document.querySelector('.stage').getBoundingClientRect();
    var left=clamp(fr.left-sr.left+fr.width-p.offsetWidth, 6, Math.max(6,sr.width-p.offsetWidth-6));
    var top=fr.top-sr.top+fr.height+8;
    if(top+p.offsetHeight>sr.height-6)top=Math.max(6,fr.top-sr.top-p.offsetHeight-8);
    p.style.left=left+'px';p.style.top=top+'px';
  }
  function alignSel(k){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;pushHistory();
    if(k==='l')it.x=0.3; else if(k==='cx')it.x=0.5; else if(k==='r')it.x=0.7;
    else if(k==='t')it.y=0.28; else if(k==='cy')it.y=0.5; else if(k==='b')it.y=0.72;
    else if(k==='c'){it.x=0.5;it.y=0.5;}
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node){node.style.left=(it.x*100)+'%';node.style.top=(it.y*100)+'%';if(it.type==='text')node.style.maxWidth=(usableWidthFrac(it.x,it.y)*100).toFixed(1)+'%';}
    syncGrey();positionFloat();scheduleLive();mtAutosave();
  }
  function handleFloatctlClick(e){
    var bar=e.currentTarget, isM=(bar&&bar.id==='floatctlM');
    var b=e.target.closest('button');if(!b)return;var a=b.dataset.act;
    if(a!=='spacing'&&a!=='weight'&&a!=='align')closeFcPop();
    if(a==='minus')changeSize(-2);
    else if(a==='plus')changeSize(2);
    else if(a==='spacing')openFcPop('spacing');
    else if(a==='weight')openFcPop('weight');
    else if(a==='tune')openFcPop('tune');
    else if(a==='align'){if(isM)openAlignStrip();else openFcPop('align');}
    else if(a==='adjust'){if(isM)openAdjStrip('size');else openSheet('adjust');}
    else if(a==='font'){if(isM||COARSE)openSheet('font');else{lpTab('text');var q=document.getElementById('fontSearch');if(q){q.focus();}}}
    else if(a==='flip')flipSel();
    else if(a==='lock')toggleLock();
    else if(a==='rotl')rotSel(-15);
    else if(a==='rotr')rotSel(15);
    else if (a === 'edit') { var _mtEl = document.querySelector('#stack .el[data-id="'+state.sel+'"]'); if (window.__MT_TEXTE__ && _mtEl && _mtEl.classList.contains('text')) { window.__MT_TEXTE__(_mtEl); } else if (isM || COARSE) openSheet('edittext'); else { var n2 = document.querySelector('#stack .el[data-id="'+state.sel+'"]'); if (n2 && n2.classList.contains('text')) inlineEdit(n2); else openSheet('edittext'); } }
    else if (a==='dup')dupSel();
    else if(a==='del')delSel();
  }
  document.getElementById('floatctl').addEventListener('click',handleFloatctlClick);
  var _fcm=document.getElementById('floatctlM');if(_fcm)_fcm.addEventListener('click',handleFloatctlClick);
  document.addEventListener('pointerdown',function(e){
    if(!_fcPopKind)return;
    if(e.target.closest('#fcPop')||e.target.closest('#floatctl'))return;
    closeFcPop();
  });

  // shape bar
  document.getElementById('shapebar').addEventListener('click',function(e){
    var b=e.target.closest('button');if(!b)return;var s=b.dataset.shape;
    if(s==='hole')toggleHole();else setShape(s);
  });

  var _hz=document.getElementById('harmonizeBtn');if(_hz)_hz.addEventListener('click',harmonizeAll);
  var _hzm=document.getElementById('harmonizeBtnM');if(_hzm)_hzm.addEventListener('click',harmonizeAll);
  // tools (rail + mobile)
  document.querySelectorAll('[data-tool]').forEach(function(t){
    t.addEventListener('click',function(){openSheet(t.dataset.tool);});
  });
  // styles
  document.querySelectorAll('[data-style]').forEach(function(s){
    s.addEventListener('click',function(){
      var k=s.dataset.style;
      if(k==='titre')addText({text:'Titre',font:'cormorant',size:8});
      else if(k==='date')addText({text:'01 · 01 · 26',font:'dmcaps',size:3.6});
      else if(k==='mot')addText({text:'avec amour',font:'caveat',size:7});
    });
  });

  var _amb=document.getElementById('addMenuBtn');if(_amb)_amb.addEventListener('click',function(){openSheet('addmenu');});
  var _fbm=document.getElementById('formatBtnM');if(_fbm)_fbm.addEventListener('click',function(){openSheet('format');});
  var _cbm=document.getElementById('cartM');if(_cbm)_cbm.addEventListener('click',goValid);
  document.getElementById('undoBtn').addEventListener('click',function(){if(history.length){redoStack.push(snapshot());redoLabels.push(histLabels.pop()||'modification');restore(history.pop());updateUndo();mtAutosave();}});
  document.getElementById('redoBtn').addEventListener('click',function(){if(redoStack.length){history.push(snapshot());histLabels.push(redoLabels.pop()||'modification');restore(redoStack.pop());updateUndo();mtAutosave();}});
  document.getElementById('resetBtn').addEventListener('click',function(){
    if(!state.els.length && !state.hole){return;}
    if(window.confirm(window.MT_CONFIG_I18N.text("ui_71147d369718_html", "Tout effacer et repartir de zéro ?"))){
      pushHistory();
      state.els=[];state.sel=null;state.hole=false;
      render();syncShapeUI();updatePrice();deselect();
      toast(window.MT_CONFIG_I18N.text("ui_8c676f4e94b7_html", "Gravure réinitialisée"));
    }
  });
  document.getElementById('toValid').addEventListener('click',goValid);
  document.getElementById('sheetClose').addEventListener('click',closeSheet);
  document.getElementById('sheetOv').addEventListener('click',function(e){if(e.target.id==='sheetOv')closeSheet();});

  // validation
  document.getElementById('qty').addEventListener('click',function(e){
    var t=e.target.closest('.qtile');if(!t)return;
    document.querySelectorAll('#qty .qtile').forEach(function(x){x.classList.remove('on');});t.classList.add('on');
    qtyMult=parseFloat(t.dataset.mult);qtyCount=parseInt(t.dataset.q,10)||1;updateTotal();
  });
  document.getElementById('holeToggle').addEventListener('click',function(){
    state.hole=!state.hole;syncShapeUI();refreshHoleUI();updateTotal();
  });
  document.getElementById('giftToggle').addEventListener('click',function(){
    state.gift.on=!state.gift.on;syncGiftUI();updateTotal();
  });
  document.getElementById('giftWrap').addEventListener('change',function(){
    state.gift.wrap=this.checked;updateTotal();
  });
  document.getElementById('giftShip').addEventListener('change',function(){
    state.gift.ship=this.checked;
  });
  document.getElementById('giftMsg').addEventListener('input',function(){
    state.gift.msg=this.value;
    var gc=document.getElementById('giftCount');if(gc)gc.textContent=this.value.length;
  });
  document.querySelectorAll('[data-fix]').forEach(function(b){
    b.addEventListener('click',function(){goEditor();});
  });
  document.getElementById('replay').addEventListener('click',goEditor);
  document.getElementById('addCart').addEventListener('click',function(){
    _mtSaved=true;mtTrack('cfg_add_to_cart',{shape:state.shape,elements:state.els.length});
    if(isLive()){addToShopify(function(){showLoading();navTop(window.MT_CONFIG_I18N.url("/cart"));});}
    else{addCurrentToCart();openCart();}
  });
  document.getElementById('another').addEventListener('click',function(){
    if(isLive()){var snap=cartSnapshot();addToShopify(function(){cartItems.push(snap);toast(window.MT_CONFIG_I18N.text("ui_d547797aa4c5_html", "Gardée dans le panier ✓"));goInsp();});}
    else{addCurrentToCart();toast(window.MT_CONFIG_I18N.text("ui_d547797aa4c5_html", "Gardée dans le panier ✓"));goInsp();}
  });
  document.getElementById('cartClose').addEventListener('click',closeCart);
  document.getElementById('cartOv').addEventListener('click',function(e){if(e.target.id==='cartOv')closeCart();});
  document.getElementById('cartUpsell').addEventListener('click',function(){
    if(isLive()){var snap=cartSnapshot();addToShopify(function(){cartItems.push(snap);buildCartList();toast(window.MT_CONFIG_I18N.text("ui_aabe5f4ee3f9_html", "Ajoutée au panier ✓"));});return;}
    if(cartItems.length){cartItems.push(JSON.parse(JSON.stringify(cartItems[cartItems.length-1])));buildCartList();toast(window.MT_CONFIG_I18N.text("ui_aabe5f4ee3f9_html", "Ajoutée au panier ✓"));}
    else{toast(window.MT_CONFIG_I18N.text("ui_625c40a40c38_html", "Ajoutez d'abord une tomette"));}
  });
  document.getElementById('applePayBtn').addEventListener('click',function(){goCheckout(true);});
  document.getElementById('shopPayBtn').addEventListener('click',function(){goCheckout(true);});
  document.getElementById('checkout').addEventListener('click',function(){goCheckout(false);});
  // garder son modèle par email (depuis l'éditeur, optionnel)
  document.getElementById('saveBtn').addEventListener('click',function(){openSheet('save');});
  var _rsv=document.getElementById('railSaveBtn');if(_rsv)_rsv.addEventListener('click',function(){openSheet('save');});

  // ---- retour au site : une seule fenêtre de sauvegarde ----
  (function(){
    // Client approval links have their own save/validation flow.
    var cov=document.getElementById('confirmOv');
    function hideConfirm(){if(cov){cov.classList.remove('on');cov.setAttribute('aria-hidden','true');}}
    var cc=document.getElementById('confirmCancel');if(cc)cc.addEventListener('click',hideConfirm);
    var co=document.getElementById('confirmOk');if(co)co.addEventListener('click',function(){hideConfirm();mtLeaveEditor();});
    if(cov)cov.addEventListener('click',function(e){if(e.target===cov)hideConfirm();});
    function requestClose(){
      if(document.documentElement.classList.contains('mtv-client')&&cov){cov.classList.add('on');cov.setAttribute('aria-hidden','false');return;}
      if(!mtHasUnsavedCreation()){mtLeaveEditor();return;}
      window._mtLeaveAfterSave=true;
      var ov=document.getElementById('sheetOv'),form=document.getElementById('mtSaveForm');
      if(ov&&ov.dataset.kind==='save'&&ov.classList.contains('on')&&!ov.classList.contains('closing')&&form){
        form.querySelector('#smLeave').hidden=false;return;
      }
      openSheet('save');
    }
    var sb=document.getElementById('siteBtn');if(sb)sb.addEventListener('click',requestClose);
    window._mtAskClose=requestClose;
  })();

  // ---- indicateur de défilement ----
  var CUES=[];
  function attachScrollCue(sel, lift){
    var els=document.querySelectorAll(sel);
    for(var i=0;i<els.length;i++){(function(sc){
      if(sc.__cue)return;
      var cue=document.createElement('div');cue.className='scrollcue'+(lift?' lift':'');
      cue.innerHTML='<div class="fade"></div><div class="pill"><span class="ar">↓</span> voir plus</div>';
      sc.appendChild(cue);sc.__cue=cue;
      cue.querySelector('.pill').addEventListener('click',function(){
        sc.scrollBy({top:Math.round(sc.clientHeight*0.8),behavior:'smooth'});
      });
      function upd(){
        var can=(sc.scrollHeight - sc.clientHeight)>10;
        var more=(sc.scrollHeight - sc.clientHeight - sc.scrollTop)>10;
        cue.classList.toggle('show', can && more);
      }
      CUES.push(upd);
      sc.addEventListener('scroll',upd,{passive:true});
      if(window.MutationObserver){new MutationObserver(upd).observe(sc,{childList:true,subtree:true});}
    })(els[i]);}
  }
  function updateAllCues(){for(var i=0;i<CUES.length;i++){try{CUES[i]();}catch(e){}}}
  window.addEventListener('resize',updateAllCues);

  // init
  window.addEventListener('resize',function(){
    if(document.getElementById('sEdit').classList.contains('on')){positionFloat();scheduleLive();}
    if(document.getElementById('sValid').classList.contains('on')){drawValid();}
  });
  attachScrollCue('.sheet-c');
  attachScrollCue('.cb');
  attachScrollCue('.vright');
  buildFonts(FONTDEFS);
  buildTemplatesFrom(TPLFULL);
  ASSET_FLAGS.photos=true;
  (function(){
    var mk=(location.hash||'').match(/[#&]k=([^&]+)/);if(mk){try{EDIT_KEY=decodeURIComponent(mk[1]);}catch(e){EDIT_KEY=mk[1];}}
    if(EDIT_KEY)EDIT_HASH=String(location.hash||'');   // Greffe 5 : relu si la clé a changé (recette #d= du lien)
    INITIAL_RECIPE=hashToRecipe();
    if(INITIAL_RECIPE&&Object.prototype.hasOwnProperty.call(INITIAL_RECIPE,'photoProduct')&&!mtcfgEmbedded()&&!MT_ADMIN){
      var photoHash=(location.hash||'').match(/[#&]d=([^&]+)/);
      var photoData='';try{photoData=photoHash?decodeURIComponent(photoHash[1]):'';}catch(e){}
      mtResumePhoto(INITIAL_RECIPE,photoData);return;
    }
    INITIAL_RECIPE_ACTIVE=!!(INITIAL_RECIPE&&loadRecipe(INITIAL_RECIPE));
    if(INITIAL_RECIPE_ACTIVE){ensureCurrentDisplayFonts();render();updatePrice();goEditor();}
    else{goInsp();cfReveal();mtOfferResume();}
    if(EDIT_KEY)updatePrice();
  })();
  if(mtcfgEmbedded()){
    try{document.body.classList.add('mt-embed');}catch(e){}
    var _hdr=document.querySelector('.app > .hdr'); if(_hdr)_hdr.style.display='none';
    window.addEventListener('message',function(ev){
      if(!ev||ev.source!==window.parent)return;
      var d=ev.data;
      if(d&&d.mtcfg==='back'){ var b=document.getElementById('backBtn'); if(b&&!b.hidden){ if(typeof b.onclick==='function')b.onclick(); else b.click(); } }
      if(d&&(d.mtcfg==='requestClose'||d.mtcfg==='askClose')){ if(typeof window._mtAskClose==='function'){window._mtAskClose();} }
    });
    try{var step=document.getElementById('sValid').classList.contains('on')?3:(document.getElementById('sEdit').classList.contains('on')?2:1);mtcfgStep(step,step>1);}catch(e){}
  }
  loadFontsCdn();
  if(INITIAL_RECIPE_ACTIVE)loadTemplateLogos(templateLogoUrlsForRecipe(INITIAL_RECIPE),false);
  if(INITIAL_RECIPE_ACTIVE){(function(){
    var _essais=0;
    (function _mtLogosReprise(){
      var _enAttente=false;
      ((INITIAL_RECIPE&&INITIAL_RECIPE.elements)||[]).forEach(function(e){
        if(!e||e.type!=='logo'||!e.logo||e.svg)return;
        var rec=LOGOCAT[e.logo];
        if(rec&&rec.svg&&/<svg[s>]/i.test(String(rec.svg)))return;   /* déjà là */
        _enAttente=true;
        if(rec)ensureLogoSvg(e.logo,function(ok){if(ok)refreshAfterAssets();});
      });
      if(_enAttente&&++_essais<40)setTimeout(_mtLogosReprise,500);
      else refreshAfterAssets();
    })();
  })();}
  setTimeout(updateAllCues,80);

  var _asHist=false;
  function closeStrips(){
    var a=document.getElementById('adjStrip');if(a)a.hidden=true;
    var g=document.getElementById('alignStrip');if(g)g.hidden=true;
    var f=document.getElementById('floatctlM');if(f&&state.sel&&!(typeof msel!=='undefined'&&msel.on))f.classList.add('on');
  }
  function _asDefs(it){
    var b=sizeBounds(it);
    var defs=[{k:'size',lbl:window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),min:b.min,max:b.max,step:0.1,
      get:function(){var i2=getItem(state.sel);return i2?(i2.size||b.min):b.min;},
      set:function(v){var i2=getItem(state.sel);if(!i2)return;var bb=sizeBounds(i2);i2.size=Math.round(clamp(v,bb.min,bb.max)*10)/10;i2.manual=true;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd){if(i2.type==='text'){_applySize(nd,i2);}else{applyLogoSize(nd,i2);}}},
      fmt:function(){var i2=getItem(state.sel);var v=i2?Math.round((i2.size||0)*10)/10:0;return (v%1===0)?String(Math.round(v)):v.toFixed(1);}}];
    if(it.type==='text'){
      defs.push({k:'ls',lbl:window.MT_CONFIG_I18N.text("ui_f3da1558c6bf_html", "Espacement"),min:0,max:0.4,step:0.01,
        get:function(){var i2=getItem(state.sel);return i2?(i2.ls||0):0;},
        set:function(v){var i2=getItem(state.sel);if(!i2)return;i2.ls=Math.round(clamp(v,0,0.4)*100)/100;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyStyle(nd,i2);},
        fmt:function(){var i2=getItem(state.sel);return Math.round(((i2&&i2.ls)||0)*100)+'%';}});
    }
    defs.push({k:'rot',lbl:window.MT_CONFIG_I18N.text("ui_bc301ef97255_html", "Pivoter"),min:-180,max:180,step:1,
      get:function(){var i2=getItem(state.sel);return i2?normRot(i2.rot):0;},
      set:function(v){var i2=getItem(state.sel);if(!i2)return;var sn=Math.round(v/15)*15;if(Math.abs(v-sn)<3)v=sn;i2.rot=normRot(v);var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyRot(nd,i2);},
      fmt:function(){var i2=getItem(state.sel);return Math.round(normRot(i2&&i2.rot))+'°';}});
    if(it.type==='text'){
      defs.push({k:'curve',lbl:window.MT_CONFIG_I18N.text("ui_3fa528fe0ab8_html", "Courbure"),min:-100,max:100,step:5,
        get:function(){var i2=getItem(state.sel);return i2?(i2.curve||0):0;},
        set:function(v){var i2=getItem(state.sel);if(!i2)return;var vv=Math.round(clamp(v,-100,100));if(Math.abs(vv)<6)vv=0;i2.curve=vv;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyStyle(nd,i2);},
        fmt:function(){var i2=getItem(state.sel);var c=(i2&&i2.curve)||0;return c===0?'Droit':(c>0?('Sourire '+c):(window.MT_CONFIG_I18N.text("ui_9a2eff3c1b65_html", "Arqué ")+Math.abs(c)));}});
    }
    defs.push({k:'w',lbl:window.MT_CONFIG_I18N.text("ui_9930487b4208_html", "Épaisseur"),stepper:true});
    if(it.type==='text'){
      defs.push({k:'caps',lbl:'Petites maj.',toggle:true,
        get:function(){var i2=getItem(state.sel);return !!(i2&&i2.smallcaps);},
        set:function(){var i2=getItem(state.sel);if(!i2)return;pushHistory('petites majuscules');i2.smallcaps=!i2.smallcaps;var nd=document.querySelector('#stack .el[data-id="'+i2.id+'"]');if(nd)applyStyle(nd,i2);mtAutosave();}});
    }
    return defs;
  }
  function openAdjStrip(prop){
    if(!state.sel)return;var it=getItem(state.sel);if(!it)return;
    var st=document.getElementById('adjStrip');if(!st)return;
    var fm=document.getElementById('floatctlM');if(fm)fm.classList.remove('on');
    var ga=document.getElementById('alignStrip');if(ga)ga.hidden=true;
    st.hidden=false;
    var defs=_asDefs(it), chips=document.getElementById('asChips');
    chips.innerHTML='';
    defs.forEach(function(d){
      var ch=el('button','as-chip'+(d.toggle?' as-tog':''));ch.textContent=d.lbl;ch.dataset.k=d.k;
      if(d.toggle)ch.classList.toggle('on',!!d.get());
      ch.addEventListener('click',function(){
        if(d.toggle){d.set();ch.classList.toggle('on',!!d.get());syncGrey();positionHandles();scheduleLive();return;}
        bindProp(d.k);
      });
      chips.appendChild(ch);
    });
    var ok=el('button','as-chip ok');ok.textContent='✓ OK';
    ok.addEventListener('click',function(){closeStrips();positionFloat();});
    chips.appendChild(ok);
    function bindProp(k){
      var d=null;defs.forEach(function(x){if(x.k===k)d=x;});if(!d)return;if(d.toggle)return;
      _asHist=false;
      chips.querySelectorAll('.as-chip:not(.as-tog)').forEach(function(x){x.classList.toggle('on',x.dataset.k===k);});
      var lbl=document.getElementById('asLbl'),rg=document.getElementById('asRange'),vl=document.getElementById('asVal'),sp=document.getElementById('asStep');
      lbl.textContent=d.lbl;
      if(d.stepper){
        rg.hidden=true;sp.hidden=false;vl.textContent='';
        document.getElementById('asV').textContent=weightLabel();
        document.getElementById('asM').onclick=function(){changeWeight(-1);document.getElementById('asV').textContent=weightLabel();};
        document.getElementById('asP').onclick=function(){changeWeight(1);document.getElementById('asV').textContent=weightLabel();};
        return;
      }
      rg.hidden=false;sp.hidden=true;
      rg.min=d.min;rg.max=d.max;rg.step=d.step;rg.value=d.get();
      vl.textContent=d.fmt();
      rg.oninput=function(){if(!_asHist){_asHist=true;pushHistory(d.lbl.toLowerCase());}d.set(parseFloat(rg.value));vl.textContent=d.fmt();syncGrey();positionHandles();scheduleLive();};
      rg.onchange=function(){_asHist=false;mtAutosave();};
    }
    bindProp(prop&&defs.some(function(d){return d.k===prop;})?prop:'size');
  }
  // ===== bandeau Aligner (mobile) =====
  function openAlignStrip(){
    if(!state.sel)return;
    var st=document.getElementById('alignStrip');if(!st)return;
    var fm=document.getElementById('floatctlM');if(fm)fm.classList.remove('on');
    var ad=document.getElementById('adjStrip');if(ad)ad.hidden=true;
    st.hidden=false;
  }
  (function(){
    var st=document.getElementById('alignStrip');if(!st)return;
    st.querySelectorAll('[data-al]').forEach(function(b){b.addEventListener('click',function(){alignSel(b.dataset.al);});});
    document.getElementById('alignClose').addEventListener('click',function(){closeStrips();positionFloat();});
    document.getElementById('alignMulti').addEventListener('click',function(){var id0=state.sel;closeStrips();if(id0)mselStart(id0);});
  })();

  var _ptHist=false;
  function refreshTxtTune(){
    var box=document.getElementById('txtTune');if(!box)return;
    var it=state.sel?getItem(state.sel):null;
    if(!it||it.type!=='text'){box.hidden=true;return;}
    box.hidden=false;
    var b=sizeBounds(it), rg=document.getElementById('ptSize');
    rg.min=b.min;rg.max=b.max;rg.step=0.1;
    if(document.activeElement!==rg)rg.value=(it.size||b.min);
    var v=Math.round((it.size||0)*10)/10;
    document.getElementById('ptSizeV').textContent=(v%1===0)?String(Math.round(v)):v.toFixed(1);
    document.getElementById('ptWv').textContent=weightLabel();
  }
  (function(){
    var rg=document.getElementById('ptSize');if(!rg)return;
    rg.addEventListener('pointerdown',function(){if(!_ptHist){_ptHist=true;pushHistory('taille');}});
    rg.addEventListener('input',function(){
      var it=state.sel?getItem(state.sel):null;if(!it||it.type!=='text')return;
      var b=sizeBounds(it);
      it.size=Math.round(clamp(parseFloat(rg.value),b.min,b.max)*10)/10;it.manual=true;
      var nd=document.querySelector('#stack .el[data-id="'+it.id+'"]');
      if(nd)_applySize(nd,it);
      refreshTxtTune();syncGrey();positionFloat();scheduleLive();
    });
    rg.addEventListener('change',function(){_ptHist=false;mtAutosave();});
    document.getElementById('ptWm').addEventListener('click',function(){changeWeight(-1);refreshTxtTune();});
    document.getElementById('ptWp').addEventListener('click',function(){changeWeight(1);refreshTxtTune();});
  })();

  var msel={on:false,ids:[]};
  function mselHas(id){return msel.ids.indexOf(String(id))>=0;}
  function mselStart(id){
    msel.on=true;msel.ids=[String(id)];
    deselect();hideGuides();
    if(navigator.vibrate){try{navigator.vibrate(12);}catch(e){}}
    mselSync();
    toast(COARSE?window.MT_CONFIG_I18N.text("ui_266a9188c861_html", "Touchez les autres éléments à aligner"):window.MT_CONFIG_I18N.text("ui_e70d4db62c1a_html", "Ctrl/Cmd + clic sur les autres éléments à aligner"));
  }
  function mselToggle(id){
    id=String(id);
    var i=msel.ids.indexOf(id);
    if(i>=0)msel.ids.splice(i,1);else msel.ids.push(id);
    if(!msel.ids.length){mselEnd();return;}
    mselSync();
  }
  function mselEnd(){msel.on=false;msel.ids=[];mselSync();}
  function mselSync(){
    if(msel.on){
      var f1=document.getElementById('floatctl');if(f1)f1.classList.remove('on');
      var f2=document.getElementById('floatctlM');if(f2)f2.classList.remove('on');
      var a1=document.getElementById('adjStrip');if(a1)a1.hidden=true;
      var a2=document.getElementById('alignStrip');if(a2)a2.hidden=true;
      var fw=document.getElementById('fontWheel');if(fw)fw.classList.remove('on');
    }
    document.querySelectorAll('#stack .el').forEach(function(n){n.classList.toggle('msel',msel.on&&mselHas(n.dataset.id));});
    var bar=document.getElementById('mselBar');if(!bar)return;
    bar.hidden=!msel.on;
    if(msel.on){
      var n=msel.ids.length;
      document.getElementById('mselCount').textContent=n+window.MT_CONFIG_I18N.text("ui_3f8c0e1af69b_html", " sélectionné")+(n>1?'s':'');
      document.getElementById('mselApply').disabled=n<3;
    }
  }
  function mselDistribute(){
    var items=msel.ids.map(getItem).filter(Boolean);
    if(items.length<3){toast(window.MT_CONFIG_I18N.text("ui_49da14effef1_html", "Sélectionnez au moins 3 éléments"));return;}
    var xs=items.map(function(i){return i.x!=null?i.x:0.5;});
    var ys=items.map(function(i){return i.y!=null?i.y:0.5;});
    var sx=Math.max.apply(null,xs)-Math.min.apply(null,xs);
    var sy=Math.max.apply(null,ys)-Math.min.apply(null,ys);
    var ax=(sy>=sx)?'y':'x';
    items.sort(function(a,b){return (a[ax]!=null?a[ax]:0.5)-(b[ax]!=null?b[ax]:0.5);});
    pushHistory('espacement égal');
    var first=(items[0][ax]!=null?items[0][ax]:0.5), last=(items[items.length-1][ax]!=null?items[items.length-1][ax]:0.5);
    var step=(last-first)/(items.length-1);
    var cross=(ax==='y')?'x':'y';
    var cvs=items.map(function(i){return i[cross]!=null?i[cross]:0.5;});
    var cSpread=Math.max.apply(null,cvs)-Math.min.apply(null,cvs);
    var cAvg=null;
    if(cSpread<0.09){cAvg=Math.round((cvs.reduce(function(a,b){return a+b;},0)/cvs.length)*1000)/1000;}
    items.forEach(function(it,i){
      it[ax]=Math.round((first+i*step)*1000)/1000;
      if(cAvg!=null)it[cross]=cAvg;
      var nd=document.querySelector('#stack .el[data-id="'+it.id+'"]');
      if(nd){nd.style.left=((it.x!=null?it.x:0.5)*100)+'%';nd.style.top=((it.y!=null?it.y:0.5)*100)+'%';if(it.type==='text')nd.style.maxWidth=(usableWidthFrac(it.x,it.y)*100).toFixed(1)+'%';}
    });
    syncGrey();scheduleLive();mtAutosave();mtTrack('cfg_distribute',{axis:ax,n:items.length});
    toast(ax==='y'?window.MT_CONFIG_I18N.text("ui_fd02d6fff97d_html", "Écarts verticaux égalisés ✓"):window.MT_CONFIG_I18N.text("ui_63e0089e7e09_html", "Écarts horizontaux égalisés ✓"));
    mselEnd();
  }
  (function(){
    var a=document.getElementById('mselApply');if(a)a.addEventListener('click',mselDistribute);
    var x=document.getElementById('mselCancel');if(x)x.addEventListener('click',mselEnd);
  })();

  (function(){
    var btn=document.getElementById('gpsOpenBtn');if(!btn)return;
    var pop=null;
    function close(){if(pop){pop.remove();pop=null;document.removeEventListener('pointerdown',outside,true);}}
    function outside(e){if(pop&&!pop.contains(e.target)&&!btn.contains(e.target))close();}
    function fmtDec(v,isLat){var h=isLat?(v>=0?'N':'S'):(v>=0?'E':'O');return Math.abs(v).toFixed(2)+'°'+h;}
    function showFormats(lat,lon,name){
      var dms=toDMS(lat,true)+'  '+toDMS(lon,false);
      var dec=fmtDec(lat,true)+'  '+fmtDec(lon,false);
      pop.innerHTML='<h5>Comment graver ce lieu ?</h5><div class="rhint" style="margin:0 0 8px">'+name.replace(/</g,'&lt;')+window.MT_CONFIG_I18N.text("ui_bd1b6d962dcf_html", "</div><div class=\"gps-fmt\"></div><button class=\"gps-back\">← Chercher un autre lieu</button>");
      var fw=pop.querySelector('.gps-fmt');
      [[dms,window.MT_CONFIG_I18N.text("ui_2e4f69a30adc_html", "Degrés · minutes · secondes")],[dec,window.MT_CONFIG_I18N.text("ui_21ae20e058e2_html", "Décimal, plus épuré")]].forEach(function(f){
        var b=el('button','gps-fmt-b');
        b.innerHTML='<span class="g-prev">'+f[0]+'</span><span class="g-lbl">'+f[1]+'</span>';
        b.addEventListener('click',function(){
          addText({text:f[0],font:'dmsans',size:3.4},false);
          var it=state.sel?getItem(state.sel):null;
          if(it){it.ls=0.14;var nd=document.querySelector('#stack .el[data-id="'+it.id+'"]');if(nd)applyStyle(nd,it);syncGrey();scheduleLive();}
          mtTrack('cfg_add_gps');close();toast(window.MT_CONFIG_I18N.text("ui_efd104007fac_html", "Point GPS ajouté ✓"));
        });
        fw.appendChild(b);
      });
      pop.querySelector('.gps-back').addEventListener('click',function(){close();btn.click();});
    }
    btn.addEventListener('click',function(){
      if(pop){close();return;}
      pop=el('div','gps-pop');
      pop.innerHTML=window.MT_CONFIG_I18N.text("ui_04582f652cf2_html", "<h5>Point GPS</h5><input class=\"gq\" placeholder=\"Ville, rue, restaurant…\" autocomplete=\"off\"><div class=\"gps-list\"></div>");
      document.body.appendChild(pop);
      var r=btn.getBoundingClientRect();
      pop.style.left=Math.min(r.right+12,window.innerWidth-334)+'px';
      pop.style.top=clamp(r.top-8,10,Math.max(10,window.innerHeight-420))+'px';
      var q=pop.querySelector('.gq'), list=pop.querySelector('.gps-list'), T=null, seq=0;
      q.addEventListener('input',function(){
        var v=q.value.trim();
        if(T)clearTimeout(T);
        if(v.length<3){list.innerHTML='';return;}
        T=setTimeout(function(){
          var s2=++seq;
          fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5&accept-language='+encodeURIComponent(window.MT_CONFIG_I18N.locale||'fr')+'&q='+encodeURIComponent(v))
            .then(function(r2){return r2.json();})
            .then(function(ls){
              if(s2!==seq||!pop)return;
              list.innerHTML='';
              if(!ls||!ls.length){list.innerHTML=window.MT_CONFIG_I18N.text("ui_3c0462efa6f2_html", "<div class=\"gps-empty\">Aucun lieu trouvé — essayez « nom, ville »</div>");return;}
              ls.forEach(function(pl){
                var nm=String(pl.display_name||'').split(',').slice(0,3).join(',');
                var it2=el('button','gps-item');
                it2.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 21.5s-6.5-5.4-6.5-10.3A6.5 6.5 0 0112 4.7a6.5 6.5 0 016.5 6.5c0 4.9-6.5 10.3-6.5 10.3z"/><circle cx="12" cy="11.2" r="2.2"/></svg><span>'+nm.replace(/</g,'&lt;')+'</span>';
                it2.addEventListener('click',function(){showFormats(parseFloat(pl.lat),parseFloat(pl.lon),nm);});
                list.appendChild(it2);
              });
            })['catch'](function(){if(s2===seq&&pop)list.innerHTML=window.MT_CONFIG_I18N.text("ui_cbc254c644e7_html", "<div class=\"gps-empty\">Recherche indisponible — réessayez</div>");});
        },380);
      });
      setTimeout(function(){q.focus();},40);
      document.addEventListener('pointerdown',outside,true);
    });
  })();

  function mtTrack(name,params){
    if(MT_ADMIN)return;   /* admin : pas d'analytics */
    try{
      window.dataLayer=window.dataLayer||[];
      var o={event:name};if(params)for(var k in params)o[k]=params[k];
      window.dataLayer.push(o);
      if(typeof window.gtag==='function')window.gtag('event',name,params||{});
    }catch(e){}
  }
  var _mtSaved=false;

  var _fwBuilt=false;
function _mtFacesReady(cb){
  var n=0;
  var poll=function(){
    if(MT_FONT_FACES_READY||(++n>60)){cb();return;}
    setTimeout(poll,100);
  };
  poll();
}
function _mtWaitFont(spec,sample,onReady){
  var tries=0;
  var t=setTimeout(onReady,6000);
  var done=function(){clearTimeout(t);onReady();};
  var attempt=function(){
    var ok=false;try{ok=document.fonts.check(spec);}catch(e){ok=true;}
    if(ok){done();return;}
    var again=function(){
      var k=false;try{k=document.fonts.check(spec);}catch(e){k=true;}
      if(k){done();return;}
      if(++tries<14){setTimeout(attempt,220);}else{done();}
    };
    try{document.fonts.load(spec,sample||'Aa').then(again,again);}catch(e){done();}
  };
  _mtFacesReady(attempt);
}
function _mtChipFont(ch,f){
  var apply=function(){
    if(f.italic){ch.style.fontStyle='italic';ch.style.fontFamily="'Cormorant Garamond',serif";}
    else ch.style.fontFamily=f.css;
  };
  try{
    if(!document.fonts||!document.fonts.check){apply();return;}
    var fam=f.italic?"'Cormorant Garamond'":String(f.css||'').split(',')[0].trim();
    if(!fam){apply();return;}
    var spec=(f.italic?'italic ':'')+'1rem '+fam;
    var okNow=false;try{okNow=document.fonts.check(spec);}catch(e){okNow=false;}
    if(MT_FONT_FACES_READY&&okNow){apply();return;}
    ch.classList.add('fw-wait');
    _mtWaitFont(spec,ch.textContent,function(){ch.classList.remove('fw-wait');apply();});
  }catch(e){apply();}
}
  function buildFontWheel(){
    var w=document.getElementById('fontWheel');if(!w)return;
    w.innerHTML='';_fwBuilt=true;
    var ids=RECENT_FONTS.slice();
    FONTS.forEach(function(f){if(ids.indexOf(f.id)<0)ids.push(f.id);});
    ids.slice(0,14).forEach(function(id){
      var f=fontById(id);if(!f)return;
      var ch=el('button','fw-chip');ch.dataset.font=id;ch.textContent=f.label;
      _mtChipFont(ch,f);
      if(f.caps){ch.style.textTransform='uppercase';ch.style.fontSize='.78rem';ch.style.letterSpacing='.05em';}
      ch.addEventListener('click',function(){setFont(id);updateFontWheel(getItem(state.sel));});
      w.appendChild(ch);
    });
  }
  function updateFontWheel(item){
    var w=document.getElementById('fontWheel');if(!w)return;
    if(!item||item.type!=='text'){w.classList.remove('on');return;}
    ensureAllDisplayFonts();
    if(!_fwBuilt)buildFontWheel();
    w.classList.add('on');
    var chips=w.querySelectorAll('.fw-chip'),selChip=null;
    for(var i=0;i<chips.length;i++){var on=chips[i].dataset.font===item.font;chips[i].classList.toggle('on',on);if(on)selChip=chips[i];}
    if(selChip&&selChip.scrollIntoView)try{selChip.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});}catch(e){}
  }

  if(window.visualViewport){
    var _vvH=function(){
      var vv=window.visualViewport;
      var kb=Math.max(0,window.innerHeight-vv.height-vv.offsetTop);
      document.documentElement.style.setProperty('--kb',(kb>60?kb:0)+'px');
    };
    window.visualViewport.addEventListener('resize',_vvH);
    window.visualViewport.addEventListener('scroll',_vvH);
  }

  // ===== flèches clavier (desktop) : 1 mm, Maj = 5 mm =====
  document.addEventListener('keydown',function(e){
    if(document.getElementById('sheetOv').dataset.kind==='save'){if(e.key==='Escape'){e.preventDefault();closeSheet();}return;}
    if(!document.getElementById('sEdit').classList.contains('on'))return;
    var ae=document.activeElement;
    if(ae&&(ae.tagName==='INPUT'||ae.tagName==='TEXTAREA'||ae.isContentEditable))return;
    var k=e.key;
    if(k==='Escape'){ if(state.sel){e.preventDefault();deselect();} return; }
    if(!state.sel)return;
    var it=getItem(state.sel);if(!it)return;
    if((e.metaKey||e.ctrlKey)&&(k==='d'||k==='D')){e.preventDefault();dupSel();return;}
    if(k==='Delete'||k==='Backspace'){e.preventDefault();delSel();if(!COARSE){var lpv=document.querySelector('.lpage.on');if(lpv&&lpv.id==='lp-edit'&&typeof buildEditPanel==='function')buildEditPanel();}return;}
    if(k!=='ArrowLeft'&&k!=='ArrowRight'&&k!=='ArrowUp'&&k!=='ArrowDown')return;
    if(it.lock)return;
    e.preventDefault();
    if(!window._nudgeArmed){window._nudgeArmed=true;pushHistory('déplacement fin');}
    clearTimeout(window._nudgeT);window._nudgeT=setTimeout(function(){window._nudgeArmed=false;},800);
    var sh=SHAPES[state.shape]||SHAPES.hexa;
    var mm=(e.shiftKey?5:1);
    var stx=mm/(sh.wcm*10), sty=mm/(sh.hcm*10);
    if(k==='ArrowLeft')it.x=clamp((it.x||0.5)-stx,-0.1,1.1);
    if(k==='ArrowRight')it.x=clamp((it.x||0.5)+stx,-0.1,1.1);
    if(k==='ArrowUp')it.y=clamp((it.y||0.5)-sty,-0.1,1.1);
    if(k==='ArrowDown')it.y=clamp((it.y||0.5)+sty,-0.1,1.1);
    var node=document.querySelector('#stack .el[data-id="'+it.id+'"]');
    if(node){node.style.left=(it.x*100)+'%';node.style.top=(it.y*100)+'%';if(it.type==='text')node.style.maxWidth=(usableWidthFrac(it.x,it.y)*100).toFixed(1)+'%';}
    showDims(it);
    clearTimeout(window._nudgeDimsT);window._nudgeDimsT=setTimeout(hideDims,900);
    syncGrey();positionFloat();scheduleLive();mtAutosave();
  });





  // ===== préchargement des polices les plus probables =====
  setTimeout(function(){
    try{
      var d=el('div');d.style.cssText='position:absolute;left:-9999px;top:-9999px;visibility:hidden';
      var ids=RECENT_FONTS.slice();
      FONTS.slice(0,8).forEach(function(f){if(ids.indexOf(f.id)<0)ids.push(f.id);});
      ids.slice(0,10).forEach(function(id){var f=fontById(id);if(!f)return;var sp=document.createElement('span');sp.style.fontFamily=f.italic?"'Cormorant Garamond',serif":f.css;sp.textContent='Abg';d.appendChild(sp);});
      document.body.appendChild(d);setTimeout(function(){d.remove();},5000);
    }catch(e){}
  },1600);
  /* ================================================================
     PANNEAU MODIFIER (desktop) : liste des elements presents +
     editeur contextuel complet. Selection tomette et liste convergent
     vers le meme ecran ; la boite a outils flottante desktop disparait
     (CSS), seuls cadenas / rotation / poubelle restent en poignees.
     ================================================================ */
  /* ================================================================
     PANNEAU MODIFIER v3 — encre sur blanc, takeover a la selection.
     - texte : reecriture inline, police, taille/espacement steppers,
               graisse 300-800 (paliers reels), alignement facon Word.
     - logo  : taille + trait 1,7-2,2 (6 paliers laser). Pas de "changer".
     - QR    : contenu reeditable (rouvre le QR Lab prerempli), taille.
     - GPS   : c'est un texte -> editeur texte standard.
     - barre Miroir / Dupliquer / Supprimer ancree en bas via #editActs.
     ================================================================ */
  function _elKind(it){
    if(it.type==='text')return 'text';
    var svg=String(it.svg||'');
    if(it.qrMeta||svg.indexOf('crispEdges')>=0)return 'qr';
    if(String(it.icon||'').indexOf('custom_')===0)return 'logo';
    return window.MT_CONFIG_I18N.text("ui_7d0c43beb087_html", "motif");
  }
  function _edLabel(it){
    var k=_elKind(it);
    if(k==='text'){var t=String(it.text||window.MT_CONFIG_I18N.text("ui_bbb0bd5ff551_html", "Texte")).replace(/\s+/g,' ').trim();if(t.length>22)t=t.slice(0,22)+'\u2026';return '\u201c '+t+' \u201d';}
    if(k==='qr')return 'QR code';
    if(k==='logo')return window.MT_CONFIG_I18N.text("ui_6b3aef3b66f1_html", "Votre logo");
    return window.MT_CONFIG_I18N.text("ui_c89ac8f0d41a_html", "Motif");
  }
  function _edIcon(k){
    if(k==='text')return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 6V4.5h14V6M12 4.5V20M9 20h6"/></svg>';
    if(k==='qr')return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><rect x="3.5" y="3.5" width="7" height="7" rx="1"/><rect x="13.5" y="3.5" width="7" height="7" rx="1"/><rect x="3.5" y="13.5" width="7" height="7" rx="1"/><path d="M13.5 13.5h3v3h-3zM18 15.5h2.5M15.5 18v2.5M18 18h2.5v2.5"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 20s-6.8-4.4-8.8-8.8C1.9 8.2 4 5.4 6.9 5.4c1.9 0 3.2 1 4.1 2.5.9-1.5 2.2-2.5 4.1-2.5 2.9 0 5 2.8 3.7 5.8C16.8 15.6 12 20 12 20z"/></svg>';
  }
  function _liveNode(it){return document.querySelector('#stack .el[data-id="'+it.id+'"]');}
  function _sync(){syncGrey();positionFloat();scheduleLive();mtAutosave();}

  function buildEditPanel(){
    var list=document.getElementById('editList'),box=document.getElementById('editCtrls');
    if(!list||!box)return;
    list.innerHTML='';box.innerHTML='';
    if(!state.els.length){
      list.innerHTML=window.MT_CONFIG_I18N.text("ui_53cfb00310b2_html", "<div class=\"ed-empty\">Votre tomette est vide.<br>Ajoutez un texte, un motif, un point GPS ou un QR code via l’onglet <b>＋ Ajouter</b>.</div>");
      return;
    }
    function addRow(it){
      var k=_elKind(it);
      var b=el('button','ed-row'+(String(state.sel)===String(it.id)?' on':''));
      b.innerHTML='<span class="ed-ric">'+_edIcon(k)+'</span><span class="ed-lab"></span><span class="ed-car">\u203a</span>';
      var lab=b.querySelector('.ed-lab');lab.textContent=_edLabel(it);
      if(k==='text'){try{var f=fontById(it.font);if(f)lab.style.fontFamily=f.italic?"'Cormorant Garamond',serif":f.css;}catch(e){}}
      b.addEventListener('click',function(){if(String(state.sel)===String(it.id))deselect();else select(it.id);});
      list.appendChild(b);
    }
    if(!state.sel){
      // aucune selection : la liste complete, aeree
      state.els.forEach(addRow);
      box.innerHTML=window.MT_CONFIG_I18N.text("ui_4a4919b77c7b_html", "<div class=\"ed-hint\">Sélectionnez un élément ci-dessus — ou cliquez-le directement sur la tomette.</div>");return;
    }
    var back=el('button','ed-listback');
    back.innerHTML='\u2190 Tous les \u00e9l\u00e9ments <span class="ed-count">'+state.els.length+'</span>';
    back.addEventListener('click',function(){deselect();});
    list.appendChild(back);
    var cur=getItem(state.sel);if(cur)addRow(cur);
    var it=getItem(state.sel);if(!it)return;
    var kind=_elKind(it);

    if(kind==='text')      _edText(box,it,list);
    else if(kind==='qr')   _edQr(box,it);
    else                   _edLogo(box,it);   // logo + motif

    _edActions(box,it,kind);
  }

  /* ---------- éditeur TEXTE ---------- */
  function _isMultiline(it){return String(it.text||'').indexOf('\n')>=0;}
  function _edText(box,it,list){
    var inp=el('input','ed-input');inp.type='text';inp.value=it.text||'';inp.setAttribute('maxlength','60');
    try{var f0=fontById(it.font);if(f0)inp.style.fontFamily=f0.italic?"'Cormorant Garamond',serif":f0.css;}catch(e){}
    inp.addEventListener('input',function(){
      it.text=inp.value;var nd=_liveNode(it);if(nd)nd.textContent=it.text;
      var on=list.querySelector('.ed-row.on .ed-lab');if(on)on.textContent=_edLabel(it);
      _sync();buildEditPanel();   // recalcul : l'alignement n'apparait que si multi-lignes
    });
    box.appendChild(inp);

    // Police -> ouvre le navigateur de polices (plein panneau)
    var frow=el('button','ed-fontrow');
    var fname=window.MT_CONFIG_I18N.text("ui_2efeeeb01318_html", "Police");try{var f2=fontById(it.font);if(f2)fname=f2.label;}catch(e){}
    frow.innerHTML=window.MT_CONFIG_I18N.text("ui_2916440b90e0_html", "<span>Police</span><b></b><span class=\"ed-car\">›</span>");
    frow.querySelector('b').textContent=fname;
    try{if(f2)frow.querySelector('b').style.fontFamily=f2.italic?"'Cormorant Garamond',serif":f2.css;}catch(e){}
    frow.addEventListener('click',function(){lpTab('text');var q=document.getElementById('fontSearch');if(q)setTimeout(function(){q.focus();},60);});
    box.appendChild(frow);

    var grid=el('div','ed-arows');

    grid.appendChild(_aRow(window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),_edSvg('size'),
      _miniStepper('A\u2212','A+',function(){return _tSize(it);},function(d){_setSize(it,d);})));
    grid.appendChild(_aRow(window.MT_CONFIG_I18N.text("ui_f3da1558c6bf_html", "Espacement"),_edSvg('ls'),
      _miniStepper('\u2212','+',function(){return Math.round((it.ls||0)*100)+'%';},function(d){_setLs(it,d);})));

    // Interligne : seulement si le texte est multi-lignes
    if(_isMultiline(it)){
      grid.appendChild(_aRow('Interligne',_edSvg('lh'),
        _miniStepper('\u2212','+',function(){return (it.lh||1.1).toFixed(2);},function(d){_setLh(it,d);})));
    }

    // Graisse : rangée de 6 puces compactes
    var gcs=el('div','ed-chipset');
    var cw=it.weight||defaultWeight(it.font);
    [300,400,500,600,700,800].forEach(function(w){
      var b=el('button','ed-chip'+(w===cw?' on':''));b.type='button';b.textContent=w;
      b.addEventListener('click',function(){_setWeight(it,w);gcs.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});
      gcs.appendChild(b);
    });
    grid.appendChild(_aRow('Graisse',_edSvg('weight'),gcs));

    if(_isMultiline(it)){
      var seg=el('div','ed-miniseg');
      var A={left:'M4 6h16M4 12h10M4 18h13',center:'M4 6h16M7 12h10M5.5 18h13',right:'M4 6h16M10 12h10M7 18h13'};
      var curAl=it.align||'center';
      ['left','center','right'].forEach(function(dir){
        var b=el('button',dir===curAl?'on':'');b.type='button';
        b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="'+A[dir]+'"/></svg>';
        b.addEventListener('click',function(){_setAlign(it,dir);seg.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});
        seg.appendChild(b);
      });
      grid.appendChild(_aRow('Alignement',_edSvg('align'),seg));
    }

    // Rotation par pas de 15°
    var rot=el('div','ed-rotctl');
    rot.innerHTML=window.MT_CONFIG_I18N.text("ui_489b36d5aeb4_html", "<button type=\"button\" class=\"rl\" aria-label=\"Pivoter à gauche\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M9 5H4V0.5M4 5a8 8 0 108-3\" transform=\"translate(0 2)\"/></svg></button><output></output><button type=\"button\" class=\"rr\" aria-label=\"Pivoter à droite\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M15 5h5V0.5M20 5a8 8 0 10-8-3\" transform=\"translate(0 2)\"/></svg></button>");
    var rout=rot.querySelector('output');rout.textContent=(normRot(it.rot)||0)+'\u00b0';
    rot.querySelector('.rl').addEventListener('click',function(){rotSel(-15);rout.textContent=(normRot(it.rot)||0)+'\u00b0';});
    rot.querySelector('.rr').addEventListener('click',function(){rotSel(15);rout.textContent=(normRot(it.rot)||0)+'\u00b0';});
    grid.appendChild(_aRow('Rotation',_edSvg('rot'),rot));

    var curv=el('div','ed-ministep');
    curv.innerHTML='<button type="button" class="m" aria-label="Courber vers le bas">\u2312</button><output></output><button type="button" class="p" aria-label="Courber vers le haut">\u203f</button>';
    var cout=curv.querySelector('output');
    function _cLbl(){var v=it.curve||0;return v===0?'Droit':(v>0?'+'+v:''+v);}
    cout.textContent=_cLbl();
    curv.querySelector('.m').addEventListener('click',function(){_setCurve(it,-10);cout.textContent=_cLbl();});
    curv.querySelector('.p').addEventListener('click',function(){_setCurve(it,10);cout.textContent=_cLbl();});
    grid.appendChild(_aRow(window.MT_CONFIG_I18N.text("ui_3fa528fe0ab8_html", "Courbure"),_edSvg('curve'),curv));

    // Petites majuscules (interrupteur)
    var caps=el('button','ed-toggle'+(it.smallcaps?' on':''));caps.type='button';
    caps.innerHTML='<span class="ed-tk">'+window.MT_CONFIG_I18N.label('Petites majuscules')+'</span><span class="ed-sw"></span>';
    caps.addEventListener('click',function(){_setSmallcaps(it,!it.smallcaps);caps.classList.toggle('on',!!it.smallcaps);});
    grid.appendChild(caps);

    box.appendChild(grid);

    _edMultiBlock(box,it);
  }
  /* ---------- éditeur LOGO / MOTIF ---------- */
  function _edLogo(box,it){
    var pv=el('div','ed-logopv');
    pv.innerHTML=svgSized(logoSvg(it)||('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="'+(it.stroke||1.9)+'">'+(ICONS[it.icon]||ICONS.leaf)+'</svg>'),42,it.flip);
    box.appendChild(pv);
    box.appendChild(_stepperFull(window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),'\u2212','\uFF0B',function(){return _lSizeLabel(it);},function(d){_setSize(it,d);}));
    // Trait 1,7 -> 2,2 (6 paliers)
    var twrap=el('div','');twrap.innerHTML='<span class="ed-lab">'+window.MT_CONFIG_I18N.label('Trait de gravure')+'</span>';
    var steps=el('div','ed-steps');
    var vals=[1.7,1.8,1.9,2.0,2.1,2.2], hts=[1.4,2,2.6,3.2,3.9,4.6];
    var cur=Math.round((it.stroke||1.9)*10)/10;
    vals.forEach(function(v,i){
      var b=el('button','');b.type='button';if(Math.abs(v-cur)<0.05)b.className='on';
      b.innerHTML='<span class="edbar" style="height:'+hts[i]+'px"></span><span class="edv">'+String(v).replace('.',',')+'</span>';
      b.addEventListener('click',function(){_setStroke(it,v);steps.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});
      steps.appendChild(b);
    });
    twrap.appendChild(steps);box.appendChild(twrap);
    // Rotation par pas de 15°
    var rgrid=el('div','ed-arows');
    var rot=el('div','ed-rotctl');
    rot.innerHTML=window.MT_CONFIG_I18N.text("ui_114a798b94db_html", "<button type=\"button\" class=\"rl\" aria-label=\"Pivoter à gauche\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M20 12a8 8 0 11-2.3-5.6M20 4v3.5h-3.5\" transform=\"scale(-1 1) translate(-24 0)\"/></svg></button><output></output><button type=\"button\" class=\"rr\" aria-label=\"Pivoter à droite\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M20 12a8 8 0 11-2.3-5.6M20 4v3.5h-3.5\"/></svg></button>");
    var rout=rot.querySelector('output');rout.textContent=(normRot(it.rot)||0)+'\u00b0';
    rot.querySelector('.rl').addEventListener('click',function(){rotSel(-15);rout.textContent=(normRot(it.rot)||0)+'\u00b0';});
    rot.querySelector('.rr').addEventListener('click',function(){rotSel(15);rout.textContent=(normRot(it.rot)||0)+'\u00b0';});
    rgrid.appendChild(_aRow('Rotation',_edSvg('rot'),rot));
    box.appendChild(rgrid);
    var hint=el('p','ed-tip');hint.innerHTML=window.MT_CONFIG_I18N.text("ui_05bb2a4b3c11_html", "Pour un autre motif ou logo : supprimez celui-ci, ou ajoutez-en un via <b>＋ Ajouter</b>.");
    box.appendChild(hint);
    // aligner ce logo avec les textes/autres logos
    _edMultiBlock(box,it);
  }

  /* ---------- éditeur QR ---------- */
  function _edQr(box,it){
    var pv=el('div','ed-logopv');pv.innerHTML=svgSized(it.svg||'',48,false);box.appendChild(pv);
    var row=el('button','ed-fontrow');
    row.innerHTML='<span>'+window.MT_CONFIG_I18N.label('Contenu')+'</span><b></b><span class="ed-car">'+window.MT_CONFIG_I18N.label('Modifier ›')+'</span>';
    row.querySelector('b').textContent=_qrSummary(it);
    row.addEventListener('click',function(){
      qrStart(function(svg,meta){
        it.svg=svg;if(meta)it.qrMeta=meta;
        var nd=_liveNode(it);if(nd)nd.innerHTML=svgSized(svg,renderSize(it),false);
        _sync();buildEditPanel();
      }, it.qrMeta||null);
    });
    box.appendChild(row);
    box.appendChild(_stepperFull(window.MT_CONFIG_I18N.text("ui_77093e0c33ff_html", "Taille"),'\u2212','\uFF0B',function(){return _lSizeLabel(it);},function(d){_setSize(it,d);}));
    var hint=el('p','ed-tip');hint.textContent=window.MT_CONFIG_I18N.text("ui_465aa9488d8f_html", "« Modifier » rouvre le QR Lab prérempli. Pas de réglage de trait : le QR reste net pour le scan.");
    box.appendChild(hint);
  }
  function _qrSummary(it){
    var m=it.qrMeta;if(!m)return window.MT_CONFIG_I18N.text("ui_d1daa436fba3_html", "QR personnalisé");
    var L={url:'Site web',vcard:'Contact',wifi:'Wi-Fi',event:window.MT_CONFIG_I18N.text("ui_81c7cdb0866e_html", "Événement"),phone:window.MT_CONFIG_I18N.text("ui_cc4c424b571f_html", "Téléphone"),sms:'SMS',email:'Email',maps:'Adresse',text:'Texte'};
    var lbl=L[m.type]||'QR';
    var v=m.fields&&(m.fields.qrf_url||m.fields.qrf_ssid||m.fields.qrf_phone||m.fields.qrf_mailto||m.fields.qrf_addr||m.fields.qrf_fn||m.fields.qrf_title||m.fields.qrf_text);
    return v?(lbl+' \u2014 '+String(v).slice(0,20)):lbl;
  }

  /* ---------- barre d'actions bas de panneau ---------- */
  function _edActions(box,it,kind){
    var acts=el('div','ed-actbar');
    var canFlip=(kind==='logo'||kind==='motif');   // miroir inutile sur du texte
    acts.innerHTML=(canFlip?'<button type="button" data-a="flip">\u21cb Miroir</button>':'')
      +'<button type="button" data-a="dup">\u29c9 Dupliquer</button>'
      +window.MT_CONFIG_I18N.text("ui_e7ae7b58b4d0_html", "<button type=\"button\" class=\"ed-del\" data-a=\"del\" aria-label=\"Supprimer\">✕</button>");
    var f=acts.querySelector('[data-a="flip"]');if(f)f.addEventListener('click',function(){flipSel();});
    acts.querySelector('[data-a="dup"]').addEventListener('click',function(){dupSel();});
    acts.querySelector('[data-a="del"]').addEventListener('click',function(){delSel();buildEditPanel();});
    box.appendChild(acts);
  }

  /* ---------- helpers approche A ---------- */
  function _aRow(label,icon,control){
    var r=el('div','ed-arow');
    var k=el('span','ed-ak');k.innerHTML=icon+'<span>'+label+'</span>';
    var v=el('span','ed-av');v.appendChild(control);
    r.appendChild(k);r.appendChild(v);return r;
  }
  function _miniStepper(minus,plus,getV,onStep){
    var w=el('div','ed-ministep');
    w.innerHTML='<button type="button" class="m">'+minus+'</button><output></output><button type="button" class="p">'+plus+'</button>';
    var out=w.querySelector('output');out.textContent=getV();
    w.querySelector('.m').addEventListener('click',function(){onStep(-1);out.textContent=getV();});
    w.querySelector('.p').addEventListener('click',function(){onStep(1);out.textContent=getV();});
    return w;
  }
  function _edSvg(kind){
    var P={
      size:'<path d="M4 20L20 4M4 20h5M4 20v-5"/>',
      ls:'<path d="M5 8v8M19 8v8M9 12h6"/>',
      lh:'<path d="M4 5h16M4 12h16M4 19h16"/>',
      weight:'<path d="M6 4h7a4 4 0 010 8H6zM6 12h8a4 4 0 010 8H6z" stroke-width="1.6"/>',
      align:'<path d="M4 6h16M4 12h10M4 18h13"/>',
      rot:'<path d="M20 12a8 8 0 11-2.3-5.6M20 4v3.5h-3.5"/>',
      curve:'<path d="M4 16c4-8 12-8 16 0"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+(P[kind]||'')+'</svg>';
  }

  /* ---------- bloc "aligner avec d'autres éléments" ---------- */
  function _edMultiBlock(box,it){
    // pas proposé si un seul élément sur la tomette
    if(state.els.length<2)return;
    var wrap=el('div','ed-multi');
    wrap.innerHTML=window.MT_CONFIG_I18N.text("ui_28d25c7cbadd_html", "<div class=\"ed-multi-h\">Aligner avec d’autres éléments</div>")
      +window.MT_CONFIG_I18N.text("ui_d82b2764ea3f_html", "<p class=\"ed-multi-p\">Sélectionnez les autres textes ou logos à ranger avec celui-ci (<b>Ctrl/Cmd + clic</b> sur la tomette), puis répartissez l’espacement — l’axe se choisit tout seul selon leur position.</p>")
      +'<button type="button" class="ed-multi-go"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16M9 3v18" opacity=".35"/><path d="M9 3v18M15 3v18"/></svg> R\u00e9partir l\u2019espacement</button>';
    wrap.querySelector('.ed-multi-go').addEventListener('click',function(){var id0=state.sel;if(id0)mselStart(id0);});
    box.appendChild(wrap);
  }

  /* ---------- setters nouveaux ---------- */
  function _setLh(it,dir){
    pushHistory();it.lh=Math.round(clamp((it.lh||1.1)+dir*0.05,0.8,2.2)*100)/100;
    var nd=_liveNode(it);if(nd){nd.style.lineHeight=it.lh;}
    _sync();
  }
  function _setSmallcaps(it,on){
    pushHistory();it.smallcaps=!!on;
    var nd=_liveNode(it);if(nd)applyStyle(nd,it);
    _sync();
  }
  function _setCurve(it,dir){
    pushHistory();it.curve=Math.round(clamp((it.curve||0)+dir,-100,100));
    var nd=_liveNode(it);if(nd)applyStyle(nd,it);
    _sync();
  }
  /* ---------- helpers de contrôle ---------- */
  function _stepperFull(lbl,minus,plus,getV,onStep){
    var w=el('div','');
    w.innerHTML='<span class="ed-lab">'+lbl+'</span><div class="ed-stepper"><button type="button" class="m">'+minus+'</button><output></output><button type="button" class="p">'+plus+'</button></div>';
    var out=w.querySelector('output');out.textContent=getV();
    w.querySelector('.m').addEventListener('click',function(){onStep(-1);out.textContent=getV();});
    w.querySelector('.p').addEventListener('click',function(){onStep(1);out.textContent=getV();});
    return w;
  }

  /* ---------- setters (branchés sur le moteur existant) ---------- */
  function _tSize(it){var v=Math.round((it.size||0)*10)/10;return (v%1===0)?String(Math.round(v)):v.toFixed(1);}
  function _lSizeLabel(it){var v=Math.round((it.size||0)*10)/10;return (v%1===0)?String(Math.round(v)):v.toFixed(1);}
  function _setSize(it,dir){
    pushHistory();var b=sizeBounds(it);var step=(it.type==='text')?1:2;
    it.size=Math.round(clamp((it.size||b.min)+dir*step,b.min,b.max)*10)/10;it.manual=true;
    var nd=_liveNode(it);if(nd){if(it.type==='text'){_applySize(nd,it);}else{applyLogoSize(nd,it);}}
    _sync();
  }
  function _setLs(it,dir){
    pushHistory();it.ls=Math.round(clamp((it.ls||0)+dir*0.02,0,0.4)*100)/100;
    var nd=_liveNode(it);if(nd)applyStyle(nd,it);_sync();
  }
  function _setWeight(it,w){
    pushHistory();it.weight=clamp(w,300,800);
    ensureCurrentDisplayFonts();
    var nd=_liveNode(it);if(nd)applyStyle(nd,it);_sync();
  }
  function _setAlign(it,dir){
    pushHistory();it.align=dir;
    var nd=_liveNode(it);if(nd)applyStyle(nd,it);_sync();
  }
  function _setStroke(it,v){
    if(mtEstFond(it)||mtEstFilet(it))return;   // greffe F5 : la carte et son filet restent à la graisse 1,7 (sinon un halo de ≈ 1,9 mm)
    pushHistory();it.stroke=Math.round(clamp(v,1.7,2.2)*10)/10;
    var nd=_liveNode(it);var svg=nd&&nd.querySelector('svg');if(svg)svg.style.strokeWidth=it.stroke;_sync();
  }

  function _collectClientLogos(){
    var out=[];
    state.els.forEach(function(e2){
      if(e2.type==='icon'&&e2.svg&&String(e2.icon||'').indexOf('custom_')===0&&e2.icon!=='custom_map'&&e2.icon!=='custom_filet'&&!mtEstFond(e2)&&out.length<3){   // greffe F3 : ni la carte ni le filet
        var s2=String(e2.svg);if(s2.length<200000)out.push(s2);
      }
    });
    return out;
  }
  (function(){
    var mt=document.getElementById('addMotifTile');if(mt)mt.addEventListener('click',function(){lpTab('motif');});
    var qt=document.getElementById('addQrTile');if(qt)qt.addEventListener('click',function(){qrStart(function(svg,meta){addCustomSvg(svg,meta);});});
    var fb=document.getElementById('fontsBack');if(fb)fb.addEventListener('click',function(){lpTab(state.sel?'edit':'add');});
    var mb=document.getElementById('motifBack');if(mb)mb.addEventListener('click',function(){lpTab(state.sel?'edit':'add');});
  })();

  /* =====================================================================
     PONT ADMIN — dialogue postMessage avec admin.mytomette.fr
     Actif UNIQUEMENT si MT_ADMIN (iframe/fenêtre admin + ?admin=1).
     Protocole :
       admin -> configurateur : {mt:'load', recipe}  {mt:'get'}
       configurateur -> admin : {mt:'ready'} {mt:'loaded'} {mt:'recipe', recipe} {mt:'logo', svg} {mt:'cancel'}
     Les recettes transportent, par élément, un objet _adm (champs $variables$,
     groupes, réglages guidés…) que le moteur fait transiter SANS y toucher.
     ===================================================================== */
  (function(){
    if(!MT_ADMIN) return;
    var PARENT_OK=/^https?:\/\/(admin\.mytomette\.fr|mytomette\.fr|www\.mytomette\.fr|localhost(:\d+)?|127\.0\.0\.1(:\d+)?)$/;
    var parentOrigin=null;
    var target=(window.opener&&!window.opener.closed)?window.opener:window.parent;
    function post(msg){try{target.postMessage(msg,parentOrigin||'*');}catch(e){}}

    /* UI boutique masquée : pas de panier, prix, sauvegarde email ni sortie site */
    var css=document.createElement('style');
    css.textContent='#saveTop,#railSaveBtn,#saveM,#cartM,#saveBtn,#siteBtn,.pricebar,.etop-price,#toValid,#sValid,.cart-ov,#resumePill,.mtoolbar .mtool.cart{display:none!important}'
      +'#toValidTop .ctaFull,#toValidTop .ctaShort{display:none!important}'
      +'#toValidTop:after{content:"\\2713 Terminer \\2192 Admin"}';
    document.head.appendChild(css);

    /* « Terminer » et « Retour » renvoient vers l\'admin au lieu du parcours client */
    var done=document.getElementById('toValidTop');
    if(done)done.addEventListener('click',function(ev){ev.preventDefault();ev.stopImmediatePropagation();try{syncTextFromDom();restackByFootprint();}catch(e){}post({mt:'recipe',recipe:getRecipe()});},true);
    var back=document.getElementById('etopBack');
    if(back)back.addEventListener('click',function(ev){ev.preventDefault();ev.stopImmediatePropagation();post({mt:'cancel'});},true);

    /* Logo importé (vectorisé) -> remonte à la bibliothèque admin. Les QR (crispEdges / meta) restent hors bibliothèque. */
    var _origAddCustomSvg=addCustomSvg;
    addCustomSvg=function(svg,meta){
      _origAddCustomSvg(svg,meta);
      if(!meta && !/crispEdges/i.test(String(svg||''))) post({mt:'logo',svg:String(svg||'')});
    };

    window.addEventListener('message',function(ev){
      if(!PARENT_OK.test(ev.origin||''))return;
      var d=ev.data||{};
      if(!d||typeof d.mt!=='string')return;
      parentOrigin=ev.origin;
      if(ev.source&&ev.source!==window)target=ev.source;
      if(d.mt==='load'){
        var r=d.recipe||null;
        if(r&&r.elements&&r.elements.length&&loadRecipe(r)){render();updatePrice();goEditor();}
        else{
          /* modèle vide : on ouvre l\'éditeur avec la bonne forme, prêt à créer */
          if(r){state.shape=(r.shape==='carree')?'carree':'hexa';state.hole=!!r.hole;
               state.allowShapes=(r.allowShapes&&r.allowShapes.length)?r.allowShapes.slice():['hexa','carree'];
               state.allowPlein=(r.allowPlein!==false);state.allowPerce=(r.allowPerce!==false);}
          state.els=[];state.sel=null;history=[];updateUndo();
          syncShapeUI();render();updatePrice();goEditor();
        }
        post({mt:'loaded'});
      } else if(d.mt==='get'){
        try{syncTextFromDom();restackByFootprint();}catch(e){}
        post({mt:'recipe',recipe:getRecipe()});
      }
    });
    post({mt:'ready'});
  })();
;window.__MT_CORE__={getRecipe:typeof getRecipe!=="undefined"?getRecipe:null,loadRecipe:typeof loadRecipe!=="undefined"?loadRecipe:null,renderPNG:typeof renderPNG!=="undefined"?renderPNG:null,buildLaserSVG:typeof buildLaserSVG!=="undefined"?buildLaserSVG:null,render:typeof render!=="undefined"?render:null,updatePrice:typeof updatePrice!=="undefined"?updatePrice:null,goEditor:typeof goEditor!=="undefined"?goEditor:null,select:typeof select!=="undefined"?select:null,getItem:typeof getItem!=="undefined"?getItem:null,applyRot:typeof applyRot!=="undefined"?applyRot:null,normRot:typeof normRot!=="undefined"?normRot:null,pushHistory:typeof pushHistory!=="undefined"?pushHistory:null,sizeBounds:typeof sizeBounds!=="undefined"?sizeBounds:null,loadTemplate:typeof loadTemplate!=="undefined"?loadTemplate:null,loadBlank:typeof loadBlank!=="undefined"?loadBlank:null,goInsp:typeof goInsp!=="undefined"?goInsp:null,buildInsp:typeof buildInsp!=="undefined"?buildInsp:null,buildChips:typeof buildChips!=="undefined"?buildChips:null,setFont:typeof setFont!=="undefined"?setFont:null,fontById:typeof fontById!=="undefined"?fontById:null,addIcon:typeof addIcon!=="undefined"?addIcon:null,addText:typeof addText!=="undefined"?addText:null,deselect:typeof deselect!=="undefined"?deselect:null,syncShapeUI:typeof syncShapeUI!=="undefined"?syncShapeUI:null,goValid:typeof goValid!=="undefined"?goValid:null,applyStyle:typeof applyStyle!=="undefined"?applyStyle:null,applyLogoSize:typeof applyLogoSize!=="undefined"?applyLogoSize:null,syncGrey:typeof syncGrey!=="undefined"?syncGrey:null,positionFloat:typeof positionFloat!=="undefined"?positionFloat:null,scheduleLive:typeof scheduleLive!=="undefined"?scheduleLive:null,positionHandles:typeof positionHandles!=="undefined"?positionHandles:null,inlineEdit:typeof inlineEdit!=="undefined"?inlineEdit:null,defaultWeight:typeof defaultWeight!=="undefined"?defaultWeight:null,usableWidthFrac:typeof usableWidthFrac!=="undefined"?usableWidthFrac:null,dupSel:typeof dupSel!=="undefined"?dupSel:null,delSel:typeof delSel!=="undefined"?delSel:null,flipSel:typeof flipSel!=="undefined"?flipSel:null,ensureFullLogos:typeof ensureFullLogos!=="undefined"?ensureFullLogos:null,ensureLogoSvg:typeof ensureLogoSvg!=="undefined"?ensureLogoSvg:null,toast:typeof toast!=="undefined"?toast:null,mtTrack:typeof mtTrack!=="undefined"?mtTrack:null,priceShape:typeof priceShape!=="undefined"?priceShape:null,holeFeeFor:typeof holeFeeFor!=="undefined"?holeFeeFor:null,eur:typeof eur!=="undefined"?eur:null,addCustomSvg:typeof addCustomSvg!=="undefined"?addCustomSvg:null,mtAutosave:typeof mtAutosave!=="undefined"?mtAutosave:null,closeSheet:typeof closeSheet!=="undefined"?closeSheet:null,syncTextFromDom:typeof syncTextFromDom!=="undefined"?syncTextFromDom:null,mtEstFond:typeof mtEstFond!=="undefined"?mtEstFond:null,mtHasFond:typeof mtHasFond!=="undefined"?mtHasFond:null,mtFondTaille:typeof mtFondTaille!=="undefined"?mtFondTaille:null,mtFondBoites:typeof mtFondBoites!=="undefined"?mtFondBoites:null,fondPret:typeof mtFondPretP!=="undefined"?mtFondPretP:null,fondProps:typeof mtFondProps!=="undefined"?mtFondProps:null,mtFondAccorde:typeof mtFondAccorde!=="undefined"?mtFondAccorde:null,mtFondType:typeof mtFondType!=="undefined"?mtFondType:null,mtFondTypeDe:typeof mtFondTypeDe!=="undefined"?mtFondTypeDe:null,get state(){return typeof state!=="undefined"?state:null},get SHAPES(){return typeof SHAPES!=="undefined"?SHAPES:null},get TEMPLATES(){return typeof TEMPLATES!=="undefined"?TEMPLATES:null},get OCCASIONS(){return typeof OCCASIONS!=="undefined"?OCCASIONS:null},get FONTS(){return typeof FONTS!=="undefined"?FONTS:null},get FONTREG(){return typeof FONTREG!=="undefined"?FONTREG:null},get LOGOCAT(){return typeof LOGOCAT!=="undefined"?LOGOCAT:null},get LOGOCATS(){return typeof LOGOCATS!=="undefined"?LOGOCATS:null},get history(){return typeof history!=="undefined"?history:null},get histLabels(){return typeof histLabels!=="undefined"?histLabels:null}};})();